// import React, { useEffect, useState, useRef, useMemo } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { setActiveModule } from '../store/slices/uiSlice';
// import {
//   Users, Clock, Calendar, Search, User, BarChart2, Briefcase,
//   Plus, ChevronRight, Award, BookOpen, ShieldAlert, Package,
//   LogOut, FileText, DollarSign, Settings, X, Camera, Upload,
//   Check, AlertTriangle, Eye, ChevronDown, ChevronUp,
//   Database, Tag, Building2, MapPin, MapPinned, Shield, Save, RotateCcw, CheckCircle,
//   AlertCircle, Loader2, Download,
// } from 'lucide-react';
// import {
//   fetchEmployees, fetchAttendance, fetchLeave, fetchPayroll,
//   fetchRecruitment, fetchTraining, fetchDisciplinary,
//   fetchHRAssets, fetchExits,
//   createEmployee, createLeaveRequest, approveLeave, rejectLeave,
//   createRecruitment, createTraining, createDisciplinary,
//   createHRAsset, createExit
// } from '../store/slices/hrSlice';
// import { fetchAllEMP, addEMPEmployee, clearEMPError, clearEMPSuccess } from '../store/slices/newEmpSlice';
// import { fetchAllEmployees } from '../store/slices/employeeSlice';
// import { fetchLocationMaster, addLocationMaster } from '../store/slices/locationMasterSlice';
// import { clearLocationMasterAddState } from '../store/slices/locationMasterSlice';
// import {
//   PageHeader, Card, Badge, Table, Modal, FormField,
//   SearchBar, LoadingState, EmptyState, StatCard
// } from '../components/common';
// import { StatusPill } from '../components/Table/Table';
// import LocationMapModal from '../components/common/LocationMapModal';
// import LocationPickerMapModal from '../components/common/LocationPickerMapModal';
// import { formatDate } from '../utils/helpers';
// import HRMDashboard from './employee/HRMDashboard';
// import AttendanceExplorer from '../components/employee/AttendanceExplorer';
// import AttendanceReport from './Attendance/AttendanceReport';
// import { addDesignation, clearDesignationError, clearDesignationSuccess, getDesignationList, updateDesignation } from '../store/slices/designationSlice';
// import { addDepartment, clearDepartmentError, clearDepartmentSuccess, getDepartmentList, updateDepartment } from '../store/slices/departmentSlice';
// import { addLocation, clearLocationError, clearLocationSuccess, getLocationList, updateLocation } from '../store/slices/locationSlice';
// import { addEmployeeCategory, clearEmployeeCategoryError, clearEmployeeCategorySuccess, getEmployeeCategoryList, updateEmployeeCategory } from '../store/slices/employeeCategorySlice';
// import { addGrade, clearGradeError, clearGradeSuccess, getGradeList, updateGrade } from '../store/slices/gradeSlice';
// import { addBankBranch, clearBankBranchSuccess, getBankBranchList, updateBankBranch } from '../store/slices/bankBranchSlice';
// import { addShift, clearShiftSuccess, getShiftList, updateShift } from '../store/slices/shiftSlice';
// import { addBank, clearBankError, clearBankSuccess, getBankList, updateBank } from '../store/slices/bankSlice';
// import { getLoggedInServiceNo } from '../utils/masterDataUtils';
// import {
//   isMasterApproved, masterApprovalParams, NEW_MASTER_IS_APPROVED,
// } from '../utils/masterApproval';
// import { exportToExcel, importFromExcel } from '../utils/excelUtils';

// // ─── Sidebar sub-navigation items ────────────────────────────────────────────
// const HR_MODULES = [
//   { key: 'overview',    label: 'Overview',          icon: BarChart2 },
//   { key: 'employees',   label: 'Employee Management', icon: Users },
//   { key: 'recruitment', label: 'Recruitment',        icon: Briefcase },
//   { key: 'masterfiles', label: 'Master Files',       icon: Database },
//   { key: 'attendance',  label: 'Attendance & Shifts', icon: Clock },
//   { key: 'leave',       label: 'Leave Management',   icon: Calendar },
//   { key: 'payroll',     label: 'Payroll',            icon: DollarSign },
//   { key: 'performance', label: 'Performance',        icon: Award },
//   { key: 'training',    label: 'Training',           icon: BookOpen },
//   { key: 'selfservice', label: 'Self Service',       icon: User },
//   { key: 'disciplinary',label: 'Disciplinary',       icon: ShieldAlert },
//   { key: 'hrassets',    label: 'Assets',             icon: Package },
//   { key: 'exit',        label: 'Exit Management',    icon: LogOut },
//   { key: 'reports',     label: 'Reports',            icon: FileText },
// ];

// // ─── Helper ───────────────────────────────────────────────────────────────────
// function SectionTitle({ children }) {
//   return <h3 className="text-xs font-bold text-primary-600 uppercase tracking-widest mb-3 mt-1">{children}</h3>;
// }
// function FieldRow({ label, value }) {
//   return (
//     <div className="flex items-start gap-1 py-1 border-b border-surface-50">
//       <span className="text-xs text-surface-400 w-36 shrink-0">{label}</span>
//       <span className="text-xs text-surface-800 font-medium">{value || '—'}</span>
//     </div>
//   );
// }

// // ─── Add Employee Form (connected to real EMP API) ────────────────────────────
// function AddEmployeeForm({ onClose, onSuccess }) {
//   const dispatch = useDispatch();
//   const { adding, error, successMessage } = useSelector(s => s.emp);
//   const photoRef = useRef();
//   const [photoPreview, setPhotoPreview] = useState(null);
//   const [formErrors, setFormErrors] = useState({});

//   const EMPTY = {
//     p_ced_service_no: '', p_title: 'Mr', p_sex: 'M', p_initials: '',
//     p_first_name: '', p_last_name: '', p_report_name: '',
//     p_cat_code: '', p_newold: 'N', p_barcode: '',

//     p_contact_address_1: '', p_contact_address_2: '',
//     p_contact_town: '', p_contact_city: '',
//     p_contact_tel: '', p_off_mobile: '', p_mobile: '',
//     p_contact_distance: '',

//     p_home_address_1: '', p_home_address_2: '',
//     p_home_town: '', p_home_city: '',
//     p_home_distance: '', p_home_tel: '',
//     p_electorate: '', p_police_station: '',

//     p_location_code: '', p_department_code: '', p_division_code: '',
//     p_extension: '', p_email: '',

//     p_initial_category: '', p_initial_grade: '',
//     p_retirement_date: '', p_recruitment_date: '',
//     p_shift1: '1', p_shift2: '0', p_shift3: '0',
//     p_inactive_type: '', p_union_code: '', p_association_code: '',
//     p_gramasewaka: '', p_marital_status: 'S',

//     p_nid: '', p_passport: '', p_licence: '',
//     p_birth_date: '', p_first_employer: '',
//     p_employee_category: 'E', p_work_category: 'P', p_epf: '',

//     p_breakfast: 'N', p_meal: 'N', p_snack: 'N',

//     p_nok_fname: '', p_nok_lname: '', p_nok_address: '',
//     p_nok_tel: '', p_nok_relation: '',

//     p_spouse_fname: '', p_spouse_lname: '',
//     p_spouse_dob: '', p_children: '',

//     p_own_home: 'N', p_rent: '',
//     p_vehicle: 'N', p_vehicle_type: '', p_vehicle_no: '',
//     p_transport: '', p_religion: '', p_race: '',
//     p_info: '',

//     p_fe_start: '', p_fe_end: '',
//     p_ehrs: 'N', p_prof_qual: '', p_skills: '',
//     p_odate: '', p_leave_remarks: '0',
//     p_reporting_officer: '', p_qualification: '',
//     p_present_grade: '', p_attenpay: 'N',
//     p_snack_location: '', p_proximity: '',
//     p_contract: 'P', p_jcat: '', p_jmain: '',

//     p_created_by: 'HR_ADMIN', p_updated_by: 'HR_ADMIN',
//     p_blood_group: '', p_cdl_service_no: '',
//     p_ip: '192.168.1.1', p_device: 'Web',
//   };

//   const [form, setForm] = useState(EMPTY);
//   const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

//   useEffect(() => {
//     dispatch(clearEMPError());
//     dispatch(clearEMPSuccess());
//   }, [dispatch]);

//   useEffect(() => {
//     if (successMessage) {
//       const t = setTimeout(() => {
//         dispatch(clearEMPSuccess());
//         if (onSuccess) onSuccess();
//         onClose();
//       }, 1500);
//       return () => clearTimeout(t);
//     }
//   }, [successMessage, dispatch, onClose, onSuccess]);

//   const handlePhoto = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;
//     const reader = new FileReader();
//     reader.onload = (ev) => setPhotoPreview(ev.target.result);
//     reader.readAsDataURL(file);
//   };

//   const validate = () => {
//     const errs = {};
//     if (!form.p_ced_service_no) errs.p_ced_service_no = 'Required';
//     else if (form.p_ced_service_no.length > 7) errs.p_ced_service_no = 'Max 7 characters';
//     if (!form.p_first_name) errs.p_first_name = 'Required';
//     if (!form.p_last_name)  errs.p_last_name  = 'Required';
//     if (!form.p_department_code) errs.p_department_code = 'Required';
//     if (form.p_nid && !/^\d{9}[Vv]$/.test(form.p_nid))
//       errs.p_nid = '10 chars: 9 digits + V (e.g. 198765432V)';
//     if (form.p_passport && !/^P.{6}$/.test(form.p_passport))
//       errs.p_passport = '7 chars starting with P (e.g. P987654)';
//     if (form.p_licence && !/^B.{6}$/.test(form.p_licence))
//       errs.p_licence = '7 chars starting with B (e.g. B765432)';
//     if (form.p_email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.p_email))
//       errs.p_email = 'Invalid email format';
//     if (form.p_epf && !/^EPF\d{4}$/.test(form.p_epf))
//       errs.p_epf = '7 chars: EPF + 4 digits (e.g. EPF9876)';
//     setFormErrors(errs);
//     return Object.keys(errs).length === 0;
//   };

//   const handleSubmit = async () => {
//     if (!validate()) return;
//     try { await dispatch(addEMPEmployee(form)); } catch (_) {}
//   };

//   const iCls = (k) =>
//     `w-full border rounded px-2 py-1 text-xs text-surface-800 focus:outline-none bg-amber-50/30 ${
//       formErrors[k] ? 'border-red-400 focus:border-red-500' : 'border-surface-200 focus:border-primary-400'
//     }`;
//   const sCls = `w-full border border-surface-200 rounded px-2 py-1 text-xs text-surface-800 focus:outline-none focus:border-primary-400 bg-amber-50/30`;
//   const lbl = (text, req) => (
//     <label className="block text-xs text-surface-500 mb-0.5">
//       {text}{req && <span className="text-red-500">*</span>}
//     </label>
//   );
//   const ErrMsg = ({ k }) => formErrors[k]
//     ? <p className="text-red-500 text-[10px] mt-0.5">{formErrors[k]}</p> : null;

//   return (
//     <div className="text-xs">
//       {error && (
//         <div className="mb-3 flex items-center gap-2 bg-red-50 border border-red-200 text-red-700 rounded-lg px-3 py-2 text-xs">
//           <AlertTriangle size={14} /> <span>{error}</span>
//           <button onClick={() => dispatch(clearEMPError())} className="ml-auto"><X size={12}/></button>
//         </div>
//       )}
//       {successMessage && (
//         <div className="mb-3 flex items-center gap-2 bg-emerald-50 border border-emerald-200 text-emerald-700 rounded-lg px-3 py-2 text-xs">
//           <CheckCircle size={14} /> <span>{successMessage}</span>
//         </div>
//       )}

//       {/* Row 1: Identity */}
//       <div className="grid grid-cols-12 gap-2 mb-3 pb-3 border-b border-surface-100">
//         <div className="col-span-2">
//           {lbl('CED Service No', true)}
//           <input className={iCls('p_ced_service_no')} maxLength={7}
//             value={form.p_ced_service_no} onChange={e => set('p_ced_service_no', e.target.value)} placeholder="2024001" />
//           <ErrMsg k="p_ced_service_no" />
//         </div>
//         <div className="col-span-1">
//           {lbl('Title')}
//           <select className={sCls} value={form.p_title} onChange={e => set('p_title', e.target.value)}>
//             {['Mr','Mrs','Ms','Dr','Prof','Rev'].map(t => <option key={t}>{t}</option>)}
//           </select>
//         </div>
//         <div className="col-span-1">
//           {lbl('Sex')}
//           <select className={sCls} value={form.p_sex} onChange={e => set('p_sex', e.target.value)}>
//             <option value="M">Male</option><option value="F">Female</option>
//           </select>
//         </div>
//         <div className="col-span-2">
//           {lbl('Initials')}
//           <input className={iCls('')} value={form.p_initials}
//             onChange={e => set('p_initials', e.target.value)} placeholder="e.g. R.P." />
//         </div>
//         <div className="col-span-1">
//           {lbl('New/Old')}
//           <select className={sCls} value={form.p_newold} onChange={e => set('p_newold', e.target.value)}>
//             <option value="N">New</option><option value="O">Old</option>
//           </select>
//         </div>
//         {/* Photo upload */}
//         <div className="col-span-5 row-span-4 flex flex-col items-center justify-center border border-dashed border-surface-200 rounded p-2 bg-surface-50">
//           <div className="w-24 h-28 border border-surface-200 rounded overflow-hidden bg-white flex items-center justify-center mb-2">
//             {photoPreview ? <img src={photoPreview} alt="Employee" className="w-full h-full object-cover" /> : <Camera size={28} className="text-surface-200" />}
//           </div>
//           <input ref={photoRef} type="file" accept="image/*" className="hidden" onChange={handlePhoto} />
//           <button type="button" onClick={() => photoRef.current.click()}
//             className="flex items-center gap-1 text-xs bg-surface-800 text-white px-3 py-1 rounded hover:bg-surface-700">
//             <Upload size={12} /> Upload Photo
//           </button>
//         </div>
//         <div className="col-span-7">
//           {lbl('First Name', true)}
//           <input className={iCls('p_first_name')} value={form.p_first_name}
//             onChange={e => set('p_first_name', e.target.value)} />
//           <ErrMsg k="p_first_name" />
//         </div>
//         <div className="col-span-7">
//           {lbl('Last Name', true)}
//           <input className={iCls('p_last_name')} value={form.p_last_name}
//             onChange={e => set('p_last_name', e.target.value)} />
//           <ErrMsg k="p_last_name" />
//         </div>
//         <div className="col-span-4">
//           {lbl('Report Name')}
//           <input className={iCls('')} value={form.p_report_name}
//             onChange={e => set('p_report_name', e.target.value)} />
//         </div>
//         <div className="col-span-2">
//           {lbl('Barcode')}
//           <input className={iCls('')} value={form.p_barcode}
//             onChange={e => set('p_barcode', e.target.value)} />
//         </div>
//         <div className="col-span-1">
//           {lbl('Cat Code')}
//           <input className={iCls('')} value={form.p_cat_code}
//             onChange={e => set('p_cat_code', e.target.value)} placeholder="HRM" />
//         </div>
//       </div>

//       <div className="grid grid-cols-2 gap-x-4">
//         {/* LEFT */}
//         <div>
//           <SectionTitle>Contact Address</SectionTitle>
//           <div className="grid grid-cols-2 gap-1 mb-2">
//             <div className="col-span-2">{lbl('Address Line 1')}<input className={iCls('')} value={form.p_contact_address_1} onChange={e => set('p_contact_address_1', e.target.value)} /></div>
//             <div className="col-span-2">{lbl('Address Line 2')}<input className={iCls('')} value={form.p_contact_address_2} onChange={e => set('p_contact_address_2', e.target.value)} /></div>
//             <div>{lbl('Town')}<input className={iCls('')} value={form.p_contact_town} onChange={e => set('p_contact_town', e.target.value)} /></div>
//             <div>{lbl('City/Province')}<input className={iCls('')} value={form.p_contact_city} onChange={e => set('p_contact_city', e.target.value)} /></div>
//             <div>{lbl('Telephone')}<input className={iCls('')} value={form.p_contact_tel} onChange={e => set('p_contact_tel', e.target.value)} /></div>
//             <div>{lbl('Office Mobile')}<input className={iCls('')} value={form.p_off_mobile} onChange={e => set('p_off_mobile', e.target.value)} /></div>
//             <div>{lbl('Personal Mobile')}<input className={iCls('')} value={form.p_mobile} onChange={e => set('p_mobile', e.target.value)} /></div>
//             <div>{lbl('Distance (km)')}<input className={iCls('')} value={form.p_contact_distance} onChange={e => set('p_contact_distance', e.target.value)} placeholder="3.5" /></div>
//           </div>
//           <SectionTitle>Home Address</SectionTitle>
//           <div className="grid grid-cols-2 gap-1 mb-2">
//             <div className="col-span-2">{lbl('Address Line 1')}<input className={iCls('')} value={form.p_home_address_1} onChange={e => set('p_home_address_1', e.target.value)} /></div>
//             <div className="col-span-2">{lbl('Address Line 2')}<input className={iCls('')} value={form.p_home_address_2} onChange={e => set('p_home_address_2', e.target.value)} /></div>
//             <div>{lbl('Town')}<input className={iCls('')} value={form.p_home_town} onChange={e => set('p_home_town', e.target.value)} /></div>
//             <div>{lbl('City/Province')}<input className={iCls('')} value={form.p_home_city} onChange={e => set('p_home_city', e.target.value)} /></div>
//             <div>{lbl('Telephone')}<input className={iCls('')} value={form.p_home_tel} onChange={e => set('p_home_tel', e.target.value)} /></div>
//             <div>{lbl('Distance (km)')}<input className={iCls('')} value={form.p_home_distance} onChange={e => set('p_home_distance', e.target.value)} placeholder="10.0" /></div>
//             <div>{lbl('Electorate Code')}<input className={iCls('')} value={form.p_electorate} onChange={e => set('p_electorate', e.target.value)} placeholder="107" /></div>
//             <div>{lbl('Police Station')}<input className={iCls('')} value={form.p_police_station} onChange={e => set('p_police_station', e.target.value)} placeholder="25" /></div>
//             <div>{lbl('Gramasewaka')}<input className={iCls('')} value={form.p_gramasewaka} onChange={e => set('p_gramasewaka', e.target.value)} /></div>
//           </div>
//           <SectionTitle>Employment Details</SectionTitle>
//           <div className="grid grid-cols-2 gap-1 mb-2">
//             <div>{lbl('Location Code')}<input className={iCls('')} value={form.p_location_code} onChange={e => set('p_location_code', e.target.value)} placeholder="HRD" /></div>
//             <div>{lbl('Department Code', true)}<input className={iCls('p_department_code')} value={form.p_department_code} onChange={e => set('p_department_code', e.target.value)} placeholder="HR" /><ErrMsg k="p_department_code" /></div>
//             <div>{lbl('Division Code')}<input className={iCls('')} value={form.p_division_code} onChange={e => set('p_division_code', e.target.value)} placeholder="TAL" /></div>
//             <div>{lbl('Extension')}<input className={iCls('')} value={form.p_extension} onChange={e => set('p_extension', e.target.value)} placeholder="4569" /></div>
//             <div className="col-span-2">{lbl('Email Address')}<input className={iCls('p_email')} type="email" value={form.p_email} onChange={e => set('p_email', e.target.value)} placeholder="name@company.com" /><ErrMsg k="p_email" /></div>
//             <div>{lbl('Reporting Officer')}<input className={iCls('')} value={form.p_reporting_officer} onChange={e => set('p_reporting_officer', e.target.value)} placeholder="HRD001" /></div>
//             <div>{lbl('Job Category')}<input className={iCls('')} value={form.p_jcat} onChange={e => set('p_jcat', e.target.value)} placeholder="HR" /></div>
//             <div>{lbl('Job Main Code')}<input className={iCls('')} value={form.p_jmain} onChange={e => set('p_jmain', e.target.value)} placeholder="HR01" /></div>
//             <div>{lbl('Contract Type')}<select className={sCls} value={form.p_contract} onChange={e => set('p_contract', e.target.value)}><option value="P">Permanent</option><option value="C">Contract</option><option value="T">Temporary</option></select></div>
//             <div>{lbl('Work Category')}<select className={sCls} value={form.p_work_category} onChange={e => set('p_work_category', e.target.value)}><option value="P">Permanent</option><option value="C">Contract</option><option value="T">Casual</option></select></div>
//             <div>{lbl('Employee Category')}<select className={sCls} value={form.p_employee_category} onChange={e => set('p_employee_category', e.target.value)}><option value="E">Executive</option><option value="N">Non-Executive</option><option value="M">Management</option></select></div>
//             <div>{lbl('First Employer')}<input className={iCls('')} value={form.p_first_employer} onChange={e => set('p_first_employer', e.target.value)} placeholder="02" /></div>
//           </div>
//           <SectionTitle>Grade & Dates</SectionTitle>
//           <div className="grid grid-cols-2 gap-1 mb-2">
//             <div>{lbl('Initial Category')}<input className={iCls('')} value={form.p_initial_category} onChange={e => set('p_initial_category', e.target.value)} placeholder="PRO" /></div>
//             <div>{lbl('Initial Grade')}<input className={iCls('')} value={form.p_initial_grade} onChange={e => set('p_initial_grade', e.target.value)} placeholder="M1" /></div>
//             <div>{lbl('Present Grade')}<input className={iCls('')} value={form.p_present_grade} onChange={e => set('p_present_grade', e.target.value)} placeholder="M1" /></div>
//             <div>{lbl('Recruitment Date')}<input className={iCls('')} type="date" value={form.p_recruitment_date} onChange={e => set('p_recruitment_date', e.target.value)} /></div>
//             <div>{lbl('Retirement Date')}<input className={iCls('')} type="date" value={form.p_retirement_date} onChange={e => set('p_retirement_date', e.target.value)} /></div>
//             <div>{lbl('Offer Date')}<input className={iCls('')} type="date" value={form.p_odate} onChange={e => set('p_odate', e.target.value)} /></div>
//           </div>
//           <SectionTitle>Shifts</SectionTitle>
//           <div className="grid grid-cols-3 gap-1 mb-2">
//             <div>{lbl('Shift 1')}<input className={iCls('')} value={form.p_shift1} onChange={e => set('p_shift1', e.target.value)} placeholder="1" /></div>
//             <div>{lbl('Shift 2')}<input className={iCls('')} value={form.p_shift2} onChange={e => set('p_shift2', e.target.value)} placeholder="0" /></div>
//             <div>{lbl('Shift 3')}<input className={iCls('')} value={form.p_shift3} onChange={e => set('p_shift3', e.target.value)} placeholder="0" /></div>
//           </div>
//         </div>

//         {/* RIGHT */}
//         <div>
//           <SectionTitle>Personal Details</SectionTitle>
//           <div className="grid grid-cols-2 gap-1 mb-2">
//             <div>{lbl('National ID')}<input className={iCls('p_nid')} maxLength={10} value={form.p_nid} onChange={e => set('p_nid', e.target.value)} placeholder="198765432V" /><ErrMsg k="p_nid" /></div>
//             <div>{lbl('Date of Birth')}<input className={iCls('')} type="date" value={form.p_birth_date} onChange={e => set('p_birth_date', e.target.value)} /></div>
//             <div>{lbl('Passport No')}<input className={iCls('p_passport')} maxLength={7} value={form.p_passport} onChange={e => set('p_passport', e.target.value)} placeholder="P987654" /><ErrMsg k="p_passport" /></div>
//             <div>{lbl('Licence No')}<input className={iCls('p_licence')} maxLength={7} value={form.p_licence} onChange={e => set('p_licence', e.target.value)} placeholder="B765432" /><ErrMsg k="p_licence" /></div>
//             <div>{lbl('EPF No')}<input className={iCls('p_epf')} maxLength={7} value={form.p_epf} onChange={e => set('p_epf', e.target.value)} placeholder="EPF9876" /><ErrMsg k="p_epf" /></div>
//             <div>{lbl('CDL Service No')}<input className={iCls('')} value={form.p_cdl_service_no} onChange={e => set('p_cdl_service_no', e.target.value)} /></div>
//             <div>{lbl('Marital Status')}<select className={sCls} value={form.p_marital_status} onChange={e => set('p_marital_status', e.target.value)}><option value="S">Single</option><option value="M">Married</option><option value="D">Divorced</option><option value="W">Widowed</option></select></div>
//             <div>{lbl('Blood Group')}<select className={sCls} value={form.p_blood_group} onChange={e => set('p_blood_group', e.target.value)}><option value="">Select...</option>{[['1','A+'],['2','A-'],['3','B+'],['4','B-'],['5','O+'],['6','O-'],['7','AB+'],['8','AB-']].map(([v,l]) => <option key={v} value={v}>{l}</option>)}</select></div>
//             <div>{lbl('Religion')}<select className={sCls} value={form.p_religion} onChange={e => set('p_religion', e.target.value)}><option value="">Select...</option><option value="1">Buddhist</option><option value="2">Hindu</option><option value="3">Muslim</option><option value="4">Catholic</option><option value="5">Christian</option><option value="6">Other</option></select></div>
//             <div>{lbl('Race')}<select className={sCls} value={form.p_race} onChange={e => set('p_race', e.target.value)}><option value="">Select...</option><option value="1">Sinhalese</option><option value="2">Tamil</option><option value="3">Muslim</option><option value="4">Burgher</option><option value="5">Other</option></select></div>
//           </div>
//           <SectionTitle>Transport & Facilities</SectionTitle>
//           <div className="grid grid-cols-2 gap-1 mb-2">
//             <div>{lbl('Transport')}<select className={sCls} value={form.p_transport} onChange={e => set('p_transport', e.target.value)}><option value="">Select...</option><option value="1">Company Bus</option><option value="2">Own Vehicle</option><option value="3">Public Transport</option><option value="4">Walking</option></select></div>
//             <div>{lbl('Own Vehicle')}<select className={sCls} value={form.p_vehicle} onChange={e => set('p_vehicle', e.target.value)}><option value="N">No</option><option value="Y">Yes</option></select></div>
//             {form.p_vehicle === 'Y' && <>
//               <div>{lbl('Vehicle Type')}<select className={sCls} value={form.p_vehicle_type} onChange={e => set('p_vehicle_type', e.target.value)}><option value="">Select...</option><option value="1">Motorbike</option><option value="2">Car</option><option value="3">Van</option><option value="4">SUV</option></select></div>
//               <div>{lbl('Vehicle No')}<input className={iCls('')} value={form.p_vehicle_no} onChange={e => set('p_vehicle_no', e.target.value)} placeholder="ABC-1234" /></div>
//             </>}
//             <div>{lbl('Meal')}<select className={sCls} value={form.p_meal} onChange={e => set('p_meal', e.target.value)}><option value="N">No</option><option value="Y">Yes</option></select></div>
//             <div>{lbl('Breakfast')}<select className={sCls} value={form.p_breakfast} onChange={e => set('p_breakfast', e.target.value)}><option value="N">No</option><option value="Y">Yes</option></select></div>
//             <div>{lbl('Snack')}<select className={sCls} value={form.p_snack} onChange={e => set('p_snack', e.target.value)}><option value="N">No</option><option value="Y">Yes</option></select></div>
//             <div>{lbl('Own Home')}<select className={sCls} value={form.p_own_home} onChange={e => set('p_own_home', e.target.value)}><option value="N">No</option><option value="Y">Yes</option></select></div>
//           </div>
//           <SectionTitle>Next of Kin</SectionTitle>
//           <div className="grid grid-cols-2 gap-1 mb-2">
//             <div>{lbl('First Name')}<input className={iCls('')} value={form.p_nok_fname} onChange={e => set('p_nok_fname', e.target.value)} /></div>
//             <div>{lbl('Last Name')}<input className={iCls('')} value={form.p_nok_lname} onChange={e => set('p_nok_lname', e.target.value)} /></div>
//             <div className="col-span-2">{lbl('Address')}<input className={iCls('')} value={form.p_nok_address} onChange={e => set('p_nok_address', e.target.value)} /></div>
//             <div>{lbl('Telephone')}<input className={iCls('')} value={form.p_nok_tel} onChange={e => set('p_nok_tel', e.target.value)} /></div>
//             <div>{lbl('Relation')}<select className={sCls} value={form.p_nok_relation} onChange={e => set('p_nok_relation', e.target.value)}><option value="">Select...</option><option value="1">Spouse</option><option value="2">Father</option><option value="3">Mother</option><option value="4">Son</option><option value="5">Daughter</option><option value="6">Brother</option><option value="7">Sister</option><option value="8">Other</option></select></div>
//           </div>
//           <SectionTitle>Spouse Details</SectionTitle>
//           <div className="grid grid-cols-2 gap-1 mb-2">
//             <div>{lbl('Spouse First Name')}<input className={iCls('')} value={form.p_spouse_fname} onChange={e => set('p_spouse_fname', e.target.value)} /></div>
//             <div>{lbl('Spouse Last Name')}<input className={iCls('')} value={form.p_spouse_lname} onChange={e => set('p_spouse_lname', e.target.value)} /></div>
//             <div>{lbl('Spouse DOB')}<input className={iCls('')} type="date" value={form.p_spouse_dob} onChange={e => set('p_spouse_dob', e.target.value)} /></div>
//             <div>{lbl('No. of Children')}<input className={iCls('')} type="number" min="0" value={form.p_children} onChange={e => set('p_children', e.target.value)} /></div>
//           </div>
//           <SectionTitle>Qualifications & Skills</SectionTitle>
//           <div className="grid grid-cols-2 gap-1 mb-2">
//             <div>{lbl('Education Level')}<select className={sCls} value={form.p_qualification} onChange={e => set('p_qualification', e.target.value)}><option value="">Select...</option><option value="1">Below Grade V</option><option value="3">GCE O/L</option><option value="5">Passed GCE O/L</option><option value="7">Passed GCE A/L</option><option value="11">B.Sc. Eng. (Hons)</option><option value="13">M.Sc.</option><option value="14">B.Sc.</option><option value="19">B.Com</option></select></div>
//             <div>{lbl('Professional Qual')}<select className={sCls} value={form.p_prof_qual} onChange={e => set('p_prof_qual', e.target.value)}><option value="">Select...</option><option value="1">Higher Diploma</option><option value="3">Honours Degree</option><option value="4">M.Sc.</option><option value="9">NDT</option><option value="22">Diploma in Engineering</option></select></div>
//             <div className="col-span-2">{lbl('Skills')}<textarea className={iCls('') + ' h-12 resize-none'} value={form.p_skills} onChange={e => set('p_skills', e.target.value)} placeholder="Recruitment, Performance Management..." /></div>
//             <div className="col-span-2">{lbl('Other Info')}<textarea className={iCls('') + ' h-10 resize-none'} value={form.p_info} onChange={e => set('p_info', e.target.value)} /></div>
//           </div>
//           <SectionTitle>Entitlements</SectionTitle>
//           <div className="grid grid-cols-3 gap-1 mb-2">
//             <div>{lbl('eHRS Enabled')}<select className={sCls} value={form.p_ehrs} onChange={e => set('p_ehrs', e.target.value)}><option value="N">No</option><option value="Y">Yes</option></select></div>
//             <div>{lbl('Atten. Pay')}<select className={sCls} value={form.p_attenpay} onChange={e => set('p_attenpay', e.target.value)}><option value="N">No</option><option value="Y">Yes</option></select></div>
//             <div>{lbl('Leave Remarks')}<input className={iCls('')} value={form.p_leave_remarks} onChange={e => set('p_leave_remarks', e.target.value)} placeholder="0" /></div>
//             <div>{lbl('Union Code')}<input className={iCls('')} value={form.p_union_code} onChange={e => set('p_union_code', e.target.value)} /></div>
//             <div>{lbl('Association')}<input className={iCls('')} value={form.p_association_code} onChange={e => set('p_association_code', e.target.value)} /></div>
//           </div>
//         </div>
//       </div>

//       <div className="flex justify-end gap-3 pt-3 border-t border-surface-100 mt-2">
//         <button type="button" onClick={onClose} className="btn-ghost" disabled={adding}>Cancel</button>
//         <button type="button" onClick={handleSubmit} disabled={adding}
//           className="btn-primary flex items-center gap-2">
//           {adding
//             ? <><span className="animate-spin border-2 border-white border-t-transparent rounded-full w-3 h-3 inline-block" /> Saving...</>
//             : <><Check size={14} /> Save Employee</>}
//         </button>
//       </div>
//     </div>
//   );
// }

// // ─── Normalize API employee fields (supports both mock and real API shapes) ──
// function normEmp(e) {
//   if (!e) return e;
//   // If already normalized or mock data, return as-is
//   if (e._normalized) return e;
//   return {
//     ...e,
//     _normalized: true,
//     id:              e.id              || e.p_ced_service_no || '',
//     firstName:       e.firstName       || e.p_first_name     || '',
//     lastName:        e.lastName        || e.p_last_name      || '',
//     name:            e.name            || `${e.p_first_name || ''} ${e.p_last_name || ''}`.trim(),
//     title:           e.title           || e.p_title          || '',
//     initials:        e.initials        || e.p_initials       || '',
//     designation:     e.designation     || e.p_cat_code       || '',
//     department:      e.department      || e.p_department_code|| '',
//     division:        e.division        || e.p_division_code  || '',
//     email:           e.email           || e.p_email          || '',
//     phone:           e.phone           || e.p_mobile         || '',
//     personalMobile:  e.personalMobile  || e.p_mobile         || '',
//     status:          e.status          || 'Active',
//     epfNo:           e.epfNo           || e.p_epf            || '',
//     nationalId:      e.nationalId      || e.p_nid            || '',
//     dob:             e.dob             || e.p_birth_date      || '',
//     gender:          e.gender          || (e.p_sex === 'M' ? 'Male' : e.p_sex === 'F' ? 'Female' : e.p_sex) || '',
//     maritalStatus:   e.maritalStatus   || e.p_marital_status || '',
//     bloodGroup:      e.bloodGroup      || e.p_blood_group    || '',
//     serviceNo:       e.serviceNo       || e.p_ced_service_no || '',
//     address1:        e.address1        || e.p_contact_address_1 || '',
//     city:            e.city            || e.p_contact_city   || '',
//     homeAddress1:    e.homeAddress1    || e.p_home_address_1 || '',
//     grade:           e.grade           || e.p_present_grade  || '',
//     workCategory:    e.workCategory    || e.p_work_category  || '',
//     contractType:    e.contractType    || e.p_contract       || '',
//     recruitmentDate: e.recruitmentDate || e.p_recruitment_date || '',
//     retirementDate:  e.retirementDate  || e.p_retirement_date || '',
//     skills:          e.skills          || e.p_skills         || '',
//     nextOfKinFirstName: e.nextOfKinFirstName || e.p_nok_fname || '',
//     nextOfKinLastName:  e.nextOfKinLastName  || e.p_nok_lname || '',
//     nextOfKinPhone:     e.nextOfKinPhone     || e.p_nok_tel   || '',
//     nextOfKinRelationship: e.nextOfKinRelationship || e.p_nok_relation || '',
//   };
// }

// // ─── Employee Summary Card ────────────────────────────────────────────────────
// function EmployeeSummaryCard({ emp: rawEmp, onClick }) {
//   const emp = normEmp(rawEmp);
//   const initials = emp.firstName ? `${emp.firstName[0]}${emp.lastName ? emp.lastName[0] : ''}` : emp.name?.split(' ').map(n => n[0]).join('') || '?';
//   return (
//     <Card className="cursor-pointer hover:border-primary-400 hover:shadow-md transition-all" onClick={() => onClick(emp)}>
//       <div className="flex gap-3">
//         <div className="shrink-0">
//           {emp.photo
//             ? <img src={emp.photo} alt={emp.firstName} className="w-14 h-16 rounded-lg object-cover border border-surface-100" />
//             : <div className="w-14 h-16 primary-gradient rounded-lg flex items-center justify-center"><span className="text-surface-900 font-bold text-base">{initials}</span></div>
//           }
//         </div>
//         <div className="min-w-0 flex-1">
//           <div className="flex items-start justify-between gap-1">
//             <p className="font-bold text-surface-900 text-sm leading-tight">{emp.firstName || emp.name} {emp.lastName || ''}</p>
//             <Badge status={emp.status} />
//           </div>
//           <p className="text-xs text-primary-600 font-medium mt-0.5">{emp.id}</p>
//           <p className="text-xs text-surface-500 mt-1">{emp.designation}</p>
//           <p className="text-xs text-surface-400">{emp.department} {emp.division ? `· ${emp.division}` : ''}</p>
//         </div>
//       </div>
//     </Card>
//   );
// }

// // ─── Employee Detail View ──────────────────────────────────────────────────────
// function EmployeeDetailView({ emp: rawEmpDetail, onClose }) {
//   const emp = normEmp(rawEmpDetail);
//   const [tab, setTab] = useState('personal');
//   const tabs = ['personal','contact','employment','kin','qualifications'];
//   return (
//     <div className="text-xs">
//       <div className="flex items-center gap-4 mb-4 pb-4 border-b border-surface-100">
//         <div className="shrink-0">
//           {emp.photo
//             ? <img src={emp.photo} alt="" className="w-20 h-24 rounded-xl object-cover border-2 border-primary-300" />
//             : <div className="w-20 h-24 primary-gradient rounded-xl flex items-center justify-center"><span className="text-surface-900 font-bold text-2xl">{emp.initials || (emp.firstName?.[0] + (emp.lastName?.[0] || ''))}</span></div>
//           }
//         </div>
//         <div>
//           <h2 className="text-lg font-bold text-surface-900">{emp.title} {emp.firstName} {emp.lastName}</h2>
//           <p className="text-primary-600 font-medium">{emp.id} · {emp.designation}</p>
//           <p className="text-surface-400">{emp.department} {emp.division ? `— ${emp.division}` : ''}</p>
//           <div className="flex items-center gap-2 mt-1"><Badge status={emp.status} /><span className="text-surface-400">EPF: {emp.epfNo}</span></div>
//         </div>
//       </div>
//       <div className="flex gap-1 mb-3 overflow-x-auto">
//         {tabs.map(t => (
//           <button key={t} onClick={() => setTab(t)} className={`px-3 py-1.5 rounded text-xs font-medium capitalize whitespace-nowrap transition-colors ${tab === t ? 'bg-surface-900 text-primary-400' : 'bg-surface-100 text-surface-500 hover:text-surface-800'}`}>{t}</button>
//         ))}
//       </div>
//       {tab === 'personal' && (
//         <div className="grid grid-cols-2 gap-x-6">
//           <div><SectionTitle>Personal</SectionTitle><FieldRow label="National ID" value={emp.nationalId} /><FieldRow label="Date of Birth" value={emp.dob} /><FieldRow label="Gender" value={emp.gender} /><FieldRow label="Marital Status" value={emp.maritalStatus} /><FieldRow label="Blood Group" value={emp.bloodGroup} /></div>
//           <div><SectionTitle>Identification</SectionTitle><FieldRow label="Service No" value={emp.serviceNo} /><FieldRow label="Proximity Card" value={emp.proximityCardNo} /><SectionTitle>Transport</SectionTitle><FieldRow label="Transport Mode" value={emp.transportMode} /><FieldRow label="Own Vehicle" value={emp.ownVehicle} /></div>
//         </div>
//       )}
//       {tab === 'contact' && (
//         <div className="grid grid-cols-2 gap-x-6">
//           <div><SectionTitle>Contact Address</SectionTitle><FieldRow label="Address 1" value={emp.address1} /><FieldRow label="City" value={emp.city} /><FieldRow label="Personal Mobile" value={emp.phone || emp.personalMobile} /><FieldRow label="Email" value={emp.email} /></div>
//           <div><SectionTitle>Home Address</SectionTitle><FieldRow label="Address 1" value={emp.homeAddress1} /><FieldRow label="District" value={emp.homeDistrict || emp.district} /><FieldRow label="Province" value={emp.homeProvince || emp.province} /></div>
//         </div>
//       )}
//       {tab === 'employment' && (
//         <div className="grid grid-cols-2 gap-x-6">
//           <div><SectionTitle>Employment</SectionTitle><FieldRow label="Division" value={emp.division} /><FieldRow label="Department" value={emp.department} /><FieldRow label="Grade" value={emp.grade} /><FieldRow label="Work Category" value={emp.workCategory} /><FieldRow label="EPF No" value={emp.epfNo} /><FieldRow label="Contract Type" value={emp.contractType} /></div>
//           <div><SectionTitle>Key Dates</SectionTitle><FieldRow label="Recruitment Date" value={emp.recruitmentDate} /><FieldRow label="Promoted Date" value={emp.promotedDate} /><FieldRow label="Retirement Date" value={emp.retirementDate} /></div>
//         </div>
//       )}
//       {tab === 'kin' && (
//         <div><SectionTitle>Next of Kin</SectionTitle><div className="grid grid-cols-2 gap-x-6"><FieldRow label="Name" value={`${emp.nextOfKinFirstName || ''} ${emp.nextOfKinLastName || ''}`.trim()} /><FieldRow label="Relationship" value={emp.nextOfKinRelationship} /><FieldRow label="Telephone" value={emp.nextOfKinPhone} /></div></div>
//       )}
//       {tab === 'qualifications' && (
//         <div><SectionTitle>Education & Skills</SectionTitle><FieldRow label="Highest Education" value={emp.highestEducation} /><FieldRow label="Highest Professional" value={emp.highestProfessional} /><div className="mt-2"><span className="text-xs text-surface-400">Skills</span><p className="text-xs text-surface-800 mt-1 bg-surface-50 p-2 rounded">{emp.skills || '—'}</p></div></div>
//       )}
//       <div className="flex justify-end mt-4 pt-3 border-t border-surface-100"><button onClick={onClose} className="btn-ghost">Close</button></div>
//     </div>
//   );
// }

// // ══════════════════════════════════════════════════════════════════════════════
// // ─── MASTER FILES EMBEDDED IN HR ─────────────────────────────────────────────
// // ══════════════════════════════════════════════════════════════════════════════

// // Shared styles for master files forms (primary-themed to match HRM)
// const MF_INP = 'h-9 w-full bg-white border border-gray-200 rounded-lg px-2.5 text-xs text-gray-800 outline-none focus:border-primary-500';
// const MF_SEL = 'h-9 w-full bg-white border border-gray-200 rounded-lg px-2.5 text-xs text-gray-800 outline-none focus:border-primary-500';

// function MFLabel({ children, req }) {
//   return <label className="block text-[11px] font-medium text-gray-500 mb-1">{children}{req && <span className="text-red-500 ml-0.5">*</span>}</label>;
// }

// function MFEntryPanel({ title, children, onSave, onClear, saved }) {
//   return (
//     <div className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden">
//       <div className="px-5 py-3.5 border-b border-gray-200">
//         <h3 className="text-sm font-semibold text-gray-900">{title}</h3>
//       </div>
//       <div className="p-4">
//         {saved && (
//           <div className="flex items-center gap-1.5 text-emerald-700 bg-emerald-50 border border-emerald-100 rounded-lg px-2.5 py-1.5 text-xs mb-3">
//             <CheckCircle size={12} /> Saved
//           </div>
//         )}
//         <div className="space-y-2.5">{children}</div>
//         <div className="flex gap-2 mt-4">
//           <button onClick={onSave}
//             className="flex items-center gap-2 h-9 px-4 rounded-lg text-xs font-semibold bg-primary-600 text-white hover:bg-primary-700 transition-colors">
//             <Save size={13} /> Save
//           </button>
//           <button onClick={onClear}
//             className="flex items-center gap-2 h-9 px-4 rounded-lg text-xs font-semibold bg-white border border-gray-200 text-gray-600 hover:bg-gray-50 transition-colors">
//             <RotateCcw size={13} /> Clear
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// /**
//  * The card every master-file grid sits in.
//  *
//  * Same shell as the payroll tables (components/Table/Table.jsx): white card,
//  * gray-200 border, a light title strip with the record count on the right, and
//  * a scroll area rather than a fixed short box. Restyling this one component
//  * moves every master-file grid at once.
//  */
// function MFGridSection({ title, count, children }) {
//   return (
//     <div className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
//       <div className="px-5 py-3.5 border-b border-gray-200 flex items-center justify-between gap-3">
//         <h3 className="text-sm font-semibold text-gray-900">{title}</h3>
//         {count !== undefined && count !== null && (
//           <span className="text-xs text-gray-500">
//             {count === 1 ? '1 record' : `${count} records`}
//           </span>
//         )}
//       </div>
//       <div className="overflow-auto max-h-[calc(100vh-380px)] min-h-[240px]">{children}</div>
//     </div>
//   );
// }

// /* Row / cell classes shared by every master-file grid, so one change here is
//    one change everywhere. They mirror the payroll table exactly. */
// const MF_TH   = 'px-4 py-3 text-left text-[12px] font-semibold text-gray-500 whitespace-nowrap bg-gray-50';
// const MF_ROW  = 'border-b border-gray-100 last:border-0 cursor-pointer transition-colors';
// const MF_ROW_IDLE = 'hover:bg-gray-50';
// const MF_ROW_SEL  = 'bg-primary-50';

// function pickField(row, keys, fallback = '') {
//   for (const k of keys) {
//     if (row?.[k] !== undefined && row?.[k] !== null) return row[k];
//   }
//   return fallback;
// }

// // ─── Seed data ────────────────────────────────────────────────────────────────
// const SEED_DESIGNATIONS = [
//   { code: '181', description: 'TECHNICAL SALES & MARKETING MANAGER', abbr: 'TECH. SALES & MARKE…', type: 'Executive', status: 'Active' },
//   { code: '176', description: 'ACCOUNTANT', abbr: 'ACCOUNTANT', type: 'Executive', status: 'Active' },
//   { code: '182', description: 'ACCOUNTS ASSISTANT', abbr: 'ACC. ASST.', type: 'Non Executive', status: 'Active' },
//   { code: '869', description: 'ACCOUNTS CLERK', abbr: 'AC', type: 'Non Executive', status: 'Active' },
//   { code: '854', description: 'ACCOUNTS EXECUTIVE', abbr: 'AE', type: 'Executive', status: 'Active' },
//   { code: '114', description: 'ACTING GENERAL MANAGER', abbr: 'ACT. GM.', type: 'Executive', status: 'Active' },
//   { code: '023', description: 'ADMINISTRATIVE ASSISTANT', abbr: 'A A', type: 'Non Executive', status: 'Active' },
//   { code: '019', description: 'ASSISTANT ELECTRICAL ENGINEER', abbr: 'ASST. E. ENG.', type: 'Executive', status: 'Active' },
//   { code: '172', description: 'ASSISTANT ENGINEER (CIVIL)', abbr: 'ASST. ENG. (CIVIL)', type: 'Executive', status: 'Active' },
// ];
// const SEED_EDUCATION = [
//   { code: '1', country: 'SRI LANKA', description: 'Below Grade V', conductedBy: '', status: 'Active' },
//   { code: '3', country: 'SRI LANKA', description: 'Upto GCE(O/L) /SSC/ NCGE', conductedBy: '', status: 'Active' },
//   { code: '5', country: 'SRI LANKA', description: 'Passed GCE(O/L) /SSC / NCGE', conductedBy: '', status: 'Active' },
//   { code: '7', country: 'SRI LANKA', description: 'Passed GCE(A/L)', conductedBy: '', status: 'Active' },
//   { code: '11', country: 'SRI LANKA', description: 'B.Sc.Eng.(Hons.)', conductedBy: '', status: 'Active' },
//   { code: '13', country: 'SRI LANKA', description: 'M.Sc.', conductedBy: '', status: 'Active' },
//   { code: '14', country: 'SRI LANKA', description: 'B.Sc.', conductedBy: '', status: 'Active' },
//   { code: '19', country: 'SRI LANKA', description: 'B.Com', conductedBy: '', status: 'Active' },
//   { code: '21', country: 'SRI LANKA', description: 'DIPLOMA IN QUANTITY SURVEYING', conductedBy: 'NAITA', status: 'Active' },
// ];
// const SEED_PROFESSIONAL = [
//   { code: '1', country: 'SRI LANKA', description: 'HIGHER DIPLOMA', instituteName: '', duration: '', status: 'Active' },
//   { code: '3', country: 'SRI LANKA', description: 'HONORS DEGREE', instituteName: '', duration: '', status: 'Active' },
//   { code: '4', country: 'SRI LANKA', description: 'M.Sc.', instituteName: '', duration: '', status: 'Active' },
//   { code: '9', country: 'SRI LANKA', description: 'NATIONAL DIPLOMA IN TECHNOLOGY (N.D.T)', instituteName: '', duration: '', status: 'Active' },
//   { code: '22', country: 'SRI LANKA', description: 'DIPLOMA IN ENGINEERING', instituteName: '', duration: '', status: 'Active' },
// ];
// const SEED_DIVISIONS = [
//   { code: 'MAIN', description: 'Main Division', effectiveDate: '2010-01-01', status: 'Active', inactiveDate: '' },
//   { code: 'ENG', description: 'Engineering Division', effectiveDate: '2010-01-01', status: 'Active', inactiveDate: '' },
//   { code: 'FIN', description: 'Finance Division', effectiveDate: '2010-01-01', status: 'Active', inactiveDate: '' },
//   { code: 'OPS', description: 'Operations Division', effectiveDate: '2010-01-01', status: 'Active', inactiveDate: '' },
// ];
// const SEED_DEPARTMENTS = [
//   { divCode: 'ENG', code: 'CIVIL', description: 'Civil Engineering', effectiveDate: '2010-01-01', status: 'Active', inactiveDate: '' },
//   { divCode: 'ENG', code: 'MECH', description: 'Mechanical Engineering', effectiveDate: '2010-01-01', status: 'Active', inactiveDate: '' },
//   { divCode: 'ENG', code: 'ELEC', description: 'Electrical Engineering', effectiveDate: '2010-01-01', status: 'Active', inactiveDate: '' },
//   { divCode: 'FIN', code: 'ACC', description: 'Accounts', effectiveDate: '2010-01-01', status: 'Active', inactiveDate: '' },
//   { divCode: 'OPS', code: 'HR', description: 'Human Resources', effectiveDate: '2010-01-01', status: 'Active', inactiveDate: '' },
// ];
// const SEED_LOCATIONS = [
//   { divCode: 'ENG', deptCode: 'CIVIL', code: 'HO', description: 'Head Office', effectiveDate: '2010-01-01', status: 'Active', inactiveDate: '' },
//   { divCode: 'ENG', deptCode: 'MECH', code: 'WK1', description: 'Workshop 1 - Colombo', effectiveDate: '2010-01-01', status: 'Active', inactiveDate: '' },
//   { divCode: 'OPS', deptCode: 'HR', code: 'HR-HO', description: 'HR Head Office', effectiveDate: '2010-01-01', status: 'Active', inactiveDate: '' },
// ];
// const SEED_SHIFTS = [
//   { code: 'DAY', description: 'Day Shift', type: 'Normal', timeIn: '08:00', timeOut: '17:00', status: 'Active' },
//   { code: 'NIGHT', description: 'Night Shift', type: 'Rotating', timeIn: '20:00', timeOut: '06:00', status: 'Active' },
//   { code: 'GENERAL', description: 'General Shift', type: 'Normal', timeIn: '08:30', timeOut: '17:30', status: 'Active' },
// ];
// const SEED_PROVINCES = [
//   { code: 'WP', name: 'Western Province', status: 'Active' },
//   { code: 'CP', name: 'Central Province', status: 'Active' },
//   { code: 'SP', name: 'Southern Province', status: 'Active' },
//   { code: 'NP', name: 'Northern Province', status: 'Active' },
//   { code: 'EP', name: 'Eastern Province', status: 'Active' },
//   { code: 'NWP', name: 'North Western Province', status: 'Active' },
// ];
// const SEED_DISTRICTS = [
//   { provCode: 'WP', provName: 'Western Province', code: 'CMB', name: 'Colombo', status: 'Active' },
//   { provCode: 'WP', provName: 'Western Province', code: 'GAM', name: 'Gampaha', status: 'Active' },
//   { provCode: 'CP', provName: 'Central Province', code: 'KDY', name: 'Kandy', status: 'Active' },
//   { provCode: 'SP', provName: 'Southern Province', code: 'GLE', name: 'Galle', status: 'Active' },
// ];
// const SEED_ELECTORATES = [
//   { provCode: 'WP', distCode: 'CMB', code: '134', name: 'Colombo Central', status: 'Active' },
//   { provCode: 'WP', distCode: 'CMB', code: '135', name: 'Colombo East', status: 'Active' },
//   { provCode: 'WP', distCode: 'GAM', code: '140', name: 'Gampaha', status: 'Active' },
// ];
// const SEED_POLICE_STATIONS = [
//   { code: '1', electorateCode: '134', name: 'AHANGAMA', status: 'Active' },
//   { code: '2', electorateCode: '134', name: 'KADUWELA', status: 'Active' },
//   { code: '3', electorateCode: '134', name: 'ATURUGIRIYA', status: 'Active' },
//   { code: '4', electorateCode: '134', name: 'BORELLA', status: 'Active' },
//   { code: '5', electorateCode: '134', name: 'DEHIWALA', status: 'Active' },
// ];
// const SEED_CALENDAR = [
//   { date: '2025-01-14', type: 'Mercantile Holiday', hours: 0, description: 'Thai - Pongal Day' },
//   { date: '2025-04-13', type: 'Mercantile Holiday', hours: 0, description: 'Sinhala New Year' },
//   { date: '2025-04-14', type: 'Mercantile Holiday', hours: 0, description: 'Sinhala New Year' },
//   { date: '2025-05-01', type: 'Mercantile Holiday', hours: 0, description: 'May Day' },
//   { date: '2025-12-25', type: 'Mercantile Holiday', hours: 0, description: 'Christmas Day' },
//   { date: '2026-01-14', type: 'Mercantile Holiday', hours: 0, description: 'Thai - Pongal Day' },
//   { date: '2026-04-13', type: 'Mercantile Holiday', hours: 0, description: 'Sinhala New Year' },
//   { date: '2026-04-14', type: 'Mercantile Holiday', hours: 0, description: 'Sinhala New Year' },
//   { date: '2026-05-01', type: 'Mercantile Holiday', hours: 0, description: 'May Day' },
//   { date: '2026-12-25', type: 'Mercantile Holiday', hours: 0, description: 'Christmas Day' },
// ];

// // ─── MF Tab definitions ───────────────────────────────────────────────────────
// const MF_TABS = [
//   { key: 'overview',     label: 'Overview',                      icon: BarChart2 },
//   { key: 'department',  label: 'Department Details',           icon: Tag },
//   { key: 'location',    label: 'Location Details',           icon: BookOpen },
//   { key: 'designation', label: 'Designation Details',          icon: Briefcase },
//   { key: 'emptype',    label: 'Employment Types',               icon: Building2 },
//   { key: 'grade',     label: 'Grade Details', icon: MapPin },
//   { key: 'shift',        label: 'Shift Details',                 icon: Clock },
//   { key: 'bank',       label: 'Bank Details',        icon: Shield },
//   { key: 'bankBranch',     label: 'Bank Branch Details',                      icon: Calendar },
// ];

// export const CODE_PREFIXES = {
//   DEPARTMENT: 'D',
//   LOCATION: 'L',
//   DESIGNATION: 'DS',
//   EMPLOYMENT_TYPE: 'E',
//   GRADE: 'G',
//   SHIFT: 'S',
//   BANK: 'B',
//   BANK_BRANCH: 'BR',
// };

// export const generateCode = (existingCodes = [], prefix = '', padding = 3) => {
//   const normalizedPrefix = String(prefix).toUpperCase();

//   const numbers = existingCodes.map(code => {
//     const value = String(code || '').trim().toUpperCase();

//     if (!value.startsWith(normalizedPrefix)) {
//       return null;
//     }

//     const numberPart = value.slice(normalizedPrefix.length);

//     if (!/^\d+$/.test(numberPart)) {
//       return null;
//     }

//     return parseInt(numberPart, 10);
//   })
//   .filter(Number.isFinite);

//   const nextNumber = numbers.length ? Math.max(...numbers) + 1 : 1;

//   return `${normalizedPrefix}${String(nextNumber).padStart(padding, '0')}`
// }

// // ─── MF Section: Overview ─────────────────────────────────────────────────────
// function MFOverview({ setMfTab }) {
//   const dispatch = useDispatch();

//   const { departments = [] } = useSelector(s => s.departmentSlice) || {};
//   const { locations = [] } = useSelector(s => s.locationSlice) || {};
//   const { designations = [] } = useSelector(s => s.designationSlice) || {};
//   const { categories = [] } = useSelector(s => s.employeeCategorySlice) || {};
//   const { grades = [] } = useSelector(s => s.gradeSlice) || {};
//   const { shifts = [] } = useSelector(s => s.shiftSlice) || {};
//   const { banks = [] } = useSelector(s => s.bankSlice) || {};
//   const { bankBranches = [] } = useSelector(s => s.bankBranchSlice) || {};

//   useEffect(() => {
//     dispatch(getDepartmentList());
//     dispatch(getLocationList());
//     dispatch(getDesignationList());
//     dispatch(getEmployeeCategoryList());
//     dispatch(getGradeList());
//     dispatch(getShiftList());
//     dispatch(getBankList());
//     dispatch(getBankBranchList());
//   }, [dispatch]);

//   const cards = [
//     { key: 'department', label: 'Department Details', icon: BookOpen, count: departments.length, color: 'bg-blue-50 text-blue-600', desc: 'Organizational departments' },
//     { key: 'location', label: 'Location Details', icon: Briefcase, count: locations.length, color: 'bg-purple-50 text-purple-600', desc: 'Work locations and sites' },
//     { key: 'designation', label: 'Designation Details', icon: Tag, count: designations.length, color: 'bg-primary-50 text-primary-600', desc: 'Job titles, abbreviations & types' },
//     { key: 'emptype', label: 'Employment Types', icon: Building2, count: categories.length + SEED_DEPARTMENTS.length, color: 'bg-orange-50 text-orange-600', desc: 'Employment categories' },
//     { key: 'grade', label: 'Grade Details', icon: MapPin, count: grades.length, color: 'bg-teal-50 text-teal-600', desc: 'Salary grade tiers' },
//     { key: 'shift', label: 'Shift Details', icon: Clock, count: shifts.length, color: 'bg-sky-50 text-sky-600', desc: 'Work shift configurations' },
//     { key: 'bank', label: 'Bank Details', icon: Shield, count: banks.length, color: 'bg-red-50 text-red-600', desc: 'Registered banks' },
//     { key: 'bankBranch', label: 'Bank Branch Details', icon: Calendar, count: bankBranches.length, color: 'bg-emerald-50 text-emerald-600', desc: 'Registered bank branches' },
//   ];
//   const total = cards.reduce((a, c) => a + c.count, 0);
//   return (
//     <div>
//       <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-6">
//         <StatCard label="Total Records" value={total} icon={Database} color="gold" />
//         <StatCard label="Designations" value={designations.length} icon={Tag} color="blue" />
//         <StatCard label="Registered Banks" value={banks.length} icon={Shield} color="green" />
//         <StatCard label="Bank Branches" value={bankBranches.length} icon={Building2} color="purple" />
//       </div>
//       <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-4">
//         {cards.map(c => (
//           <button key={c.key} onClick={() => setMfTab(c.key)}
//             className="bg-white border border-surface-100 rounded-xl p-5 text-left hover:border-primary-400 hover:shadow-md transition-all group">
//             <div className={`w-10 h-10 rounded-lg flex items-center justify-center mb-3 ${c.color}`}><c.icon size={20} /></div>
//             <p className="font-semibold text-surface-800 text-sm">{c.label}</p>
//             <p className="text-xs text-surface-400 mt-0.5 mb-2">{c.desc}</p>
//             <div className="flex items-center justify-between">
//               <span className="text-xs font-bold text-primary-600">{c.count} records</span>
//               <ChevronRight size={14} className="text-surface-300 group-hover:text-primary-400 transition-colors" />
//             </div>
//           </button>
//         ))}
//       </div>
//     </div>
//   );
// }

// // ─── MF Section: Designation ──────────────────────────────────────────────────
// // function MFDesignation() {
// //   const [rows, setRows] = useState(SEED_DESIGNATIONS);
// //   const [search, setSearch] = useState('');
// //   const [form, setForm] = useState({ code: '', description: '', abbr: '', type: 'Non Executive', status: 'Active' });
// //   const [saved, setSaved] = useState(false);
// //   const filtered = rows.filter(r => r.description.toLowerCase().includes(search.toLowerCase()) || r.code.includes(search));
// //   const handleSave = () => {
// //     if (!form.code || !form.description) return;
// //     setRows(prev => { const idx = prev.findIndex(r => r.code === form.code); if (idx >= 0) { const n = [...prev]; n[idx] = { ...form }; return n; } return [...prev, { ...form }]; });
// //     setSaved(true); setTimeout(() => setSaved(false), 1500);
// //   };
// //   return (
// //     <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
// //       <div className="lg:col-span-2 space-y-3">
// //         <div className="relative"><Search size={12} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" /><input className="h-9 bg-white border border-gray-200 rounded-lg text-xs pl-8 pr-3 w-full outline-none text-gray-700 focus:border-primary-500" placeholder="Search designations…" value={search} onChange={e => setSearch(e.target.value)} /></div>
// //         <MFGridSection title="Designation Details">
// //           <table className="w-full text-[13px]">
// //             <thead><tr className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">{['Code','Description','Abbreviation','Type','Status'].map(h => <th key={h} className={MF_TH}>{h}</th>)}</tr></thead>
// //             <tbody>
// //               {filtered.map((r, i) => (
// //                 <tr key={r.code} onClick={() => setForm({ code: r.code, description: r.description, abbr: r.abbr, type: r.type, status: r.status })}
// //                   className={`${MF_ROW} ${MF_ROW_IDLE} ${i === 0 ? 'bg-primary-50/50' : ''}`}>
// //                   <td className="px-4 py-3 font-mono text-gray-900 font-semibold">{r.code}</td>
// //                   <td className="px-4 py-3 text-gray-900 font-medium max-w-xs truncate">{r.description}</td>
// //                   <td className="px-4 py-3 text-gray-600 max-w-[120px] truncate">{r.abbr}</td>
// //                   <td className="px-4 py-3"><span className={`px-2 py-0.5 rounded text-[10px] font-medium ${r.type === 'Executive' ? 'bg-purple-100 text-purple-700' : 'bg-sky-100 text-sky-700'}`}>{r.type}</span></td>
// //                   <td className="px-4 py-3"><StatusPill label={r.status} /></td>
// //                 </tr>
// //               ))}
// //             </tbody>
// //           </table>
// //         </MFGridSection>
// //       </div>
// //       <MFEntryPanel title="Designation Entry" onSave={handleSave} onClear={() => setForm({ code: '', description: '', abbr: '', type: 'Non Executive', status: 'Active' })} saved={saved}>
// //         <div><MFLabel req>Code</MFLabel><input className={MF_INP} value={form.code} onChange={e => setForm(f => ({ ...f, code: e.target.value }))} /></div>
// //         <div><MFLabel req>Description</MFLabel><input className={MF_INP} value={form.description} onChange={e => setForm(f => ({ ...f, description: e.target.value }))} /></div>
// //         <div><MFLabel>Abbreviation</MFLabel><input className={MF_INP} value={form.abbr} onChange={e => setForm(f => ({ ...f, abbr: e.target.value }))} /></div>
// //         <div><MFLabel>Type</MFLabel><select className={MF_SEL} value={form.type} onChange={e => setForm(f => ({ ...f, type: e.target.value }))}><option>Executive</option><option>Non Executive</option></select></div>
// //         <div><MFLabel>Status</MFLabel><select className={MF_SEL} value={form.status} onChange={e => setForm(f => ({ ...f, status: e.target.value }))}><option>Active</option><option>Inactive</option></select></div>
// //       </MFEntryPanel>
// //     </div>
// //   );
// // }

// // ─── MF Section: Department ───────────────────────────────────────────────────
// const EMPTY_DEPARTMENT_FORM = {
//   code: '',
//   name: '',
//   description: '',
//   remarks: ''
// };

// function MFDepartment() {
//   const dispatch = useDispatch();
//   const departmentState = useSelector(s => s.departmentSlice || s.department) || {};
//   const { departments = [], list = [], loading = false, saving = false, error = null, success = false } = departmentState;

//   const [search, setSearch] = useState('');
//   const [form, setForm] = useState(EMPTY_DEPARTMENT_FORM);
//   const [editingId, setEditingId] = useState(null);

//   useEffect(() => {
//     dispatch(getDepartmentList());
//   }, [dispatch]);

//   useEffect(() => {
//     if (success) {
//       dispatch(getDepartmentList());
//       setForm(EMPTY_DEPARTMENT_FORM);
//       setEditingId(null);
//       const t = setTimeout(() => dispatch(clearDepartmentSuccess()), 1500);
//       return () => clearTimeout(t);
//     }
//   }, [success, dispatch]);

//   useEffect(() => {
//     if (editingId) return;

//     const existingCodes = (departments || []).map(r =>
//       pickField(r, [
//         'DepartmentCode',
//         'departmentCode',
//         'HDD_DEPARTMENT_CODE'
//       ])
//     );

//     setForm(f => ({
//       ...f,
//       code: generateCode(
//         existingCodes,
//         CODE_PREFIXES.DEPARTMENT,
//         2
//       )
//     })); 
//   }, [departments, editingId]);

//   const pickField = (obj, keys, fallbackPattern) => {
//     if (!obj || typeof obj !== 'object') return '';
//     for (const k of keys) {
//       if (obj[k] !== undefined && obj[k] !== null && String(obj[k]).trim() !== '') {
//         return String(obj[k]).trim();
//       }
//     }
//     const objKeys = Object.keys(obj);
//     for (const targetKey of keys) {
//       const found = objKeys.find((k) => k.toLowerCase() === targetKey.toLowerCase());
//       if (found && obj[found] !== undefined && obj[found] !== null && String(obj[found]).trim() !== '') {
//         return String(obj[found]).trim();
//       }
//     }
//     if (fallbackPattern) {
//       const found = objKeys.find((k) => fallbackPattern.test(k));
//       if (found && obj[found] !== undefined && obj[found] !== null && String(obj[found]).trim() !== '') {
//         return String(obj[found]).trim();
//       }
//     }
//     return '';
//   };

//   const rawList = Array.isArray(departments) && departments.length ? departments : Array.isArray(list) && list.length ? list : [];
//   const rows = rawList.map(r => {
//     const id = pickField(r, [
//       'HDD_DEPARTMENT_ID', 'HDD_DEP_ID', 'DepartmentId', 'departmentId', 'id', 'ID'
//     ], /department_id|dep_id|^id$/i);

//     const code = pickField(r, [
//       'HDD_DEPARTMENT_CODE', 'HDD_DEP_CODE', 'DepartmentCode', 'departmentCode',
//       'deptCode', 'dept_code', 'HDD_DEPARTMENT_ID', 'HDD_DEP_ID', 'HLD_DEP_CODE',
//       'DEP_CODE', 'dep_code', 'DepCode', 'Code', 'code', 'p_dep_code', 'p_department_code', 'id'
//     ], /code/i);

//     const name = pickField(r, [
//       'HDD_DEP_DESC', 'HDD_DEPARTMENT_NAME', 'HDD_DEP_NAME', 'DepartmentName',
//       'departmentName', 'deptName', 'dept_name', 'HLD_DEP_DESC', 'DEP_DESC',
//       'dep_desc', 'DepDesc', 'Description', 'description', 'Name', 'name',
//       'p_dep_desc', 'p_department_name'
//     ], /name|desc/i);

//     const description = pickField(r, [
//       'Description', 'description', 'HDD_DEP_DESC', 'HDD_DEPARTMENT_NAME', 'HLD_DEP_DESC', 'remarks', 'Remarks'
//     ]);

//     const status = (r.IsActive !== false && r.HLD_CURRENT_STATUS !== 'I' && r.status !== 'Inactive' && r.Status !== 'Inactive') ? 'Active' : 'Inactive';
//     const remarks = pickField(r, ['Remarks', 'remarks', 'HDD_REMARKS']);

//     return {
//       id: id || code || name,
//       HDD_DEPARTMENT_ID: id || code || name,
//       code: code || name || '—',
//       name: name || code || '—',
//       description,
//       status,
//       remarks,
//       raw: r,
//     };
//   });

//   const filtered = rows.filter(r =>
//     (r.name || '').toLowerCase().includes(search.toLowerCase()) ||
//     (r.code || '').toLowerCase().includes(search.toLowerCase()) ||
//     (r.description || '').toLowerCase().includes(search.toLowerCase())
//   );

//   const handleSelect = (r) => {
//     setEditingId(r.HDD_DEPARTMENT_ID || r.id || r.code);
//     setForm({ code: r.code, name: r.name, description: r.description, remarks: r.remarks });
//   };

//   const handleClear = () => {
//     setEditingId(null);
//     setForm(EMPTY_DEPARTMENT_FORM);
//     dispatch(clearDepartmentError());
//   };

//   const handleSave = () => {
//     if (!form.code || !form.name) return;
//     const serviceNo = getLoggedInServiceNo() || "3000807";

//     if (editingId) {
//       dispatch(updateDepartment({
//         p_departmentId: editingId,
//         p_updatedBy: serviceNo,
//         p_departmentCode: form.code,
//         p_departmentName: form.name,
//         p_description: form.description || "",
//         p_isActive: 1,
//         p_remarks: form.remarks || "",
//       }));
//     } else {
//       dispatch(addDepartment({
//         p_createdBy: serviceNo,
//         p_departmentCode: form.code,
//         p_departmentName: form.name,
//         p_description: form.description || "",
//         p_isActive: 1,
//         p_remarks: form.remarks || "",
//       }));
//     }
//   };

//   return (
//     <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
//       <div className="lg:col-span-2 space-y-3">
//         <div className="relative">
//           <Search size={12} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
//           <input
//             className="h-9 bg-white border border-gray-200 rounded-lg text-xs pl-8 pr-3 w-full outline-none text-gray-700 focus:border-primary-500"
//             placeholder="Search departments…" value={search} onChange={e => setSearch(e.target.value)}
//           />
//         </div>
//         <MFGridSection title="Department Details" count={filtered.length}>
//           {loading ? (
//             <div className="py-20 flex items-center justify-center gap-2 text-sm text-gray-400">
//               <Loader2 size={14} className="animate-spin" /> Loading departments...
//             </div>
//           ) : error ? (
//             <div className="py-20 flex items-center justify-center gap-2 text-sm text-red-600">
//               <AlertCircle size={13} className="shrink-0" /> {error}
//             </div>
//           ) : filtered.length === 0 ? (
//             <div className="flex flex-col items-center justify-center py-20 text-center text-gray-400">
//               <Tag size={24} className="text-gray-300 mb-2" />
//               <p className="text-sm text-gray-400">No departments yet</p>
//             </div>
//           ) : (
//             <table className="w-full text-[13px]">
//               <thead>
//                 <tr className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">
//                   {['Code', 'Name', 'Description', 'Remarks', 'Status'].map(h => (
//                     <th key={h} className={MF_TH}>{h}</th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {filtered.map((r) => (
//                   <tr key={r.id || r.code} onClick={() => handleSelect(r)}
//                     className={`${MF_ROW} ${MF_ROW_IDLE} ${editingId === (r.id || r.code) ? MF_ROW_SEL : ''}`}>
//                     <td className="px-4 py-3 font-mono text-gray-900 font-semibold">{r.code}</td>
//                     <td className="px-4 py-3 text-gray-900 font-medium max-w-xs truncate">{r.name}</td>
//                     <td className="px-4 py-3 text-gray-600 max-w-[120px] truncate">{r.description}</td>
//                     <td className="px-4 py-3 text-gray-600 max-w-[120px] truncate">{r.remarks || '—'}</td>
//                     <td className="px-4 py-3"><StatusPill label={r.status} /></td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           )}
//         </MFGridSection>
//       </div>

//       <MFEntryPanel
//         title={editingId ? 'Edit Department' : 'Department Entry'}
//         onSave={handleSave}
//         onClear={handleClear}
//         saved={success}
//       >
//         <div>
//           <MFLabel req>Code</MFLabel>
//           <input className={`${MF_INP} cursor-not-allowed bg-gray-200`} value={form.code} disabled readOnly
//             onChange={e => setForm(f => ({ ...f, code: e.target.value }))} />
//           {editingId && <p className="text-[10px] text-surface-400 mt-0.5">Code can't be changed once created</p>}
//         </div>
//         <div>
//           <MFLabel req>Name</MFLabel>
//           <input className={MF_INP} value={form.name}
//             onChange={e => setForm(f => ({ ...f, name: e.target.value }))} />
//         </div>
//         <div>
//           <MFLabel>Description</MFLabel>
//           <input className={MF_INP} value={form.description}
//             onChange={e => setForm(f => ({ ...f, description: e.target.value }))} />
//         </div>
//         <div>
//           <MFLabel>Remarks</MFLabel>
//           <input className={MF_INP} value={form.remarks}
//             onChange={e => setForm(f => ({ ...f, remarks: e.target.value }))} />
//         </div>
//         {saving && <p className="text-[10px] text-primary-500">Saving...</p>}
//         {error && <p className="text-[10px] text-red-500">{error}</p>}
//       </MFEntryPanel>
//     </div>
//   );
// }

// // ─── MF Section: Location ─────────────────────────────────────────────────────
// const EMPTY_LOCATION_FORM = {
//   code: '',
//   name: '',
//   description: '',
//   remarks: ''
// };

// function MFLocation() {
//   const dispatch = useDispatch();
//   const locationState = useSelector(s => s.locationSlice || s.location) || {};
//   const { locations = [], list = [], loading = false, saving = false, error = null, success = false } = locationState;

//   const [search, setSearch] = useState('');
//   const [form, setForm] = useState(EMPTY_LOCATION_FORM);
//   const [editingId, setEditingId] = useState(null);

//   useEffect(() => {
//     dispatch(getLocationList());
//   }, [dispatch]);

//   useEffect(() => {
//     if (success) {
//       dispatch(getLocationList());
//       setForm(EMPTY_LOCATION_FORM);
//       setEditingId(null);
//       const t = setTimeout(() => dispatch(clearLocationSuccess()), 1500);
//       return () => clearTimeout(t);
//     }
//   }, [success, dispatch]);

//   useEffect(() => {
//     if (editingId) return;

//     const existingCodes = (locations || []).map(r =>
//       pickField(r, [
//         'LocationCode',
//         'locationCode',
//         'HLD_LOCATION_CODE'
//       ])
//     );

//     setForm(f => ({
//       ...f,
//       code: generateCode(
//         existingCodes,
//         CODE_PREFIXES.LOCATION
//       )
//     })); 
//   }, [locations, editingId]);

//   const pickField = (obj, keys, fallbackPattern) => {
//     if (!obj || typeof obj !== 'object') return '';
//     for (const k of keys) {
//       if (obj[k] !== undefined && obj[k] !== null && String(obj[k]).trim() !== '') {
//         return String(obj[k]).trim();
//       }
//     }
//     const objKeys = Object.keys(obj);
//     for (const targetKey of keys) {
//       const found = objKeys.find((k) => k.toLowerCase() === targetKey.toLowerCase());
//       if (found && obj[found] !== undefined && obj[found] !== null && String(obj[found]).trim() !== '') {
//         return String(obj[found]).trim();
//       }
//     }
//     if (fallbackPattern) {
//       const found = objKeys.find((k) => fallbackPattern.test(k));
//       if (found && obj[found] !== undefined && obj[found] !== null && String(obj[found]).trim() !== '') {
//         return String(obj[found]).trim();
//       }
//     }
//     return '';
//   };

//   const rawList = Array.isArray(locations) && locations.length ? locations : Array.isArray(list) && list.length ? list : [];
//   const rows = rawList.map(r => {
//     const id = pickField(r, [
//       'HDD_LOCATION_ID', 'HDD_LOC_ID', 'LocationId', 'locationId', 'id', 'ID'
//     ], /location_id|loc_id|^id$/i);

//     const code = pickField(r, [
//       'HDD_LOCATION_CODE', 'HDD_LOC_CODE', 'LocationCode', 'locationCode',
//       'HLD_LOC_CODE', 'LOC_CODE', 'loc_code', 'LocCode', 'Code', 'code', 'id',
//       'p_loc_code', 'p_location_code'
//     ], /code/i);

//     const name = pickField(r, [
//       'HDD_LOC_DESC', 'HDD_LOCATION_NAME', 'HDD_LOC_NAME', 'LocationName',
//       'locationName', 'HLD_LOC_DESC', 'LOC_DESC', 'loc_desc', 'LocDesc',
//       'Description', 'description', 'Name', 'name', 'p_loc_desc', 'p_location_name'
//     ], /name|desc/i);

//     const description = pickField(r, [
//       'Description', 'description', 'Address', 'address', 'HDD_ADDRESS', 'HLD_ADDRESS', 'HDD_LOC_DESC', 'remarks', 'Remarks'
//     ]);

//     const status = (r.IsActive !== false && r.HLD_CURRENT_STATUS !== 'I' && r.status !== 'Inactive' && r.Status !== 'Inactive') ? 'Active' : 'Inactive';
//     const remarks = pickField(r, ['Remarks', 'remarks', 'HDD_REMARKS', 'HLD_REMARKS']);

//     return {
//       id: id || code || name,
//       HDD_LOCATION_ID: id || code || name,
//       code: code || name || '—',
//       name: name || code || '—',
//       description,
//       status,
//       remarks,
//       raw: r,
//     };
//   });

//   const filtered = rows.filter(r =>
//     (r.name || '').toLowerCase().includes(search.toLowerCase()) ||
//     (r.code || '').toLowerCase().includes(search.toLowerCase()) ||
//     (r.description || '').toLowerCase().includes(search.toLowerCase())
//   );

//   const handleSelect = (r) => {
//     setEditingId(r.HDD_LOCATION_ID || r.id || r.code);
//     setForm({ code: r.code, name: r.name, description: r.description, remarks: r.remarks });
//   };

//   const handleClear = () => {
//     setEditingId(null);
//     setForm(EMPTY_LOCATION_FORM);
//     dispatch(clearLocationError());
//   };

//   const handleSave = () => {
//     if (!form.code || !form.name) return;
//     const serviceNo = getLoggedInServiceNo() || "3000807";

//     if (editingId) {
//       dispatch(updateLocation({
//         p_locationId: editingId,
//         p_updatedBy: serviceNo,
//         p_locationCode: form.code,
//         p_locationName: form.name,
//         p_address: form.description || "",
//         p_isActive: 1,
//         p_remarks: form.remarks || "",
//       }));
//     } else {
//       dispatch(addLocation({
//         p_createdBy: serviceNo,
//         p_locationCode: form.code,
//         p_locationName: form.name,
//         p_address: form.description || "",
//         p_isActive: 1,
//         p_remarks: form.remarks || "",
//       }));
//     }
//   };

//   return (
//     <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
//       <div className="lg:col-span-2 space-y-3">
//         <div className="relative">
//           <Search size={12} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
//           <input
//             className="h-9 bg-white border border-gray-200 rounded-lg text-xs pl-8 pr-3 w-full outline-none text-gray-700 focus:border-primary-500"
//             placeholder="Search locations…" value={search} onChange={e => setSearch(e.target.value)}
//           />
//         </div>
//         <MFGridSection title="Location Details" count={filtered.length}>
//           {loading ? (
//             <div className="py-20 flex items-center justify-center gap-2 text-sm text-gray-400">
//               <Loader2 size={14} className="animate-spin" /> Loading locations...
//             </div>
//           ) : error ? (
//             <div className="py-20 flex items-center justify-center gap-2 text-sm text-red-600">
//               <AlertCircle size={13} className="shrink-0" /> {error}
//             </div>
//           ) : filtered.length === 0 ? (
//             <div className="flex flex-col items-center justify-center py-20 text-center text-gray-400">
//               <Tag size={24} className="text-gray-300 mb-2" />
//               <p className="text-sm text-gray-400">No locations yet</p>
//             </div>
//           ) : (
//             <table className="w-full text-[13px]">
//               <thead>
//                 <tr className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">
//                   {['Code', 'Name', 'Description', 'Remarks', 'Status'].map(h => (
//                     <th key={h} className={MF_TH}>{h}</th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {filtered.map((r) => (
//                   <tr key={r.id || r.code} onClick={() => handleSelect(r)}
//                     className={`${MF_ROW} ${MF_ROW_IDLE} ${editingId === (r.id || r.code) ? MF_ROW_SEL : ''}`}>
//                     <td className="px-4 py-3 font-mono text-gray-900 font-semibold">{r.code}</td>
//                     <td className="px-4 py-3 text-gray-900 font-medium max-w-xs truncate">{r.name}</td>
//                     <td className="px-4 py-3 text-gray-600 max-w-[120px] truncate">{r.description}</td>
//                     <td className="px-4 py-3 text-gray-600 max-w-[120px] truncate">{r.remarks || '—'}</td>
//                     <td className="px-4 py-3"><StatusPill label={r.status} /></td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           )}
//         </MFGridSection>
//       </div>

//       <MFEntryPanel
//         title={editingId ? 'Edit Location' : 'Location Entry'}
//         onSave={handleSave}
//         onClear={handleClear}
//         saved={success}
//       >
//         <div>
//           <MFLabel req>Code</MFLabel>
//           <input className={`${MF_INP} bg-gray-200 cursor-not-allowed`} value={form.code} disabled readonly
//             onChange={e => setForm(f => ({ ...f, code: e.target.value }))} />
//           {editingId && <p className="text-[10px] text-surface-400 mt-0.5">Code can't be changed once created</p>}
//         </div>
//         <div>
//           <MFLabel req>Name</MFLabel>
//           <input className={MF_INP} value={form.name}
//             onChange={e => setForm(f => ({ ...f, name: e.target.value }))} />
//         </div>
//         <div>
//           <MFLabel>Description</MFLabel>
//           <input className={MF_INP} value={form.description}
//             onChange={e => setForm(f => ({ ...f, description: e.target.value }))} />
//         </div>
//         <div>
//           <MFLabel>Remarks</MFLabel>
//           <input className={MF_INP} value={form.remarks}
//             onChange={e => setForm(f => ({ ...f, remarks: e.target.value }))} />
//         </div>
//         {saving && <p className="text-[10px] text-primary-500">Saving...</p>}
//         {error && <p className="text-[10px] text-red-500">{error}</p>}
//       </MFEntryPanel>
//     </div>
//   );
// }

// const EMPTY_DESIGNATION_FORM = {
//   code: '',
//   name: '',
//   abbreviation: '',
//   remarks: ''
// };

// function MFDesignation() {
//   const dispatch = useDispatch();
//   const { designations, loading, saving, error, success } = useSelector(s => s.designationSlice);

//   const [search, setSearch] = useState('');
//   const [form, setForm] = useState(EMPTY_DESIGNATION_FORM);
//   const [editingId, setEditingId] = useState(null);

//   useEffect(() => {
//     dispatch(getDesignationList());
//   }, [dispatch]);

//   useEffect(() => {
//     if (editingId) return;

//     const existingCodes = (designations || []).map(r =>
//       pickField(r, [
//         'DesignationCode',
//         'designationCode',
//         'HED_DESIGNATION_CODE'
//       ])
//     );

//     setForm(f => ({
//       ...f,
//       code: generateCode(
//         existingCodes,
//         CODE_PREFIXES.DESIGNATION
//       )
//     }));
//   }, [designations, editingId]);

//   useEffect(() => {
//     if (success) {
//       dispatch(getDesignationList());
//       setForm(EMPTY_DESIGNATION_FORM);
//       setEditingId(null);
//       const t = setTimeout(() => dispatch(clearDesignationSuccess()), 1500);
//       return () => clearTimeout(t);
//     }
//   }, [success, dispatch]);

//   const rows = (designations || []).map(r => ({
//     id:           pickField(r, ['DesignationId', 'designationId', 'HED_DESIGNATION_ID']),
//     code:         pickField(r, ['DesignationCode', 'designationCode', 'HED_DESIGNATION_CODE']),
//     name:         pickField(r, ['DesignationName', 'designationName', 'HED_DESIGNATION_NAME']),
//     abbreviation: pickField(r, ['Abbreviation', 'abbreviation', 'HED_ABBRIVATION']),
//     remarks:      pickField(r, ['Remarks', 'remarks', 'HED_REMARKS']),
//   }));

//   const filtered = rows.filter(r =>
//     r.name.toLowerCase().includes(search.toLowerCase()) ||
//     r.code.toLowerCase().includes(search.toLowerCase())
//   );

//   const handleSelect = (r) => {
//     setEditingId(r.id);
//     setForm({ code: r.code, name: r.name, abbreviation: r.abbreviation, remarks: r.remarks });
//   };

//   const handleClear = () => {
//     setEditingId(null);
//     setForm(EMPTY_DESIGNATION_FORM);
//     dispatch(clearDesignationError());
//   };

//   const handleSave = () => {
//     if (!form.code || !form.name) return;
//     if (editingId) {
//       dispatch(updateDesignation({
//         p_designationId: editingId,
//         p_designationName: form.name,
//         p_remarks: form.remarks || '',
//         p_updatedBy: 'HR_ADMIN', // TODO: swap for the real logged-in user, same as p_created_by elsewhere
//       }));
//     } else {
//       dispatch(addDesignation({
//         p_designationCode: form.code,
//         p_designationName: form.name,
//         p_abbreviation: form.abbreviation || '',
//         p_createdBy: 'HR_ADMIN', // TODO: same as above
//         p_remarks: form.remarks || '',
//       }));
//     }
//   };

//   return (
//     <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
//       <div className="lg:col-span-2 space-y-3">
//         <div className="relative">
//           <Search size={12} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
//           <input
//             className="h-9 bg-white border border-gray-200 rounded-lg text-xs pl-8 pr-3 w-full outline-none text-gray-700 focus:border-primary-500"
//             placeholder="Search designations…" value={search} onChange={e => setSearch(e.target.value)}
//           />
//         </div>
//         <MFGridSection title="Designation Details" count={filtered.length}>
//           {loading ? (
//             <div className="py-20 flex items-center justify-center gap-2 text-sm text-gray-400">
//               <Loader2 size={14} className="animate-spin" /> Loading designations...
//             </div>
//           ) : error ? (
//             <div className="py-20 flex items-center justify-center gap-2 text-sm text-red-600">
//               <AlertCircle size={13} className="shrink-0" /> {error}
//             </div>
//           ) : filtered.length === 0 ? (
//             <div className="flex flex-col items-center justify-center py-20 text-center text-gray-400">
//               <Tag size={24} className="text-gray-300 mb-2" />
//               <p className="text-sm text-gray-400">No designations yet</p>
//             </div>
//           ) : (
//             <table className="w-full text-[13px]">
//               <thead>
//                 <tr className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">
//                   {['Code', 'Name', 'Abbreviation', 'Remarks'].map(h => (
//                     <th key={h} className={MF_TH}>{h}</th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {filtered.map((r) => (
//                   <tr key={r.id || r.code} onClick={() => handleSelect(r)}
//                     className={`${MF_ROW} ${MF_ROW_IDLE} ${editingId === r.id ? MF_ROW_SEL : ''}`}>
//                     <td className="px-4 py-3 font-mono text-gray-900 font-semibold">{r.code}</td>
//                     <td className="px-4 py-3 text-gray-900 font-medium max-w-xs truncate">{r.name}</td>
//                     <td className="px-4 py-3 text-gray-600 max-w-[120px] truncate">{r.abbreviation}</td>
//                     <td className="px-4 py-3 text-gray-600 max-w-[160px] truncate">{r.remarks}</td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           )}
//         </MFGridSection>
//       </div>

//       <MFEntryPanel
//         title={editingId ? 'Edit Designation' : 'Designation Entry'}
//         onSave={handleSave}
//         onClear={handleClear}
//         saved={success}
//       >
//         <div>
//           <MFLabel req>Code</MFLabel>
//           <input className={`${MF_INP} bg-gray-200 cursor-not-allowed`} value={form.code} disabled readOnly
//             onChange={e => setForm(f => ({ ...f, code: e.target.value }))} />
//           {editingId && <p className="text-[10px] text-surface-400 mt-0.5">Code can't be changed once created</p>}
//         </div>
//         <div>
//           <MFLabel req>Name</MFLabel>
//           <input className={MF_INP} value={form.name}
//             onChange={e => setForm(f => ({ ...f, name: e.target.value }))} />
//         </div>
//         <div>
//           <MFLabel>Abbreviation</MFLabel>
//           <input className={MF_INP} value={form.abbreviation} disabled={!!editingId}
//             onChange={e => setForm(f => ({ ...f, abbreviation: e.target.value }))} />
//           {editingId && <p className="text-[10px] text-surface-400 mt-0.5">Not editable via update — abbreviation is fixed after creation</p>}
//         </div>
//         <div>
//           <MFLabel>Remarks</MFLabel>
//           <input className={MF_INP} value={form.remarks}
//             onChange={e => setForm(f => ({ ...f, remarks: e.target.value }))} />
//         </div>
//         {saving && <p className="text-[10px] text-primary-500">Saving...</p>}
//         {error && <p className="text-[10px] text-red-500">{error}</p>}
//       </MFEntryPanel>
//     </div>
//   );
// }

// // ─── MF Section: Employment Types ─────────────────────────────────────────────
// const EMPTY_EMPLOYMENT_TYPE_FORM = {
//   code: '',
//   name: '',
//   remarks: ''
// };

// function MFEmploymentTypes() {
//   const dispatch = useDispatch();
//   const categoryState = useSelector(s => s.employeeCategorySlice || s.employeeCategory) || {};
//   const { categories = [], list = [], loading = false, saving = false, error = null, success = false } = categoryState;

//   const [search, setSearch] = useState('');
//   const [form, setForm] = useState(EMPTY_EMPLOYMENT_TYPE_FORM);
//   const [editingId, setEditingId] = useState(null);

//   useEffect(() => {
//     dispatch(getEmployeeCategoryList());
//   }, [dispatch]);

//   useEffect(() => {
//     if (success) {
//       dispatch(getEmployeeCategoryList());
//       setForm(EMPTY_EMPLOYMENT_TYPE_FORM);
//       setEditingId(null);
//       const t = setTimeout(() => dispatch(clearEmployeeCategorySuccess()), 1500);
//       return () => clearTimeout(t);
//     }
//   }, [success, dispatch]);

//   useEffect(() => {
//     if (editingId) return;

//     const existingCodes = (categories || []).map(r =>
//       pickField(r, [
//         'EmploymentCategoryId',
//         'employmentCategoryId',
//         'HEC_CATEGORY_CODE'
//       ])
//     );

//     setForm(f => ({
//       ...f,
//       code: generateCode(
//         existingCodes,
//         CODE_PREFIXES.EMPLOYMENT_TYPE
//       )
//     })); 
//   }, [categories, editingId]);

//   const rawList = Array.isArray(categories) && categories.length ? categories : Array.isArray(list) && list.length ? list : [];
//   const rows = rawList.map(r => {
//     const id = pickField(r, [
//       'HEC_EMPLOYMENT_CATEGORY_ID', 'HEC_CATEGORY_ID', 'CategoryId', 'categoryId', 'id', 'ID'
//     ]);
//     const code = pickField(r, [
//       'HEC_CATEGORY_CODE', 'HEC_CODE', 'CategoryCode', 'categoryCode',
//       'catCode', 'cat_code', 'Code', 'code', 'p_cat_code', 'p_category_code', 'id'
//     ]);
//     const name = pickField(r, [
//       'HEC_CATEGORY_NAME', 'HEC_CATEGORY_DESC', 'CategoryName', 'categoryName',
//       'catName', 'cat_name', 'Description', 'description', 'Name', 'name',
//       'p_cat_name', 'p_category_name'
//     ]);
//     const remarks = pickField(r, ['Remarks', 'remarks', 'HEC_REMARKS', 'Description', 'description']);
//     const status = (r.IsActive !== false && r.HEC_ACTIVE_STATUS !== 'I' && r.HEC_CURRENT_STATUS !== 'I' && r.status !== 'Inactive' && r.Status !== 'Inactive') ? 'Active' : 'Inactive';

//     return {
//       id: id || code || name,
//       code: code || name || '—',
//       name: name || code || '—',
//       status,
//       remarks,
//       raw: r,
//     };
//   });

//   const filtered = rows.filter(r =>
//     (r.name || '').toLowerCase().includes(search.toLowerCase()) ||
//     (r.code || '').toLowerCase().includes(search.toLowerCase()) ||
//     (r.remarks || '').toLowerCase().includes(search.toLowerCase())
//   );

//   const handleSelect = (r) => {
//     setEditingId(r.id || r.code);
//     setForm({ code: r.code, name: r.name, remarks: r.remarks });
//   };

//   const handleClear = () => {
//     setEditingId(null);
//     setForm(EMPTY_EMPLOYMENT_TYPE_FORM);
//     dispatch(clearEmployeeCategoryError());
//   };

//   const handleSave = () => {
//     if (!form.code || !form.name) return;
//     const serviceNo = getLoggedInServiceNo() || "3000807";

//     if (editingId) {
//       dispatch(updateEmployeeCategory({
//         p_categoryId: editingId,
//         p_updatedBy: serviceNo,
//         p_categoryCode: form.code,
//         p_categoryName: form.name,
//         p_isActive: 1,
//         p_remarks: form.remarks || "",
//       }));
//     } else {
//       dispatch(addEmployeeCategory({
//         p_createdBy: serviceNo,
//         p_categoryCode: form.code,
//         p_categoryName: form.name,
//         p_isActive: 1,
//         p_remarks: form.remarks || "",
//       }));
//     }
//   };

//   return (
//     <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
//       <div className="lg:col-span-2 space-y-3">
//         <div className="relative">
//           <Search size={12} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
//           <input
//             className="h-9 bg-white border border-gray-200 rounded-lg text-xs pl-8 pr-3 w-full outline-none text-gray-700 focus:border-primary-500"
//             placeholder="Search employment types…" value={search} onChange={e => setSearch(e.target.value)}
//           />
//         </div>
//         <MFGridSection title="Employment Types" count={filtered.length}>
//           {loading ? (
//             <div className="py-20 flex items-center justify-center gap-2 text-sm text-gray-400">
//               <Loader2 size={14} className="animate-spin" /> Loading employment types...
//             </div>
//           ) : error ? (
//             <div className="py-20 flex items-center justify-center gap-2 text-sm text-red-600">
//               <AlertCircle size={13} className="shrink-0" /> {error}
//             </div>
//           ) : filtered.length === 0 ? (
//             <div className="flex flex-col items-center justify-center py-20 text-center text-gray-400">
//               <Tag size={24} className="text-gray-300 mb-2" />
//               <p className="text-sm text-gray-400">No employment types yet</p>
//             </div>
//           ) : (
//             <table className="w-full text-[13px]">
//               <thead>
//                 <tr className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">
//                   {['Code', 'Name', 'Status', 'Remarks'].map(h => (
//                     <th key={h} className={MF_TH}>{h}</th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {filtered.map((r) => (
//                   <tr key={r.id || r.code} onClick={() => handleSelect(r)}
//                     className={`${MF_ROW} ${MF_ROW_IDLE} ${editingId === (r.id || r.code) ? MF_ROW_SEL : ''}`}>
//                     <td className="px-4 py-3 font-mono text-gray-900 font-semibold">{r.code}</td>
//                     <td className="px-4 py-3 text-gray-900 font-medium max-w-xs truncate">{r.name}</td>
//                     <td className="px-4 py-3"><StatusPill label={r.status} /></td>
//                     <td className="px-4 py-3 text-gray-600 max-w-[160px] truncate">{r.remarks}</td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           )}
//         </MFGridSection>
//       </div>

//       <MFEntryPanel
//         title={editingId ? 'Edit Employment Type' : 'Employment Type Entry'}
//         onSave={handleSave}
//         onClear={handleClear}
//         saved={success}
//       >
//         <div>
//           <MFLabel req>Category Code</MFLabel>
//           <input className={`${MF_INP} bg-gray-200 cursor-not-allowed`} value={form.code} disabled readOnly
//             onChange={e => setForm(f => ({ ...f, code: e.target.value }))} />
//           {editingId && <p className="text-[10px] text-surface-400 mt-0.5">Code can't be changed once created</p>}
//         </div>
//         <div>
//           <MFLabel req>Category Name</MFLabel>
//           <input className={MF_INP} value={form.name}
//             onChange={e => setForm(f => ({ ...f, name: e.target.value }))} />
//         </div>
//         <div>
//           <MFLabel>Remarks</MFLabel>
//           <input className={MF_INP} value={form.remarks}
//             onChange={e => setForm(f => ({ ...f, remarks: e.target.value }))} />
//         </div>
//         {saving && <p className="text-[10px] text-primary-500">Saving...</p>}
//         {error && <p className="text-[10px] text-red-500">{error}</p>}
//       </MFEntryPanel>
//     </div>
//   );
// }

// // ─── MF Section: Grade ────────────────────────────────────────────────────────
// const EMPTY_GRADE_FORM = {
//   code: '',
//   name: '',
//   minSalary: '',
//   maxSalary: '',
//   remarks: ''
// };

// function MFGrade() {
//   const dispatch = useDispatch();
//   const gradeState = useSelector(s => s.gradeSlice || s.grade) || {};
//   const { grades = [], list = [], loading = false, saving = false, error = null, success = false } = gradeState;

//   const [search, setSearch] = useState('');
//   const [form, setForm] = useState(EMPTY_GRADE_FORM);
//   const [editingId, setEditingId] = useState(null);

//   useEffect(() => {
//     dispatch(getGradeList());
//   }, [dispatch]);

//   useEffect(() => {
//     if (success) {
//       dispatch(getGradeList());
//       setForm(EMPTY_GRADE_FORM);
//       setEditingId(null);
//       const t = setTimeout(() => dispatch(clearGradeSuccess()), 1500);
//       return () => clearTimeout(t);
//     }
//   }, [success, dispatch]);

//   useEffect(() => {
//     if (editingId) return;

//     const existingCodes = (grades || []).map(r =>
//       pickField(r, [
//         'GradeCode',
//         'gradeCode',
//         'HGD_GRADE_CODE'
//       ])
//     );

//     setForm(f => ({
//       ...f,
//       code: generateCode(
//         existingCodes,
//         CODE_PREFIXES.GRADE
//       )
//     })); 
//   }, [grades, editingId]);

//   const rawList = Array.isArray(grades) ? grades : [];
//   const rows = rawList.map(r => {
//     const id = pickField(r, [
//       'HGD_GRADE_ID', 'HG_GRADE_ID', 'HedGradeId', 'GradeId', 'gradeId', 'id', 'ID'
//     ]);
//     const code = pickField(r, [
//       'HGD_GRADE_CODE', 'HG_GRADE_CODE', 'GradeCode', 'gradeCode', 'Code', 'code', 'p_grade_code', 'p_initial_grade', 'p_present_grade', 'id'
//     ]);
//     const name = pickField(r, [
//       'HGD_GRADE_NAME', 'HG_GRADE_NAME', 'GradeName', 'gradeName', 'Description', 'description', 'Name', 'name', 'p_grade_name'
//     ]);
//     const minSalary = pickField(r, [
//       'HGD_MIN_SALARY', 'HG_MIN_SALARY', 'MinSalary', 'minSalary', 'MIN_SALARY', 'p_min_salary', 'p_minSalary'
//     ]);
//     const maxSalary = pickField(r, [
//       'HGD_MAX_SALARY', 'HG_MAX_SALARY', 'MaxSalary', 'maxSalary', 'MAX_SALARY', 'p_max_salary', 'p_maxSalary'
//     ]);
//     const remarks = pickField(r, ['Remarks', 'remarks', 'HG_REMARKS', 'HGD_REMARKS', 'Description', 'description']);
//     const status = (r.IsActive !== false && r.HG_CURRENT_STATUS !== 'I' && r.status !== 'Inactive' && r.Status !== 'Inactive') ? 'Active' : 'Inactive';

//     return {
//       id: id || code || name,
//       code: code || name || '—',
//       name: name || code || '—',
//       minSalary: minSalary || '',
//       maxSalary: maxSalary || '',
//       status,
//       remarks,
//       raw: r,
//     };
//   });

//   const filtered = rows.filter(r =>
//     (r.name || '').toLowerCase().includes(search.toLowerCase()) ||
//     (r.code || '').toLowerCase().includes(search.toLowerCase()) ||
//     (String(r.minSalary) || '').toLowerCase().includes(search.toLowerCase()) ||
//     (String(r.maxSalary) || '').toLowerCase().includes(search.toLowerCase()) ||
//     (r.remarks || '').toLowerCase().includes(search.toLowerCase())
//   );

//   const handleSelect = (r) => {
//     setEditingId(r.id || r.code);
//     setForm({ code: r.code, name: r.name, minSalary: r.minSalary, maxSalary: r.maxSalary, remarks: r.remarks });
//   };

//   const handleClear = () => {
//     setEditingId(null);
//     setForm(EMPTY_GRADE_FORM);
//     dispatch(clearGradeError());
//   };

//   const handleSave = () => {
//     if (!form.code || !form.name) return;
//     const serviceNo = getLoggedInServiceNo() || "3000807";

//     if (editingId) {
//       dispatch(updateGrade({
//         p_gradeId: editingId,
//         p_updatedBy: serviceNo,
//         p_gradeCode: form.code,
//         p_gradeName: form.name,
//         p_minSalary: form.minSalary ? Number(form.minSalary) : 0,
//         p_maxSalary: form.maxSalary ? Number(form.maxSalary) : 0,
//         p_isActive: 1,
//         p_remarks: form.remarks || "",
//       }));
//     } else {
//       dispatch(addGrade({
//         p_createdBy: serviceNo,
//         p_gradeCode: form.code,
//         p_gradeName: form.name,
//         p_minSalary: form.minSalary ? Number(form.minSalary) : 0,
//         p_maxSalary: form.maxSalary ? Number(form.maxSalary) : 0,
//         p_isActive: 1,
//         p_remarks: form.remarks || "",
//       }));
//     }
//   };

//   return (
//     <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
//       <div className="lg:col-span-2 space-y-3">
//         <div className="relative">
//           <Search size={12} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
//           <input
//             className="h-9 bg-white border border-gray-200 rounded-lg text-xs pl-8 pr-3 w-full outline-none text-gray-700 focus:border-primary-500"
//             placeholder="Search grades…" value={search} onChange={e => setSearch(e.target.value)}
//           />
//         </div>
//         <MFGridSection title="Grade Details" count={filtered.length}>
//           {loading ? (
//             <div className="py-20 flex items-center justify-center gap-2 text-sm text-gray-400">
//               <Loader2 size={14} className="animate-spin" /> Loading grades...
//             </div>
//           ) : error ? (
//             <div className="py-20 flex items-center justify-center gap-2 text-sm text-red-600">
//               <AlertCircle size={13} className="shrink-0" /> {error}
//             </div>
//           ) : filtered.length === 0 ? (
//             <div className="flex flex-col items-center justify-center py-20 text-center text-gray-400">
//               <Tag size={24} className="text-gray-300 mb-2" />
//               <p className="text-sm text-gray-400">No grades yet</p>
//             </div>
//           ) : (
//             <table className="w-full text-[13px]">
//               <thead>
//                 <tr className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">
//                   {['Code', 'Name', 'Min Salary', 'Max Salary', 'Status', 'Remarks'].map(h => (
//                     <th key={h} className={MF_TH}>{h}</th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {filtered.map((r) => (
//                   <tr key={r.id || r.code} onClick={() => handleSelect(r)}
//                     className={`${MF_ROW} ${MF_ROW_IDLE} ${editingId === (r.id || r.code) ? MF_ROW_SEL : ''}`}>
//                     <td className="px-4 py-3 font-mono text-gray-900 font-semibold">{r.code}</td>
//                     <td className="px-4 py-3 text-gray-900 font-medium max-w-xs truncate">{r.name}</td>
//                     <td className="px-4 py-3 text-gray-600">{r.minSalary ? Number(r.minSalary).toLocaleString() : '—'}</td>
//                     <td className="px-4 py-3 text-gray-600">{r.maxSalary ? Number(r.maxSalary).toLocaleString() : '—'}</td>
//                     <td className="px-4 py-3"><StatusPill label={r.status} /></td>
//                     <td className="px-4 py-3 text-gray-600 max-w-[160px] truncate">{r.remarks}</td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           )}
//         </MFGridSection>
//       </div>

//       <MFEntryPanel
//         title={editingId ? 'Edit Grade' : 'Grade Entry'}
//         onSave={handleSave}
//         onClear={handleClear}
//         saved={success}
//       >
//         <div>
//           <MFLabel req>Grade Code</MFLabel>
//           <input className={`${MF_INP} bg-gray-200 cursor-not-allowed`} value={form.code} disabled readOnly
//             onChange={e => setForm(f => ({ ...f, code: e.target.value }))} />
//           {editingId && <p className="text-[10px] text-surface-400 mt-0.5">Code can't be changed once created</p>}
//         </div>
//         <div>
//           <MFLabel req>Grade Name</MFLabel>
//           <input className={MF_INP} value={form.name}
//             onChange={e => setForm(f => ({ ...f, name: e.target.value }))} />
//         </div>
//         <div>
//           <MFLabel>Minimum Salary</MFLabel>
//           <input type="number" className={MF_INP} value={form.minSalary}
//             onChange={e => setForm(f => ({ ...f, minSalary: e.target.value }))} />
//         </div>
//         <div>
//           <MFLabel>Maximum Salary</MFLabel>
//           <input type="number" className={MF_INP} value={form.maxSalary}
//             onChange={e => setForm(f => ({ ...f, maxSalary: e.target.value }))} />
//         </div>
//         <div>
//           <MFLabel>Remarks</MFLabel>
//           <input className={MF_INP} value={form.remarks}
//             onChange={e => setForm(f => ({ ...f, remarks: e.target.value }))} />
//         </div>
//         {saving && <p className="text-[10px] text-primary-500">Saving...</p>}
//         {error && <p className="text-[10px] text-red-500">{error}</p>}
//       </MFEntryPanel>
//     </div>
//   );
// }

// // ─── MF Section: Education ────────────────────────────────────────────────────
// function MFEducation() {
//   const [rows, setRows] = useState(SEED_EDUCATION);
//   const [form, setForm] = useState({ code: '', country: 'SRI LANKA', description: '', conductedBy: '', status: 'Active' });
//   const [saved, setSaved] = useState(false);
//   const handleSave = () => {
//     if (!form.code || !form.description) return;
//     setRows(prev => { const idx = prev.findIndex(r => r.code === form.code); if (idx >= 0) { const n = [...prev]; n[idx] = { ...form }; return n; } return [...prev, { ...form }]; });
//     setSaved(true); setTimeout(() => setSaved(false), 1500);
//   };
//   return (
//     <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
//       <div className="lg:col-span-2">
//         <MFGridSection title="Educational Details" count={rows.length}>
//           <table className="w-full text-[13px]">
//             <thead><tr className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">{['Code','Country','Description','Conducted By','Status'].map(h => <th key={h} className={MF_TH}>{h}</th>)}</tr></thead>
//             <tbody>
//               {rows.map((r, i) => (
//                 <tr key={r.code} onClick={() => setForm({ code: r.code, country: r.country, description: r.description, conductedBy: r.conductedBy, status: r.status })}
//                   className={`${MF_ROW} ${MF_ROW_IDLE} ${i === 0 ? 'bg-primary-50/50' : ''}`}>
//                   <td className="px-4 py-3 font-mono text-gray-900 font-semibold">{r.code}</td>
//                   <td className="px-4 py-3 text-gray-600">{r.country}</td>
//                   <td className="px-4 py-3 text-gray-900 font-medium">{r.description}</td>
//                   <td className="px-4 py-3 text-gray-600">{r.conductedBy}</td>
//                   <td className="px-4 py-3"><StatusPill label={r.status} /></td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </MFGridSection>
//       </div>
//       <MFEntryPanel title="Education Entry" onSave={handleSave} onClear={() => setForm({ code: '', country: 'SRI LANKA', description: '', conductedBy: '', status: 'Active' })} saved={saved}>
//         <div><MFLabel req>Qualification Code</MFLabel><input className={MF_INP} value={form.code} onChange={e => setForm(f => ({ ...f, code: e.target.value }))} /></div>
//         <div><MFLabel>Country</MFLabel><select className={MF_SEL} value={form.country} onChange={e => setForm(f => ({ ...f, country: e.target.value }))}><option>SRI LANKA</option><option>INDIA</option><option>UNITED KINGDOM</option><option>AUSTRALIA</option><option>USA</option></select></div>
//         <div><MFLabel req>Description</MFLabel><input className={MF_INP} value={form.description} onChange={e => setForm(f => ({ ...f, description: e.target.value }))} /></div>
//         <div><MFLabel>Conducted By</MFLabel><input className={MF_INP} value={form.conductedBy} onChange={e => setForm(f => ({ ...f, conductedBy: e.target.value }))} /></div>
//         <div><MFLabel>Status</MFLabel><select className={MF_SEL} value={form.status} onChange={e => setForm(f => ({ ...f, status: e.target.value }))}><option>Active</option><option>Inactive</option></select></div>
//       </MFEntryPanel>
//     </div>
//   );
// }

// // ─── MF Section: Professional ─────────────────────────────────────────────────
// function MFProfessional() {
//   const [rows, setRows] = useState(SEED_PROFESSIONAL);
//   const [form, setForm] = useState({ code: '', country: 'SRI LANKA', description: '', instituteName: '', duration: '', status: 'Active' });
//   const [saved, setSaved] = useState(false);
//   const handleSave = () => {
//     if (!form.code || !form.description) return;
//     setRows(prev => { const idx = prev.findIndex(r => r.code === form.code); if (idx >= 0) { const n = [...prev]; n[idx] = { ...form }; return n; } return [...prev, { ...form }]; });
//     setSaved(true); setTimeout(() => setSaved(false), 1500);
//   };
//   return (
//     <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
//       <div className="lg:col-span-2">
//         <MFGridSection title="Professional Details" count={rows.length}>
//           <table className="w-full text-[13px]">
//             <thead><tr className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">{['Code','Country','Description','Institute','Duration','Status'].map(h => <th key={h} className={MF_TH}>{h}</th>)}</tr></thead>
//             <tbody>
//               {rows.map((r, i) => (
//                 <tr key={r.code} onClick={() => setForm({ code: r.code, country: r.country, description: r.description, instituteName: r.instituteName, duration: r.duration, status: r.status })}
//                   className={`${MF_ROW} ${MF_ROW_IDLE} ${i === 0 ? 'bg-primary-50/50' : ''}`}>
//                   <td className="px-4 py-3 font-mono text-gray-900 font-semibold">{r.code}</td>
//                   <td className="px-4 py-3 text-gray-600">{r.country}</td>
//                   <td className="px-4 py-3 text-gray-900 font-medium max-w-xs truncate">{r.description}</td>
//                   <td className="px-4 py-3 text-gray-600">{r.instituteName || '—'}</td>
//                   <td className="px-4 py-3 text-gray-600">{r.duration || '—'}</td>
//                   <td className="px-4 py-3"><StatusPill label={r.status} /></td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </MFGridSection>
//       </div>
//       <MFEntryPanel title="Professional Entry" onSave={handleSave} onClear={() => setForm({ code: '', country: 'SRI LANKA', description: '', instituteName: '', duration: '', status: 'Active' })} saved={saved}>
//         <div><MFLabel req>Qualification Code</MFLabel><input className={MF_INP} value={form.code} onChange={e => setForm(f => ({ ...f, code: e.target.value }))} /></div>
//         <div><MFLabel>Country</MFLabel><select className={MF_SEL} value={form.country} onChange={e => setForm(f => ({ ...f, country: e.target.value }))}><option>SRI LANKA</option><option>INDIA</option><option>UNITED KINGDOM</option><option>AUSTRALIA</option><option>USA</option></select></div>
//         <div><MFLabel req>Description</MFLabel><input className={MF_INP} value={form.description} onChange={e => setForm(f => ({ ...f, description: e.target.value }))} /></div>
//         <div><MFLabel>Institute Name</MFLabel><input className={MF_INP} value={form.instituteName} onChange={e => setForm(f => ({ ...f, instituteName: e.target.value }))} /></div>
//         <div><MFLabel>Duration</MFLabel><input className={MF_INP} value={form.duration} onChange={e => setForm(f => ({ ...f, duration: e.target.value }))} /></div>
//         <div><MFLabel>Status</MFLabel><select className={MF_SEL} value={form.status} onChange={e => setForm(f => ({ ...f, status: e.target.value }))}><option>Active</option><option>Inactive</option></select></div>
//       </MFEntryPanel>
//     </div>
//   );
// }

// // ─── MF Section: Div / Dep / Loc ─────────────────────────────────────────────
// function MFDivDepLoc() {
//   const today = new Date().toISOString().split('T')[0];
//   const [divisions, setDivisions] = useState(SEED_DIVISIONS);
//   const [departments, setDepartments] = useState(SEED_DEPARTMENTS);
//   const [locations, setLocations] = useState(SEED_LOCATIONS);
//   const [selDiv, setSelDiv] = useState('');
//   const [divForm, setDivForm] = useState({ code: '', description: '', effectiveDate: today, status: 'Active' });
//   const [deptForm, setDeptForm] = useState({ divCode: '', code: '', description: '', effectiveDate: today, status: 'Active' });
//   const [locForm, setLocForm] = useState({ divCode: '', deptCode: '', code: '', description: '', effectiveDate: today, status: 'Active' });
//   const filtDepts = selDiv ? departments.filter(d => d.divCode === selDiv) : departments;

//   // ── Physical Location master (real API: GetLocationDetails / AddLocation) ──
//   const dispatch = useDispatch();
//   const { rows: phyRows, loading: phyLoading, error: phyError, adding: phyAdding, addError: phyAddError, addSuccess: phyAddSuccess } =
//     useSelector(s => s.locationMaster);

//   // Physical Locations grid: GetLocationDetails also returns non-physical
//   // location rows mixed in — only keep rows whose HLD_DIV_CODE and
//   // HLD_DEP_CODE are both "PHY" (Physical), and show those real field
//   // values instead of a hard-coded label.
//   const phyRowsFiltered = useMemo(() => {
//     const isPhy = (v) => String(v ?? '').trim().toUpperCase().includes('PHY');
//     return (phyRows || []).filter(r => isPhy(r.HLD_DIV_CODE) && isPhy(r.HLD_DEP_CODE));
//   }, [phyRows]);

//   const [phyForm, setPhyForm] = useState({ code: '', description: '', latitude: '', longitude: '' });
//   const [mapRow, setMapRow] = useState(null);
//   const [pickerOpen, setPickerOpen] = useState(false);

//   useEffect(() => {
//     dispatch(fetchLocationMaster());
//     // eslint-disable-next-line
//   }, []);

//   useEffect(() => {
//     if (phyAddSuccess) {
//       dispatch(fetchLocationMaster());
//       setPhyForm({ code: '', description: '', latitude: '', longitude: '' });
//       const t = setTimeout(() => dispatch(clearLocationMasterAddState()), 2500);
//       return () => clearTimeout(t);
//     }
//     // eslint-disable-next-line
//   }, [phyAddSuccess]);

//   const savePhyLocation = () => {
//     if (!phyForm.code || !phyForm.description) return;
//     dispatch(addLocationMaster({
//       code: phyForm.code,
//       description: phyForm.description,
//       latitude: phyForm.latitude,
//       longitude: phyForm.longitude,
//     }));
//   };

//   return (
//     <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
//       <div className="space-y-4">
//         <div className="bg-white border border-surface-100 rounded-xl p-4 shadow-sm">
//           <p className="text-xs font-bold text-primary-600 uppercase tracking-widest mb-2">Division Filter</p>
//           <select className={MF_SEL} value={selDiv} onChange={e => setSelDiv(e.target.value)}>
//             <option value="">All Divisions</option>
//             {divisions.map(d => <option key={d.code} value={d.code}>{d.description}</option>)}
//           </select>
//         </div>
//         <MFGridSection title="Department Details" count={filtDepts.length}>
//           <table className="w-full text-[13px]">
//             <thead><tr className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">{['Code','Description','Effective Date','Status'].map(h => <th key={h} className={MF_TH}>{h}</th>)}</tr></thead>
//             <tbody>
//               {filtDepts.map((r, i) => (
//                 <tr key={r.code + r.divCode} onClick={() => setDeptForm({ divCode: r.divCode, code: r.code, description: r.description, effectiveDate: r.effectiveDate, status: r.status })}
//                   className={`${MF_ROW} ${MF_ROW_IDLE} ${i === 0 ? 'bg-primary-50/50' : ''}`}>
//                   <td className="px-4 py-3 font-mono text-gray-900 font-semibold">{r.code}</td>
//                   <td className="px-4 py-3 text-gray-900 font-medium">{r.description}</td>
//                   <td className="px-4 py-3 text-gray-600">{r.effectiveDate}</td>
//                   <td className="px-4 py-3"><StatusPill label={r.status} /></td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </MFGridSection>
//         <MFGridSection title="Location Details" count={locations.length}>
//           <table className="w-full text-[13px]">
//             <thead><tr className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">{['Code','Description','Effective Date','Status'].map(h => <th key={h} className={MF_TH}>{h}</th>)}</tr></thead>
//             <tbody>
//               {locations.map((r, i) => (
//                 <tr key={r.code} onClick={() => setLocForm({ divCode: r.divCode, deptCode: r.deptCode, code: r.code, description: r.description, effectiveDate: r.effectiveDate, status: r.status })}
//                   className={`${MF_ROW} ${MF_ROW_IDLE} ${i === 0 ? 'bg-primary-50/50' : ''}`}>
//                   <td className="px-4 py-3 font-mono text-gray-900 font-semibold">{r.code}</td>
//                   <td className="px-4 py-3 text-gray-900 font-medium">{r.description}</td>
//                   <td className="px-4 py-3 text-gray-600">{r.effectiveDate}</td>
//                   <td className="px-4 py-3"><StatusPill label={r.status} /></td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </MFGridSection>

//         {/* Physical Locations grid — real API (GetLocationDetails) */}
//         <MFGridSection title="Physical Locations" count={phyRowsFiltered.length}>
//           {phyLoading ? (
//             <div className="py-20 flex items-center justify-center gap-2 text-sm text-gray-400">
//               <Loader2 size={14} className="animate-spin" /> Loading physical locations...
//             </div>
//           ) : phyError ? (
//             <div className="py-20 flex items-center justify-center gap-2 text-sm text-red-600">
//               <AlertCircle size={13} className="shrink-0" /> {phyError}
//             </div>
//           ) : phyRowsFiltered.length === 0 ? (
//             <div className="flex flex-col items-center justify-center py-20 text-center text-gray-400">
//               <MapPinned size={24} className="text-gray-300 mb-2" />
//               <p className="text-sm text-gray-400">No physical locations yet</p>
//             </div>
//           ) : (
//             <table className="w-full text-[13px]">
//               <thead>
//                 <tr className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">
//                   {['Code', 'Name', 'Division', 'Department', 'Status', ''].map(h => (
//                     <th key={h} className={MF_TH}>{h}</th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {phyRowsFiltered.map((r, i) => (
//                   <tr key={r.HLD_LOC_CODE || i} className={`border-b border-gray-100 last:border-0 ${i === 0 ? MF_ROW_SEL : ''}`}>
//                     <td className="px-4 py-3 font-mono text-gray-900 font-semibold">{r.HLD_LOC_CODE}</td>
//                     <td className="px-4 py-3 text-gray-900 font-medium">{r.HLD_LOC_DESC}</td>
//                     <td className="px-4 py-3 text-gray-600 font-medium">{r.HLD_DIV_CODE}</td>
//                     <td className="px-4 py-3 text-gray-600 font-medium">{r.HLD_DEP_CODE}</td>
//                     <td className="px-4 py-3"><StatusPill label={r.HLD_CURRENT_STATUS === 'A' ? 'Active' : 'Inactive'} /></td>
//                     <td className="px-4 py-3">
//                       <button
//                         onClick={() => setMapRow(r)}
//                         className="flex items-center gap-1 text-[11px] font-semibold text-primary-600 hover:text-primary-700 transition-colors"
//                         title="View on map"
//                       >
//                         <MapPinned size={12} /> Map
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           )}
//         </MFGridSection>
//       </div>
//       <div className="space-y-4">
//         <div className="bg-white border border-surface-100 rounded-xl p-4 shadow-sm">
//           <p className="text-xs font-bold text-primary-600 uppercase tracking-widest mb-3 border-b border-primary-100 pb-2">Create New Division</p>
//           <div className="grid grid-cols-2 gap-2 mb-3">
//             <div><MFLabel req>Division Code</MFLabel><input className={MF_INP} value={divForm.code} onChange={e => setDivForm(f => ({ ...f, code: e.target.value }))} /></div>
//             <div><MFLabel req>Description</MFLabel><input className={MF_INP} value={divForm.description} onChange={e => setDivForm(f => ({ ...f, description: e.target.value }))} /></div>
//             <div><MFLabel>Effective Date</MFLabel><input className={MF_INP} type="date" value={divForm.effectiveDate} onChange={e => setDivForm(f => ({ ...f, effectiveDate: e.target.value }))} /></div>
//             <div><MFLabel>Status</MFLabel><select className={MF_SEL} value={divForm.status} onChange={e => setDivForm(f => ({ ...f, status: e.target.value }))}><option>Active</option><option>Inactive</option></select></div>
//           </div>
//           <div className="flex gap-2">
//             <button onClick={() => { if (!divForm.code) return; setDivisions(prev => { const idx = prev.findIndex(d => d.code === divForm.code); if (idx >= 0) { const n = [...prev]; n[idx] = { ...divForm }; return n; } return [...prev, { ...divForm }]; }); setDivForm({ code: '', description: '', effectiveDate: today, status: 'Active' }); }} className="flex items-center gap-1 bg-surface-800 text-primary-400 text-xs px-3 py-1.5 rounded hover:bg-surface-700"><Save size={11} /> Save</button>
//             <button onClick={() => setDivForm({ code: '', description: '', effectiveDate: today, status: 'Active' })} className="flex items-center gap-1 border border-surface-200 text-surface-500 text-xs px-3 py-1.5 rounded hover:bg-surface-50"><RotateCcw size={11} /> Clear</button>
//           </div>
//         </div>
//         <div className="bg-white border border-surface-100 rounded-xl p-4 shadow-sm">
//           <p className="text-xs font-bold text-primary-600 uppercase tracking-widest mb-3 border-b border-primary-100 pb-2">Create New Department</p>
//           <div className="grid grid-cols-2 gap-2 mb-3">
//             <div><MFLabel>Division Code</MFLabel><input className={MF_INP} value={deptForm.divCode} onChange={e => setDeptForm(f => ({ ...f, divCode: e.target.value }))} /></div>
//             <div><MFLabel req>Dept. Code</MFLabel><input className={MF_INP} value={deptForm.code} onChange={e => setDeptForm(f => ({ ...f, code: e.target.value }))} /></div>
//             <div className="col-span-2"><MFLabel req>Description</MFLabel><input className={MF_INP} value={deptForm.description} onChange={e => setDeptForm(f => ({ ...f, description: e.target.value }))} /></div>
//             <div><MFLabel>Effective Date</MFLabel><input className={MF_INP} type="date" value={deptForm.effectiveDate} onChange={e => setDeptForm(f => ({ ...f, effectiveDate: e.target.value }))} /></div>
//             <div><MFLabel>Status</MFLabel><select className={MF_SEL} value={deptForm.status} onChange={e => setDeptForm(f => ({ ...f, status: e.target.value }))}><option>Active</option><option>Inactive</option></select></div>
//           </div>
//           <div className="flex gap-2">
//             <button onClick={() => { if (!deptForm.code) return; setDepartments(prev => { const idx = prev.findIndex(d => d.code === deptForm.code && d.divCode === deptForm.divCode); if (idx >= 0) { const n = [...prev]; n[idx] = { ...deptForm }; return n; } return [...prev, { ...deptForm }]; }); setDeptForm({ divCode: '', code: '', description: '', effectiveDate: today, status: 'Active' }); }} className="flex items-center gap-1 bg-surface-800 text-primary-400 text-xs px-3 py-1.5 rounded hover:bg-surface-700"><Save size={11} /> Save</button>
//             <button onClick={() => setDeptForm({ divCode: '', code: '', description: '', effectiveDate: today, status: 'Active' })} className="flex items-center gap-1 border border-surface-200 text-surface-500 text-xs px-3 py-1.5 rounded hover:bg-surface-50"><RotateCcw size={11} /> Clear</button>
//           </div>
//         </div>
//         <div className="bg-white border border-surface-100 rounded-xl p-4 shadow-sm">
//           <p className="text-xs font-bold text-primary-600 uppercase tracking-widest mb-3 border-b border-primary-100 pb-2">Create New Location</p>
//           <div className="grid grid-cols-2 gap-2 mb-3">
//             <div><MFLabel>Division Code</MFLabel><input className={MF_INP} value={locForm.divCode} onChange={e => setLocForm(f => ({ ...f, divCode: e.target.value }))} /></div>
//             <div><MFLabel>Dept. Code</MFLabel><input className={MF_INP} value={locForm.deptCode} onChange={e => setLocForm(f => ({ ...f, deptCode: e.target.value }))} /></div>
//             <div><MFLabel req>Location Code</MFLabel><input className={MF_INP} value={locForm.code} onChange={e => setLocForm(f => ({ ...f, code: e.target.value }))} /></div>
//             <div><MFLabel req>Description</MFLabel><input className={MF_INP} value={locForm.description} onChange={e => setLocForm(f => ({ ...f, description: e.target.value }))} /></div>
//             <div><MFLabel>Effective Date</MFLabel><input className={MF_INP} type="date" value={locForm.effectiveDate} onChange={e => setLocForm(f => ({ ...f, effectiveDate: e.target.value }))} /></div>
//             <div><MFLabel>Status</MFLabel><select className={MF_SEL} value={locForm.status} onChange={e => setLocForm(f => ({ ...f, status: e.target.value }))}><option>Active</option><option>Inactive</option></select></div>
//           </div>
//           <div className="flex gap-2">
//             <button onClick={() => { if (!locForm.code) return; setLocations(prev => { const idx = prev.findIndex(l => l.code === locForm.code); if (idx >= 0) { const n = [...prev]; n[idx] = { ...locForm }; return n; } return [...prev, { ...locForm }]; }); setLocForm({ divCode: '', deptCode: '', code: '', description: '', effectiveDate: today, status: 'Active' }); }} className="flex items-center gap-1 bg-surface-800 text-primary-400 text-xs px-3 py-1.5 rounded hover:bg-surface-700"><Save size={11} /> Save</button>
//             <button onClick={() => setLocForm({ divCode: '', deptCode: '', code: '', description: '', effectiveDate: today, status: 'Active' })} className="flex items-center gap-1 border border-surface-200 text-surface-500 text-xs px-3 py-1.5 rounded hover:bg-surface-50"><RotateCcw size={11} /> Clear</button>
//           </div>
//         </div>

//         {/* Create New Physical Location — real API (AddLocation) */}
//         <div className="bg-white border border-surface-100 rounded-xl p-4 shadow-sm">
//           <p className="text-xs font-bold text-primary-600 uppercase tracking-widest mb-3 border-b border-primary-100 pb-2 flex items-center gap-1.5">
//             <MapPinned size={12} /> Create New Physical Location
//           </p>

//           {phyAddError && (
//             <div className="flex items-center gap-1.5 text-red-600 text-[11px] mb-2">
//               <AlertCircle size={12} className="shrink-0" /> {phyAddError}
//             </div>
//           )}
//           {phyAddSuccess && (
//             <div className="flex items-center gap-1.5 text-emerald-600 text-[11px] mb-2">
//               <CheckCircle size={12} className="shrink-0" /> Physical location added.
//             </div>
//           )}

//           <div className="grid grid-cols-2 gap-2 mb-2">
//             <div className="col-span-2">
//               <MFLabel req>Location Code</MFLabel>
//               <input className={MF_INP} value={phyForm.code} onChange={e => setPhyForm(f => ({ ...f, code: e.target.value.toUpperCase() }))} placeholder="e.g. CDL" />
//             </div>
//             <div className="col-span-2">
//               <MFLabel req>Description / Name</MFLabel>
//               <input className={MF_INP} value={phyForm.description} onChange={e => setPhyForm(f => ({ ...f, description: e.target.value }))} placeholder="e.g. DOCKYARD SITE" />
//             </div>
//             <div>
//               <MFLabel>Latitude</MFLabel>
//               <input className={MF_INP} value={phyForm.latitude} onChange={e => setPhyForm(f => ({ ...f, latitude: e.target.value }))} placeholder="6.927079" />
//             </div>
//             <div>
//               <MFLabel>Longitude</MFLabel>
//               <input className={MF_INP} value={phyForm.longitude} onChange={e => setPhyForm(f => ({ ...f, longitude: e.target.value }))} placeholder="79.861244" />
//             </div>
//             <div className="col-span-2">
//               <button
//                 type="button"
//                 onClick={() => setPickerOpen(true)}
//                 className="flex items-center gap-1 text-[11px] font-semibold text-primary-600 hover:text-primary-700 transition-colors"
//               >
//                 <MapPinned size={12} /> Pick on Map
//               </button>
//             </div>
//           </div>
//           <div className="flex gap-2">
//             <button
//               onClick={savePhyLocation}
//               disabled={phyAdding || !phyForm.code || !phyForm.description}
//               className="flex items-center gap-1 bg-surface-800 hover:bg-surface-700 text-primary-400 text-xs px-3 py-1.5 rounded disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
//             >
//               {phyAdding ? <Loader2 size={11} className="animate-spin" /> : <Save size={11} />} {phyAdding ? 'Saving...' : 'Save'}
//             </button>
//             <button
//               onClick={() => setPhyForm({ code: '', description: '', latitude: '', longitude: '' })}
//               className="flex items-center gap-1 border border-surface-200 text-surface-500 text-xs px-3 py-1.5 rounded hover:bg-surface-50 transition-colors"
//             >
//               <RotateCcw size={11} /> Clear
//             </button>
//           </div>
//         </div>
//       </div>

//       <LocationMapModal
//         isOpen={!!mapRow}
//         onClose={() => setMapRow(null)}
//         name={mapRow?.HLD_LOC_DESC}
//         code={mapRow?.HLD_LOC_CODE}
//         latitude={mapRow?.HLD_LATITUDE}
//         longitude={mapRow?.HLD_LONGITUDE}
//       />

//       <LocationPickerMapModal
//         isOpen={pickerOpen}
//         onClose={() => setPickerOpen(false)}
//         title="Pick Physical Location Coordinates"
//         initialLat={phyForm.latitude}
//         initialLng={phyForm.longitude}
//         onSelect={(lat, lng) => setPhyForm(f => ({ ...f, latitude: String(lat.toFixed(6)), longitude: String(lng.toFixed(6)) }))}
//       />
//     </div>
//   );
// }

// // ─── MF Section: Shift ────────────────────────────────────────────────────────
// // function MFShift() {
// //   const [shifts, setShifts] = useState(SEED_SHIFTS);
// //   const [form, setForm] = useState({ code: '', description: '', type: 'Normal', timeIn: '08:00', timeOut: '17:00', status: 'Active' });
// //   const [saved, setSaved] = useState(false);
// //   const handleSave = () => {
// //     if (!form.code) return;
// //     setShifts(prev => { const idx = prev.findIndex(s => s.code === form.code); if (idx >= 0) { const n = [...prev]; n[idx] = { ...form }; return n; } return [...prev, { ...form }]; });
// //     setSaved(true); setTimeout(() => setSaved(false), 1500);
// //   };
// //   return (
// //     <div className="space-y-4">
// //       <div className="bg-white border border-surface-100 rounded-xl p-4 shadow-sm">
// //         <p className="text-xs font-bold text-primary-600 uppercase tracking-widest mb-3 border-b border-primary-100 pb-2">Shift Type Entry</p>
// //         {saved && <div className="flex items-center gap-1 text-emerald-600 text-xs mb-2"><CheckCircle size={12}/> Saved!</div>}
// //         <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 items-end">
// //           <div><MFLabel req>Shift Code</MFLabel><input className={MF_INP} value={form.code} onChange={e => setForm(f => ({ ...f, code: e.target.value }))} /></div>
// //           <div className="col-span-2"><MFLabel>Description</MFLabel><input className={MF_INP} value={form.description} onChange={e => setForm(f => ({ ...f, description: e.target.value }))} /></div>
// //           <div><MFLabel>Type</MFLabel><select className={MF_SEL} value={form.type} onChange={e => setForm(f => ({ ...f, type: e.target.value }))}><option>Normal</option><option>Rotating</option><option>Flexible</option></select></div>
// //           <div><MFLabel>Time In</MFLabel><input className={MF_INP} type="time" value={form.timeIn} onChange={e => setForm(f => ({ ...f, timeIn: e.target.value }))} /></div>
// //           <div><MFLabel>Time Out</MFLabel><input className={MF_INP} type="time" value={form.timeOut} onChange={e => setForm(f => ({ ...f, timeOut: e.target.value }))} /></div>
// //         </div>
// //         <div className="flex gap-2 mt-3">
// //           <button onClick={handleSave} className="flex items-center gap-1 bg-surface-800 text-primary-400 text-xs px-3 py-1.5 rounded hover:bg-surface-700"><Save size={11} /> Save</button>
// //           <button onClick={() => setForm({ code: '', description: '', type: 'Normal', timeIn: '08:00', timeOut: '17:00', status: 'Active' })} className="flex items-center gap-1 border border-surface-200 text-surface-500 text-xs px-3 py-1.5 rounded hover:bg-surface-50"><RotateCcw size={11} /> Clear</button>
// //         </div>
// //       </div>
// //       <MFGridSection title="Defined Shifts">
// //         <table className="w-full text-[13px]">
// //           <thead><tr className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">{['Shift Code','Description','Type','Time In','Time Out','Status'].map(h => <th key={h} className={MF_TH}>{h}</th>)}</tr></thead>
// //           <tbody>
// //             {shifts.map((r, i) => (
// //               <tr key={r.code} onClick={() => setForm({ code: r.code, description: r.description, type: r.type, timeIn: r.timeIn, timeOut: r.timeOut, status: r.status })}
// //                 className={`${MF_ROW} ${MF_ROW_IDLE} ${i === 0 ? 'bg-primary-50/50' : ''}`}>
// //                 <td className="px-4 py-3 font-mono text-gray-900 font-semibold">{r.code}</td>
// //                 <td className="px-4 py-3 text-gray-900 font-medium">{r.description}</td>
// //                 <td className="px-4 py-3 text-gray-600">{r.type}</td>
// //                 <td className="px-4 py-3 text-gray-600">{r.timeIn}</td>
// //                 <td className="px-4 py-3 text-gray-600">{r.timeOut}</td>
// //                 <td className="px-4 py-3"><StatusPill label={r.status} /></td>
// //               </tr>
// //             ))}
// //           </tbody>
// //         </table>
// //       </MFGridSection>
// //     </div>
// //   );
// // }

// const EMPTY_SHIFT_FORM = {
//   shiftCode: '',
//   shiftName: '',
//   startTime: '',
//   endTime: '',
//   breakStartTime: '',
//   breakEndTime: '',
//   breakDuration: '',
//   graceInMin: '',
//   graceOutMin: '',
//   halfDayHours: '',
//   fullDayHours: '',
//   otAfterMinutes: '',
//   shiftColor: '',
//   isActive: '',
//   remarks: '',
// };


// function MFShift() {
//   const dispatch = useDispatch();
//   const { shifts, loading, saving, error, success } = useSelector(s => s.shiftSlice);

//   const [search, setSearch] = useState('');
//   const [form, setForm] = useState(EMPTY_BANK_FORM);
//   const [editingId, setEditingId] = useState(null);

//   useEffect(() => {
//     dispatch(getShiftList());
//   }, [dispatch]);

//   useEffect(() => {
//     if (success) {
//       dispatch(getShiftList());
//       setForm(EMPTY_SHIFT_FORM);
//       setEditingId(null);
//       const t = setTimeout(() => dispatch(clearShiftSuccess()), 1500);
//       return () => clearTimeout(t);
//     }
//   }, [success, dispatch]);

//   useEffect(() => {
//     if (editingId) return;

//     const existingCodes = (shifts || []).map(r =>
//       pickField(r, [
//         'ShiftCode',
//         'shiftCode',
//         'HSD_SHIFT_CODE'
//       ])
//     );

//     setForm(f => ({
//       ...f,
//       shiftCode: generateCode(
//         existingCodes,
//         CODE_PREFIXES.SHIFT
//       )
//     })); 
//   }, [shifts, editingId]);

//   const rows = (shifts || []).map(r => ({
//     id: pickField(r, ['HSD_SHIFT_ID']),
//     shiftCode: pickField(r, ['HSD_SHIFT_CODE']),
//     shiftName: pickField(r, ['HSD_SHIFT_NAME']),
//     startTime: pickField(r, ['HSD_START_TIME']),
//     endTime: pickField(r, ['HSD_END_TIME']),
//     breakStartTime: pickField(r, ['HSD_BREAK_START_TIME']),
//     breakEndTime: pickField(r, ['HSD_BREAK_END_TIME']),
//     breakDuration: pickField(r, ['HSD_BREAK_DURATION_MIN']),
//     graceInMin: pickField(r, ['HSD_GRACE_IN_MIN']),
//     graceOutMin: pickField(r, ['HSD_GRACE_OUT_MIN']),
//     halfDayHours: pickField(r, ['HSD_HALF_DAY_HOURS']),
//     fullDayHours: pickField(r, ['HSD_FULL_DAY_HOURS']),
//     otAfterMinutes: pickField(r, ['HSD_OT_AFTER_MINUTES']),
//     shiftColor: pickField(r, ['HSD_SHIFT_COLOR']), 
//     isActive: pickField(r, ['HSD_IS_ACTIVE']), 
//     remarks: pickField(r, ['HSD_REMARKS']), 
//   }));

//   const filtered = rows.filter(r =>
//     r.shiftCode.toLowerCase().includes(search.toLowerCase()) ||
//     r.shiftName.toLowerCase().includes(search.toLowerCase())
//   );

//   const handleSelect = (r) => {
//     setEditingId(r.id);
//     setForm({ 
//       shiftCode: r.shiftCode, 
//       shiftName: r.shiftName, 
//       startTime: r.startTime, 
//       endTime: r.endTime, 
//       breakStartTime: r.breakStartTime, 
//       breakEndTime: r.breakEndTime, 
//       breakDuration: r.breakDuration, 
//       graceInMin: r.graceInMin, 
//       graceOutMin: r.graceOutMin, 
//       halfDayHours: r.halfDayHours, 
//       fullDayHours: r.fullDayHours, 
//       otAfterMinutes: r.otAfterMinutes, 
//       shiftColor: r.shiftColor, 
//       isActive: r.isActive, 
//       remarks: r.remarks,
//     });
//   };

//   const handleClear = () => {
//     setEditingId(null);
//     setForm(EMPTY_SHIFT_FORM);
//     dispatch(clearBankError());
//   };

//   const handleSave = () => {
//     if (!form.shiftCode || !form.shiftName) return;
//     if (editingId) {
//       dispatch(updateShift({
//         p_shiftId: editingId,
//         p_shiftCode: form.shiftCode,
//         p_shiftName: form.shiftName,
//         p_startTime: form.startTime,
//         p_endTime: form.endTime,
//         p_breakStartTime: form.breakStartTime || '',
//         p_breakEndTime: form.breakEndTime || '',
//         p_breakDurationMin: form.breakDuration || '',
//         p_graceInMin: form.graceInMin || '',
//         p_graceOutMin: form.graceOutMin || '',
//         p_halfDayHours: form.halfDayHours || '',
//         p_fullDayHours: form.fullDayHours || '',
//         p_otAfterMinutes: form.otAfterMinutes || '',
//         p_shiftColor: form.shiftColor || '',
//         p_remarks: form.remarks || '',
//         p_updatedBy: getLoggedInServiceNo() || 'admin',
//       }));
//     } else {
//       dispatch(addShift({
//         p_shiftCode: form.shiftCode,
//         p_shiftName: form.shiftName,
//         p_startTime: form.startTime,
//         p_endTime: form.endTime,
//         p_breakStartTime: form.breakStartTime || '',
//         p_breakEndTime: form.breakEndTime || '',
//         p_breakDurationMin: form.breakDuration || '',
//         p_graceInMin: form.graceInMin || '',
//         p_graceOutMin: form.graceOutMin || '',
//         p_halfDayHours: form.halfDayHours || '',
//         p_fullDayHours: form.fullDayHours || '',
//         p_otAfterMinutes: form.otAfterMinutes || '',
//         p_shiftColor: form.shiftColor || '',
//         p_remarks: form.remarks || '',
//         p_createdBy: getLoggedInServiceNo() || 'admin',
//       }));
//     }
//   };

//   return (
//     <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
//       <div className="lg:col-span-2 space-y-3">
//         <div className="relative">
//           <Search size={12} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
//           <input
//             className="h-9 bg-white border border-gray-200 rounded-lg text-xs pl-8 pr-3 w-full outline-none text-gray-700 focus:border-primary-500"
//             placeholder="Search shifts" value={search} onChange={e => setSearch(e.target.value)}
//           />
//         </div>
//         <MFGridSection title="Shift Details" count={filtered.length}>
//           {loading ? (
//             <div className="py-20 flex items-center justify-center gap-2 text-sm text-gray-400">
//               <Loader2 size={14} className="animate-spin" /> Loading shifts...
//             </div>
//           ) : error ? (
//             <div className="py-20 flex items-center justify-center gap-2 text-sm text-red-600">
//               <AlertCircle size={13} className="shrink-0" /> {error}
//             </div>
//           ) : filtered.length === 0 ? (
//             <div className="flex flex-col items-center justify-center py-20 text-center text-gray-400">
//               <Tag size={24} className="text-gray-300 mb-2" />
//               <p className="text-sm text-gray-400">No shifts yet</p>
//             </div>
//           ) : (
//             <table className="w-full text-[13px]">
//               <thead>
//                 <tr className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">
//                   {['Code', 'Name', 'Start Time', 'End Time', 'Status'].map(h => (
//                     <th key={h} className={MF_TH}>{h}</th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {filtered.map((r) => (
//                   <tr key={r.id || r.code} onClick={() => handleSelect(r)}
//                     className={`${MF_ROW} ${MF_ROW_IDLE} ${editingId === r.id ? MF_ROW_SEL : ''}`}>
//                     <td className="px-4 py-3 font-mono text-gray-900 font-semibold">{r.shiftCode}</td>
//                     <td className="px-4 py-3 text-gray-900 font-medium max-w-xs truncate">{r.shiftName}</td>
//                     <td className="px-4 py-3 text-gray-600 max-w-[120px] truncate">{r.startTime || '-'}</td>
//                     <td className="px-4 py-3 text-gray-600 max-w-[160px] truncate">{r.endTime || '-'}</td>
//                     <td className="px-4 py-3 text-gray-600 max-w-[160px] truncate">{r.isActive ? "Active" : "Inactive" || '-'}</td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           )}
//         </MFGridSection>
//       </div>

//       <MFEntryPanel
//         title={editingId ? 'Edit Shift' : 'Shift Entry'}
//         onSave={handleSave}
//         onClear={handleClear}
//         saved={success}
//       >
//         <div>
//           <MFLabel req>Shift Code</MFLabel>
//           <input className={`${MF_INP} cursor-not-allowed bg-gray-200`} value={form.shiftCode} disabled readOnly
//             onChange={e => setForm(f => ({ ...f, shiftCode: e.target.value }))} />
//           {editingId && <p className="text-[10px] text-surface-400 mt-0.5">Code can't be changed once created</p>}
//         </div>
//         <div>
//           <MFLabel req>Shift Name</MFLabel>
//           <input className={MF_INP} value={form.shiftName}
//             onChange={e => setForm(f => ({ ...f, shiftName: e.target.value }))} />
//         </div>
//         <div>
//           <MFLabel>Start Time</MFLabel>
//           <input className={MF_INP} value={form.startTime}
//             onChange={e => setForm(f => ({ ...f, startTime: e.target.value }))} />
//         </div>
//         <div>
//           <MFLabel>End Time</MFLabel>
//           <input className={MF_INP} value={form.endTime}
//             onChange={e => setForm(f => ({ ...f, endTime: e.target.value }))} />
//         </div>
//         <div>
//           <MFLabel>Break Start Time</MFLabel>
//           <input className={MF_INP} value={form.breakStartTime}
//             onChange={e => setForm(f => ({ ...f, breakStartTime: e.target.value }))} />
//         </div>
//         <div>
//           <MFLabel>Break End Time</MFLabel>
//           <input className={MF_INP} value={form.breakEndTime}
//             onChange={e => setForm(f => ({ ...f, breakEndTime: e.target.value }))} />
//         </div>
//         <div>
//           <MFLabel>Grace In (minutes)</MFLabel>
//           <input className={MF_INP} value={form.graceInMin}
//             onChange={e => setForm(f => ({ ...f, graceInMin: e.target.value }))} />
//         </div>
//         <div>
//           <MFLabel>Grace Out (minutes)</MFLabel>
//           <input className={MF_INP} value={form.graceOutMin}
//             onChange={e => setForm(f => ({ ...f, graceOutMin: e.target.value }))} />
//         </div>
//         <div>
//           <MFLabel>Half Day Hours</MFLabel>
//           <input className={MF_INP} value={form.halfDayHours}
//             onChange={e => setForm(f => ({ ...f, halfDayHours: e.target.value }))} />
//         </div>
//         <div>
//           <MFLabel>Full Day Hours</MFLabel>
//           <input className={MF_INP} value={form.fullDayHours}
//             onChange={e => setForm(f => ({ ...f, fullDayHours: e.target.value }))} />
//         </div>
//         <div>
//           <MFLabel>OT After Minutes</MFLabel>
//           <input className={MF_INP} value={form.otAfterMinutes}
//             onChange={e => setForm(f => ({ ...f, otAfterMinutes: e.target.value }))} />
//         </div>
//         <div>
//           <MFLabel>Shift Color</MFLabel>
//           <input className={MF_INP} value={form.shiftColor}
//             onChange={e => setForm(f => ({ ...f, shiftColor: e.target.value }))} />
//         </div>
//         <div>
//           <MFLabel>Remarks</MFLabel>
//           <input className={MF_INP} value={form.remarks}
//             onChange={e => setForm(f => ({ ...f, remarks: e.target.value }))} />
//         </div>
//         {saving && <p className="text-[10px] text-primary-500">Saving...</p>}
//         {error && <p className="text-[10px] text-red-500">{error}</p>}
//       </MFEntryPanel>
//     </div>
//   );
// }

// // ─── MF Section: Province ─────────────────────────────────────────────────────
// function MFProvince() {
//   const [provinces, setProvinces] = useState(SEED_PROVINCES);
//   const [districts, setDistricts] = useState(SEED_DISTRICTS);
//   const [electorates, setElectorates] = useState(SEED_ELECTORATES);
//   const [provForm, setProvForm] = useState({ code: '', name: '', status: 'Active' });
//   const [distForm, setDistForm] = useState({ code: '', name: '', status: 'Active' });
//   const [elecForm, setElecForm] = useState({ code: '', name: '', status: 'Active' });
//   return (
//     <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
//       <div className="space-y-4">
//         <MFGridSection title="Districts" count={districts.length}>
//           <table className="w-full text-[13px]">
//             <thead><tr className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">{['Prov. Code','Province','Dist. Code','District','Status'].map(h => <th key={h} className={MF_TH}>{h}</th>)}</tr></thead>
//             <tbody>
//               {districts.map((r, i) => (
//                 <tr key={r.code} onClick={() => setDistForm({ code: r.code, name: r.name, status: r.status })}
//                   className={`${MF_ROW} ${MF_ROW_IDLE} ${i === 0 ? 'bg-primary-50/50' : ''}`}>
//                   <td className="px-4 py-3 font-mono text-gray-900 font-semibold">{r.provCode}</td>
//                   <td className="px-4 py-3 text-gray-600">{r.provName}</td>
//                   <td className="px-4 py-3 font-mono text-gray-700 font-semibold">{r.code}</td>
//                   <td className="px-4 py-3 text-gray-900 font-medium">{r.name}</td>
//                   <td className="px-4 py-3"><StatusPill label={r.status} /></td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </MFGridSection>
//         <MFGridSection title="Electorates" count={electorates.length}>
//           <table className="w-full text-[13px]">
//             <thead><tr className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">{['Prov.','Dist.','Code','Name','Status'].map(h => <th key={h} className={MF_TH}>{h}</th>)}</tr></thead>
//             <tbody>
//               {electorates.map((r, i) => (
//                 <tr key={r.code} onClick={() => setElecForm({ code: r.code, name: r.name, status: r.status })}
//                   className={`${MF_ROW} ${MF_ROW_IDLE} ${i === 0 ? 'bg-primary-50/50' : ''}`}>
//                   <td className="px-4 py-3 font-mono text-primary-600">{r.provCode}</td>
//                   <td className="px-4 py-3 font-mono text-gray-600">{r.distCode}</td>
//                   <td className="px-4 py-3 font-mono text-gray-700 font-semibold">{r.code}</td>
//                   <td className="px-4 py-3 text-gray-900 font-medium">{r.name}</td>
//                   <td className="px-4 py-3"><StatusPill label={r.status} /></td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </MFGridSection>
//       </div>
//       <div className="space-y-4">
//         <div className="bg-white border border-surface-100 rounded-xl p-4 shadow-sm">
//           <p className="text-xs font-bold text-primary-600 uppercase tracking-widest mb-3 border-b border-primary-100 pb-2">Province Entry</p>
//           <div className="grid grid-cols-3 gap-2 mb-3 items-end">
//             <div><MFLabel req>Code</MFLabel><input className={MF_INP} value={provForm.code} onChange={e => setProvForm(f => ({ ...f, code: e.target.value }))} placeholder="e.g. WP" /></div>
//             <div className="col-span-2"><MFLabel>Name</MFLabel><input className={MF_INP} value={provForm.name} onChange={e => setProvForm(f => ({ ...f, name: e.target.value }))} /></div>
//             <div><MFLabel>Status</MFLabel><select className={MF_SEL} value={provForm.status} onChange={e => setProvForm(f => ({ ...f, status: e.target.value }))}><option>Active</option><option>Inactive</option></select></div>
//           </div>
//           <div className="flex gap-2">
//             <button onClick={() => { if (!provForm.code) return; setProvinces(prev => { const idx = prev.findIndex(p => p.code === provForm.code); if (idx >= 0) { const n = [...prev]; n[idx] = { ...provForm }; return n; } return [...prev, { ...provForm }]; }); setProvForm({ code: '', name: '', status: 'Active' }); }} className="flex items-center gap-1 bg-surface-800 text-primary-400 text-xs px-3 py-1.5 rounded hover:bg-surface-700"><Save size={11} /> Save</button>
//             <button onClick={() => setProvForm({ code: '', name: '', status: 'Active' })} className="flex items-center gap-1 border border-surface-200 text-surface-500 text-xs px-3 py-1.5 rounded hover:bg-surface-50"><RotateCcw size={11} /> Clear</button>
//           </div>
//         </div>
//         <div className="bg-white border border-surface-100 rounded-xl p-4 shadow-sm">
//           <p className="text-xs font-bold text-primary-600 uppercase tracking-widest mb-3 border-b border-primary-100 pb-2">District Entry</p>
//           <div className="grid grid-cols-2 gap-2 mb-3">
//             <div><MFLabel req>District Code</MFLabel><input className={MF_INP} value={distForm.code} onChange={e => setDistForm(f => ({ ...f, code: e.target.value }))} /></div>
//             <div><MFLabel req>District Name</MFLabel><input className={MF_INP} value={distForm.name} onChange={e => setDistForm(f => ({ ...f, name: e.target.value }))} /></div>
//             <div><MFLabel>Status</MFLabel><select className={MF_SEL} value={distForm.status} onChange={e => setDistForm(f => ({ ...f, status: e.target.value }))}><option>Active</option><option>Inactive</option></select></div>
//           </div>
//           <div className="flex gap-2">
//             <button onClick={() => { if (!distForm.code) return; setDistricts(prev => { const idx = prev.findIndex(d => d.code === distForm.code); if (idx >= 0) { const n = [...prev]; n[idx] = { ...distForm, provCode: 'WP', provName: 'Western Province' }; return n; } return [...prev, { ...distForm, provCode: 'WP', provName: 'Western Province' }]; }); setDistForm({ code: '', name: '', status: 'Active' }); }} className="flex items-center gap-1 bg-surface-800 text-primary-400 text-xs px-3 py-1.5 rounded hover:bg-surface-700"><Save size={11} /> Save</button>
//             <button onClick={() => setDistForm({ code: '', name: '', status: 'Active' })} className="flex items-center gap-1 border border-surface-200 text-surface-500 text-xs px-3 py-1.5 rounded hover:bg-surface-50"><RotateCcw size={11} /> Clear</button>
//           </div>
//         </div>
//         <div className="bg-white border border-surface-100 rounded-xl p-4 shadow-sm">
//           <p className="text-xs font-bold text-primary-600 uppercase tracking-widest mb-3 border-b border-primary-100 pb-2">Electorate Entry</p>
//           <div className="grid grid-cols-2 gap-2 mb-3">
//             <div><MFLabel req>Electorate Code</MFLabel><input className={MF_INP} value={elecForm.code} onChange={e => setElecForm(f => ({ ...f, code: e.target.value }))} /></div>
//             <div><MFLabel req>Electorate Name</MFLabel><input className={MF_INP} value={elecForm.name} onChange={e => setElecForm(f => ({ ...f, name: e.target.value }))} /></div>
//             <div><MFLabel>Status</MFLabel><select className={MF_SEL} value={elecForm.status} onChange={e => setElecForm(f => ({ ...f, status: e.target.value }))}><option>Active</option><option>Inactive</option></select></div>
//           </div>
//           <div className="flex gap-2">
//             <button onClick={() => { if (!elecForm.code) return; setElectorates(prev => { const idx = prev.findIndex(e => e.code === elecForm.code); if (idx >= 0) { const n = [...prev]; n[idx] = { ...elecForm, provCode: 'WP', distCode: 'CMB' }; return n; } return [...prev, { ...elecForm, provCode: 'WP', distCode: 'CMB' }]; }); setElecForm({ code: '', name: '', status: 'Active' }); }} className="flex items-center gap-1 bg-surface-800 text-primary-400 text-xs px-3 py-1.5 rounded hover:bg-surface-700"><Save size={11} /> Save</button>
//             <button onClick={() => setElecForm({ code: '', name: '', status: 'Active' })} className="flex items-center gap-1 border border-surface-200 text-surface-500 text-xs px-3 py-1.5 rounded hover:bg-surface-50"><RotateCcw size={11} /> Clear</button>
//           </div>
//         </div>
//         <MFGridSection title="All Provinces" count={provinces.length}>
//           <table className="w-full text-[13px]">
//             <thead><tr className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">{['Code','Province Name','Status'].map(h => <th key={h} className={MF_TH}>{h}</th>)}</tr></thead>
//             <tbody>
//               {provinces.map((r, i) => (
//                 <tr key={r.code} onClick={() => setProvForm({ code: r.code, name: r.name, status: r.status })}
//                   className={`${MF_ROW} ${MF_ROW_IDLE} ${i === 0 ? 'bg-primary-50/50' : ''}`}>
//                   <td className="px-4 py-3 font-mono text-gray-900 font-semibold">{r.code}</td>
//                   <td className="px-4 py-3 text-gray-900 font-medium">{r.name}</td>
//                   <td className="px-4 py-3"><StatusPill label={r.status} /></td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </MFGridSection>
//       </div>
//     </div>
//   );
// }

// // ─── MF Section: Police ───────────────────────────────────────────────────────
// // function MFPolice() {
// //   const [stations, setStations] = useState(SEED_POLICE_STATIONS);
// //   const [form, setForm] = useState({ code: '', electorateCode: '', name: '', status: 'Active' });
// //   const [search, setSearch] = useState('');
// //   const [saved, setSaved] = useState(false);
// //   const filtered = stations.filter(s => s.name.toLowerCase().includes(search.toLowerCase()) || s.code.includes(search));
// //   const handleSave = () => {
// //     if (!form.code || !form.name) return;
// //     setStations(prev => { const idx = prev.findIndex(s => s.code === form.code); if (idx >= 0) { const n = [...prev]; n[idx] = { ...form }; return n; } return [...prev, { ...form }]; });
// //     setSaved(true); setTimeout(() => setSaved(false), 1500);
// //   };
// //   return (
// //     <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
// //       <div className="lg:col-span-2 space-y-3">
// //         <div className="relative"><Search size={12} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" /><input className="h-9 bg-white border border-gray-200 rounded-lg text-xs pl-8 pr-3 w-full outline-none text-gray-700 focus:border-primary-500" placeholder="Search stations…" value={search} onChange={e => setSearch(e.target.value)} /></div>
// //         <MFGridSection title="Police Station Details">
// //           <table className="w-full text-[13px]">
// //             <thead><tr className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">{['Code','Electorate','Station Name','Status'].map(h => <th key={h} className={MF_TH}>{h}</th>)}</tr></thead>
// //             <tbody>
// //               {filtered.map((r, i) => (
// //                 <tr key={r.code} onClick={() => setForm({ code: r.code, electorateCode: r.electorateCode, name: r.name, status: r.status })}
// //                   className={`${MF_ROW} ${MF_ROW_IDLE} ${i === 0 ? 'bg-primary-50/50' : ''}`}>
// //                   <td className="px-4 py-3 font-mono text-gray-900 font-semibold">{r.code}</td>
// //                   <td className="px-4 py-3 text-gray-600">{r.electorateCode}</td>
// //                   <td className="px-4 py-3 text-gray-900 font-medium">{r.name}</td>
// //                   <td className="px-4 py-3"><StatusPill label={r.status} /></td>
// //                 </tr>
// //               ))}
// //             </tbody>
// //           </table>
// //         </MFGridSection>
// //       </div>
// //       <MFEntryPanel title="Police Station Entry" onSave={handleSave} onClear={() => setForm({ code: '', electorateCode: '', name: '', status: 'Active' })} saved={saved}>
// //         <div><MFLabel req>Code</MFLabel><input className={MF_INP} value={form.code} onChange={e => setForm(f => ({ ...f, code: e.target.value }))} /></div>
// //         <div><MFLabel>Electorate</MFLabel><select className={MF_SEL} value={form.electorateCode} onChange={e => setForm(f => ({ ...f, electorateCode: e.target.value }))}><option value="">Select...</option>{SEED_ELECTORATES.map(e => <option key={e.code} value={e.code}>{e.name}</option>)}</select></div>
// //         <div><MFLabel req>Station Name</MFLabel><input className={MF_INP} value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} /></div>
// //         <div><MFLabel>Status</MFLabel><select className={MF_SEL} value={form.status} onChange={e => setForm(f => ({ ...f, status: e.target.value }))}><option>Active</option><option>Inactive</option></select></div>
// //       </MFEntryPanel>
// //     </div>
// //   );
// // }

// // ─── MF Section: Bank ───────────────────────────────────────────────────────
// const EMPTY_BANK_FORM = {
//   bankCode: '',
//   bankName: '',
//   shortName: '',
//   swiftCode: '',
//   headOffice: '',
//   remarks: '',
//   isActive: false,
//   isApproved: false,   // approval is separate from active; new banks start pending
// };

// const toBoolean = (value) => {
//   if (typeof value === 'boolean') return value;

//   return String(value).toLowerCase() === 'true';
// };

// function MFBank() {
//   const dispatch = useDispatch();
//   const { banks, loading, saving, error, success } = useSelector(s => s.bankSlice);

//   const [search, setSearch] = useState('');
//   const [statusFilter, setStatusFilter] = useState('all');
//   const [form, setForm] = useState(EMPTY_BANK_FORM);
//   const [editingId, setEditingId] = useState(null);
//   const [importing, setImporting] = useState(false);
//   const [importSuccess, setImportSuccess] = useState('');
//   const [importError, setImportError] = useState('');

//   useEffect(() => {
//     dispatch(getBankList());
//   }, [dispatch]);

//   useEffect(() => {
//     if (success) {
//       dispatch(getBankList());
//       setForm(EMPTY_BANK_FORM);
//       setEditingId(null);
//       const t = setTimeout(() => dispatch(clearBankSuccess()), 1500);
//       return () => clearTimeout(t);
//     }
//   }, [success, dispatch]);

//   const rows = (banks || []).map(r => ({
//     id:           pickField(r, ['HBD_BANK_ID']),
//     bankCode:         pickField(r, ['HBD_BANK_CODE']),
//     bankName:         pickField(r, ['HBD_BANK_NAME']),
//     shortName:         pickField(r, ['HBD_SHORT_NAME']),
//     swiftCode:         pickField(r, ['HBD_SWIFT_CODE']),
//     headOffice:     pickField(r, ['HBD_HEAD_OFFICE']),
//     isActive:     toBoolean(pickField(r, ['HBD_IS_ACTIVE'])),
//     isApproved:   isMasterApproved(r),
//   }));

//   const filtered = rows.filter(r => {
//     const matchesSearch =
//       r.bankName.toLowerCase().includes(search.toLowerCase()) ||
//       r.bankCode.toLowerCase().includes(search.toLowerCase());

//     const matchesStatus =
//       statusFilter === 'all' ||
//       (statusFilter === 'pending' && !r.isApproved) ||
//       (statusFilter === 'approved' && r.isApproved);

//     return matchesSearch && matchesStatus;
//   });

//   const handleExport = () => {
//     const exportData = rows.map(r => ({
//       Bank_Code: r.bankCode || '',
//       Bank_Name: r.bankName || '',
//       Swift_Code: r.swiftCode || '',
//       Head_Office: r.headOffice || '',
//       Remarks: '',   // Not returned by the API but can be inserted via AddBank API
//       'Created _By': 'System', // Created by is not returned by GetBanks so, hardcoded
//     }));

//     exportToExcel(exportData, 'banks.xlsx');
//   }

//   const handleImport = async (event) => {
//     const file = event.target.files?.[0];

//     if (!file) return;

//     try {
//       setImporting(true);

//       const rows = await importFromExcel(file);

//       if (!rows.length) {
//         setImportError('The Excel file does not contain any data.');

//         setTimeout(() => {
//           setImportError('');
//         }, 3000);

//         return;
//       }

//       const requiredFields = [
//         'Bank_Code',
//         'Bank_Name',
//         'Swift_Code',
//         'Head_Office',
//         'Remarks',
//         'Created _By',
//       ];

//       const missingHeaders = requiredFields.filter(
//         field => !(field in rows[0])
//       );

//       if (missingHeaders.length) {
//         setImportError(`Invalid bank Excel file.\n\nMissing columns:\n${missingHeaders.join('\n')}`);

//         setTimeout(() => {
//           setImportError('');
//         }, 3000);

//         return;
//       }

//       for (const row of rows) {
//         if (!row.Bank_Code || !row.Bank_Name) {
//           continue;
//         }

//         await dispatch(addBank({
//           p_bankCode: String(row.Bank_Code).trim(),
//           p_bankName: String(row.Bank_Name).trim(),
//           p_shortName: '',
//           p_swiftCode: String(row.Swift_Code || '').trim(),
//           p_headOffice: String(row.Head_Office || '').trim() === "Null" ? '' : String(row.Head_Office),
//           p_bankRemarks: String(row.Remarks || '').trim(),
//           p_bankCreatedBy: String(row['Created _By'] || 'System').trim(),
//         }));
//       }

//       await dispatch(getBankList());

//       setImportSuccess(`Successfully imported ${rows.length} bank row(s).`);

//       setTimeout(() => {
//         setImportSuccess('');
//       }, 3000);
//     } catch (error) {
//       console.error('Bank import failed:', error);

//       setImportError(error?.message || 'An error occurred while importing the bank Excel file.');

//       setTimeout(() => {
//         setImportError('');
//       }, 3000);

//     } finally {
//       setImporting(false);
//       event.target.value = '';
//     }
//   };

//   const handleSelect = (r) => {
//     setEditingId(r.id);
//     setForm({ bankCode: r.bankCode, bankName: r.bankName, shortName: r.shortName, swiftCode: r.swiftCode, headOffice: r.headOffice, isActive: r.isActive, isApproved: r.isApproved });
//   };

//   const handleClear = () => {
//     setEditingId(null);
//     setForm(EMPTY_BANK_FORM);
//     dispatch(clearBankError());
//   };

//   const handleSave = () => {
//     if (!form.bankCode || !form.bankName) return;
//     if (editingId) {
//       dispatch(updateBank({
//         p_bankId: editingId,
//         p_bankCode: form.bankCode,
//         p_bankName: form.bankName,
//         p_shortName: form.shortName,
//         p_swiftCode: form.swiftCode,
//         p_headOffice: form.headOffice,
//         p_remarks: form.remarks || '',
//         p_bankIsActive: form.isActive ? "True" : "False", 
//         p_updatedBy: getLoggedInServiceNo() || 'admin',
//         // Ticking "Approved" in edit mode stamps who approved it and when.
//         ...masterApprovalParams(form.isApproved, getLoggedInServiceNo() || 'admin'),
//       }));
//     } else {
//       dispatch(addBank({
//         p_bankCode: form.bankCode,
//         p_bankName: form.bankName,
//         p_shortName: form.shortName || '',
//         p_swiftCode: form.swiftCode,
//         p_headOffice: form.headOffice || '',
//         p_bankRemarks: form.remarks || '',
//         p_bankCreatedBy: getLoggedInServiceNo() || 'admin',
//         p_isApproved: NEW_MASTER_IS_APPROVED,   // new banks always start pending
//       }));
//     }
//   };

//   return (
//     <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
//       <div className="lg:col-span-2 space-y-3">
//         <div className="flex gap-2">
//           <div className="relative flex-1">
//             <Search
//               size={12}
//               className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
//             />

//             <input
//               className="h-9 bg-white border border-gray-200 rounded-lg text-xs pl-8 pr-3 w-full outline-none text-gray-700 focus:border-primary-500"
//               placeholder="Search banks"
//               value={search}
//               onChange={e => setSearch(e.target.value)}
//             />
//           </div>

//           <select
//             value={statusFilter}
//             onChange={e => setStatusFilter(e.target.value)}
//             className="border border-surface-200 rounded-lg px-3 py-2 text-xs focus:outline-none focus:border-primary-400 bg-white"
//           >
//             <option value="all">All</option>
//             <option value="pending">Pending</option>
//             <option value="approved">Approved</option>
//           </select>

//           <label
//             className={`flex items-center gap-1 border border-surface-200 ${
//               importing
//                 ? 'text-surface-400 cursor-not-allowed'
//                 : 'text-surface-600 hover:bg-surface-50 cursor-pointer'
//             } text-xs px-3 py-2 rounded-lg transition-colors whitespace-nowrap`}
//           >
//             <Upload size={13} />
//             {importing ? 'Importing...' : 'Import'}

//             <input
//               type="file"
//               accept=".xlsx,.xls"
//               onChange={handleImport}
//               disabled={importing}
//               className="hidden"
//             />
//           </label>

//           <button
//             type="button"
//             onClick={handleExport}
//             className="flex items-center gap-1 border border-surface-200 hover:bg-surface-50 text-surface-600 text-xs px-3 py-2 rounded-lg transition-colors whitespace-nowrap"
//           >
//             <Download size={13} />
//             Export
//           </button>
//         </div>

//         {importSuccess && (
//           <div className="mb-3 flex items-center gap-2 bg-emerald-50 border border-emerald-200 text-emerald-700 rounded-lg px-3 py-2 text-xs">
//             <CheckCircle size={14} />
//             <span>{importSuccess}</span>
//           </div>
//         )}

//         {importError && (
//           <div className="mb-3 flex items-center gap-2 bg-red-50 border border-red-200 text-red-700 rounded-lg px-3 py-2 text-xs">
//             <CheckCircle size={14} />
//             <span>{importError}</span>
//           </div>
//         )}

//         <MFGridSection title="Bank Details" count={filtered.length}>
//           {loading ? (
//             <div className="py-20 flex items-center justify-center gap-2 text-sm text-gray-400">
//               <Loader2 size={14} className="animate-spin" /> Loading banks...
//             </div>
//           ) : error ? (
//             <div className="py-20 flex items-center justify-center gap-2 text-sm text-red-600">
//               <AlertCircle size={13} className="shrink-0" /> {error}
//             </div>
//           ) : filtered.length === 0 ? (
//             <div className="flex flex-col items-center justify-center py-20 text-center text-gray-400">
//               <Tag size={24} className="text-gray-300 mb-2" />
//               <p className="text-sm text-gray-400">No banks yet</p>
//             </div>
//           ) : (
//             <table className="w-full text-[13px]">
//               <thead>
//                 <tr className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">
//                   {['Code', 'Name', 'Short Name', 'Swift Code', 'Head Office', 'Status'].map(h => (
//                     <th key={h} className={MF_TH}>{h}</th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {filtered.map((r) => (
//                   <tr key={r.id || r.code} onClick={() => handleSelect(r)}
//                     className={`${MF_ROW} ${MF_ROW_IDLE} ${editingId === r.id ? MF_ROW_SEL : ''}`}>
//                     <td className="px-4 py-3 font-mono text-gray-900 font-semibold">{r.bankCode}</td>
//                     <td className="px-4 py-3 text-gray-900 font-medium max-w-xs truncate">{r.bankName}</td>
//                     <td className="px-4 py-3 text-gray-600 max-w-[120px] truncate">{r.shortName || '-'}</td>
//                     <td className="px-4 py-3 text-gray-600 max-w-[160px] truncate">{r.swiftCode || '-'}</td>
//                     <td className="px-4 py-3 text-gray-600 max-w-[160px] truncate">{r.headOffice || '-'}</td>
//                     <td className="px-4 py-3 text-gray-600 max-w-[160px] truncate">
//                       <span
//                         className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
//                           r.isApproved
//                             ? 'bg-emerald-50 text-emerald-700'
//                             : 'bg-amber-50 text-amber-700'
//                         }`}
//                       >
//                         {r.isApproved ? 'Approved' : 'Pending'}
//                       </span>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           )}
//         </MFGridSection>
//       </div>

//       <MFEntryPanel
//         title={editingId ? 'Edit Bank' : 'Bank Entry'}
//         onSave={handleSave}
//         onClear={handleClear}
//         saved={success}
//       >
//         <div>
//           <MFLabel req>Code</MFLabel>
//           <input className={MF_INP} value={form.bankCode} disabled={!!editingId}
//             onChange={e => setForm(f => ({ ...f, bankCode: e.target.value }))} />
//           {editingId && <p className="text-[10px] text-surface-400 mt-0.5">Code can't be changed once created</p>}
//         </div>
//         <div>
//           <MFLabel req>Name</MFLabel>
//           <input className={MF_INP} value={form.bankName}
//             onChange={e => setForm(f => ({ ...f, bankName: e.target.value }))} />
//         </div>
//         <div>
//           <MFLabel>Short Name</MFLabel>
//           <input className={MF_INP} value={form.shortName}
//             onChange={e => setForm(f => ({ ...f, shortName: e.target.value }))} />
//         </div>
//         <div>
//           <MFLabel>Swift Code</MFLabel>
//           <input className={MF_INP} value={form.swiftCode}
//             onChange={e => setForm(f => ({ ...f, swiftCode: e.target.value }))} />
//         </div>
//         <div>
//           <MFLabel>Head Office</MFLabel>
//           <input className={MF_INP} value={form.headOffice}
//             onChange={e => setForm(f => ({ ...f, headOffice: e.target.value }))} />
//         </div>

//         {/* Approval tick only while editing an existing bank — a new entry is
//             always saved as pending, so showing it during entry is misleading. */}
//         {editingId ? (
//           <div className="flex items-center gap-2 pt-2">
//             <input
//               id="bankIsApproved"
//               type="checkbox"
//               checked={form.isApproved}
//               onChange={e =>
//                 setForm(prev => ({ ...prev, isApproved: e.target.checked }))
//               }
//               className="w-4 h-4 rounded border-surface-300 text-primary-600 focus:ring-primary-500"
//             />
//             <label
//               htmlFor="bankIsApproved"
//               className="text-sm font-medium text-surface-700 cursor-pointer"
//             >
//               Approved
//             </label>
//           </div>
//         ) : (
//           <p className="pt-2 text-[10px] text-amber-600">
//             New banks are saved as <span className="font-semibold">Pending</span> and can be approved after saving.
//           </p>
//         )}
//         {saving && <p className="text-[10px] text-primary-500">Saving...</p>}
//         {error && <p className="text-[10px] text-red-500">{error}</p>}
//       </MFEntryPanel>
//     </div>
//   );
// }

// // ─── MF Section: Bank Branch ──────────────────────────────────────────────────
// const EMPTY_BRANCH_FORM = {
//   bankId: '',
//   branchCode: '',
//   branchName: '',
//   address: '',
//   swiftCode: '',
//   isActive: false,
//   isApproved: false,   // new branches start pending
// };

// function MFBankBranch() {
//   const dispatch = useDispatch();
//   const { banks } = useSelector(s => s.bankSlice);
//   const { bankBranches, loading, saving, error, success } = useSelector(s => s.bankBranchSlice);

//   const [search, setSearch] = useState('');
//   const [statusFilter, setStatusFilter] = useState('all');
//   const [form, setForm] = useState(EMPTY_BRANCH_FORM);
//   const [editingId, setEditingId] = useState(null);
//   const [importing, setImporting] = useState(false);
//   const [importSuccess, setImportSuccess] = useState('');
//   const [importError, setImportError] = useState('');
//   const [duplicateError, setDuplicateError] = useState('');

//   useEffect(() => {
//     dispatch(getBankList());
//     dispatch(getBankBranchList());
//   }, [dispatch]);

//   useEffect(() => {
//     if (success) {
//       dispatch(getBankBranchList());

//       setForm(EMPTY_BRANCH_FORM);
//       setEditingId(null);
//       setDuplicateError('');

//       const t = setTimeout(
//         () => dispatch(clearBankBranchSuccess()),
//         1500
//       );

//       return () => clearTimeout(t);
//     }
//   }, [success, dispatch]);

//   // Bank lookup: id -> name, used to label groups and the select dropdown
//   const bankRows = (banks || []).map(b => ({
//     id:   pickField(b, ['HBD_BANK_ID']),
//     code:   pickField(b, ['HBD_BANK_CODE']),
//     name: pickField(b, ['HBD_BANK_NAME']),
//   }));

//   const bankNameById = Object.fromEntries(bankRows.map(b => [String(b.id), b.name]));
//   const bankCodeById = Object.fromEntries(bankRows.map(b => [String(b.id), b.code]));

//   const branchRows = (bankBranches || []).map(r => ({
//     id:         pickField(r, ['HBB_BRANCH_ID', 'BranchId', 'branchId']),
//     bankId:     pickField(r, ['HBB_BANK_ID', 'BankId', 'bankId']),
//     code:       pickField(r, ['HBB_BRANCH_CODE', 'BranchCode', 'branchCode']),
//     name:       pickField(r, ['HBB_BRANCH_NAME', 'BranchName', 'branchName']),
//     address:    pickField(r, ['HBB_ADDRESS', 'BranchAddress', 'branchAddress']),
//     swiftCode:  pickField(r, ['HBB_SWIFT_CODE', 'SwitftCode', 'swiftCode']),
//     isActive:   toBoolean(pickField(r, ['HBB_IS_ACTIVE', 'HBB_BRANCH_IS_ACTIVE', 'BranchIsActive', 'branchIsActive', 'IsActive', 'isActive'])),
//     isApproved: isMasterApproved(r),
//   }));

//   const handleExport = () => {
//     const exportData = branchRows.map(r => ({
//       Bank_Code: bankCodeById[String(r.bankId)] || '',
//       Branch_Code: r.code || '',
//       Branch_Name: r.name || '',
//       Branch_Address: r.address || '',
//       Swift_Code: r.swiftCode || '',
//     }));

//     exportToExcel(exportData, 'bankBranches.xlsx');
//   };

//   const handleImport = async (event) => {
//     const file = event.target.files?.[0];

//     if (!file) return;

//     try {
//       setImporting(true);

//       const rows = await importFromExcel(file);

//       if (!rows.length) {
//         setImportError('The Excel file does not contain any data.');

//         setTimeout(() => {
//           setImportError('');
//         }, 3000);

//         return;
//       }

//       const requiredFields = [
//         'Bank_Code',
//         'Branch_Code',
//         'Branch_Name',
//         'Branch_Address',
//         'Swift_Code',
//       ];

//       const missingHeaders = requiredFields.filter(
//         field => !(field in rows[0])
//       );

//       if (missingHeaders.length) {
//         setImportError(`Invalid bank branch Excel file.\n\nMissing columns:\n${missingHeaders.join('\n')}`);

//         setTimeout(() => {
//           setImportError('');
//         }, 3000);

//         return;
//       }

//       for (const row of rows) {
//         if (!row.Bank_Code || !row.Branch_Code || !row.Branch_Name) {
//           continue;
//         }

//         const bankCode = String(row.Bank_Code).trim();

//         const bank = bankRows.find(
//           b => String(b.code).trim() === bankCode
//         );

//         if (!bank) {
//           console.error(
//             `Bank code ${bankCode} was not found. Skipping branch.`,
//             row
//           );
//           continue;
//         }

//         await dispatch(addBankBranch({
//           p_bankId: bank.id,
//           p_branchCode: String(row.Branch_Code).trim(),
//           p_branchName: String(row.Branch_Name).trim(),
//           p_branchAddress: String(row.Branch_Address || '').trim(),
//           p_swiftCode: String(row.Swift_Code || '').trim(),
//           p_branchCreatedBy: getLoggedInServiceNo() || 'admin',
//           p_branchIsActive: 'False',
//         }));
//       }

//       await dispatch(getBankBranchList());

//       setImportSuccess(`Successfully imported ${rows.length} branch row(s).`);

//       setTimeout(() => {
//         setImportSuccess('');
//       }, 3000);
//     } catch (error) {
//       console.error('Bank branch import failed:', error);

//       setImportError(error?.message || 'An error occurred while importing the bank branch Excel file.');

//       setTimeout(() => {
//         setImportError('');
//       }, 3000);

//     } finally {
//       setImporting(false);
//       event.target.value = '';
//     }
//   };

//   const filtered = branchRows.filter(r => {
//     const matchesSearch =
//       r.name.toLowerCase().includes(search.toLowerCase()) ||
//       r.code.toLowerCase().includes(search.toLowerCase()) ||
//       (bankNameById[String(r.bankId)] || '').toLowerCase().includes(search.toLowerCase());

//     const matchesStatus =
//       statusFilter === 'all' ||
//       (statusFilter === 'pending' && !r.isApproved) ||
//       (statusFilter === 'approved' && r.isApproved);

//     return matchesSearch && matchesStatus;
//   });

//   // Group branches by bank, sorted so branches with the same bank sit together
//   const grouped = useMemo(() => {
//     const map = new Map();
//     filtered.forEach(r => {
//       const key = String(r.bankId);
//       if (!map.has(key)) map.set(key, []);
//       map.get(key).push(r);
//     });
//     return Array.from(map.entries())
//       .map(([bankId, branches]) => ({
//         bankId,
//         bankName: bankNameById[bankId] || `Bank #${bankId}`,
//         branches,
//       }))
//       .sort((a, b) => a.bankName.localeCompare(b.bankName));
//   }, [filtered, bankNameById]);

//   const handleSave = () => {
//     setDuplicateError('');
//     if (!form.bankId || !form.branchCode || !form.branchName) return;

//     const trimmedCode = form.branchCode.trim().toLowerCase();
//     const trimmedName = form.branchName.trim().toLowerCase();

//     const dupCode = branchRows.find(
//       r => String(r.id) !== String(editingId) &&
//            String(r.bankId) === String(form.bankId) &&
//            (r.code || '').trim().toLowerCase() === trimmedCode
//     );

//     const dupName = branchRows.find(
//       r => String(r.id) !== String(editingId) &&
//            String(r.bankId) === String(form.bankId) &&
//            (r.name || '').trim().toLowerCase() === trimmedName
//     );

//     if (dupCode && dupName) {
//       setDuplicateError(`Duplicate branch entry! Code '${form.branchCode.trim()}' and Name '${form.branchName.trim()}' already exist for this bank.`);
//       return;
//     }

//     if (dupCode) {
//       setDuplicateError(`Duplicate branch code! A branch with code '${form.branchCode.trim()}' already exists for this bank.`);
//       return;
//     }

//     if (dupName) {
//       setDuplicateError(`Duplicate branch name! A branch with name '${form.branchName.trim()}' already exists for this bank.`);
//       return;
//     }

//     const serviceNo = getLoggedInServiceNo() || 'admin';

//     if (editingId) {
//       dispatch(updateBankBranch({
//         p_branchId: editingId,
//         p_bankId: form.bankId,
//         p_branchCode: form.branchCode,
//         p_branchName: form.branchName,
//         p_branchAddress: form.address || '',
//         p_swiftCode: form.swiftCode || '',
//         p_branchUpdatedBy: serviceNo,
//         p_branchRemarks: form.remarks || '',
//         p_branchIsActive: form.isActive ? "True" : "False",
//         // Ticking "Approved" in edit mode stamps who approved it and when.
//         ...masterApprovalParams(form.isApproved, getLoggedInServiceNo() || 'admin'),
//       }));
//     } else {
//       dispatch(addBankBranch({
//         p_bankId: form.bankId,
//         p_branchCode: form.branchCode,
//         p_branchName: form.branchName,
//         p_branchAddress: form.address || '',
//         p_swiftCode: form.swiftCode || '',
//         p_branchCreatedBy: serviceNo,
//         p_branchRemarks: form.remarks || '',
//         p_branchIsActive: "False",
//         p_isApproved: NEW_MASTER_IS_APPROVED,   // new branches always start pending
//       }));
//     }
//   };

//   const handleSelect = (r) => {
//     setEditingId(r.id);
//     setDuplicateError('');

//     setForm({
//       bankId: r.bankId != null ? String(r.bankId) : '',
//       branchCode: r.code ?? '',
//       branchName: r.name ?? '',
//       address: r.address ?? '',
//       swiftCode: r.swiftCode ?? '',
//       isActive: r.isActive ?? false,
//       isApproved: r.isApproved ?? false,
//     });
//   };

//   return (
//     <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
//       <div className="lg:col-span-2 space-y-3">
//         <div className="flex gap-2">
//           <div className="relative flex-1">
//             <Search
//               size={12}
//               className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
//             />
//             <input
//               className="h-9 bg-white border border-gray-200 rounded-lg text-xs pl-8 pr-3 w-full outline-none text-gray-700 focus:border-primary-500"
//               placeholder="Search bank branches"
//               value={search}
//               onChange={e => setSearch(e.target.value)}
//             />
//           </div>

//           <select
//             value={statusFilter}
//             onChange={e => setStatusFilter(e.target.value)}
//             className="border border-surface-200 rounded-lg px-3 py-2 text-xs focus:outline-none focus:border-primary-400 bg-white"
//           >
//             <option value="all">All</option>
//             <option value="pending">Pending</option>
//             <option value="approved">Approved</option>
//           </select>

//           <label
//             className={`flex items-center gap-1 border border-surface-200 ${
//               importing
//                 ? 'text-surface-400 cursor-not-allowed'
//                 : 'text-surface-600 hover:bg-surface-50 cursor-pointer'
//             } text-xs px-3 py-2 rounded-lg transition-colors whitespace-nowrap`}
//           >
//             <Upload size={13} />
//             {importing ? 'Importing...' : 'Import'}

//             <input
//               type="file"
//               accept=".xlsx,.xls"
//               onChange={handleImport}
//               disabled={importing}
//               className="hidden"
//             />
//           </label>

//           <button
//             type="button"
//             onClick={handleExport}
//             className="flex items-center gap-1 border border-surface-200 hover:bg-surface-50 text-surface-600 text-xs px-3 py-2 rounded-lg transition-colors whitespace-nowrap"
//           >
//             <Download size={13} />
//             Export
//           </button>
//         </div>

//         {importSuccess && (
//           <div className="mb-3 flex items-center gap-2 bg-emerald-50 border border-emerald-200 text-emerald-700 rounded-lg px-3 py-2 text-xs">
//             <CheckCircle size={14} />
//             <span>{importSuccess}</span>
//           </div>
//         )}

//         {importError && (
//           <div className="mb-3 flex items-center gap-2 bg-red-50 border border-red-200 text-red-700 rounded-lg px-3 py-2 text-xs">
//             <CheckCircle size={14} />
//             <span>{importError}</span>
//           </div>
//         )}

//         {loading ? (
//           <MFGridSection title="Bank Branch Details">
//             <div className="py-20 flex items-center justify-center gap-2 text-sm text-gray-400">
//               <Loader2 size={14} className="animate-spin" /> Loading branches...
//             </div>
//           </MFGridSection>
//         ) : error ? (
//           <MFGridSection title="Bank Branch Details">
//             <div className="py-20 flex items-center justify-center gap-2 text-sm text-red-600">
//               <AlertCircle size={13} className="shrink-0" /> {error}
//             </div>
//           </MFGridSection>
//         ) : grouped.length === 0 ? (
//           <MFGridSection title="Bank Branch Details">
//             <div className="flex flex-col items-center justify-center py-20 text-center text-gray-400">
//               <Building2 size={24} className="text-gray-300 mb-2" />
//               <p className="text-sm text-gray-400">No branches yet</p>
//             </div>
//           </MFGridSection>
//         ) : (
//           grouped.map(group => (
//             <MFGridSection key={group.bankId} title={group.bankName} count={group.branches.length}>
//               <table className="w-full text-[13px]">
//                 <thead>
//                   <tr className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">
//                     {['Code', 'Name', 'Address', 'Swift Code', 'Status'].map(h => (
//                       <th key={h} className={MF_TH}>{h}</th>
//                     ))}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {group.branches.map(r => (
//                     <tr
//                       key={r.id || r.code}
//                       onClick={() => handleSelect(r)}
//                       className={`${MF_ROW} ${MF_ROW_IDLE} ${
//                         editingId === r.id ? MF_ROW_SEL : ''
//                       }`}
//                     >
//                       <td className="px-4 py-3 font-mono text-gray-900 font-semibold">
//                         {r.code}
//                       </td>

//                       <td className="px-4 py-3 text-gray-900 font-medium">
//                         {r.name}
//                       </td>

//                       <td className="px-4 py-3 text-gray-600 max-w-[200px] truncate">
//                         {r.address || '—'}
//                       </td>

//                       <td className="px-4 py-3 text-gray-600 max-w-[160px] truncate">
//                         {r.swiftCode || '—'}
//                       </td>

//                       <td className="px-4 py-3 text-gray-600 max-w-[160px] truncate">
//                         <span
//                           className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
//                             r.isApproved
//                               ? 'bg-emerald-50 text-emerald-700'
//                               : 'bg-amber-50 text-amber-700'
//                           }`}
//                         >
//                           {r.isApproved ? 'Approved' : 'Pending'}
//                         </span>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </MFGridSection>
//           ))
//         )}
//       </div>

//       <MFEntryPanel
//         title={editingId ? 'Edit Bank Branch' : 'Branch Entry'}
//         onSave={handleSave}
//         onClear={() => {
//           setEditingId(null);
//           setDuplicateError('');
//           setForm(EMPTY_BRANCH_FORM);
//         }}
//         saved={success}
//       >
//         <div>
//           <MFLabel req>Bank</MFLabel>
//           <select
//             className={MF_SEL}
//             value={form.bankId}
//             onChange={e => {
//               setDuplicateError('');
//               setForm(f => ({
//                 ...f,
//                 bankId: e.target.value,
//               }));
//             }}
//           >
//             <option value="">Select...</option>

//             {bankRows.map(b => (
//               <option key={b.id} value={String(b.id)}>
//                 {b.name}
//               </option>
//             ))}
//           </select>
//         </div>
//         <div>
//           <MFLabel req>Branch Code</MFLabel>
//           <input
//             className={MF_INP}
//             value={form.branchCode}
//             onChange={e => {
//               setDuplicateError('');
//               setForm(f => ({ ...f, branchCode: e.target.value }));
//             }}
//           />
//         </div>
//         <div>
//           <MFLabel req>Branch Name</MFLabel>
//           <input
//             className={MF_INP}
//             value={form.branchName}
//             onChange={e => {
//               setDuplicateError('');
//               setForm(f => ({ ...f, branchName: e.target.value }));
//             }}
//           />
//         </div>
//         <div>
//           <MFLabel>Address</MFLabel>
//           <input className={MF_INP} value={form.address} onChange={e => setForm(f => ({ ...f, address: e.target.value }))} />
//         </div>
//         <div>
//           <MFLabel>Swift Code</MFLabel>
//           <input className={MF_INP} value={form.swiftCode} onChange={e => setForm(f => ({ ...f, swiftCode: e.target.value }))} />
//         </div>

//         {/* Approval tick only while editing an existing branch. */}
//         {editingId ? (
//           <div className="flex items-center gap-2 pt-2">
//             <input
//               id="branchIsApproved"
//               type="checkbox"
//               checked={form.isApproved}
//               onChange={e =>
//                 setForm(prev => ({ ...prev, isApproved: e.target.checked }))
//               }
//               className="w-4 h-4 rounded border-surface-300 text-primary-600 focus:ring-primary-500"
//             />
//             <label
//               htmlFor="branchIsApproved"
//               className="text-sm font-medium text-surface-700 cursor-pointer"
//             >
//               Approved
//             </label>
//           </div>
//         ) : (
//           <p className="pt-2 text-[10px] text-amber-600">
//             New branches are saved as <span className="font-semibold">Pending</span> and can be approved after saving.
//           </p>
//         )}

//         {duplicateError && (
//           <div className="flex items-center gap-1.5 text-xs text-red-600 bg-red-50 border border-red-200 rounded p-2 mt-2 font-medium">
//             <AlertCircle size={14} className="shrink-0 text-red-500" />
//             <span>{duplicateError}</span>
//           </div>
//         )}

//         {saving && <p className="text-[10px] text-primary-500">Saving...</p>}
//         {error && <p className="text-[10px] text-red-500">{error}</p>}
//       </MFEntryPanel>
//     </div> 
//   );
// }

// // ─── MF Section: Calendar ─────────────────────────────────────────────────────
// function MFCalendar() {
//   const today = new Date().toISOString().split('T')[0];
//   const [holidays, setHolidays] = useState(SEED_CALENDAR);
//   const [form, setForm] = useState({ date: today, type: '', hours: 0, description: '' });
//   const [saved, setSaved] = useState(false);
//   const handleSave = () => {
//     if (!form.date || !form.type) return;
//     setHolidays(prev => { const idx = prev.findIndex(h => h.date === form.date); if (idx >= 0) { const n = [...prev]; n[idx] = { ...form }; return n; } return [...prev, { ...form }].sort((a, b) => a.date.localeCompare(b.date)); });
//     setSaved(true); setTimeout(() => setSaved(false), 1500);
//   };
//   return (
//     <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
//       <div className="lg:col-span-2">
//         <MFGridSection title="Calendar — Holiday Schedule" count={holidays.length}>
//           <table className="w-full text-[13px]">
//             <thead><tr className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">{['Date','Type','Hours','Description'].map(h => <th key={h} className={MF_TH}>{h}</th>)}</tr></thead>
//             <tbody>
//               {holidays.map((r, i) => (
//                 <tr key={r.date + r.type} onClick={() => setForm({ date: r.date, type: r.type, hours: r.hours, description: r.description })}
//                   className={`${MF_ROW} ${MF_ROW_IDLE} ${i === 0 ? 'bg-primary-50/50' : ''}`}>
//                   <td className="px-4 py-3 font-mono text-gray-900 font-semibold">{r.date}</td>
//                   <td className="px-4 py-3">
//                     <span className={`px-2 py-0.5 rounded text-[10px] font-medium ${r.type === 'Mercantile Holiday' ? 'bg-orange-100 text-orange-700' : r.type === 'Poya Day' ? 'bg-purple-100 text-purple-700' : r.type === 'Company Holiday' ? 'bg-blue-100 text-blue-700' : r.type === 'Half Day' ? 'bg-yellow-100 text-yellow-700' : 'bg-surface-100 text-surface-600'}`}>{r.type}</span>
//                   </td>
//                   <td className="px-4 py-3 text-gray-600">{r.hours}</td>
//                   <td className="px-4 py-3 text-gray-900 font-medium">{r.description}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </MFGridSection>
//       </div>
//       <MFEntryPanel title="Holiday Entry" onSave={handleSave} onClear={() => setForm({ date: today, type: '', hours: 0, description: '' })} saved={saved}>
//         <div><MFLabel req>Date</MFLabel><input className={MF_INP} type="date" value={form.date} onChange={e => setForm(f => ({ ...f, date: e.target.value }))} /></div>
//         <div><MFLabel req>Type</MFLabel><select className={MF_SEL} value={form.type} onChange={e => setForm(f => ({ ...f, type: e.target.value }))}><option value="">Select...</option><option>Mercantile Holiday</option><option>Poya Day</option><option>Company Holiday</option><option>Half Day</option><option>Bank Holiday</option></select></div>
//         <div><MFLabel>No. of Hours</MFLabel><input className={MF_INP} type="number" min="0" max="12" value={form.hours} onChange={e => setForm(f => ({ ...f, hours: parseInt(e.target.value) }))} /></div>
//         <div><MFLabel>Description</MFLabel><input className={MF_INP} value={form.description} onChange={e => setForm(f => ({ ...f, description: e.target.value }))} /></div>
//       </MFEntryPanel>
//     </div>
//   );
// }

// // ─── Master Files Main View (embedded in HRM) ─────────────────────────────────
// function HRMasterFilesView() {
//   const [mfTab, setMfTab] = useState('overview');
//   const activeTab = MF_TABS.find(t => t.key === mfTab);

//   const renderContent = () => {
//     switch (mfTab) {
//       case 'overview':     return <MFOverview setMfTab={setMfTab} />;
//       case 'department':   return <MFDepartment />;
//       case 'location':     return <MFLocation />;
//       case 'designation':  return <MFDesignation />;
//       case 'emptype':      return <MFEmploymentTypes />;
//       case 'grade':        return <MFGrade />;
//       case 'education':    return <MFEducation />;
//       case 'professional': return <MFProfessional />;
//       case 'shift':        return <MFShift />;
//       case 'province':     return <MFProvince />;
//       case 'bank':         return <MFBank />;
//       case 'bankBranch':   return <MFBankBranch />;
//       default:             return null;
//     }
//   };

//   return (
//     <div className="-mx-4 lg:-mx-6 -mt-2 min-h-screen">
//       {/* Main content area (no vertical sidebar) */}
//       <div className="overflow-auto bg-gray-50/50">
//         <div className="p-4 lg:p-6">
//           {/* Breadcrumb header */}
//           <div className="flex items-center justify-between mb-5">
//             <div>
//               <div className="flex items-center gap-2 text-xs text-surface-400 mb-1">
//                 <span>eHRM</span>
//                 <ChevronRight size={10} />
//                 <span>Master Files</span>
//                 <ChevronRight size={10} />
//                 <span className="text-primary-600 font-semibold">{activeTab?.label}</span>
//               </div>
//               <h1 className="text-xl font-bold text-surface-900">{activeTab?.label}</h1>
//             </div>
//             {mfTab !== 'overview' && (
//               <button
//                 onClick={() => setMfTab('overview')}
//                 className="flex items-center gap-1 text-xs text-surface-500 hover:text-primary-600 border border-surface-200 rounded-lg px-3 py-1.5 transition-colors hover:border-primary-400"
//               >
//                 ← Back to Overview
//               </button>
//             )}
//           </div>
//           {/* Horizontal tabs for quicker navigation (scrollable) */}
//           <div className="mb-5 overflow-x-auto">
//             <div className="flex items-center gap-2">
//               {MF_TABS.map(t => (
//                 <button
//                   key={t.key}
//                   onClick={() => setMfTab(t.key)}
//                   className={`px-3 py-1.5 rounded text-xs font-medium whitespace-nowrap transition-colors ${mfTab === t.key ? 'bg-surface-900 text-primary-400' : 'bg-surface-100 text-surface-500 hover:bg-surface-200 hover:text-surface-800'}`}
//                 >
//                   <t.icon size={12} className="inline mr-2" />
//                   {t.label}
//                 </button>
//               ))}
//             </div>
//           </div>
//           {renderContent()}
//         </div>
//       </div>
//     </div>
//   );
// }

// // ─── MAIN HRM PAGE ────────────────────────────────────────────────────────────
// export default function HRMPage() {
//   const dispatch = useDispatch();
//   const { employees: hrEmployees, attendance, leaveRequests, payroll, recruitment, training, disciplinary, hrAssets, exits, loading } = useSelector(s => s.hr);
//   const { employees: empEmployees, loading: empLoading, adding: empAdding, error: empError } = useSelector(s => s.emp);
//   const { employees: realEmployees } = useSelector(s => s.employees);
//   // Merge: real API employees take priority; fall back to mock hr employees
//   const employees = empEmployees && empEmployees.length > 0 ? empEmployees : hrEmployees;
//   const { activeModule: reduxActiveModule } = useSelector(s => s.ui);
//   const activeModule = reduxActiveModule || 'overview';
//   const [activeReport, setActiveReport] = useState(null);

//   const [search, setSearch] = useState('');
//   const [showAddEmployee, setShowAddEmployee] = useState(false);
//   const [viewEmployee, setViewEmployee] = useState(null);
//   const [showLeaveModal, setShowLeaveModal] = useState(false);
//   const [showRecruitModal, setShowRecruitModal] = useState(false);
//   const [showTrainingModal, setShowTrainingModal] = useState(false);
//   const [showDiscModal, setShowDiscModal] = useState(false);
//   const [showAssetModal, setShowAssetModal] = useState(false);
//   const [showExitModal, setShowExitModal] = useState(false);
//   const [leaveForm, setLeaveForm] = useState({ employeeId: '', type: 'Annual', from: '', to: '', days: 1, reason: '' });
//   const [recruitForm, setRecruitForm] = useState({ position: '', department: '', vacancies: 1, postedDate: '', closingDate: '' });
//   const [trainingForm, setTrainingForm] = useState({ title: '', employeeId: '', category: 'Technical', startDate: '', endDate: '', provider: '', status: 'Scheduled' });
//   const [discForm, setDiscForm] = useState({ employeeId: '', type: 'Warning Letter', reason: '', date: '', issuedBy: '' });
//   const [assetForm, setAssetForm] = useState({ employeeId: '', assetType: '', assetId: '', issuedDate: '', condition: 'Good' });
//   const [exitForm, setExitForm] = useState({ employeeId: '', resignDate: '', lastDay: '', reason: '', finalSettlement: 0 });

//   useEffect(() => {
//     dispatch(fetchEmployees());
//     dispatch(fetchAllEMP());
//     dispatch(fetchAllEmployees());
//     dispatch(fetchAttendance());
//     dispatch(fetchLeave());
//     dispatch(fetchPayroll());
//     dispatch(fetchRecruitment());
//     dispatch(fetchTraining());
//     dispatch(fetchDisciplinary());
//     dispatch(fetchHRAssets());
//     dispatch(fetchExits());
//   }, [dispatch]);

//   const filtered = employees.map(normEmp).filter(e => {
//     const name = `${e.firstName || ''} ${e.lastName || ''}`.toLowerCase();
//     const q = search.toLowerCase();
//     return name.includes(q)
//       || (e.department || '').toLowerCase().includes(q)
//       || (e.id || '').toLowerCase().includes(q)
//       || (e.p_ced_service_no || '').toLowerCase().includes(q)
//       || (e.p_email || '').toLowerCase().includes(q);
//   });

//   const empName = (id) => { const e = employees.find(x => x.id === id); return e ? `${e.firstName || ''} ${e.lastName || e.name || ''}`.trim() : id; };
//   const setLF = (k, v) => setLeaveForm(f => ({ ...f, [k]: v }));
//   const setRF = (k, v) => setRecruitForm(f => ({ ...f, [k]: v }));
//   const setTF = (k, v) => setTrainingForm(f => ({ ...f, [k]: v }));
//   const setDF = (k, v) => setDiscForm(f => ({ ...f, [k]: v }));
//   const setAF = (k, v) => setAssetForm(f => ({ ...f, [k]: v }));
//   const setEF = (k, v) => setExitForm(f => ({ ...f, [k]: v }));

//   const inputCls = "input-field text-sm";
//   const selectCls = "input-field text-sm";
//   const activeCount = employees.filter(e => e.status === 'Active').length;
//   const pendingLeave = leaveRequests.filter(l => l.status === 'Pending').length;
//   const pendingPayroll = payroll.filter(p => p.status === 'Pending').length;

//   return (
//     <div className="min-h-screen">
//       <div className="overflow-auto min-w-0">

//         {/* ═══ OVERVIEW ═══ */}
//         {activeModule === 'overview' && (
//           <HRMDashboard />
//         )}

//         {/* ═══ EMPLOYEE MANAGEMENT ═══ */}
//         {activeModule === 'employees' && (
//           <div>
//             <PageHeader title="Employee Management" subtitle="Master data, records & documents (eHRM)"
//               actions={<button onClick={() => setShowAddEmployee(true)} className="btn-primary flex items-center gap-2"><Plus size={14} /> Add Employee</button>}
//             />
//             {(empLoading || empAdding) && (
//               <div className="flex items-center gap-2 text-xs text-primary-600 mb-3 bg-primary-50 border border-primary-200 rounded-lg px-3 py-2">
//                 <span className="animate-spin border-2 border-primary-400 border-t-transparent rounded-full w-3 h-3 inline-block" />
//                 {empAdding ? 'Saving employee to API...' : 'Loading employees from eHRM API...'}
//               </div>
//             )}
//             {empError && (
//               <div className="flex items-center gap-2 text-xs text-red-600 mb-3 bg-red-50 border border-red-200 rounded-lg px-3 py-2">
//                 <AlertTriangle size={12} /> API Error: {empError}
//               </div>
//             )}
//             <div className="mb-4 flex gap-2">
//               <div className="flex-1"><SearchBar value={search} onChange={setSearch} placeholder="Search by name, ID, department, email..." /></div>
//               <button onClick={() => dispatch(fetchAllEMP())}
//                 className="flex items-center gap-1 border border-surface-200 hover:bg-surface-50 text-surface-600 text-xs px-3 py-2 rounded-lg transition-colors">
//                 ↻ Refresh
//               </button>
//             </div>
//             <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
//               {filtered.map(e => <EmployeeSummaryCard key={e.id || e.p_ced_service_no} emp={e} onClick={setViewEmployee} />)}
//               {filtered.length === 0 && !empLoading && <div className="col-span-3"><EmptyState title="No employees found" icon={Users} /></div>}
//             </div>
//           </div>
//         )}

//         {/* ═══ RECRUITMENT ═══ */}
//         {activeModule === 'recruitment' && (
//           <div>
//             <PageHeader title="Recruitment & Onboarding" subtitle="Vacancies, applicants, interviews, selection"
//               actions={<button onClick={() => setShowRecruitModal(true)} className="btn-primary flex items-center gap-2"><Plus size={14} /> Post Vacancy</button>}
//             />
//             <div className="grid grid-cols-3 gap-4 mb-5">
//               <StatCard label="Active Vacancies" value={recruitment.filter(r=>r.status==='Active').length} icon={Briefcase} color="blue" />
//               <StatCard label="Total Applicants" value={recruitment.reduce((a,r)=>a+r.applicants,0)} icon={Users} color="green" />
//               <StatCard label="Shortlisted" value={recruitment.reduce((a,r)=>a+r.shortlisted,0)} icon={Award} color="gold" />
//             </div>
//             <Card noPad>
//               <Table headers={['Ref', 'Position', 'Department', 'Vacancies', 'Posted', 'Closing', 'Applicants', 'Shortlisted', 'Status']}>
//                 {recruitment.map(r => (
//                   <tr key={r.id} className="table-row">
//                     <td className="px-4 py-3 font-mono text-xs text-primary-600 font-semibold">{r.id}</td>
//                     <td className="px-4 py-3 font-medium text-surface-800 text-sm">{r.position}</td>
//                     <td className="px-4 py-3 text-surface-600 text-sm">{r.department}</td>
//                     <td className="px-4 py-3 text-center text-surface-700 font-medium text-sm">{r.vacancies}</td>
//                     <td className="px-4 py-3 text-surface-500 text-sm">{r.postedDate}</td>
//                     <td className="px-4 py-3 text-surface-500 text-sm">{r.closingDate}</td>
//                     <td className="px-4 py-3 text-center text-surface-700 text-sm">{r.applicants}</td>
//                     <td className="px-4 py-3 text-center text-surface-700 text-sm">{r.shortlisted}</td>
//                     <td className="px-4 py-3"><Badge status={r.status} /></td>
//                   </tr>
//                 ))}
//               </Table>
//             </Card>
//           </div>
//         )}

//         {/* ═══ MASTER FILES ═══ */}
//         {activeModule === 'masterfiles' && <HRMasterFilesView />}

//         {/* ═══ ATTENDANCE ═══ */}
//         {activeModule === 'attendance' && (
//           <div>
//             <PageHeader title="Attendance & Shifts" subtitle="Live attendance card from the eHRM API, by employee and month" />
//             <AttendanceExplorer employees={realEmployees || []} />
//           </div>
//         )}

//         {/* ═══ LEAVE MANAGEMENT ═══ */}
//         {activeModule === 'leave' && (() => {
//           // Redirect to dedicated Leave Management page
//           if (typeof window !== 'undefined') {
//             window.location.href = '/hrm/leave';
//           }
//           return null;
//         })()}

//         {/* ═══ PAYROLL ═══ */}
//         {activeModule === 'payroll' && (
//           <div>
//             <PageHeader title="Payroll Management" subtitle="Salary, EPF/ETF, payslips, deductions" />
//             <div className="grid grid-cols-4 gap-4 mb-5">
//               <StatCard label="Total Payroll" value={'Rs. ' + payroll.reduce((s,p)=>s+p.netPay,0).toLocaleString()} icon={DollarSign} color="blue" />
//               <StatCard label="Paid This Month" value={payroll.filter(p=>p.status==='Paid').length} icon={Check} color="green" />
//               <StatCard label="Pending" value={payroll.filter(p=>p.status==='Pending').length} icon={Clock} color="gold" />
//               <StatCard label="Total EPF" value={'Rs. ' + payroll.reduce((s,p)=>s+p.epf,0).toLocaleString()} icon={DollarSign} color="purple" />
//             </div>
//             <Card noPad>
//               <Table headers={['Ref', 'Employee', 'Month', 'Basic', 'Allowances', 'Overtime', 'Deductions', 'EPF (8%)', 'ETF (3%)', 'Net Pay', 'Status']}>
//                 {payroll.map(p => (
//                   <tr key={p.id} className="table-row">
//                     <td className="px-4 py-3 font-mono text-xs text-primary-600 font-semibold">{p.id}</td>
//                     <td className="px-4 py-3 font-medium text-surface-800 text-sm">{p.employeeName}</td>
//                     <td className="px-4 py-3 text-surface-600 text-sm">{p.month}</td>
//                     <td className="px-4 py-3 text-surface-700 text-sm text-right">{p.basic.toLocaleString()}</td>
//                     <td className="px-4 py-3 text-surface-700 text-sm text-right">{p.allowances.toLocaleString()}</td>
//                     <td className="px-4 py-3 text-surface-700 text-sm text-right">{p.overtime.toLocaleString()}</td>
//                     <td className="px-4 py-3 text-red-600 text-sm text-right">({p.deductions.toLocaleString()})</td>
//                     <td className="px-4 py-3 text-surface-600 text-sm text-right">{p.epf.toLocaleString()}</td>
//                     <td className="px-4 py-3 text-surface-600 text-sm text-right">{p.etf.toLocaleString()}</td>
//                     <td className="px-4 py-3 font-bold text-surface-900 text-sm text-right">{p.netPay.toLocaleString()}</td>
//                     <td className="px-4 py-3"><Badge status={p.status} /></td>
//                   </tr>
//                 ))}
//               </Table>
//             </Card>
//           </div>
//         )}

//         {/* ═══ PERFORMANCE ═══ */}
//         {activeModule === 'performance' && (
//           <div>
//             <PageHeader title="Performance Management" subtitle="KPIs, appraisals, reviews" />
//             <div className="grid grid-cols-3 gap-5">
//               <Card className="col-span-3">
//                 <p className="text-surface-500 text-sm text-center py-8">Performance appraisal cycles, KPI settings and employee reviews will be managed here.</p>
//                 <div className="grid grid-cols-3 gap-4">
//                   {employees.slice(0,3).map(e => (
//                     <div key={e.id} className="border border-surface-100 rounded-xl p-4">
//                       <div className="flex items-center gap-3 mb-3">
//                         <div className="w-10 h-10 primary-gradient rounded-full flex items-center justify-center shrink-0"><span className="text-surface-900 font-bold text-sm">{(e.firstName||e.name||'?')[0]}</span></div>
//                         <div><p className="font-semibold text-surface-800 text-sm">{e.firstName} {e.lastName}</p><p className="text-xs text-surface-400">{e.designation}</p></div>
//                       </div>
//                       <div className="space-y-2">
//                         {['KPI Achievement','Attendance','Targets Met'].map((kpi,i) => (
//                           <div key={kpi}>
//                             <div className="flex justify-between text-xs mb-1"><span className="text-surface-500">{kpi}</span><span className="font-medium text-surface-700">{[88,95,75][i]}%</span></div>
//                             <div className="h-1.5 bg-surface-100 rounded-full"><div className="h-full primary-gradient rounded-full" style={{width:`${[88,95,75][i]}%`}} /></div>
//                           </div>
//                         ))}
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               </Card>
//             </div>
//           </div>
//         )}

//         {/* ═══ TRAINING ═══ */}
//         {activeModule === 'training' && (
//           <div>
//             <PageHeader title="Training & Development" subtitle="Programs, skills, certifications"
//               actions={<button onClick={() => setShowTrainingModal(true)} className="btn-primary flex items-center gap-2"><Plus size={14} /> Add Training</button>}
//             />
//             <div className="grid grid-cols-3 gap-4 mb-5">
//               <StatCard label="Total Programs" value={training.length} icon={BookOpen} color="blue" />
//               <StatCard label="Completed" value={training.filter(t=>t.status==='Completed').length} icon={Check} color="green" />
//               <StatCard label="Scheduled" value={training.filter(t=>t.status==='Scheduled').length} icon={Calendar} color="gold" />
//             </div>
//             <Card noPad>
//               <Table headers={['Ref', 'Training Title', 'Employee', 'Category', 'Start', 'End', 'Provider', 'Score', 'Status']}>
//                 {training.map(t => (
//                   <tr key={t.id} className="table-row">
//                     <td className="px-4 py-3 font-mono text-xs text-primary-600 font-semibold">{t.id}</td>
//                     <td className="px-4 py-3 font-medium text-surface-800 text-sm">{t.title}</td>
//                     <td className="px-4 py-3 text-surface-600 text-sm">{t.employeeName || empName(t.employeeId)}</td>
//                     <td className="px-4 py-3 text-surface-500 text-sm">{t.category}</td>
//                     <td className="px-4 py-3 text-surface-500 text-sm">{t.startDate}</td>
//                     <td className="px-4 py-3 text-surface-500 text-sm">{t.endDate}</td>
//                     <td className="px-4 py-3 text-surface-500 text-sm">{t.provider}</td>
//                     <td className="px-4 py-3 text-surface-700 font-medium text-sm">{t.score != null ? `${t.score}%` : '—'}</td>
//                     <td className="px-4 py-3"><Badge status={t.status} /></td>
//                   </tr>
//                 ))}
//               </Table>
//             </Card>
//           </div>
//         )}

//         {/* ═══ SELF SERVICE ═══ */}
//         {activeModule === 'selfservice' && (
//           <div>
//             <PageHeader title="Employee Self Service" subtitle="Payslips, leave, attendance, personal info" />
//             <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
//               {[
//                 { label: 'View Payslips', icon: DollarSign, desc: 'Download monthly payslips', color: 'blue' },
//                 { label: 'Apply Leave', icon: Calendar, desc: 'Submit leave requests', color: 'green', action: () => { window.location.href = '/hrm/leave'; } },
//                 { label: 'My Attendance', icon: Clock, desc: 'View attendance history', color: 'gold', action: () => dispatch(setActiveModule('attendance')) },
//                 { label: 'Update Profile', icon: User, desc: 'Update personal details', color: 'purple' },
//               ].map(({ label, icon: Icon, desc, color, action }) => (
//                 <div key={label} onClick={action} className="bg-white border border-surface-100 rounded-xl p-5 cursor-pointer hover:border-primary-400 hover:shadow-md transition-all">
//                   <div className={`w-10 h-10 rounded-lg flex items-center justify-center mb-3 ${color==='blue'?'bg-blue-100 text-blue-600':color==='green'?'bg-emerald-100 text-emerald-600':color==='gold'?'bg-primary-100 text-primary-600':'bg-purple-100 text-purple-600'}`}><Icon size={20} /></div>
//                   <p className="font-semibold text-surface-800 text-sm">{label}</p>
//                   <p className="text-xs text-surface-400 mt-0.5">{desc}</p>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}

//         {/* ═══ DISCIPLINARY ═══ */}
//         {activeModule === 'disciplinary' && (
//           <div>
//             <PageHeader title="Disciplinary & Grievance" subtitle="Warnings, actions, incident tracking"
//               actions={<button onClick={() => setShowDiscModal(true)} className="btn-primary flex items-center gap-2"><Plus size={14} /> New Action</button>}
//             />
//             <Card noPad>
//               <Table headers={['Ref', 'Employee', 'Type', 'Reason', 'Date', 'Issued By', 'Status']}>
//                 {disciplinary.map(d => (
//                   <tr key={d.id} className="table-row">
//                     <td className="px-4 py-3 font-mono text-xs text-primary-600 font-semibold">{d.id}</td>
//                     <td className="px-4 py-3 font-medium text-surface-800 text-sm">{d.employeeName || empName(d.employeeId)}</td>
//                     <td className="px-4 py-3 text-surface-600 text-sm">{d.type}</td>
//                     <td className="px-4 py-3 text-surface-500 text-sm max-w-40 truncate">{d.reason}</td>
//                     <td className="px-4 py-3 text-surface-500 text-sm">{d.date}</td>
//                     <td className="px-4 py-3 text-surface-500 text-sm">{d.issuedBy}</td>
//                     <td className="px-4 py-3"><Badge status={d.status} /></td>
//                   </tr>
//                 ))}
//               </Table>
//               {disciplinary.length === 0 && <EmptyState title="No disciplinary records" icon={ShieldAlert} />}
//             </Card>
//           </div>
//         )}

//         {/* ═══ HR ASSETS ═══ */}
//         {activeModule === 'hrassets' && (
//           <div>
//             <PageHeader title="Asset Management (HR)" subtitle="Company assets assigned to employees"
//               actions={<button onClick={() => setShowAssetModal(true)} className="btn-primary flex items-center gap-2"><Plus size={14} /> Assign Asset</button>}
//             />
//             <Card noPad>
//               <Table headers={['Ref', 'Employee', 'Asset Type', 'Asset ID', 'Issued Date', 'Return Date', 'Condition', 'Status']}>
//                 {hrAssets.map(a => (
//                   <tr key={a.id} className="table-row">
//                     <td className="px-4 py-3 font-mono text-xs text-primary-600 font-semibold">{a.id}</td>
//                     <td className="px-4 py-3 font-medium text-surface-800 text-sm">{a.employeeName || empName(a.employeeId)}</td>
//                     <td className="px-4 py-3 text-surface-600 text-sm">{a.assetType}</td>
//                     <td className="px-4 py-3 font-mono text-xs text-surface-500">{a.assetId}</td>
//                     <td className="px-4 py-3 text-surface-500 text-sm">{a.issuedDate}</td>
//                     <td className="px-4 py-3 text-surface-500 text-sm">{a.returnDate || '—'}</td>
//                     <td className="px-4 py-3 text-surface-600 text-sm">{a.condition}</td>
//                     <td className="px-4 py-3"><Badge status={a.status} /></td>
//                   </tr>
//                 ))}
//               </Table>
//               {hrAssets.length === 0 && <EmptyState title="No assets assigned" icon={Package} />}
//             </Card>
//           </div>
//         )}

//         {/* ═══ EXIT MANAGEMENT ═══ */}
//         {activeModule === 'exit' && (
//           <div>
//             <PageHeader title="Exit Management" subtitle="Resignations, clearance, final settlement"
//               actions={<button onClick={() => setShowExitModal(true)} className="btn-primary flex items-center gap-2"><Plus size={14} /> New Exit</button>}
//             />
//             <Card noPad>
//               <Table headers={['Ref', 'Employee', 'Designation', 'Dept', 'Resign Date', 'Last Day', 'Reason', 'Final Settlement', 'Clearance', 'Status']}>
//                 {exits.map(e => (
//                   <tr key={e.id} className="table-row">
//                     <td className="px-4 py-3 font-mono text-xs text-primary-600 font-semibold">{e.id}</td>
//                     <td className="px-4 py-3 font-medium text-surface-800 text-sm">{e.employeeName || empName(e.employeeId)}</td>
//                     <td className="px-4 py-3 text-surface-500 text-sm">{e.designation}</td>
//                     <td className="px-4 py-3 text-surface-500 text-sm">{e.department}</td>
//                     <td className="px-4 py-3 text-surface-500 text-sm">{e.resignDate}</td>
//                     <td className="px-4 py-3 text-surface-500 text-sm">{e.lastDay}</td>
//                     <td className="px-4 py-3 text-surface-500 text-sm max-w-32 truncate">{e.reason}</td>
//                     <td className="px-4 py-3 text-surface-700 font-medium text-sm">{e.finalSettlement ? `Rs. ${e.finalSettlement.toLocaleString()}` : '—'}</td>
//                     <td className="px-4 py-3 text-surface-500 text-sm">{e.clearance}</td>
//                     <td className="px-4 py-3"><Badge status={e.status} /></td>
//                   </tr>
//                 ))}
//               </Table>
//               {exits.length === 0 && <EmptyState title="No exit records" icon={LogOut} />}
//             </Card>
//           </div>
//         )}

//         {/* ═══ REPORTS ═══ */}
//         {activeModule === 'reports' && (
//           activeReport === 'attendance' ? (
//             <AttendanceReport onBack={() => setActiveReport(null)} />
//           ) : (
//           <div>
//             <PageHeader title="Reports & Analytics" subtitle="Attendance, payroll, turnover, leave summaries" />
//             <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
//               {[
//                 { key: 'attendance', title: 'Attendance Report', desc: 'Daily/monthly attendance summary per department', icon: Clock, color: 'blue' },
//                 { title: 'Payroll Report', desc: 'Salary, EPF/ETF summaries for accounting', icon: DollarSign, color: 'green' },
//                 { title: 'Leave Summary', desc: 'Leave taken vs. balance per employee', icon: Calendar, color: 'gold' },
//                 { title: 'Employee Turnover', desc: 'Joins, exits, retention rate analysis', icon: Users, color: 'purple' },
//                 { title: 'Department Analytics', desc: 'Headcount & grade distribution by department', icon: BarChart2, color: 'blue' },
//                 { title: 'Training Report', desc: 'Completed trainings and skill development', icon: BookOpen, color: 'green' },
//               ].map(({ key, title, desc, icon: Icon, color }) => (
//                 <div key={title} className="bg-white border border-surface-100 rounded-xl p-5 hover:border-primary-400 hover:shadow-md transition-all cursor-pointer">
//                   <div className={`w-10 h-10 rounded-lg flex items-center justify-center mb-3 ${color==='blue'?'bg-blue-100 text-blue-600':color==='green'?'bg-emerald-100 text-emerald-600':color==='gold'?'bg-primary-100 text-primary-600':'bg-purple-100 text-purple-600'}`}><Icon size={20} /></div>
//                   <p className="font-semibold text-surface-800 text-sm">{title}</p>
//                   <p className="text-xs text-surface-400 mt-1">{desc}</p>
//                   <button onClick={() => key && setActiveReport(key)} className="mt-3 text-xs text-primary-600 font-medium hover:text-primary-700 flex items-center gap-1">Generate <ChevronRight size={12} /></button>
//                 </div>
//               ))}
//             </div>
//           </div>
//           )
//         )}
//       </div>

//       {/* ══════════════════════ MODALS ══════════════════════ */}
//       <Modal open={showAddEmployee} onClose={() => setShowAddEmployee(false)} title="Employee Information — Add New Employee" size="xl">
//         <AddEmployeeForm onClose={() => setShowAddEmployee(false)} onSuccess={() => dispatch(fetchAllEMP())} />
//       </Modal>
//       <Modal open={!!viewEmployee} onClose={() => setViewEmployee(null)} title="Employee Information" size="xl">
//         {viewEmployee && <EmployeeDetailView emp={viewEmployee} onClose={() => setViewEmployee(null)} />}
//       </Modal>
//       <Modal open={showLeaveModal} onClose={() => setShowLeaveModal(false)} title="New Leave Request">
//         <div className="space-y-4">
//           <FormField label="Employee" required><select className={selectCls} value={leaveForm.employeeId} onChange={e => setLF('employeeId', e.target.value)}><option value="">Select Employee...</option>{employees.map(e => <option key={e.id} value={e.id}>{e.firstName} {e.lastName} ({e.id})</option>)}</select></FormField>
//           <div className="grid grid-cols-2 gap-4">
//             <FormField label="Leave Type" required><select className={selectCls} value={leaveForm.type} onChange={e => setLF('type', e.target.value)}>{['Annual','Casual','Medical','Unpaid','Maternity','Paternity'].map(t => <option key={t}>{t}</option>)}</select></FormField>
//             <FormField label="No. of Days" required><input className={inputCls} type="number" min="1" value={leaveForm.days} onChange={e => setLF('days', parseInt(e.target.value))} /></FormField>
//           </div>
//           <div className="grid grid-cols-2 gap-4">
//             <FormField label="From Date" required><input className={inputCls} type="date" value={leaveForm.from} onChange={e => setLF('from', e.target.value)} /></FormField>
//             <FormField label="To Date" required><input className={inputCls} type="date" value={leaveForm.to} onChange={e => setLF('to', e.target.value)} /></FormField>
//           </div>
//           <FormField label="Reason"><textarea className={inputCls + ' h-20 resize-none'} value={leaveForm.reason} onChange={e => setLF('reason', e.target.value)} placeholder="Reason for leave..." /></FormField>
//           <div className="flex justify-end gap-3 pt-2">
//             <button onClick={() => setShowLeaveModal(false)} className="btn-ghost">Cancel</button>
//             <button onClick={() => { dispatch(createLeaveRequest({ ...leaveForm, employeeName: empName(leaveForm.employeeId) })); setShowLeaveModal(false); }} className="btn-primary">Submit Request</button>
//           </div>
//         </div>
//       </Modal>
//       <Modal open={showRecruitModal} onClose={() => setShowRecruitModal(false)} title="Post New Vacancy">
//         <div className="space-y-4">
//           <FormField label="Position Title" required><input className={inputCls} value={recruitForm.position} onChange={e => setRF('position', e.target.value)} placeholder="e.g. Mechanical Engineer" /></FormField>
//           <div className="grid grid-cols-2 gap-4">
//             <FormField label="Department" required><select className={selectCls} value={recruitForm.department} onChange={e => setRF('department', e.target.value)}><option value="">Select...</option>{['Engineering','Finance','HR','Production','Procurement','Commercial','ICT','Administration'].map(d => <option key={d}>{d}</option>)}</select></FormField>
//             <FormField label="No. of Vacancies" required><input className={inputCls} type="number" min="1" value={recruitForm.vacancies} onChange={e => setRF('vacancies', parseInt(e.target.value))} /></FormField>
//           </div>
//           <div className="grid grid-cols-2 gap-4">
//             <FormField label="Posted Date"><input className={inputCls} type="date" value={recruitForm.postedDate} onChange={e => setRF('postedDate', e.target.value)} /></FormField>
//             <FormField label="Closing Date"><input className={inputCls} type="date" value={recruitForm.closingDate} onChange={e => setRF('closingDate', e.target.value)} /></FormField>
//           </div>
//           <div className="flex justify-end gap-3 pt-2">
//             <button onClick={() => setShowRecruitModal(false)} className="btn-ghost">Cancel</button>
//             <button onClick={() => { dispatch(createRecruitment(recruitForm)); setShowRecruitModal(false); }} className="btn-primary">Post Vacancy</button>
//           </div>
//         </div>
//       </Modal>
//       <Modal open={showTrainingModal} onClose={() => setShowTrainingModal(false)} title="Add Training Record">
//         <div className="space-y-4">
//           <FormField label="Training Title" required><input className={inputCls} value={trainingForm.title} onChange={e => setTF('title', e.target.value)} /></FormField>
//           <div className="grid grid-cols-2 gap-4">
//             <FormField label="Employee" required><select className={selectCls} value={trainingForm.employeeId} onChange={e => setTF('employeeId', e.target.value)}><option value="">Select...</option>{employees.map(e => <option key={e.id} value={e.id}>{e.firstName} {e.lastName}</option>)}</select></FormField>
//             <FormField label="Category"><select className={selectCls} value={trainingForm.category} onChange={e => setTF('category', e.target.value)}>{['Technical','Compliance','Quality','Management','Soft Skills'].map(c => <option key={c}>{c}</option>)}</select></FormField>
//           </div>
//           <div className="grid grid-cols-2 gap-4">
//             <FormField label="Start Date"><input className={inputCls} type="date" value={trainingForm.startDate} onChange={e => setTF('startDate', e.target.value)} /></FormField>
//             <FormField label="End Date"><input className={inputCls} type="date" value={trainingForm.endDate} onChange={e => setTF('endDate', e.target.value)} /></FormField>
//           </div>
//           <div className="grid grid-cols-2 gap-4">
//             <FormField label="Provider"><input className={inputCls} value={trainingForm.provider} onChange={e => setTF('provider', e.target.value)} /></FormField>
//             <FormField label="Status"><select className={selectCls} value={trainingForm.status} onChange={e => setTF('status', e.target.value)}>{['Scheduled','In Progress','Completed','Cancelled'].map(s => <option key={s}>{s}</option>)}</select></FormField>
//           </div>
//           <div className="flex justify-end gap-3 pt-2">
//             <button onClick={() => setShowTrainingModal(false)} className="btn-ghost">Cancel</button>
//             <button onClick={() => { dispatch(createTraining({ ...trainingForm, employeeName: empName(trainingForm.employeeId) })); setShowTrainingModal(false); }} className="btn-primary">Save Training</button>
//           </div>
//         </div>
//       </Modal>
//       <Modal open={showDiscModal} onClose={() => setShowDiscModal(false)} title="New Disciplinary Action">
//         <div className="space-y-4">
//           <div className="grid grid-cols-2 gap-4">
//             <FormField label="Employee" required><select className={selectCls} value={discForm.employeeId} onChange={e => setDF('employeeId', e.target.value)}><option value="">Select...</option>{employees.map(e => <option key={e.id} value={e.id}>{e.firstName} {e.lastName}</option>)}</select></FormField>
//             <FormField label="Action Type" required><select className={selectCls} value={discForm.type} onChange={e => setDF('type', e.target.value)}>{['Verbal Warning','Warning Letter','Final Warning','Suspension','Termination'].map(t => <option key={t}>{t}</option>)}</select></FormField>
//           </div>
//           <FormField label="Reason" required><textarea className={inputCls + ' h-20 resize-none'} value={discForm.reason} onChange={e => setDF('reason', e.target.value)} /></FormField>
//           <div className="grid grid-cols-2 gap-4">
//             <FormField label="Date"><input className={inputCls} type="date" value={discForm.date} onChange={e => setDF('date', e.target.value)} /></FormField>
//             <FormField label="Issued By"><input className={inputCls} value={discForm.issuedBy} onChange={e => setDF('issuedBy', e.target.value)} /></FormField>
//           </div>
//           <div className="flex justify-end gap-3 pt-2">
//             <button onClick={() => setShowDiscModal(false)} className="btn-ghost">Cancel</button>
//             <button onClick={() => { dispatch(createDisciplinary({ ...discForm, employeeName: empName(discForm.employeeId) })); setShowDiscModal(false); }} className="btn-primary">Save</button>
//           </div>
//         </div>
//       </Modal>
//       <Modal open={showAssetModal} onClose={() => setShowAssetModal(false)} title="Assign HR Asset">
//         <div className="space-y-4">
//           <div className="grid grid-cols-2 gap-4">
//             <FormField label="Employee" required><select className={selectCls} value={assetForm.employeeId} onChange={e => setAF('employeeId', e.target.value)}><option value="">Select...</option>{employees.map(e => <option key={e.id} value={e.id}>{e.firstName} {e.lastName}</option>)}</select></FormField>
//             <FormField label="Asset Type" required><select className={selectCls} value={assetForm.assetType} onChange={e => setAF('assetType', e.target.value)}><option value="">Select...</option>{['Laptop','Desktop','Mobile Phone','ID Card','Uniform','Access Card','Vehicle','Tools','Other'].map(t => <option key={t}>{t}</option>)}</select></FormField>
//           </div>
//           <div className="grid grid-cols-2 gap-4">
//             <FormField label="Asset ID"><input className={inputCls} value={assetForm.assetId} onChange={e => setAF('assetId', e.target.value)} /></FormField>
//             <FormField label="Condition"><select className={selectCls} value={assetForm.condition} onChange={e => setAF('condition', e.target.value)}>{['New','Good','Fair','Poor'].map(c => <option key={c}>{c}</option>)}</select></FormField>
//           </div>
//           <FormField label="Issued Date"><input className={inputCls} type="date" value={assetForm.issuedDate} onChange={e => setAF('issuedDate', e.target.value)} /></FormField>
//           <div className="flex justify-end gap-3 pt-2">
//             <button onClick={() => setShowAssetModal(false)} className="btn-ghost">Cancel</button>
//             <button onClick={() => { dispatch(createHRAsset({ ...assetForm, employeeName: empName(assetForm.employeeId) })); setShowAssetModal(false); }} className="btn-primary">Assign Asset</button>
//           </div>
//         </div>
//       </Modal>
//       <Modal open={showExitModal} onClose={() => setShowExitModal(false)} title="New Exit Record">
//         <div className="space-y-4">
//           <div className="grid grid-cols-2 gap-4">
//             <FormField label="Employee" required><select className={selectCls} value={exitForm.employeeId} onChange={e => setEF('employeeId', e.target.value)}><option value="">Select...</option>{employees.map(e => <option key={e.id} value={e.id}>{e.firstName} {e.lastName}</option>)}</select></FormField>
//             <FormField label="Reason"><select className={selectCls} value={exitForm.reason} onChange={e => setEF('reason', e.target.value)}><option value="">Select...</option>{['Resignation','Retirement','Termination','Transfer','Contract End','Death'].map(r => <option key={r}>{r}</option>)}</select></FormField>
//           </div>
//           <div className="grid grid-cols-2 gap-4">
//             <FormField label="Resign Date"><input className={inputCls} type="date" value={exitForm.resignDate} onChange={e => setEF('resignDate', e.target.value)} /></FormField>
//             <FormField label="Last Working Day"><input className={inputCls} type="date" value={exitForm.lastDay} onChange={e => setEF('lastDay', e.target.value)} /></FormField>
//           </div>
//           <FormField label="Final Settlement (Rs.)"><input className={inputCls} type="number" value={exitForm.finalSettlement} onChange={e => setEF('finalSettlement', parseFloat(e.target.value))} /></FormField>
//           <div className="flex justify-end gap-3 pt-2">
//             <button onClick={() => setShowExitModal(false)} className="btn-ghost">Cancel</button>
//             <button onClick={() => {
//               const emp = employees.find(x => x.id === exitForm.employeeId);
//               dispatch(createExit({ ...exitForm, employeeName: empName(exitForm.employeeId), designation: emp?.designation, department: emp?.department, clearance: 'In Progress' }));
//               setShowExitModal(false);
//             }} className="btn-primary">Save Exit Record</button>
//           </div>
//         </div>
//       </Modal>
//     </div>
//   );
// }

//----------------------------------------------------------------------
import React, { useEffect, useState, useRef, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setActiveModule } from '../store/slices/uiSlice';
import {
  Users, Clock, Calendar, Search, User, BarChart2, Briefcase,
  Plus, ChevronRight, Award, BookOpen, ShieldAlert, Package,
  LogOut, FileText, DollarSign, Settings, X, Camera, Upload,
  Check, AlertTriangle, Eye, ChevronDown, ChevronUp,
  Database, Tag, Building2, MapPin, MapPinned, Shield, Landmark, Save, RotateCcw, CheckCircle,
  AlertCircle, Loader2, Download, FileSpreadsheet,
} from 'lucide-react';
import {
  fetchEmployees, fetchAttendance, fetchLeave, fetchPayroll,
  fetchRecruitment, fetchTraining, fetchDisciplinary,
  fetchHRAssets, fetchExits,
  createEmployee, createLeaveRequest, approveLeave, rejectLeave,
  createRecruitment, createTraining, createDisciplinary,
  createHRAsset, createExit
} from '../store/slices/hrSlice';
import { fetchAllEMP, addEMPEmployee, clearEMPError, clearEMPSuccess } from '../store/slices/newEmpSlice';
import { fetchAllEmployees } from '../store/slices/employeeSlice';
import { fetchLocationMaster, addLocationMaster } from '../store/slices/locationMasterSlice';
import { clearLocationMasterAddState } from '../store/slices/locationMasterSlice';
import {
  PageHeader, Card, Badge, Table, Modal, FormField,
  SearchBar, LoadingState, EmptyState, StatCard
} from '../components/common';
import { StatusPill } from '../components/Table/Table';
import LocationMapModal from '../components/common/LocationMapModal';
import LocationPickerMapModal from '../components/common/LocationPickerMapModal';
import SearchableSelect from '../components/common/SearchableSelect';
import { formatDate } from '../utils/helpers';
import HRMDashboard from './employee/HRMDashboard';
import AttendanceExplorer from '../components/employee/AttendanceExplorer';
import AttendanceReport from './Attendance/AttendanceReport';
import { addDesignation, clearDesignationError, clearDesignationSuccess, getDesignationList, updateDesignation } from '../store/slices/designationSlice';
import { addDepartment, clearDepartmentError, clearDepartmentSuccess, getDepartmentList, updateDepartment } from '../store/slices/departmentSlice';
import {
  getProvinceList, addProvince, updateProvince,
  getDistrictList, addDistrict, updateDistrict,
  getElectorateList, addElectorate, updateElectorate,
  getPoliceStationList, addPoliceStation, updatePoliceStation,
  getGramaList, addGrama,
  getProvinceById, getDistrictById, getElectorateById, getPoliceStationById,
  clearRegionSuccess, clearRegionError,
} from '../store/slices/regionSlice';
import { addLocation, clearLocationError, clearLocationSuccess, getLocationList, updateLocation } from '../store/slices/locationSlice';
import { addEmployeeCategory, clearEmployeeCategoryError, clearEmployeeCategorySuccess, getEmployeeCategoryList, updateEmployeeCategory } from '../store/slices/employeeCategorySlice';
import { addGrade, clearGradeError, clearGradeSuccess, getGradeList, updateGrade } from '../store/slices/gradeSlice';
import { addBankBranch, clearBankBranchSuccess, getBankBranchList, updateBankBranch } from '../store/slices/bankBranchSlice';
import { addShift, clearShiftSuccess, getShiftList, updateShift } from '../store/slices/shiftSlice';
import { addBank, clearBankError, clearBankSuccess, getBankList, updateBank } from '../store/slices/bankSlice';
import {
  getDivisionList,
  addDivision,
  updateDivision,
  clearDivisionSuccess,
  clearDivisionError,
} from '../store/slices/divisionSlice';
import { getLoggedInServiceNo } from '../utils/masterDataUtils';
import {
  isMasterApproved, masterApprovalParams, NEW_MASTER_IS_APPROVED,
} from '../utils/masterApproval';
import { exportToExcel, importFromExcel } from '../utils/excelUtils';
import ImportRegionModal from '../components/HRM/ImportRegionModal';

// ─── Sidebar sub-navigation items ────────────────────────────────────────────
const HR_MODULES = [
  { key: 'overview', label: 'Overview', icon: BarChart2 },
  { key: 'employees', label: 'Employee Management', icon: Users },
  { key: 'recruitment', label: 'Recruitment', icon: Briefcase },
  { key: 'masterfiles', label: 'Master Files', icon: Database },
  { key: 'attendance', label: 'Attendance & Shifts', icon: Clock },
  { key: 'leave', label: 'Leave Management', icon: Calendar },
  { key: 'payroll', label: 'Payroll', icon: DollarSign },
  { key: 'performance', label: 'Performance', icon: Award },
  { key: 'training', label: 'Training', icon: BookOpen },
  { key: 'selfservice', label: 'Self Service', icon: User },
  { key: 'disciplinary', label: 'Disciplinary', icon: ShieldAlert },
  { key: 'hrassets', label: 'Assets', icon: Package },
  { key: 'exit', label: 'Exit Management', icon: LogOut },
  { key: 'reports', label: 'Reports', icon: FileText },
];

// ─── Helper ───────────────────────────────────────────────────────────────────
function SectionTitle({ children }) {
  return <h3 className="text-xs font-bold text-primary-600 uppercase tracking-widest mb-3 mt-1">{children}</h3>;
}
function FieldRow({ label, value }) {
  return (
    <div className="flex items-start gap-1 py-1 border-b border-surface-50">
      <span className="text-xs text-surface-400 w-36 shrink-0">{label}</span>
      <span className="text-xs text-surface-800 font-medium">{value || '—'}</span>
    </div>
  );
}

// ─── Add Employee Form (connected to real EMP API) ────────────────────────────
function AddEmployeeForm({ onClose, onSuccess }) {
  const dispatch = useDispatch();
  const { adding, error, successMessage } = useSelector(s => s.emp);
  const photoRef = useRef();
  const [photoPreview, setPhotoPreview] = useState(null);
  const [formErrors, setFormErrors] = useState({});

  const EMPTY = {
    p_ced_service_no: '', p_title: 'Mr', p_sex: 'M', p_initials: '',
    p_first_name: '', p_last_name: '', p_report_name: '',
    p_cat_code: '', p_newold: 'N', p_barcode: '',

    p_contact_address_1: '', p_contact_address_2: '',
    p_contact_town: '', p_contact_city: '',
    p_contact_tel: '', p_off_mobile: '', p_mobile: '',
    p_contact_distance: '',

    p_home_address_1: '', p_home_address_2: '',
    p_home_town: '', p_home_city: '',
    p_home_distance: '', p_home_tel: '',
    p_electorate: '', p_police_station: '',

    p_location_code: '', p_department_code: '', p_division_code: '',
    p_extension: '', p_email: '',

    p_initial_category: '', p_initial_grade: '',
    p_retirement_date: '', p_recruitment_date: '',
    p_shift1: '1', p_shift2: '0', p_shift3: '0',
    p_inactive_type: '', p_union_code: '', p_association_code: '',
    p_gramasewaka: '', p_marital_status: 'S',

    p_nid: '', p_passport: '', p_licence: '',
    p_birth_date: '', p_first_employer: '',
    p_employee_category: 'E', p_work_category: 'P', p_epf: '',

    p_breakfast: 'N', p_meal: 'N', p_snack: 'N',

    p_nok_fname: '', p_nok_lname: '', p_nok_address: '',
    p_nok_tel: '', p_nok_relation: '',

    p_spouse_fname: '', p_spouse_lname: '',
    p_spouse_dob: '', p_children: '',

    p_own_home: 'N', p_rent: '',
    p_vehicle: 'N', p_vehicle_type: '', p_vehicle_no: '',
    p_transport: '', p_religion: '', p_race: '',
    p_info: '',

    p_fe_start: '', p_fe_end: '',
    p_ehrs: 'N', p_prof_qual: '', p_skills: '',
    p_odate: '', p_leave_remarks: '0',
    p_reporting_officer: '', p_qualification: '',
    p_present_grade: '', p_attenpay: 'N',
    p_snack_location: '', p_proximity: '',
    p_contract: 'P', p_jcat: '', p_jmain: '',

    p_created_by: 'HR_ADMIN', p_updated_by: 'HR_ADMIN',
    p_blood_group: '', p_cdl_service_no: '',
    p_ip: '192.168.1.1', p_device: 'Web',
  };

  const [form, setForm] = useState(EMPTY);
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  useEffect(() => {
    dispatch(clearEMPError());
    dispatch(clearEMPSuccess());
  }, [dispatch]);

  useEffect(() => {
    if (successMessage) {
      const t = setTimeout(() => {
        dispatch(clearEMPSuccess());
        if (onSuccess) onSuccess();
        onClose();
      }, 1500);
      return () => clearTimeout(t);
    }
  }, [successMessage, dispatch, onClose, onSuccess]);

  const handlePhoto = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => setPhotoPreview(ev.target.result);
    reader.readAsDataURL(file);
  };

  const validate = () => {
    const errs = {};
    if (!form.p_ced_service_no) errs.p_ced_service_no = 'Required';
    else if (form.p_ced_service_no.length > 7) errs.p_ced_service_no = 'Max 7 characters';
    if (!form.p_first_name) errs.p_first_name = 'Required';
    if (!form.p_last_name) errs.p_last_name = 'Required';
    if (!form.p_department_code) errs.p_department_code = 'Required';
    if (form.p_nid && !/^\d{9}[Vv]$/.test(form.p_nid))
      errs.p_nid = '10 chars: 9 digits + V (e.g. 198765432V)';
    if (form.p_passport && !/^P.{6}$/.test(form.p_passport))
      errs.p_passport = '7 chars starting with P (e.g. P987654)';
    if (form.p_licence && !/^B.{6}$/.test(form.p_licence))
      errs.p_licence = '7 chars starting with B (e.g. B765432)';
    if (form.p_email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.p_email))
      errs.p_email = 'Invalid email format';
    if (form.p_epf && !/^EPF\d{4}$/.test(form.p_epf))
      errs.p_epf = '7 chars: EPF + 4 digits (e.g. EPF9876)';
    setFormErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) return;
    try { await dispatch(addEMPEmployee(form)); } catch (_) { }
  };

  const iCls = (k) =>
    `w-full border rounded px-2 py-1 text-xs text-surface-800 focus:outline-none bg-amber-50/30 ${formErrors[k] ? 'border-red-400 focus:border-red-500' : 'border-surface-200 focus:border-primary-400'
    }`;
  const sCls = `w-full border border-surface-200 rounded px-2 py-1 text-xs text-surface-800 focus:outline-none focus:border-primary-400 bg-amber-50/30`;
  const lbl = (text, req) => (
    <label className="block text-xs text-surface-500 mb-0.5">
      {text}{req && <span className="text-red-500">*</span>}
    </label>
  );
  const ErrMsg = ({ k }) => formErrors[k]
    ? <p className="text-red-500 text-[10px] mt-0.5">{formErrors[k]}</p> : null;

  return (
    <div className="text-xs">
      {error && (
        <div className="mb-3 flex items-center gap-2 bg-red-50 border border-red-200 text-red-700 rounded-lg px-3 py-2 text-xs">
          <AlertTriangle size={14} /> <span>{error}</span>
          <button onClick={() => dispatch(clearEMPError())} className="ml-auto"><X size={12} /></button>
        </div>
      )}
      {successMessage && (
        <div className="mb-3 flex items-center gap-2 bg-emerald-50 border border-emerald-200 text-emerald-700 rounded-lg px-3 py-2 text-xs">
          <CheckCircle size={14} /> <span>{successMessage}</span>
        </div>
      )}

      {/* Row 1: Identity */}
      <div className="grid grid-cols-12 gap-2 mb-3 pb-3 border-b border-surface-100">
        <div className="col-span-2">
          {lbl('CED Service No', true)}
          <input className={iCls('p_ced_service_no')} maxLength={7}
            value={form.p_ced_service_no} onChange={e => set('p_ced_service_no', e.target.value)} placeholder="2024001" />
          <ErrMsg k="p_ced_service_no" />
        </div>
        <div className="col-span-1">
          {lbl('Title')}
          <select className={sCls} value={form.p_title} onChange={e => set('p_title', e.target.value)}>
            {['Mr', 'Mrs', 'Ms', 'Dr', 'Prof', 'Rev'].map(t => <option key={t}>{t}</option>)}
          </select>
        </div>
        <div className="col-span-1">
          {lbl('Sex')}
          <select className={sCls} value={form.p_sex} onChange={e => set('p_sex', e.target.value)}>
            <option value="M">Male</option><option value="F">Female</option>
          </select>
        </div>
        <div className="col-span-2">
          {lbl('Initials')}
          <input className={iCls('')} value={form.p_initials}
            onChange={e => set('p_initials', e.target.value)} placeholder="e.g. R.P." />
        </div>
        <div className="col-span-1">
          {lbl('New/Old')}
          <select className={sCls} value={form.p_newold} onChange={e => set('p_newold', e.target.value)}>
            <option value="N">New</option><option value="O">Old</option>
          </select>
        </div>
        {/* Photo upload */}
        <div className="col-span-5 row-span-4 flex flex-col items-center justify-center border border-dashed border-surface-200 rounded p-2 bg-surface-50">
          <div className="w-24 h-28 border border-surface-200 rounded overflow-hidden bg-white flex items-center justify-center mb-2">
            {photoPreview ? <img src={photoPreview} alt="Employee" className="w-full h-full object-cover" /> : <Camera size={28} className="text-surface-200" />}
          </div>
          <input ref={photoRef} type="file" accept="image/*" className="hidden" onChange={handlePhoto} />
          <button type="button" onClick={() => photoRef.current.click()}
            className="flex items-center gap-1 text-xs bg-surface-800 text-white px-3 py-1 rounded hover:bg-surface-700">
            <Upload size={12} /> Upload Photo
          </button>
        </div>
        <div className="col-span-7">
          {lbl('First Name', true)}
          <input className={iCls('p_first_name')} value={form.p_first_name}
            onChange={e => set('p_first_name', e.target.value)} />
          <ErrMsg k="p_first_name" />
        </div>
        <div className="col-span-7">
          {lbl('Last Name', true)}
          <input className={iCls('p_last_name')} value={form.p_last_name}
            onChange={e => set('p_last_name', e.target.value)} />
          <ErrMsg k="p_last_name" />
        </div>
        <div className="col-span-4">
          {lbl('Report Name')}
          <input className={iCls('')} value={form.p_report_name}
            onChange={e => set('p_report_name', e.target.value)} />
        </div>
        <div className="col-span-2">
          {lbl('Barcode')}
          <input className={iCls('')} value={form.p_barcode}
            onChange={e => set('p_barcode', e.target.value)} />
        </div>
        <div className="col-span-1">
          {lbl('Cat Code')}
          <input className={iCls('')} value={form.p_cat_code}
            onChange={e => set('p_cat_code', e.target.value)} placeholder="HRM" />
        </div>
      </div>

      <div className="grid grid-cols-2 gap-x-4">
        {/* LEFT */}
        <div>
          <SectionTitle>Contact Address</SectionTitle>
          <div className="grid grid-cols-2 gap-1 mb-2">
            <div className="col-span-2">{lbl('Address Line 1')}<input className={iCls('')} value={form.p_contact_address_1} onChange={e => set('p_contact_address_1', e.target.value)} /></div>
            <div className="col-span-2">{lbl('Address Line 2')}<input className={iCls('')} value={form.p_contact_address_2} onChange={e => set('p_contact_address_2', e.target.value)} /></div>
            <div>{lbl('Town')}<input className={iCls('')} value={form.p_contact_town} onChange={e => set('p_contact_town', e.target.value)} /></div>
            <div>{lbl('City/Province')}<input className={iCls('')} value={form.p_contact_city} onChange={e => set('p_contact_city', e.target.value)} /></div>
            <div>{lbl('Telephone')}<input className={iCls('')} value={form.p_contact_tel} onChange={e => set('p_contact_tel', e.target.value)} /></div>
            <div>{lbl('Office Mobile')}<input className={iCls('')} value={form.p_off_mobile} onChange={e => set('p_off_mobile', e.target.value)} /></div>
            <div>{lbl('Personal Mobile')}<input className={iCls('')} value={form.p_mobile} onChange={e => set('p_mobile', e.target.value)} /></div>
            <div>{lbl('Distance (km)')}<input className={iCls('')} value={form.p_contact_distance} onChange={e => set('p_contact_distance', e.target.value)} placeholder="3.5" /></div>
          </div>
          <SectionTitle>Home Address</SectionTitle>
          <div className="grid grid-cols-2 gap-1 mb-2">
            <div className="col-span-2">{lbl('Address Line 1')}<input className={iCls('')} value={form.p_home_address_1} onChange={e => set('p_home_address_1', e.target.value)} /></div>
            <div className="col-span-2">{lbl('Address Line 2')}<input className={iCls('')} value={form.p_home_address_2} onChange={e => set('p_home_address_2', e.target.value)} /></div>
            <div>{lbl('Town')}<input className={iCls('')} value={form.p_home_town} onChange={e => set('p_home_town', e.target.value)} /></div>
            <div>{lbl('City/Province')}<input className={iCls('')} value={form.p_home_city} onChange={e => set('p_home_city', e.target.value)} /></div>
            <div>{lbl('Telephone')}<input className={iCls('')} value={form.p_home_tel} onChange={e => set('p_home_tel', e.target.value)} /></div>
            <div>{lbl('Distance (km)')}<input className={iCls('')} value={form.p_home_distance} onChange={e => set('p_home_distance', e.target.value)} placeholder="10.0" /></div>
            <div>{lbl('Electorate Code')}<input className={iCls('')} value={form.p_electorate} onChange={e => set('p_electorate', e.target.value)} placeholder="107" /></div>
            <div>{lbl('Police Station')}<input className={iCls('')} value={form.p_police_station} onChange={e => set('p_police_station', e.target.value)} placeholder="25" /></div>
            <div>{lbl('Gramasewaka')}<input className={iCls('')} value={form.p_gramasewaka} onChange={e => set('p_gramasewaka', e.target.value)} /></div>
          </div>
          <SectionTitle>Employment Details</SectionTitle>
          <div className="grid grid-cols-2 gap-1 mb-2">
            <div>{lbl('Location Code')}<input className={iCls('')} value={form.p_location_code} onChange={e => set('p_location_code', e.target.value)} placeholder="HRD" /></div>
            <div>{lbl('Department Code', true)}<input className={iCls('p_department_code')} value={form.p_department_code} onChange={e => set('p_department_code', e.target.value)} placeholder="HR" /><ErrMsg k="p_department_code" /></div>
            <div>{lbl('Division Code')}<input className={iCls('')} value={form.p_division_code} onChange={e => set('p_division_code', e.target.value)} placeholder="TAL" /></div>
            <div>{lbl('Extension')}<input className={iCls('')} value={form.p_extension} onChange={e => set('p_extension', e.target.value)} placeholder="4569" /></div>
            <div className="col-span-2">{lbl('Email Address')}<input className={iCls('p_email')} type="email" value={form.p_email} onChange={e => set('p_email', e.target.value)} placeholder="name@company.com" /><ErrMsg k="p_email" /></div>
            <div>{lbl('Reporting Officer')}<input className={iCls('')} value={form.p_reporting_officer} onChange={e => set('p_reporting_officer', e.target.value)} placeholder="HRD001" /></div>
            <div>{lbl('Job Category')}<input className={iCls('')} value={form.p_jcat} onChange={e => set('p_jcat', e.target.value)} placeholder="HR" /></div>
            <div>{lbl('Job Main Code')}<input className={iCls('')} value={form.p_jmain} onChange={e => set('p_jmain', e.target.value)} placeholder="HR01" /></div>
            <div>{lbl('Contract Type')}<select className={sCls} value={form.p_contract} onChange={e => set('p_contract', e.target.value)}><option value="P">Permanent</option><option value="C">Contract</option><option value="T">Temporary</option></select></div>
            <div>{lbl('Work Category')}<select className={sCls} value={form.p_work_category} onChange={e => set('p_work_category', e.target.value)}><option value="P">Permanent</option><option value="C">Contract</option><option value="T">Casual</option></select></div>
            <div>{lbl('Employee Category')}<select className={sCls} value={form.p_employee_category} onChange={e => set('p_employee_category', e.target.value)}><option value="E">Executive</option><option value="N">Non-Executive</option><option value="M">Management</option></select></div>
            <div>{lbl('First Employer')}<input className={iCls('')} value={form.p_first_employer} onChange={e => set('p_first_employer', e.target.value)} placeholder="02" /></div>
          </div>
          <SectionTitle>Grade & Dates</SectionTitle>
          <div className="grid grid-cols-2 gap-1 mb-2">
            <div>{lbl('Initial Category')}<input className={iCls('')} value={form.p_initial_category} onChange={e => set('p_initial_category', e.target.value)} placeholder="PRO" /></div>
            <div>{lbl('Initial Grade')}<input className={iCls('')} value={form.p_initial_grade} onChange={e => set('p_initial_grade', e.target.value)} placeholder="M1" /></div>
            <div>{lbl('Present Grade')}<input className={iCls('')} value={form.p_present_grade} onChange={e => set('p_present_grade', e.target.value)} placeholder="M1" /></div>
            <div>{lbl('Recruitment Date')}<input className={iCls('')} type="date" value={form.p_recruitment_date} onChange={e => set('p_recruitment_date', e.target.value)} /></div>
            <div>{lbl('Retirement Date')}<input className={iCls('')} type="date" value={form.p_retirement_date} onChange={e => set('p_retirement_date', e.target.value)} /></div>
            <div>{lbl('Offer Date')}<input className={iCls('')} type="date" value={form.p_odate} onChange={e => set('p_odate', e.target.value)} /></div>
          </div>
          <SectionTitle>Shifts</SectionTitle>
          <div className="grid grid-cols-3 gap-1 mb-2">
            <div>{lbl('Shift 1')}<input className={iCls('')} value={form.p_shift1} onChange={e => set('p_shift1', e.target.value)} placeholder="1" /></div>
            <div>{lbl('Shift 2')}<input className={iCls('')} value={form.p_shift2} onChange={e => set('p_shift2', e.target.value)} placeholder="0" /></div>
            <div>{lbl('Shift 3')}<input className={iCls('')} value={form.p_shift3} onChange={e => set('p_shift3', e.target.value)} placeholder="0" /></div>
          </div>
        </div>

        {/* RIGHT */}
        <div>
          <SectionTitle>Personal Details</SectionTitle>
          <div className="grid grid-cols-2 gap-1 mb-2">
            <div>{lbl('National ID')}<input className={iCls('p_nid')} maxLength={10} value={form.p_nid} onChange={e => set('p_nid', e.target.value)} placeholder="198765432V" /><ErrMsg k="p_nid" /></div>
            <div>{lbl('Date of Birth')}<input className={iCls('')} type="date" value={form.p_birth_date} onChange={e => set('p_birth_date', e.target.value)} /></div>
            <div>{lbl('Passport No')}<input className={iCls('p_passport')} maxLength={7} value={form.p_passport} onChange={e => set('p_passport', e.target.value)} placeholder="P987654" /><ErrMsg k="p_passport" /></div>
            <div>{lbl('Licence No')}<input className={iCls('p_licence')} maxLength={7} value={form.p_licence} onChange={e => set('p_licence', e.target.value)} placeholder="B765432" /><ErrMsg k="p_licence" /></div>
            <div>{lbl('EPF No')}<input className={iCls('p_epf')} maxLength={7} value={form.p_epf} onChange={e => set('p_epf', e.target.value)} placeholder="EPF9876" /><ErrMsg k="p_epf" /></div>
            <div>{lbl('CDL Service No')}<input className={iCls('')} value={form.p_cdl_service_no} onChange={e => set('p_cdl_service_no', e.target.value)} /></div>
            <div>{lbl('Marital Status')}<select className={sCls} value={form.p_marital_status} onChange={e => set('p_marital_status', e.target.value)}><option value="S">Single</option><option value="M">Married</option><option value="D">Divorced</option><option value="W">Widowed</option></select></div>
            <div>{lbl('Blood Group')}<select className={sCls} value={form.p_blood_group} onChange={e => set('p_blood_group', e.target.value)}><option value="">Select...</option>{[['1', 'A+'], ['2', 'A-'], ['3', 'B+'], ['4', 'B-'], ['5', 'O+'], ['6', 'O-'], ['7', 'AB+'], ['8', 'AB-']].map(([v, l]) => <option key={v} value={v}>{l}</option>)}</select></div>
            <div>{lbl('Religion')}<select className={sCls} value={form.p_religion} onChange={e => set('p_religion', e.target.value)}><option value="">Select...</option><option value="1">Buddhist</option><option value="2">Hindu</option><option value="3">Muslim</option><option value="4">Catholic</option><option value="5">Christian</option><option value="6">Other</option></select></div>
            <div>{lbl('Race')}<select className={sCls} value={form.p_race} onChange={e => set('p_race', e.target.value)}><option value="">Select...</option><option value="1">Sinhalese</option><option value="2">Tamil</option><option value="3">Muslim</option><option value="4">Burgher</option><option value="5">Other</option></select></div>
          </div>
          <SectionTitle>Transport & Facilities</SectionTitle>
          <div className="grid grid-cols-2 gap-1 mb-2">
            <div>{lbl('Transport')}<select className={sCls} value={form.p_transport} onChange={e => set('p_transport', e.target.value)}><option value="">Select...</option><option value="1">Company Bus</option><option value="2">Own Vehicle</option><option value="3">Public Transport</option><option value="4">Walking</option></select></div>
            <div>{lbl('Own Vehicle')}<select className={sCls} value={form.p_vehicle} onChange={e => set('p_vehicle', e.target.value)}><option value="N">No</option><option value="Y">Yes</option></select></div>
            {form.p_vehicle === 'Y' && <>
              <div>{lbl('Vehicle Type')}<select className={sCls} value={form.p_vehicle_type} onChange={e => set('p_vehicle_type', e.target.value)}><option value="">Select...</option><option value="1">Motorbike</option><option value="2">Car</option><option value="3">Van</option><option value="4">SUV</option></select></div>
              <div>{lbl('Vehicle No')}<input className={iCls('')} value={form.p_vehicle_no} onChange={e => set('p_vehicle_no', e.target.value)} placeholder="ABC-1234" /></div>
            </>}
            <div>{lbl('Meal')}<select className={sCls} value={form.p_meal} onChange={e => set('p_meal', e.target.value)}><option value="N">No</option><option value="Y">Yes</option></select></div>
            <div>{lbl('Breakfast')}<select className={sCls} value={form.p_breakfast} onChange={e => set('p_breakfast', e.target.value)}><option value="N">No</option><option value="Y">Yes</option></select></div>
            <div>{lbl('Snack')}<select className={sCls} value={form.p_snack} onChange={e => set('p_snack', e.target.value)}><option value="N">No</option><option value="Y">Yes</option></select></div>
            <div>{lbl('Own Home')}<select className={sCls} value={form.p_own_home} onChange={e => set('p_own_home', e.target.value)}><option value="N">No</option><option value="Y">Yes</option></select></div>
          </div>
          <SectionTitle>Next of Kin</SectionTitle>
          <div className="grid grid-cols-2 gap-1 mb-2">
            <div>{lbl('First Name')}<input className={iCls('')} value={form.p_nok_fname} onChange={e => set('p_nok_fname', e.target.value)} /></div>
            <div>{lbl('Last Name')}<input className={iCls('')} value={form.p_nok_lname} onChange={e => set('p_nok_lname', e.target.value)} /></div>
            <div className="col-span-2">{lbl('Address')}<input className={iCls('')} value={form.p_nok_address} onChange={e => set('p_nok_address', e.target.value)} /></div>
            <div>{lbl('Telephone')}<input className={iCls('')} value={form.p_nok_tel} onChange={e => set('p_nok_tel', e.target.value)} /></div>
            <div>{lbl('Relation')}<select className={sCls} value={form.p_nok_relation} onChange={e => set('p_nok_relation', e.target.value)}><option value="">Select...</option><option value="1">Spouse</option><option value="2">Father</option><option value="3">Mother</option><option value="4">Son</option><option value="5">Daughter</option><option value="6">Brother</option><option value="7">Sister</option><option value="8">Other</option></select></div>
          </div>
          <SectionTitle>Spouse Details</SectionTitle>
          <div className="grid grid-cols-2 gap-1 mb-2">
            <div>{lbl('Spouse First Name')}<input className={iCls('')} value={form.p_spouse_fname} onChange={e => set('p_spouse_fname', e.target.value)} /></div>
            <div>{lbl('Spouse Last Name')}<input className={iCls('')} value={form.p_spouse_lname} onChange={e => set('p_spouse_lname', e.target.value)} /></div>
            <div>{lbl('Spouse DOB')}<input className={iCls('')} type="date" value={form.p_spouse_dob} onChange={e => set('p_spouse_dob', e.target.value)} /></div>
            <div>{lbl('No. of Children')}<input className={iCls('')} type="number" min="0" value={form.p_children} onChange={e => set('p_children', e.target.value)} /></div>
          </div>
          <SectionTitle>Qualifications & Skills</SectionTitle>
          <div className="grid grid-cols-2 gap-1 mb-2">
            <div>{lbl('Education Level')}<select className={sCls} value={form.p_qualification} onChange={e => set('p_qualification', e.target.value)}><option value="">Select...</option><option value="1">Below Grade V</option><option value="3">GCE O/L</option><option value="5">Passed GCE O/L</option><option value="7">Passed GCE A/L</option><option value="11">B.Sc. Eng. (Hons)</option><option value="13">M.Sc.</option><option value="14">B.Sc.</option><option value="19">B.Com</option></select></div>
            <div>{lbl('Professional Qual')}<select className={sCls} value={form.p_prof_qual} onChange={e => set('p_prof_qual', e.target.value)}><option value="">Select...</option><option value="1">Higher Diploma</option><option value="3">Honours Degree</option><option value="4">M.Sc.</option><option value="9">NDT</option><option value="22">Diploma in Engineering</option></select></div>
            <div className="col-span-2">{lbl('Skills')}<textarea className={iCls('') + ' h-12 resize-none'} value={form.p_skills} onChange={e => set('p_skills', e.target.value)} placeholder="Recruitment, Performance Management..." /></div>
            <div className="col-span-2">{lbl('Other Info')}<textarea className={iCls('') + ' h-10 resize-none'} value={form.p_info} onChange={e => set('p_info', e.target.value)} /></div>
          </div>
          <SectionTitle>Entitlements</SectionTitle>
          <div className="grid grid-cols-3 gap-1 mb-2">
            <div>{lbl('eHRS Enabled')}<select className={sCls} value={form.p_ehrs} onChange={e => set('p_ehrs', e.target.value)}><option value="N">No</option><option value="Y">Yes</option></select></div>
            <div>{lbl('Atten. Pay')}<select className={sCls} value={form.p_attenpay} onChange={e => set('p_attenpay', e.target.value)}><option value="N">No</option><option value="Y">Yes</option></select></div>
            <div>{lbl('Leave Remarks')}<input className={iCls('')} value={form.p_leave_remarks} onChange={e => set('p_leave_remarks', e.target.value)} placeholder="0" /></div>
            <div>{lbl('Union Code')}<input className={iCls('')} value={form.p_union_code} onChange={e => set('p_union_code', e.target.value)} /></div>
            <div>{lbl('Association')}<input className={iCls('')} value={form.p_association_code} onChange={e => set('p_association_code', e.target.value)} /></div>
          </div>
        </div>
      </div>

      <div className="flex justify-end gap-3 pt-3 border-t border-surface-100 mt-2">
        <button type="button" onClick={onClose} className="btn-ghost" disabled={adding}>Cancel</button>
        <button type="button" onClick={handleSubmit} disabled={adding}
          className="btn-primary flex items-center gap-2">
          {adding
            ? <><span className="animate-spin border-2 border-white border-t-transparent rounded-full w-3 h-3 inline-block" /> Saving...</>
            : <><Check size={14} /> Save Employee</>}
        </button>
      </div>
    </div>
  );
}

// ─── Normalize API employee fields (supports both mock and real API shapes) ──
function normEmp(e) {
  if (!e) return e;
  // If already normalized or mock data, return as-is
  if (e._normalized) return e;
  return {
    ...e,
    _normalized: true,
    id: e.id || e.p_ced_service_no || '',
    firstName: e.firstName || e.p_first_name || '',
    lastName: e.lastName || e.p_last_name || '',
    name: e.name || `${e.p_first_name || ''} ${e.p_last_name || ''}`.trim(),
    title: e.title || e.p_title || '',
    initials: e.initials || e.p_initials || '',
    designation: e.designation || e.p_cat_code || '',
    department: e.department || e.p_department_code || '',
    division: e.division || e.p_division_code || '',
    email: e.email || e.p_email || '',
    phone: e.phone || e.p_mobile || '',
    personalMobile: e.personalMobile || e.p_mobile || '',
    status: e.status || 'Active',
    epfNo: e.epfNo || e.p_epf || '',
    nationalId: e.nationalId || e.p_nid || '',
    dob: e.dob || e.p_birth_date || '',
    gender: e.gender || (e.p_sex === 'M' ? 'Male' : e.p_sex === 'F' ? 'Female' : e.p_sex) || '',
    maritalStatus: e.maritalStatus || e.p_marital_status || '',
    bloodGroup: e.bloodGroup || e.p_blood_group || '',
    serviceNo: e.serviceNo || e.p_ced_service_no || '',
    address1: e.address1 || e.p_contact_address_1 || '',
    city: e.city || e.p_contact_city || '',
    homeAddress1: e.homeAddress1 || e.p_home_address_1 || '',
    grade: e.grade || e.p_present_grade || '',
    workCategory: e.workCategory || e.p_work_category || '',
    contractType: e.contractType || e.p_contract || '',
    recruitmentDate: e.recruitmentDate || e.p_recruitment_date || '',
    retirementDate: e.retirementDate || e.p_retirement_date || '',
    skills: e.skills || e.p_skills || '',
    nextOfKinFirstName: e.nextOfKinFirstName || e.p_nok_fname || '',
    nextOfKinLastName: e.nextOfKinLastName || e.p_nok_lname || '',
    nextOfKinPhone: e.nextOfKinPhone || e.p_nok_tel || '',
    nextOfKinRelationship: e.nextOfKinRelationship || e.p_nok_relation || '',
  };
}

// ─── Employee Summary Card ────────────────────────────────────────────────────
function EmployeeSummaryCard({ emp: rawEmp, onClick }) {
  const emp = normEmp(rawEmp);
  const initials = emp.firstName ? `${emp.firstName[0]}${emp.lastName ? emp.lastName[0] : ''}` : emp.name?.split(' ').map(n => n[0]).join('') || '?';
  return (
    <Card className="cursor-pointer hover:border-primary-400 hover:shadow-md transition-all" onClick={() => onClick(emp)}>
      <div className="flex gap-3">
        <div className="shrink-0">
          {emp.photo
            ? <img src={emp.photo} alt={emp.firstName} className="w-14 h-16 rounded-lg object-cover border border-surface-100" />
            : <div className="w-14 h-16 primary-gradient rounded-lg flex items-center justify-center"><span className="text-surface-900 font-bold text-base">{initials}</span></div>
          }
        </div>
        <div className="min-w-0 flex-1">
          <div className="flex items-start justify-between gap-1">
            <p className="font-bold text-surface-900 text-sm leading-tight">{emp.firstName || emp.name} {emp.lastName || ''}</p>
            <Badge status={emp.status} />
          </div>
          <p className="text-xs text-primary-600 font-medium mt-0.5">{emp.id}</p>
          <p className="text-xs text-surface-500 mt-1">{emp.designation}</p>
          <p className="text-xs text-surface-400">{emp.department} {emp.division ? `· ${emp.division}` : ''}</p>
        </div>
      </div>
    </Card>
  );
}

// ─── Employee Detail View ──────────────────────────────────────────────────────
function EmployeeDetailView({ emp: rawEmpDetail, onClose }) {
  const emp = normEmp(rawEmpDetail);
  const [tab, setTab] = useState('personal');
  const tabs = ['personal', 'contact', 'employment', 'kin', 'qualifications'];
  return (
    <div className="text-xs">
      <div className="flex items-center gap-4 mb-4 pb-4 border-b border-surface-100">
        <div className="shrink-0">
          {emp.photo
            ? <img src={emp.photo} alt="" className="w-20 h-24 rounded-xl object-cover border-2 border-primary-300" />
            : <div className="w-20 h-24 primary-gradient rounded-xl flex items-center justify-center"><span className="text-surface-900 font-bold text-2xl">{emp.initials || (emp.firstName?.[0] + (emp.lastName?.[0] || ''))}</span></div>
          }
        </div>
        <div>
          <h2 className="text-lg font-bold text-surface-900">{emp.title} {emp.firstName} {emp.lastName}</h2>
          <p className="text-primary-600 font-medium">{emp.id} · {emp.designation}</p>
          <p className="text-surface-400">{emp.department} {emp.division ? `— ${emp.division}` : ''}</p>
          <div className="flex items-center gap-2 mt-1"><Badge status={emp.status} /><span className="text-surface-400">EPF: {emp.epfNo}</span></div>
        </div>
      </div>
      <div className="flex gap-1 mb-3 overflow-x-auto">
        {tabs.map(t => (
          <button key={t} onClick={() => setTab(t)} className={`px-3 py-1.5 rounded text-xs font-medium capitalize whitespace-nowrap transition-colors ${tab === t ? 'bg-surface-900 text-primary-400' : 'bg-surface-100 text-surface-500 hover:text-surface-800'}`}>{t}</button>
        ))}
      </div>
      {tab === 'personal' && (
        <div className="grid grid-cols-2 gap-x-6">
          <div><SectionTitle>Personal</SectionTitle><FieldRow label="National ID" value={emp.nationalId} /><FieldRow label="Date of Birth" value={emp.dob} /><FieldRow label="Gender" value={emp.gender} /><FieldRow label="Marital Status" value={emp.maritalStatus} /><FieldRow label="Blood Group" value={emp.bloodGroup} /></div>
          <div><SectionTitle>Identification</SectionTitle><FieldRow label="Service No" value={emp.serviceNo} /><FieldRow label="Proximity Card" value={emp.proximityCardNo} /><SectionTitle>Transport</SectionTitle><FieldRow label="Transport Mode" value={emp.transportMode} /><FieldRow label="Own Vehicle" value={emp.ownVehicle} /></div>
        </div>
      )}
      {tab === 'contact' && (
        <div className="grid grid-cols-2 gap-x-6">
          <div><SectionTitle>Contact Address</SectionTitle><FieldRow label="Address 1" value={emp.address1} /><FieldRow label="City" value={emp.city} /><FieldRow label="Personal Mobile" value={emp.phone || emp.personalMobile} /><FieldRow label="Email" value={emp.email} /></div>
          <div><SectionTitle>Home Address</SectionTitle><FieldRow label="Address 1" value={emp.homeAddress1} /><FieldRow label="District" value={emp.homeDistrict || emp.district} /><FieldRow label="Province" value={emp.homeProvince || emp.province} /></div>
        </div>
      )}
      {tab === 'employment' && (
        <div className="grid grid-cols-2 gap-x-6">
          <div><SectionTitle>Employment</SectionTitle><FieldRow label="Division" value={emp.division} /><FieldRow label="Department" value={emp.department} /><FieldRow label="Grade" value={emp.grade} /><FieldRow label="Work Category" value={emp.workCategory} /><FieldRow label="EPF No" value={emp.epfNo} /><FieldRow label="Contract Type" value={emp.contractType} /></div>
          <div><SectionTitle>Key Dates</SectionTitle><FieldRow label="Recruitment Date" value={emp.recruitmentDate} /><FieldRow label="Promoted Date" value={emp.promotedDate} /><FieldRow label="Retirement Date" value={emp.retirementDate} /></div>
        </div>
      )}
      {tab === 'kin' && (
        <div><SectionTitle>Next of Kin</SectionTitle><div className="grid grid-cols-2 gap-x-6"><FieldRow label="Name" value={`${emp.nextOfKinFirstName || ''} ${emp.nextOfKinLastName || ''}`.trim()} /><FieldRow label="Relationship" value={emp.nextOfKinRelationship} /><FieldRow label="Telephone" value={emp.nextOfKinPhone} /></div></div>
      )}
      {tab === 'qualifications' && (
        <div><SectionTitle>Education & Skills</SectionTitle><FieldRow label="Highest Education" value={emp.highestEducation} /><FieldRow label="Highest Professional" value={emp.highestProfessional} /><div className="mt-2"><span className="text-xs text-surface-400">Skills</span><p className="text-xs text-surface-800 mt-1 bg-surface-50 p-2 rounded">{emp.skills || '—'}</p></div></div>
      )}
      <div className="flex justify-end mt-4 pt-3 border-t border-surface-100"><button onClick={onClose} className="btn-ghost">Close</button></div>
    </div>
  );
}

// ══════════════════════════════════════════════════════════════════════════════
// ─── MASTER FILES EMBEDDED IN HR ─────────────────────────────────────────────
// ══════════════════════════════════════════════════════════════════════════════

// Shared styles for master files forms (primary-themed to match HRM)
const MF_INP = 'h-9 w-full bg-white border border-gray-200 rounded-lg px-2.5 text-xs text-gray-800 outline-none focus:border-primary-500';
const MF_SEL = 'h-9 w-full bg-white border border-gray-200 rounded-lg px-2.5 text-xs text-gray-800 outline-none focus:border-primary-500';

/* Searchable dropdown for the master-file entry panels — a thin wrapper over
   the shared SearchableSelect. options: [{ value, label }]; onChange gets a
   string ('' for the empty option), same as e.target.value from a <select>. */
function MFSearchSelect({ value, onChange, options = [], placeholder = 'Select...', className = MF_SEL, disabled = false }) {
  return (
    <SearchableSelect
      value={value}
      onChange={onChange}
      options={options}
      emptyOption={{ value: '', label: placeholder }}
      placeholder={placeholder}
      disabled={disabled}
      className={className}
    />
  );
}

function MFLabel({ children, req }) {
  return <label className="block text-[11px] font-medium text-gray-500 mb-1">{children}{req && <span className="text-red-500 ml-0.5">*</span>}</label>;
}

function MFEntryPanel({ title, children, onSave, onClear, saved }) {
  return (
    <div className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden">
      <div className="px-5 py-3.5 border-b border-gray-200">
        <h3 className="text-sm font-semibold text-gray-900">{title}</h3>
      </div>
      <div className="p-4">
        {saved && (
          <div className="flex items-center gap-1.5 text-emerald-700 bg-emerald-50 border border-emerald-100 rounded-lg px-2.5 py-1.5 text-xs mb-3">
            <CheckCircle size={12} /> Saved
          </div>
        )}
        <div className="space-y-2.5">{children}</div>
        <div className="flex gap-2 mt-4">
          <button onClick={onSave}
            className="flex items-center gap-2 h-9 px-4 rounded-lg text-xs font-semibold bg-primary-600 text-white hover:bg-primary-700 transition-colors">
            <Save size={13} /> Save
          </button>
          <button onClick={onClear}
            className="flex items-center gap-2 h-9 px-4 rounded-lg text-xs font-semibold bg-white border border-gray-200 text-gray-600 hover:bg-gray-50 transition-colors">
            <RotateCcw size={13} /> Clear
          </button>
        </div>
      </div>
    </div>
  );
}

/**
 * The card every master-file grid sits in.
 *
 * Same shell as the payroll tables (components/Table/Table.jsx): white card,
 * gray-200 border, a light title strip with the record count on the right, and
 * a scroll area rather than a fixed short box. Restyling this one component
 * moves every master-file grid at once.
 */
function MFGridSection({ title, count, children }) {
  return (
    <div className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
      <div className="px-5 py-3.5 border-b border-gray-200 flex items-center justify-between gap-3">
        <h3 className="text-sm font-semibold text-gray-900">{title}</h3>
        {count !== undefined && count !== null && (
          <span className="text-xs text-gray-500">
            {count === 1 ? '1 record' : `${count} records`}
          </span>
        )}
      </div>
      <div className="overflow-auto max-h-[calc(100vh-380px)] min-h-[240px]">{children}</div>
    </div>
  );
}

/* Row / cell classes shared by every master-file grid, so one change here is
   one change everywhere. They mirror the payroll table exactly. */
const MF_TH = 'px-4 py-3 text-left text-[12px] font-semibold text-gray-500 whitespace-nowrap bg-gray-50';
const MF_ROW = 'border-b border-gray-100 last:border-0 cursor-pointer transition-colors';
const MF_ROW_IDLE = 'hover:bg-gray-50';
const MF_ROW_SEL = 'bg-primary-50';

function pickField(row, keys, fallback = '') {
  for (const k of keys) {
    if (row?.[k] !== undefined && row?.[k] !== null) return row[k];
  }
  return fallback;
}

// ─── Seed data ────────────────────────────────────────────────────────────────
const SEED_DESIGNATIONS = [
  { code: '181', description: 'TECHNICAL SALES & MARKETING MANAGER', abbr: 'TECH. SALES & MARKE…', type: 'Executive', status: 'Active' },
  { code: '176', description: 'ACCOUNTANT', abbr: 'ACCOUNTANT', type: 'Executive', status: 'Active' },
  { code: '182', description: 'ACCOUNTS ASSISTANT', abbr: 'ACC. ASST.', type: 'Non Executive', status: 'Active' },
  { code: '869', description: 'ACCOUNTS CLERK', abbr: 'AC', type: 'Non Executive', status: 'Active' },
  { code: '854', description: 'ACCOUNTS EXECUTIVE', abbr: 'AE', type: 'Executive', status: 'Active' },
  { code: '114', description: 'ACTING GENERAL MANAGER', abbr: 'ACT. GM.', type: 'Executive', status: 'Active' },
  { code: '023', description: 'ADMINISTRATIVE ASSISTANT', abbr: 'A A', type: 'Non Executive', status: 'Active' },
  { code: '019', description: 'ASSISTANT ELECTRICAL ENGINEER', abbr: 'ASST. E. ENG.', type: 'Executive', status: 'Active' },
  { code: '172', description: 'ASSISTANT ENGINEER (CIVIL)', abbr: 'ASST. ENG. (CIVIL)', type: 'Executive', status: 'Active' },
];
const SEED_EDUCATION = [
  { code: '1', country: 'SRI LANKA', description: 'Below Grade V', conductedBy: '', status: 'Active' },
  { code: '3', country: 'SRI LANKA', description: 'Upto GCE(O/L) /SSC/ NCGE', conductedBy: '', status: 'Active' },
  { code: '5', country: 'SRI LANKA', description: 'Passed GCE(O/L) /SSC / NCGE', conductedBy: '', status: 'Active' },
  { code: '7', country: 'SRI LANKA', description: 'Passed GCE(A/L)', conductedBy: '', status: 'Active' },
  { code: '11', country: 'SRI LANKA', description: 'B.Sc.Eng.(Hons.)', conductedBy: '', status: 'Active' },
  { code: '13', country: 'SRI LANKA', description: 'M.Sc.', conductedBy: '', status: 'Active' },
  { code: '14', country: 'SRI LANKA', description: 'B.Sc.', conductedBy: '', status: 'Active' },
  { code: '19', country: 'SRI LANKA', description: 'B.Com', conductedBy: '', status: 'Active' },
  { code: '21', country: 'SRI LANKA', description: 'DIPLOMA IN QUANTITY SURVEYING', conductedBy: 'NAITA', status: 'Active' },
];
const SEED_PROFESSIONAL = [
  { code: '1', country: 'SRI LANKA', description: 'HIGHER DIPLOMA', instituteName: '', duration: '', status: 'Active' },
  { code: '3', country: 'SRI LANKA', description: 'HONORS DEGREE', instituteName: '', duration: '', status: 'Active' },
  { code: '4', country: 'SRI LANKA', description: 'M.Sc.', instituteName: '', duration: '', status: 'Active' },
  { code: '9', country: 'SRI LANKA', description: 'NATIONAL DIPLOMA IN TECHNOLOGY (N.D.T)', instituteName: '', duration: '', status: 'Active' },
  { code: '22', country: 'SRI LANKA', description: 'DIPLOMA IN ENGINEERING', instituteName: '', duration: '', status: 'Active' },
];
const SEED_DIVISIONS = [
  { code: 'MAIN', description: 'Main Division', effectiveDate: '2010-01-01', status: 'Active', inactiveDate: '' },
  { code: 'ENG', description: 'Engineering Division', effectiveDate: '2010-01-01', status: 'Active', inactiveDate: '' },
  { code: 'FIN', description: 'Finance Division', effectiveDate: '2010-01-01', status: 'Active', inactiveDate: '' },
  { code: 'OPS', description: 'Operations Division', effectiveDate: '2010-01-01', status: 'Active', inactiveDate: '' },
];
const SEED_DEPARTMENTS = [
  { divCode: 'ENG', code: 'CIVIL', description: 'Civil Engineering', effectiveDate: '2010-01-01', status: 'Active', inactiveDate: '' },
  { divCode: 'ENG', code: 'MECH', description: 'Mechanical Engineering', effectiveDate: '2010-01-01', status: 'Active', inactiveDate: '' },
  { divCode: 'ENG', code: 'ELEC', description: 'Electrical Engineering', effectiveDate: '2010-01-01', status: 'Active', inactiveDate: '' },
  { divCode: 'FIN', code: 'ACC', description: 'Accounts', effectiveDate: '2010-01-01', status: 'Active', inactiveDate: '' },
  { divCode: 'OPS', code: 'HR', description: 'Human Resources', effectiveDate: '2010-01-01', status: 'Active', inactiveDate: '' },
];
const SEED_LOCATIONS = [
  { divCode: 'ENG', deptCode: 'CIVIL', code: 'HO', description: 'Head Office', effectiveDate: '2010-01-01', status: 'Active', inactiveDate: '' },
  { divCode: 'ENG', deptCode: 'MECH', code: 'WK1', description: 'Workshop 1 - Colombo', effectiveDate: '2010-01-01', status: 'Active', inactiveDate: '' },
  { divCode: 'OPS', deptCode: 'HR', code: 'HR-HO', description: 'HR Head Office', effectiveDate: '2010-01-01', status: 'Active', inactiveDate: '' },
];
const SEED_SHIFTS = [
  { code: 'DAY', description: 'Day Shift', type: 'Normal', timeIn: '08:00', timeOut: '17:00', status: 'Active' },
  { code: 'NIGHT', description: 'Night Shift', type: 'Rotating', timeIn: '20:00', timeOut: '06:00', status: 'Active' },
  { code: 'GENERAL', description: 'General Shift', type: 'Normal', timeIn: '08:30', timeOut: '17:30', status: 'Active' },
];
const SEED_PROVINCES = [
  { code: 'WP', name: 'Western Province', status: 'Active' },
  { code: 'CP', name: 'Central Province', status: 'Active' },
  { code: 'SP', name: 'Southern Province', status: 'Active' },
  { code: 'NP', name: 'Northern Province', status: 'Active' },
  { code: 'EP', name: 'Eastern Province', status: 'Active' },
  { code: 'NWP', name: 'North Western Province', status: 'Active' },
];
const SEED_DISTRICTS = [
  { provCode: 'WP', provName: 'Western Province', code: 'CMB', name: 'Colombo', status: 'Active' },
  { provCode: 'WP', provName: 'Western Province', code: 'GAM', name: 'Gampaha', status: 'Active' },
  { provCode: 'CP', provName: 'Central Province', code: 'KDY', name: 'Kandy', status: 'Active' },
  { provCode: 'SP', provName: 'Southern Province', code: 'GLE', name: 'Galle', status: 'Active' },
];
const SEED_ELECTORATES = [
  { provCode: 'WP', distCode: 'CMB', code: '134', name: 'Colombo Central', status: 'Active' },
  { provCode: 'WP', distCode: 'CMB', code: '135', name: 'Colombo East', status: 'Active' },
  { provCode: 'WP', distCode: 'GAM', code: '140', name: 'Gampaha', status: 'Active' },
];
const SEED_POLICE_STATIONS = [
  { code: '1', electorateCode: '134', name: 'AHANGAMA', status: 'Active' },
  { code: '2', electorateCode: '134', name: 'KADUWELA', status: 'Active' },
  { code: '3', electorateCode: '134', name: 'ATURUGIRIYA', status: 'Active' },
  { code: '4', electorateCode: '134', name: 'BORELLA', status: 'Active' },
  { code: '5', electorateCode: '134', name: 'DEHIWALA', status: 'Active' },
];
const SEED_CALENDAR = [
  { date: '2025-01-14', type: 'Mercantile Holiday', hours: 0, description: 'Thai - Pongal Day' },
  { date: '2025-04-13', type: 'Mercantile Holiday', hours: 0, description: 'Sinhala New Year' },
  { date: '2025-04-14', type: 'Mercantile Holiday', hours: 0, description: 'Sinhala New Year' },
  { date: '2025-05-01', type: 'Mercantile Holiday', hours: 0, description: 'May Day' },
  { date: '2025-12-25', type: 'Mercantile Holiday', hours: 0, description: 'Christmas Day' },
  { date: '2026-01-14', type: 'Mercantile Holiday', hours: 0, description: 'Thai - Pongal Day' },
  { date: '2026-04-13', type: 'Mercantile Holiday', hours: 0, description: 'Sinhala New Year' },
  { date: '2026-04-14', type: 'Mercantile Holiday', hours: 0, description: 'Sinhala New Year' },
  { date: '2026-05-01', type: 'Mercantile Holiday', hours: 0, description: 'May Day' },
  { date: '2026-12-25', type: 'Mercantile Holiday', hours: 0, description: 'Christmas Day' },
];

// ─── MF Tab definitions ───────────────────────────────────────────────────────
const MF_TABS = [
  { key: 'overview', label: 'Overview', icon: BarChart2 },
  { key: 'division', label: 'Division Details', icon: Building2 },
  { key: 'department', label: 'Department Details', icon: Tag },
  { key: 'location', label: 'Location Details', icon: BookOpen },
  { key: 'designation', label: 'Designation Details', icon: Briefcase },
  { key: 'emptype', label: 'Employment Types', icon: Building2 },
  { key: 'grade', label: 'Grade Details', icon: MapPin },
  { key: 'shift', label: 'Shift Details', icon: Clock },
  { key: 'bank', label: 'Bank Details', icon: Shield },
  { key: 'bankBranch', label: 'Bank Branch Details', icon: Calendar },
  { key: 'region', label: 'Region', icon: MapPin },
];

export const CODE_PREFIXES = {
  DEPARTMENT: 'D',
  LOCATION: 'L',
  DESIGNATION: 'DS',
  EMPLOYMENT_TYPE: 'E',
  GRADE: 'G',
  SHIFT: 'S',
  BANK: 'B',
  BANK_BRANCH: 'BR',
};

export const generateCode = (existingCodes = [], prefix = '', padding = 3) => {
  const normalizedPrefix = String(prefix).toUpperCase();

  const numbers = existingCodes.map(code => {
    const value = String(code || '').trim().toUpperCase();

    if (!value.startsWith(normalizedPrefix)) {
      return null;
    }

    const numberPart = value.slice(normalizedPrefix.length);

    if (!/^\d+$/.test(numberPart)) {
      return null;
    }

    return parseInt(numberPart, 10);
  })
    .filter(Number.isFinite);

  const nextNumber = numbers.length ? Math.max(...numbers) + 1 : 1;

  return `${normalizedPrefix}${String(nextNumber).padStart(padding, '0')}`
}

// ─── MF Section: Overview ─────────────────────────────────────────────────────
function MFOverview({ setMfTab }) {
  const dispatch = useDispatch();

  const { departments = [] } = useSelector(s => s.departmentSlice) || {};
  const { locations = [] } = useSelector(s => s.locationSlice) || {};
  const { designations = [] } = useSelector(s => s.designationSlice) || {};
  const { categories = [] } = useSelector(s => s.employeeCategorySlice) || {};
  const { grades = [] } = useSelector(s => s.gradeSlice) || {};
  const { shifts = [] } = useSelector(s => s.shiftSlice) || {};
  const { banks = [] } = useSelector(s => s.bankSlice) || {};
  const { bankBranches = [] } = useSelector(s => s.bankBranchSlice) || {};
  const [codeError, setCodeError] = useState('');

  useEffect(() => {
    dispatch(getDepartmentList());
    dispatch(getLocationList());
    dispatch(getDesignationList());
    dispatch(getEmployeeCategoryList());
    dispatch(getGradeList());
    dispatch(getShiftList());
    dispatch(getBankList());
    dispatch(getBankBranchList());
  }, [dispatch]);

  const cards = [
    { key: 'department', label: 'Department Details', icon: BookOpen, count: departments.length, color: 'bg-blue-50 text-blue-600', desc: 'Organizational departments' },
    { key: 'location', label: 'Location Details', icon: Briefcase, count: locations.length, color: 'bg-purple-50 text-purple-600', desc: 'Work locations and sites' },
    { key: 'designation', label: 'Designation Details', icon: Tag, count: designations.length, color: 'bg-primary-50 text-primary-600', desc: 'Job titles, abbreviations & types' },
    { key: 'emptype', label: 'Employment Types', icon: Building2, count: categories.length + SEED_DEPARTMENTS.length, color: 'bg-orange-50 text-orange-600', desc: 'Employment categories' },
    { key: 'grade', label: 'Grade Details', icon: MapPin, count: grades.length, color: 'bg-teal-50 text-teal-600', desc: 'Salary grade tiers' },
    { key: 'shift', label: 'Shift Details', icon: Clock, count: shifts.length, color: 'bg-sky-50 text-sky-600', desc: 'Work shift configurations' },
    { key: 'bank', label: 'Bank Details', icon: Shield, count: banks.length, color: 'bg-red-50 text-red-600', desc: 'Registered banks' },
    { key: 'bankBranch', label: 'Bank Branch Details', icon: Calendar, count: bankBranches.length, color: 'bg-emerald-50 text-emerald-600', desc: 'Registered bank branches' },
  ];
  const total = cards.reduce((a, c) => a + c.count, 0);
  return (
    <div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-6">
        <StatCard label="Total Records" value={total} icon={Database} color="gold" />
        <StatCard label="Designations" value={designations.length} icon={Tag} color="blue" />
        <StatCard label="Registered Banks" value={banks.length} icon={Shield} color="green" />
        <StatCard label="Bank Branches" value={bankBranches.length} icon={Building2} color="purple" />
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {cards.map(c => (
          <button key={c.key} onClick={() => setMfTab(c.key)}
            className="bg-white border border-surface-100 rounded-xl p-5 text-left hover:border-primary-400 hover:shadow-md transition-all group">
            <div className={`w-10 h-10 rounded-lg flex items-center justify-center mb-3 ${c.color}`}><c.icon size={20} /></div>
            <p className="font-semibold text-surface-800 text-sm">{c.label}</p>
            <p className="text-xs text-surface-400 mt-0.5 mb-2">{c.desc}</p>
            <div className="flex items-center justify-between">
              <span className="text-xs font-bold text-primary-600">{c.count} records</span>
              <ChevronRight size={14} className="text-surface-300 group-hover:text-primary-400 transition-colors" />
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}

// ─── MF Section: Designation ──────────────────────────────────────────────────
// function MFDesignation() {
//   const [rows, setRows] = useState(SEED_DESIGNATIONS);
//   const [search, setSearch] = useState('');
//   const [form, setForm] = useState({ code: '', description: '', abbr: '', type: 'Non Executive', status: 'Active' });
//   const [saved, setSaved] = useState(false);
//   const filtered = rows.filter(r => r.description.toLowerCase().includes(search.toLowerCase()) || r.code.includes(search));
//   const handleSave = () => {
//     if (!form.code || !form.description) return;
//     setRows(prev => { const idx = prev.findIndex(r => r.code === form.code); if (idx >= 0) { const n = [...prev]; n[idx] = { ...form }; return n; } return [...prev, { ...form }]; });
//     setSaved(true); setTimeout(() => setSaved(false), 1500);
//   };
//   return (
//     <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
//       <div className="lg:col-span-2 space-y-3">
//         <div className="relative"><Search size={12} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" /><input className="h-9 bg-white border border-gray-200 rounded-lg text-xs pl-8 pr-3 w-full outline-none text-gray-700 focus:border-primary-500" placeholder="Search designations…" value={search} onChange={e => setSearch(e.target.value)} /></div>
//         <MFGridSection title="Designation Details">
//           <table className="w-full text-[13px]">
//             <thead><tr className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">{['Code','Description','Abbreviation','Type','Status'].map(h => <th key={h} className={MF_TH}>{h}</th>)}</tr></thead>
//             <tbody>
//               {filtered.map((r, i) => (
//                 <tr key={r.code} onClick={() => setForm({ code: r.code, description: r.description, abbr: r.abbr, type: r.type, status: r.status })}
//                   className={`${MF_ROW} ${MF_ROW_IDLE} ${i === 0 ? 'bg-primary-50/50' : ''}`}>
//                   <td className="px-4 py-3 font-mono text-gray-900 font-semibold">{r.code}</td>
//                   <td className="px-4 py-3 text-gray-900 font-medium max-w-xs truncate">{r.description}</td>
//                   <td className="px-4 py-3 text-gray-600 max-w-[120px] truncate">{r.abbr}</td>
//                   <td className="px-4 py-3"><span className={`px-2 py-0.5 rounded text-[10px] font-medium ${r.type === 'Executive' ? 'bg-purple-100 text-purple-700' : 'bg-sky-100 text-sky-700'}`}>{r.type}</span></td>
//                   <td className="px-4 py-3"><StatusPill label={r.status} /></td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </MFGridSection>
//       </div>
//       <MFEntryPanel title="Designation Entry" onSave={handleSave} onClear={() => setForm({ code: '', description: '', abbr: '', type: 'Non Executive', status: 'Active' })} saved={saved}>
//         <div><MFLabel req>Code</MFLabel><input className={MF_INP} value={form.code} onChange={e => setForm(f => ({ ...f, code: e.target.value }))} /></div>
//         <div><MFLabel req>Description</MFLabel><input className={MF_INP} value={form.description} onChange={e => setForm(f => ({ ...f, description: e.target.value }))} /></div>
//         <div><MFLabel>Abbreviation</MFLabel><input className={MF_INP} value={form.abbr} onChange={e => setForm(f => ({ ...f, abbr: e.target.value }))} /></div>
//         <div><MFLabel>Type</MFLabel><select className={MF_SEL} value={form.type} onChange={e => setForm(f => ({ ...f, type: e.target.value }))}><option>Executive</option><option>Non Executive</option></select></div>
//         <div><MFLabel>Status</MFLabel><select className={MF_SEL} value={form.status} onChange={e => setForm(f => ({ ...f, status: e.target.value }))}><option>Active</option><option>Inactive</option></select></div>
//       </MFEntryPanel>
//     </div>
//   );
// }

// ─── MF Section: Department ───────────────────────────────────────────────────
const EMPTY_DEPARTMENT_FORM = {
  code: '',
  divCode: '',
  name: '',
  description: '',
  remarks: ''
};

function MFDepartment() {
  const dispatch = useDispatch();
  const departmentState = useSelector(s => s.departmentSlice) || {};
  const { departments = [], list = [], loading = false, saving = false, error = null, success = false } = departmentState;

  // pull divisions for the dropdown
  const divisionState = useSelector(s => s.divisionSlice) || {};
  const { divisions = [] } = divisionState;

  const [search, setSearch] = useState('');
  const [form, setForm] = useState(EMPTY_DEPARTMENT_FORM);
  const [editingId, setEditingId] = useState(null);
  const [codeError, setCodeError] = useState('');

  useEffect(() => {
    dispatch(getDepartmentList());
    dispatch(getDivisionList());
  }, [dispatch]);

  useEffect(() => {
    if (success) {
      dispatch(getDepartmentList());
      setForm(EMPTY_DEPARTMENT_FORM);
      setEditingId(null);
      const t = setTimeout(() => dispatch(clearDepartmentSuccess()), 1500);
      return () => clearTimeout(t);
    }
  }, [success, dispatch]);



  const pickField = (obj, keys, fallbackPattern) => {
    if (!obj || typeof obj !== 'object') return '';
    for (const k of keys) {
      if (obj[k] !== undefined && obj[k] !== null && String(obj[k]).trim() !== '') {
        return String(obj[k]).trim();
      }
    }
    const objKeys = Object.keys(obj);
    for (const targetKey of keys) {
      const found = objKeys.find((k) => k.toLowerCase() === targetKey.toLowerCase());
      if (found && obj[found] !== undefined && obj[found] !== null && String(obj[found]).trim() !== '') {
        return String(obj[found]).trim();
      }
    }
    if (fallbackPattern) {
      const found = objKeys.find((k) => fallbackPattern.test(k));
      if (found && obj[found] !== undefined && obj[found] !== null && String(obj[found]).trim() !== '') {
        return String(obj[found]).trim();
      }
    }
    return '';
  };

  const rawList = Array.isArray(departments) && departments.length
    ? departments
    : Array.isArray(list) && list.length ? list : [];

  const rows = rawList.map(r => {
    const id = pickField(r, [
      'HDD_DEPARTMENT_ID', 'HDD_DEP_ID', 'DepartmentId', 'departmentId', 'id', 'ID'
    ], /department_id|dep_id|^id$/i);

    const code = pickField(r, [
      'HDD_DEPARTMENT_CODE', 'HDD_DEP_CODE', 'DepartmentCode', 'departmentCode',
      'deptCode', 'dept_code', 'HDD_DEPARTMENT_ID', 'HDD_DEP_ID', 'HLD_DEP_CODE',
      'DEP_CODE', 'dep_code', 'DepCode', 'Code', 'code', 'p_dep_code', 'p_department_code', 'id'
    ], /code/i);

    const name = pickField(r, [
      'HDD_DEP_DESC', 'HDD_DEPARTMENT_NAME', 'HDD_DEP_NAME', 'DepartmentName',
      'departmentName', 'deptName', 'dept_name', 'HLD_DEP_DESC', 'DEP_DESC',
      'dep_desc', 'DepDesc', 'Description', 'description', 'Name', 'name',
      'p_dep_desc', 'p_department_name'
    ], /name|desc/i);

    const description = pickField(r, [
      'Description', 'description', 'HDD_DEP_DESC', 'HDD_DEPARTMENT_NAME', 'HLD_DEP_DESC', 'remarks', 'Remarks'
    ]);

    const divCode = pickField(r, [
      'HDD_DIV_CODE', 'HDD_DIV', 'divCode', 'divisionCode', 'DivisionCode'
    ]);

    const status = (r.IsActive !== false && r.HLD_CURRENT_STATUS !== 'I' && r.status !== 'Inactive' && r.Status !== 'Inactive') ? 'Active' : 'Inactive';
    const remarks = pickField(r, ['Remarks', 'remarks', 'HDD_REMARKS']);

    return {
      id: id || code || name,
      HDD_DEPARTMENT_ID: id || code || name,
      code: code || name || '—',
      divCode,
      name: name || code || '—',
      description,
      status,
      remarks,
      raw: r,
    };
  });

  const filtered = rows.filter(r =>
    (r.name || '').toLowerCase().includes(search.toLowerCase()) ||
    (r.code || '').toLowerCase().includes(search.toLowerCase()) ||
    (r.description || '').toLowerCase().includes(search.toLowerCase())
  );

  const isDivisionActive = (d) => {
    const raw = pickField(
      d,
      ['HLD_CURRENT_STATUS', 'CURRENT_STATUS', 'currentStatus', 'p_current_status', 'Status', 'status'],
      /status/i
    ).toLowerCase();
    return !(raw === 'i' || raw === 'inactive' || raw === '0' || raw === 'false');
  };

  const divisionOptions = (divisions || [])
    .map(d => {
      const code = pickField(d, [
        'HDD_DIV_CODE', 'HLD_DIV_CODE', 'DIV_CODE', 'DivCode', 'divCode', 'Code', 'code'
      ], /div.*code|^code$/i);

      const desc = pickField(d, [
        'HDD_DIV_DESC', 'HLD_DIV_DESC', 'DIV_DESC', 'DivDesc', 'divDesc', 'Description', 'description'
      ], /div.*desc|^desc$/i);

      const active = isDivisionActive(d);

      return {
        value: code,
        active,
        label: `${desc ? `${code} — ${desc}` : code}${active ? '' : ' (Inactive)'}`,
      };
    })
    .filter(o => o.value && (o.active || o.value === form.divCode));

  const handleSelect = (r) => {
    setEditingId(r.HDD_DEPARTMENT_ID || r.id || r.code);
    setCodeError('');
    setForm({
      code: r.code,
      divCode: r.divCode || '',
      name: r.name,
      description: r.description,
      remarks: r.remarks
    });
  };

  const handleClear = () => {
    setEditingId(null);
    setCodeError('');
    setForm(EMPTY_DEPARTMENT_FORM);
    dispatch(clearDepartmentError());
  };

  const handleSave = () => {
    const code = form.code.trim().toUpperCase();

    if (!code) {
      setCodeError('Department code is required.');
      return;
    }
    if (code.length > 3) {
      setCodeError('Department code must not exceed 3 characters.');
      return;
    }
    if (!form.name.trim()) return;

    if (!editingId) {
      const exists = rows.some(r => String(r.code).trim().toUpperCase() === code);
      if (exists) {
        setCodeError(`Code '${code}' already exists.`);
        return;
      }
    }

    setCodeError('');
    const serviceNo = getLoggedInServiceNo();

    if (editingId) {
      dispatch(updateDepartment({
        p_departmentId: editingId,
        p_updatedBy: serviceNo,
        p_departmentCode: code,
        p_divisonCode: form.divCode || '',
        p_departmentName: form.name.trim(),
        p_description: form.description || '',
        p_isActive: 1,
        p_remarks: form.remarks || '',
      }));
    } else {
      dispatch(addDepartment({
        p_createdBy: serviceNo,
        p_departmentCode: code,
        p_divisonCode: form.divCode || '',
        p_departmentName: form.name.trim(),
        p_description: form.description || '',
        p_isActive: 1,
        p_remarks: form.remarks || '',
      }));
    }
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
      <div className="lg:col-span-2 space-y-3">
        <div className="relative">
          <Search size={12} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
          <input
            className="h-9 bg-white border border-gray-200 rounded-lg text-xs pl-8 pr-3 w-full outline-none text-gray-700 focus:border-primary-500"
            placeholder="Search departments…" value={search} onChange={e => setSearch(e.target.value)}
          />
        </div>
        <MFGridSection title="Department Details" count={filtered.length}>
          {loading ? (
            <div className="py-20 flex items-center justify-center gap-2 text-sm text-gray-400">
              <Loader2 size={14} className="animate-spin" /> Loading departments...
            </div>
          ) : error ? (
            <div className="py-20 flex items-center justify-center gap-2 text-sm text-red-600">
              <AlertCircle size={13} className="shrink-0" /> {error}
            </div>
          ) : filtered.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-20 text-center text-gray-400">
              <Tag size={24} className="text-gray-300 mb-2" />
              <p className="text-sm text-gray-400">No departments yet</p>
            </div>
          ) : (
            <table className="w-full text-[13px]">
              <thead>
                <tr className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">
                  {['Code', 'Division', 'Name', 'Description', 'Remarks', 'Status'].map(h => (
                    <th key={h} className={MF_TH}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filtered.map((r) => (
                  <tr key={r.id || r.code} onClick={() => handleSelect(r)}
                    className={`${MF_ROW} ${MF_ROW_IDLE} ${editingId === (r.id || r.code) ? MF_ROW_SEL : ''}`}>
                    <td className="px-4 py-3 font-mono text-gray-900 font-semibold">{r.code}</td>
                    <td className="px-4 py-3 text-gray-600 font-mono">{r.divCode || '—'}</td>
                    <td className="px-4 py-3 text-gray-900 font-medium max-w-xs truncate">{r.name}</td>
                    <td className="px-4 py-3 text-gray-600 max-w-[120px] truncate">{r.description}</td>
                    <td className="px-4 py-3 text-gray-600 max-w-[120px] truncate">{r.remarks || '—'}</td>
                    <td className="px-4 py-3"><StatusPill label={r.status} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </MFGridSection>
      </div>

      <MFEntryPanel
        title={editingId ? 'Edit Department' : 'Department Entry'}
        onSave={handleSave}
        onClear={handleClear}
        saved={success}
      >
        <div>
          <MFLabel req>Code</MFLabel>
          <input
            className={`${MF_INP} ${editingId ? 'cursor-not-allowed bg-gray-200' : ''} ${codeError ? 'border-red-400' : ''}`}
            maxLength={3}
            disabled={!!editingId}
            readOnly={!!editingId}
            value={form.code}
            placeholder="e.g. D01"
            onChange={e => {
              setCodeError('');
              setForm(f => ({ ...f, code: e.target.value.toUpperCase() }));
            }}
          />
          {codeError ? (
            <p className="text-[10px] text-red-500 mt-0.5">{codeError}</p>
          ) : editingId ? (
            <p className="text-[10px] text-surface-400 mt-0.5">Code can't be changed once created</p>
          ) : (
            <p className="text-[10px] text-surface-400 mt-0.5">Up to 3 characters</p>
          )}
        </div>

        {/* Division dropdown */}
        <div>
          <MFLabel req>Division</MFLabel>
          <MFSearchSelect
            value={form.divCode}
            onChange={v => setForm(f => ({ ...f, divCode: v }))}
            options={divisionOptions}
            placeholder="— Select division —"
          />
        </div>

        <div>
          <MFLabel req>Name</MFLabel>
          <input className={MF_INP} value={form.name}
            onChange={e => setForm(f => ({ ...f, name: e.target.value }))} />
        </div>
        <div>
          <MFLabel>Description</MFLabel>
          <input className={MF_INP} value={form.description}
            onChange={e => setForm(f => ({ ...f, description: e.target.value }))} />
        </div>
        <div>
          <MFLabel>Remarks</MFLabel>
          <input className={MF_INP} value={form.remarks}
            onChange={e => setForm(f => ({ ...f, remarks: e.target.value }))} />
        </div>
        {saving && <p className="text-[10px] text-primary-500">Saving...</p>}
        {error && <p className="text-[10px] text-red-500">{error}</p>}
      </MFEntryPanel>
    </div>
  );
}


// ─── MF Section: Division ────────────────────────────────────────────────────
const EMPTY_DIVISION_FORM = {
  code: '',
  description: '',
  effectiveDate: '',
  inactiveDate: '',
  status: 'Active',
};


const toDateInput = (v) => {
  if (!v) return '';
  const s = String(v).trim();

  // ISO: 2026-10-26 or 2026-10-26T00:00:00
  const iso = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (iso) return `${iso[1]}-${iso[2]}-${iso[3]}`;

  // US: 10/26/2026 or 10/26/2026 12:00:00 AM  
  const us = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})/);
  if (us) return `${us[3]}-${us[1].padStart(2, '0')}-${us[2].padStart(2, '0')}`;

  const d = new Date(s);
  if (!isNaN(d)) {
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  }
  return '';
};

function MFDivision() {
  const dispatch = useDispatch();
  const divisionState = useSelector(s => s.divisionSlice) || {};
  const {
    divisions = [],
    loading = false,
    saving = false,
    error = null,
    success = false,
  } = divisionState;

  const [search, setSearch] = useState('');
  const [form, setForm] = useState(EMPTY_DIVISION_FORM);
  const [editingCode, setEditingCode] = useState(null);

  useEffect(() => {
    dispatch(getDivisionList());
  }, [dispatch]);

  useEffect(() => {
    if (success) {
      dispatch(getDivisionList());
      setForm(EMPTY_DIVISION_FORM);
      setEditingCode(null);
      const t = setTimeout(() => dispatch(clearDivisionSuccess()), 1500);
      return () => clearTimeout(t);
    }
  }, [success, dispatch]);

  const rows = (divisions || []).map((r, i) => {
    // ── robust field picker (case‑insensitive + pattern fallback) ──────────
    const pick = (obj, keys, pattern) => {
      if (!obj || typeof obj !== 'object') return '';
      for (const k of keys) {
        if (obj[k] !== undefined && obj[k] !== null && String(obj[k]).trim() !== '') {
          return String(obj[k]).trim();
        }
      }
      const objKeys = Object.keys(obj);
      for (const target of keys) {
        const hit = objKeys.find(k => k.toLowerCase() === target.toLowerCase());
        if (hit && obj[hit] !== undefined && obj[hit] !== null && String(obj[hit]).trim() !== '') {
          return String(obj[hit]).trim();
        }
      }
      if (pattern) {
        const hit = objKeys.find(k => pattern.test(k));
        if (hit && obj[hit] !== undefined && obj[hit] !== null && String(obj[hit]).trim() !== '') {
          return String(obj[hit]).trim();
        }
      }
      return '';
    };

    const rawStatus = pick(
      r,
      ['HLD_CURRENT_STATUS', 'CURRENT_STATUS', 'currentStatus', 'p_current_status', 'Status', 'status'],
      /status/i
    );
    const isInactive =
      rawStatus === 'I' || rawStatus === 'Inactive' ||
      rawStatus === 0 || rawStatus === '0' || rawStatus === false;

    const code = pick(
      r,
      ['HLD_DIV_CODE', 'DIV_CODE', 'DivCode', 'divCode', 'Code', 'code'],
      /div.*code|^code$/i
    );

    return {
      id: code || `row-${i}`,
      code,
      description: pick(
        r,
        ['HLD_DIV_DESC', 'DIV_DESC', 'DivDesc', 'divDesc', 'Description', 'description'],
        /div.*desc|^description$/i
      ),
      effectiveDate: toDateInput(pick(
        r,
        ['HLD_EFFECT_DATE', 'EFFECT_DATE', 'EffectDate', 'effectDate', 'p_effect_date'],
        /effect.*date/i
      )),
      inactiveDate: toDateInput(pick(
        r,
        ['HLD_INACTIVE_DATE', 'INACTIVE_DATE', 'InactiveDate', 'inactiveDate', 'p_inactive_date'],
        /inactive.*date/i
      )),
      status: isInactive ? 'Inactive' : 'Active',
    };
  });

  const filtered = rows.filter(r =>
    (r.code || '').toLowerCase().includes(search.toLowerCase()) ||
    (r.description || '').toLowerCase().includes(search.toLowerCase())
  );

  const handleSelect = (r) => {
    setEditingCode(r.code);
    setForm({
      code: r.code,
      description: r.description,
      effectiveDate: r.effectiveDate,
      inactiveDate: r.inactiveDate,
      status: r.status,
    });
  };

  const handleClear = () => {
    setEditingCode(null);
    setForm(EMPTY_DIVISION_FORM);
    dispatch(clearDivisionError());
  };

  const handleSave = () => {
    if (!form.code.trim() || !form.description.trim()) return;

    const base = {
      p_div_code: form.code.trim().toUpperCase(),
      p_div_desc: form.description.trim(),
      p_current_status: form.status === 'Active' ? 'A' : 'I',
    };

    if (form.effectiveDate) base.p_effect_date = form.effectiveDate;
    if (form.inactiveDate) base.p_inactive_date = form.inactiveDate;

    if (editingCode) {
      dispatch(updateDivision(base));
    } else {
      dispatch(addDivision({
        ...base,
        p_start_date: form.effectiveDate || undefined,
        p_delete_status: 'N',
      }));
    }
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
      <div className="lg:col-span-2 space-y-3">
        <div className="relative">
          <Search size={12} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
          <input
            className="h-9 bg-white border border-gray-200 rounded-lg text-xs pl-8 pr-3 w-full outline-none text-gray-700 focus:border-primary-500"
            placeholder="Search divisions…"
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
        </div>

        <MFGridSection title="Division Details" count={filtered.length}>
          {loading ? (
            <div className="py-20 flex items-center justify-center gap-2 text-sm text-gray-400">
              <Loader2 size={14} className="animate-spin" /> Loading divisions...
            </div>
          ) : error ? (
            <div className="py-20 flex items-center justify-center gap-2 text-sm text-red-600">
              <AlertCircle size={13} className="shrink-0" /> {error}
            </div>
          ) : filtered.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-20 text-center text-gray-400">
              <Building2 size={24} className="text-gray-300 mb-2" />
              <p className="text-sm text-gray-400">No divisions yet</p>
            </div>
          ) : (
            <table className="w-full text-[13px]">
              <thead>
                <tr className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">
                  {['Code', 'Description', 'Effective Date', 'Inactive Date', 'Status'].map(h => (
                    <th key={h} className={MF_TH}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filtered.map(r => (
                  <tr
                    key={r.id}
                    onClick={() => handleSelect(r)}
                    className={`${MF_ROW} ${MF_ROW_IDLE} ${editingCode === r.code ? MF_ROW_SEL : ''}`}
                  >
                    <td className="px-4 py-3 font-mono text-gray-900 font-semibold">{r.code || '—'}</td>
                    <td className="px-4 py-3 text-gray-900 font-medium max-w-xs truncate">{r.description || '—'}</td>
                    <td className="px-4 py-3 text-gray-600">{r.effectiveDate || '—'}</td>
                    <td className="px-4 py-3 text-gray-600">{r.inactiveDate || '—'}</td>
                    <td className="px-4 py-3"><StatusPill label={r.status} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </MFGridSection>
      </div>

      <MFEntryPanel
        title={editingCode ? 'Edit Division' : 'Division Entry'}
        onSave={handleSave}
        onClear={handleClear}
        saved={success}
      >
        <div>
          <MFLabel req>Division Code</MFLabel>
          <input
            className={`${MF_INP} ${editingCode ? 'cursor-not-allowed bg-gray-200' : ''}`}
            maxLength={3}
            disabled={!!editingCode}
            readOnly={!!editingCode}
            value={form.code}
            onChange={e => setForm(f => ({ ...f, code: e.target.value.toUpperCase() }))}
          />
          {editingCode && (
            <p className="text-[10px] text-surface-400 mt-0.5">Code can't be changed once created</p>
          )}
        </div>

        <div>
          <MFLabel req>Description</MFLabel>
          <input
            className={MF_INP}
            maxLength={40}
            value={form.description}
            onChange={e => setForm(f => ({ ...f, description: e.target.value }))}
          />
        </div>

        <div>
          <MFLabel>Effective Date</MFLabel>
          <input
            className={MF_INP}
            type="date"
            value={form.effectiveDate}
            onChange={e => setForm(f => ({ ...f, effectiveDate: e.target.value }))}
          />
        </div>

        <div>
          <MFLabel>Inactive Date</MFLabel>
          <input
            className={MF_INP}
            type="date"
            value={form.inactiveDate}
            onChange={e => setForm(f => ({ ...f, inactiveDate: e.target.value }))}
          />
        </div>

        <div>
          <MFLabel>Status</MFLabel>
          <select
            className={MF_SEL}
            value={form.status}
            onChange={e => setForm(f => ({ ...f, status: e.target.value }))}
          >
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
          </select>
        </div>

        {saving && <p className="text-[10px] text-primary-500">Saving...</p>}
        {error && <p className="text-[10px] text-red-500">{error}</p>}
      </MFEntryPanel>
    </div>
  );
}

// ─── MF Section: Location ─────────────────────────────────────────────────────
const EMPTY_LOCATION_FORM = {
  code: '',
  name: '',
  description: '',
  remarks: ''
};

function MFLocation() {
  const dispatch = useDispatch();
  const locationState = useSelector(s => s.locationSlice) || {};
  const { locations = [], list = [], loading = false, saving = false, error = null, success = false } = locationState;

  const [search, setSearch] = useState('');
  const [form, setForm] = useState(EMPTY_LOCATION_FORM);
  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    dispatch(getLocationList());
  }, [dispatch]);

  useEffect(() => {
    if (success) {
      dispatch(getLocationList());
      setForm(EMPTY_LOCATION_FORM);
      setEditingId(null);
      const t = setTimeout(() => dispatch(clearLocationSuccess()), 1500);
      return () => clearTimeout(t);
    }
  }, [success, dispatch]);

  useEffect(() => {
    if (editingId) return;

    const existingCodes = (locations || []).map(r =>
      pickField(r, [
        'LocationCode',
        'locationCode',
        'HLD_LOCATION_CODE'
      ])
    );

    setForm(f => ({
      ...f,
      code: generateCode(
        existingCodes,
        CODE_PREFIXES.LOCATION
      )
    }));
  }, [locations, editingId]);

  const pickField = (obj, keys, fallbackPattern) => {
    if (!obj || typeof obj !== 'object') return '';
    for (const k of keys) {
      if (obj[k] !== undefined && obj[k] !== null && String(obj[k]).trim() !== '') {
        return String(obj[k]).trim();
      }
    }
    const objKeys = Object.keys(obj);
    for (const targetKey of keys) {
      const found = objKeys.find((k) => k.toLowerCase() === targetKey.toLowerCase());
      if (found && obj[found] !== undefined && obj[found] !== null && String(obj[found]).trim() !== '') {
        return String(obj[found]).trim();
      }
    }
    if (fallbackPattern) {
      const found = objKeys.find((k) => fallbackPattern.test(k));
      if (found && obj[found] !== undefined && obj[found] !== null && String(obj[found]).trim() !== '') {
        return String(obj[found]).trim();
      }
    }
    return '';
  };

  const rawList = Array.isArray(locations) && locations.length ? locations : Array.isArray(list) && list.length ? list : [];
  const rows = rawList.map(r => {
    const id = pickField(r, [
      'HDD_LOCATION_ID', 'HDD_LOC_ID', 'LocationId', 'locationId', 'id', 'ID'
    ], /location_id|loc_id|^id$/i);

    const code = pickField(r, [
      'HDD_LOCATION_CODE', 'HDD_LOC_CODE', 'LocationCode', 'locationCode',
      'HLD_LOC_CODE', 'LOC_CODE', 'loc_code', 'LocCode', 'Code', 'code', 'id',
      'p_loc_code', 'p_location_code'
    ], /code/i);

    const name = pickField(r, [
      'HDD_LOC_DESC', 'HDD_LOCATION_NAME', 'HDD_LOC_NAME', 'LocationName',
      'locationName', 'HLD_LOC_DESC', 'LOC_DESC', 'loc_desc', 'LocDesc',
      'Description', 'description', 'Name', 'name', 'p_loc_desc', 'p_location_name'
    ], /name|desc/i);

    const description = pickField(r, [
      'Description', 'description', 'Address', 'address', 'HDD_ADDRESS', 'HLD_ADDRESS', 'HDD_LOC_DESC', 'remarks', 'Remarks'
    ]);

    const status = (r.IsActive !== false && r.HLD_CURRENT_STATUS !== 'I' && r.status !== 'Inactive' && r.Status !== 'Inactive') ? 'Active' : 'Inactive';
    const remarks = pickField(r, ['Remarks', 'remarks', 'HDD_REMARKS', 'HLD_REMARKS']);

    return {
      id: id || code || name,
      HDD_LOCATION_ID: id || code || name,
      code: code || name || '—',
      name: name || code || '—',
      description,
      status,
      remarks,
      raw: r,
    };
  });

  const filtered = rows.filter(r =>
    (r.name || '').toLowerCase().includes(search.toLowerCase()) ||
    (r.code || '').toLowerCase().includes(search.toLowerCase()) ||
    (r.description || '').toLowerCase().includes(search.toLowerCase())
  );

  const handleSelect = (r) => {
    setEditingId(r.HDD_LOCATION_ID || r.id || r.code);
    setForm({ code: r.code, name: r.name, description: r.description, remarks: r.remarks });
  };

  const handleClear = () => {
    setEditingId(null);
    setForm(EMPTY_LOCATION_FORM);
    dispatch(clearLocationError());
  };

  const handleSave = () => {
    if (!form.code || !form.name) return;
    const serviceNo = getLoggedInServiceNo() || "3000807";

    if (editingId) {
      dispatch(updateLocation({
        p_locationId: editingId,
        p_updatedBy: serviceNo,
        p_locationCode: form.code,
        p_locationName: form.name,
        p_address: form.description || "",
        p_isActive: 1,
        p_remarks: form.remarks || "",
      }));
    } else {
      dispatch(addLocation({
        p_createdBy: serviceNo,
        p_locationCode: form.code,
        p_locationName: form.name,
        p_address: form.description || "",
        p_isActive: 1,
        p_remarks: form.remarks || "",
      }));
    }
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
      <div className="lg:col-span-2 space-y-3">
        <div className="relative">
          <Search size={12} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
          <input
            className="h-9 bg-white border border-gray-200 rounded-lg text-xs pl-8 pr-3 w-full outline-none text-gray-700 focus:border-primary-500"
            placeholder="Search locations…" value={search} onChange={e => setSearch(e.target.value)}
          />
        </div>
        <MFGridSection title="Location Details" count={filtered.length}>
          {loading ? (
            <div className="py-20 flex items-center justify-center gap-2 text-sm text-gray-400">
              <Loader2 size={14} className="animate-spin" /> Loading locations...
            </div>
          ) : error ? (
            <div className="py-20 flex items-center justify-center gap-2 text-sm text-red-600">
              <AlertCircle size={13} className="shrink-0" /> {error}
            </div>
          ) : filtered.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-20 text-center text-gray-400">
              <Tag size={24} className="text-gray-300 mb-2" />
              <p className="text-sm text-gray-400">No locations yet</p>
            </div>
          ) : (
            <table className="w-full text-[13px]">
              <thead>
                <tr className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">
                  {['Code', 'Name', 'Description', 'Remarks', 'Status'].map(h => (
                    <th key={h} className={MF_TH}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filtered.map((r) => (
                  <tr key={r.id || r.code} onClick={() => handleSelect(r)}
                    className={`${MF_ROW} ${MF_ROW_IDLE} ${editingId === (r.id || r.code) ? MF_ROW_SEL : ''}`}>
                    <td className="px-4 py-3 font-mono text-gray-900 font-semibold">{r.code}</td>
                    <td className="px-4 py-3 text-gray-900 font-medium max-w-xs truncate">{r.name}</td>
                    <td className="px-4 py-3 text-gray-600 max-w-[120px] truncate">{r.description}</td>
                    <td className="px-4 py-3 text-gray-600 max-w-[120px] truncate">{r.remarks || '—'}</td>
                    <td className="px-4 py-3"><StatusPill label={r.status} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </MFGridSection>
      </div>

      <MFEntryPanel
        title={editingId ? 'Edit Location' : 'Location Entry'}
        onSave={handleSave}
        onClear={handleClear}
        saved={success}
      >
        <div>
          <MFLabel req>Code</MFLabel>
          <input className={`${MF_INP} bg-gray-200 cursor-not-allowed`} value={form.code} disabled readonly
            onChange={e => setForm(f => ({ ...f, code: e.target.value }))} />
          {editingId && <p className="text-[10px] text-surface-400 mt-0.5">Code can't be changed once created</p>}
        </div>
        <div>
          <MFLabel req>Name</MFLabel>
          <input className={MF_INP} value={form.name}
            onChange={e => setForm(f => ({ ...f, name: e.target.value }))} />
        </div>
        <div>
          <MFLabel>Description</MFLabel>
          <input className={MF_INP} value={form.description}
            onChange={e => setForm(f => ({ ...f, description: e.target.value }))} />
        </div>
        <div>
          <MFLabel>Remarks</MFLabel>
          <input className={MF_INP} value={form.remarks}
            onChange={e => setForm(f => ({ ...f, remarks: e.target.value }))} />
        </div>
        {saving && <p className="text-[10px] text-primary-500">Saving...</p>}
        {error && <p className="text-[10px] text-red-500">{error}</p>}
      </MFEntryPanel>
    </div>
  );
}

const EMPTY_DESIGNATION_FORM = {
  code: '',
  name: '',
  abbreviation: '',
  remarks: ''
};

function MFDesignation() {
  const dispatch = useDispatch();
  const { designations, loading, saving, error, success } = useSelector(s => s.designationSlice);

  const [search, setSearch] = useState('');
  const [form, setForm] = useState(EMPTY_DESIGNATION_FORM);
  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    dispatch(getDesignationList());
  }, [dispatch]);

  useEffect(() => {
    if (editingId) return;

    const existingCodes = (designations || []).map(r =>
      pickField(r, [
        'DesignationCode',
        'designationCode',
        'HED_DESIGNATION_CODE'
      ])
    );

    setForm(f => ({
      ...f,
      code: generateCode(
        existingCodes,
        CODE_PREFIXES.DESIGNATION
      )
    }));
  }, [designations, editingId]);

  useEffect(() => {
    if (success) {
      dispatch(getDesignationList());
      setForm(EMPTY_DESIGNATION_FORM);
      setEditingId(null);
      const t = setTimeout(() => dispatch(clearDesignationSuccess()), 1500);
      return () => clearTimeout(t);
    }
  }, [success, dispatch]);

  const rows = (designations || []).map(r => ({
    id: pickField(r, ['DesignationId', 'designationId', 'HED_DESIGNATION_ID']),
    code: pickField(r, ['DesignationCode', 'designationCode', 'HED_DESIGNATION_CODE']),
    name: pickField(r, ['DesignationName', 'designationName', 'HED_DESIGNATION_NAME']),
    abbreviation: pickField(r, ['Abbreviation', 'abbreviation', 'HED_ABBRIVATION']),
    remarks: pickField(r, ['Remarks', 'remarks', 'HED_REMARKS']),
  }));

  const filtered = rows.filter(r =>
    r.name.toLowerCase().includes(search.toLowerCase()) ||
    r.code.toLowerCase().includes(search.toLowerCase())
  );

  const handleSelect = (r) => {
    setEditingId(r.id);
    setForm({ code: r.code, name: r.name, abbreviation: r.abbreviation, remarks: r.remarks });
  };

  const handleClear = () => {
    setEditingId(null);
    setForm(EMPTY_DESIGNATION_FORM);
    dispatch(clearDesignationError());
  };

  const handleSave = () => {
    if (!form.code || !form.name) return;
    if (editingId) {
      dispatch(updateDesignation({
        p_designationId: editingId,
        p_designationName: form.name,
        p_remarks: form.remarks || '',
        p_updatedBy: 'HR_ADMIN', // TODO: swap for the real logged-in user, same as p_created_by elsewhere
      }));
    } else {
      dispatch(addDesignation({
        p_designationCode: form.code,
        p_designationName: form.name,
        p_abbreviation: form.abbreviation || '',
        p_createdBy: 'HR_ADMIN', // TODO: same as above
        p_remarks: form.remarks || '',
      }));
    }
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
      <div className="lg:col-span-2 space-y-3">
        <div className="relative">
          <Search size={12} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
          <input
            className="h-9 bg-white border border-gray-200 rounded-lg text-xs pl-8 pr-3 w-full outline-none text-gray-700 focus:border-primary-500"
            placeholder="Search designations…" value={search} onChange={e => setSearch(e.target.value)}
          />
        </div>
        <MFGridSection title="Designation Details" count={filtered.length}>
          {loading ? (
            <div className="py-20 flex items-center justify-center gap-2 text-sm text-gray-400">
              <Loader2 size={14} className="animate-spin" /> Loading designations...
            </div>
          ) : error ? (
            <div className="py-20 flex items-center justify-center gap-2 text-sm text-red-600">
              <AlertCircle size={13} className="shrink-0" /> {error}
            </div>
          ) : filtered.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-20 text-center text-gray-400">
              <Tag size={24} className="text-gray-300 mb-2" />
              <p className="text-sm text-gray-400">No designations yet</p>
            </div>
          ) : (
            <table className="w-full text-[13px]">
              <thead>
                <tr className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">
                  {['Code', 'Name', 'Abbreviation', 'Remarks'].map(h => (
                    <th key={h} className={MF_TH}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filtered.map((r) => (
                  <tr key={r.id || r.code} onClick={() => handleSelect(r)}
                    className={`${MF_ROW} ${MF_ROW_IDLE} ${editingId === r.id ? MF_ROW_SEL : ''}`}>
                    <td className="px-4 py-3 font-mono text-gray-900 font-semibold">{r.code}</td>
                    <td className="px-4 py-3 text-gray-900 font-medium max-w-xs truncate">{r.name}</td>
                    <td className="px-4 py-3 text-gray-600 max-w-[120px] truncate">{r.abbreviation}</td>
                    <td className="px-4 py-3 text-gray-600 max-w-[160px] truncate">{r.remarks}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </MFGridSection>
      </div>

      <MFEntryPanel
        title={editingId ? 'Edit Designation' : 'Designation Entry'}
        onSave={handleSave}
        onClear={handleClear}
        saved={success}
      >
        <div>
          <MFLabel req>Code</MFLabel>
          <input className={`${MF_INP} bg-gray-200 cursor-not-allowed`} value={form.code} disabled readOnly
            onChange={e => setForm(f => ({ ...f, code: e.target.value }))} />
          {editingId && <p className="text-[10px] text-surface-400 mt-0.5">Code can't be changed once created</p>}
        </div>
        <div>
          <MFLabel req>Name</MFLabel>
          <input className={MF_INP} value={form.name}
            onChange={e => setForm(f => ({ ...f, name: e.target.value }))} />
        </div>
        <div>
          <MFLabel>Abbreviation</MFLabel>
          <input className={MF_INP} value={form.abbreviation} disabled={!!editingId}
            onChange={e => setForm(f => ({ ...f, abbreviation: e.target.value }))} />
          {editingId && <p className="text-[10px] text-surface-400 mt-0.5">Not editable via update — abbreviation is fixed after creation</p>}
        </div>
        <div>
          <MFLabel>Remarks</MFLabel>
          <input className={MF_INP} value={form.remarks}
            onChange={e => setForm(f => ({ ...f, remarks: e.target.value }))} />
        </div>
        {saving && <p className="text-[10px] text-primary-500">Saving...</p>}
        {error && <p className="text-[10px] text-red-500">{error}</p>}
      </MFEntryPanel>
    </div>
  );
}

// ─── MF Section: Employment Types ─────────────────────────────────────────────
const EMPTY_EMPLOYMENT_TYPE_FORM = {
  code: '',
  name: '',
  remarks: ''
};

function MFEmploymentTypes() {
  const dispatch = useDispatch();
  const categoryState = useSelector(s => s.employeeCategorySlice) || {};
  const { categories = [], list = [], loading = false, saving = false, error = null, success = false } = categoryState;

  const [search, setSearch] = useState('');
  const [form, setForm] = useState(EMPTY_EMPLOYMENT_TYPE_FORM);
  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    dispatch(getEmployeeCategoryList());
  }, [dispatch]);

  useEffect(() => {
    if (success) {
      dispatch(getEmployeeCategoryList());
      setForm(EMPTY_EMPLOYMENT_TYPE_FORM);
      setEditingId(null);
      const t = setTimeout(() => dispatch(clearEmployeeCategorySuccess()), 1500);
      return () => clearTimeout(t);
    }
  }, [success, dispatch]);

  useEffect(() => {
    if (editingId) return;

    const existingCodes = (categories || []).map(r =>
      pickField(r, [
        'code',
        'HEC_CATEGORY_CODE',
        'CategoryCode',
        'categoryCode'
      ])
    );

    setForm(f => ({
      ...f,
      code: generateCode(
        existingCodes,
        CODE_PREFIXES.EMPLOYMENT_TYPE
      )
    }));
  }, [categories, editingId]);

  const rawList = Array.isArray(categories) && categories.length ? categories : Array.isArray(list) && list.length ? list : [];
  const rows = rawList.map(r => {
    const id = pickField(r, [
      'HEC_EMPLOYMENT_CATEGORY_ID', 'HEC_CATEGORY_ID', 'CategoryId', 'categoryId', 'id', 'ID'
    ]);
    const code = pickField(r, [
      'HEC_CATEGORY_CODE', 'HEC_CODE', 'CategoryCode', 'categoryCode',
      'catCode', 'cat_code', 'Code', 'code', 'p_cat_code', 'p_category_code', 'id'
    ]);
    const name = pickField(r, [
      'HEC_CATEGORY_NAME', 'HEC_CATEGORY_DESC', 'CategoryName', 'categoryName',
      'catName', 'cat_name', 'Description', 'description', 'Name', 'name',
      'p_cat_name', 'p_category_name'
    ]);
    const remarks = pickField(r, ['Remarks', 'remarks', 'HEC_REMARKS', 'Description', 'description']);
    const status = (r.IsActive !== false && r.HEC_ACTIVE_STATUS !== 'I' && r.HEC_CURRENT_STATUS !== 'I' && r.status !== 'Inactive' && r.Status !== 'Inactive') ? 'Active' : 'Inactive';

    return {
      id: id || code || name,
      code: code || name || '—',
      name: name || code || '—',
      status,
      remarks,
      raw: r,
    };
  });

  const filtered = rows.filter(r =>
    (r.name || '').toLowerCase().includes(search.toLowerCase()) ||
    (r.code || '').toLowerCase().includes(search.toLowerCase()) ||
    (r.remarks || '').toLowerCase().includes(search.toLowerCase())
  );

  const handleSelect = (r) => {
    setEditingId(r.id || r.code);
    setForm({ code: r.code, name: r.name, remarks: r.remarks });
  };

  const handleClear = () => {
    setEditingId(null);
    setForm(EMPTY_EMPLOYMENT_TYPE_FORM);
    dispatch(clearEmployeeCategoryError());
  };

  const handleSave = () => {
    if (!form.code || !form.name) return;
    const serviceNo = getLoggedInServiceNo() || "3000807";

    if (editingId) {
      dispatch(updateEmployeeCategory({
        p_categoryId: editingId,
        p_updatedBy: serviceNo,
        p_categoryCode: form.code,
        p_categoryName: form.name,
        p_isActive: 1,
        p_remarks: form.remarks || "",
      }));
    } else {
      dispatch(addEmployeeCategory({
        p_createdBy: serviceNo,
        p_categoryCode: form.code,
        p_categoryName: form.name,
        p_isActive: 1,
        p_remarks: form.remarks || "",
      }));
    }
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
      <div className="lg:col-span-2 space-y-3">
        <div className="relative">
          <Search size={12} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
          <input
            className="h-9 bg-white border border-gray-200 rounded-lg text-xs pl-8 pr-3 w-full outline-none text-gray-700 focus:border-primary-500"
            placeholder="Search employment types…" value={search} onChange={e => setSearch(e.target.value)}
          />
        </div>
        <MFGridSection title="Employment Types" count={filtered.length}>
          {loading ? (
            <div className="py-20 flex items-center justify-center gap-2 text-sm text-gray-400">
              <Loader2 size={14} className="animate-spin" /> Loading employment types...
            </div>
          ) : error ? (
            <div className="py-20 flex items-center justify-center gap-2 text-sm text-red-600">
              <AlertCircle size={13} className="shrink-0" /> {error}
            </div>
          ) : filtered.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-20 text-center text-gray-400">
              <Tag size={24} className="text-gray-300 mb-2" />
              <p className="text-sm text-gray-400">No employment types yet</p>
            </div>
          ) : (
            <table className="w-full text-[13px]">
              <thead>
                <tr className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">
                  {['Code', 'Name', 'Status', 'Remarks'].map(h => (
                    <th key={h} className={MF_TH}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filtered.map((r) => (
                  <tr key={r.id || r.code} onClick={() => handleSelect(r)}
                    className={`${MF_ROW} ${MF_ROW_IDLE} ${editingId === (r.id || r.code) ? MF_ROW_SEL : ''}`}>
                    <td className="px-4 py-3 font-mono text-gray-900 font-semibold">{r.code}</td>
                    <td className="px-4 py-3 text-gray-900 font-medium max-w-xs truncate">{r.name}</td>
                    <td className="px-4 py-3"><StatusPill label={r.status} /></td>
                    <td className="px-4 py-3 text-gray-600 max-w-[160px] truncate">{r.remarks}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </MFGridSection>
      </div>

      <MFEntryPanel
        title={editingId ? 'Edit Employment Type' : 'Employment Type Entry'}
        onSave={handleSave}
        onClear={handleClear}
        saved={success}
      >
        <div>
          <MFLabel req>Category Code</MFLabel>
          <input className={`${MF_INP} bg-gray-200 cursor-not-allowed`} value={form.code} disabled readOnly
            onChange={e => setForm(f => ({ ...f, code: e.target.value }))} />
          {editingId && <p className="text-[10px] text-surface-400 mt-0.5">Code can't be changed once created</p>}
        </div>
        <div>
          <MFLabel req>Category Name</MFLabel>
          <input className={MF_INP} value={form.name}
            onChange={e => setForm(f => ({ ...f, name: e.target.value }))} />
        </div>
        <div>
          <MFLabel>Remarks</MFLabel>
          <input className={MF_INP} value={form.remarks}
            onChange={e => setForm(f => ({ ...f, remarks: e.target.value }))} />
        </div>
        {saving && <p className="text-[10px] text-primary-500">Saving...</p>}
        {error && <p className="text-[10px] text-red-500">{error}</p>}
      </MFEntryPanel>
    </div>
  );
}

// ─── MF Section: Grade ────────────────────────────────────────────────────────
const EMPTY_GRADE_FORM = {
  code: '',
  name: '',
  minSalary: '',
  maxSalary: '',
  remarks: ''
};

function MFGrade() {
  const dispatch = useDispatch();
  const gradeState = useSelector(s => s.gradeSlice) || {};
  const { grades = [], list = [], loading = false, saving = false, error = null, success = false } = gradeState;

  const [search, setSearch] = useState('');
  const [form, setForm] = useState(EMPTY_GRADE_FORM);
  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    dispatch(getGradeList());
  }, [dispatch]);

  useEffect(() => {
    if (success) {
      dispatch(getGradeList());
      setForm(EMPTY_GRADE_FORM);
      setEditingId(null);
      const t = setTimeout(() => dispatch(clearGradeSuccess()), 1500);
      return () => clearTimeout(t);
    }
  }, [success, dispatch]);

  useEffect(() => {
    if (editingId) return;

    const existingCodes = (grades || []).map(r =>
      pickField(r, [
        'GradeCode',
        'gradeCode',
        'HGD_GRADE_CODE'
      ])
    );

    setForm(f => ({
      ...f,
      code: generateCode(
        existingCodes,
        CODE_PREFIXES.GRADE
      )
    }));
  }, [grades, editingId]);

  const rawList = Array.isArray(grades) ? grades : [];
  const rows = rawList.map(r => {
    const id = pickField(r, [
      'HGD_GRADE_ID', 'HG_GRADE_ID', 'HedGradeId', 'GradeId', 'gradeId', 'id', 'ID'
    ]);
    const code = pickField(r, [
      'HGD_GRADE_CODE', 'HG_GRADE_CODE', 'GradeCode', 'gradeCode', 'Code', 'code', 'p_grade_code', 'p_initial_grade', 'p_present_grade', 'id'
    ]);
    const name = pickField(r, [
      'HGD_GRADE_NAME', 'HG_GRADE_NAME', 'GradeName', 'gradeName', 'Description', 'description', 'Name', 'name', 'p_grade_name'
    ]);
    const minSalary = pickField(r, [
      'HGD_MIN_SALARY', 'HG_MIN_SALARY', 'MinSalary', 'minSalary', 'MIN_SALARY', 'p_min_salary', 'p_minSalary'
    ]);
    const maxSalary = pickField(r, [
      'HGD_MAX_SALARY', 'HG_MAX_SALARY', 'MaxSalary', 'maxSalary', 'MAX_SALARY', 'p_max_salary', 'p_maxSalary'
    ]);
    const remarks = pickField(r, ['Remarks', 'remarks', 'HG_REMARKS', 'HGD_REMARKS', 'Description', 'description']);
    const status = (r.IsActive !== false && r.HG_CURRENT_STATUS !== 'I' && r.status !== 'Inactive' && r.Status !== 'Inactive') ? 'Active' : 'Inactive';

    return {
      id: id || code || name,
      code: code || name || '—',
      name: name || code || '—',
      minSalary: minSalary || '',
      maxSalary: maxSalary || '',
      status,
      remarks,
      raw: r,
    };
  });

  const filtered = rows.filter(r =>
    (r.name || '').toLowerCase().includes(search.toLowerCase()) ||
    (r.code || '').toLowerCase().includes(search.toLowerCase()) ||
    (String(r.minSalary) || '').toLowerCase().includes(search.toLowerCase()) ||
    (String(r.maxSalary) || '').toLowerCase().includes(search.toLowerCase()) ||
    (r.remarks || '').toLowerCase().includes(search.toLowerCase())
  );

  const handleSelect = (r) => {
    setEditingId(r.id || r.code);
    setForm({ code: r.code, name: r.name, minSalary: r.minSalary, maxSalary: r.maxSalary, remarks: r.remarks });
  };

  const handleClear = () => {
    setEditingId(null);
    setForm(EMPTY_GRADE_FORM);
    dispatch(clearGradeError());
  };

  const handleSave = () => {
    if (!form.code || !form.name) return;
    const serviceNo = getLoggedInServiceNo() || "3000807";

    if (editingId) {
      dispatch(updateGrade({
        p_gradeId: editingId,
        p_updatedBy: serviceNo,
        p_gradeCode: form.code,
        p_gradeName: form.name,
        p_minSalary: form.minSalary ? Number(form.minSalary) : 0,
        p_maxSalary: form.maxSalary ? Number(form.maxSalary) : 0,
        p_isActive: 1,
        p_remarks: form.remarks || "",
      }));
    } else {
      dispatch(addGrade({
        p_createdBy: serviceNo,
        p_gradeCode: form.code,
        p_gradeName: form.name,
        p_minSalary: form.minSalary ? Number(form.minSalary) : 0,
        p_maxSalary: form.maxSalary ? Number(form.maxSalary) : 0,
        p_isActive: 1,
        p_remarks: form.remarks || "",
      }));
    }
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
      <div className="lg:col-span-2 space-y-3">
        <div className="relative">
          <Search size={12} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
          <input
            className="h-9 bg-white border border-gray-200 rounded-lg text-xs pl-8 pr-3 w-full outline-none text-gray-700 focus:border-primary-500"
            placeholder="Search grades…" value={search} onChange={e => setSearch(e.target.value)}
          />
        </div>
        <MFGridSection title="Grade Details" count={filtered.length}>
          {loading ? (
            <div className="py-20 flex items-center justify-center gap-2 text-sm text-gray-400">
              <Loader2 size={14} className="animate-spin" /> Loading grades...
            </div>
          ) : error ? (
            <div className="py-20 flex items-center justify-center gap-2 text-sm text-red-600">
              <AlertCircle size={13} className="shrink-0" /> {error}
            </div>
          ) : filtered.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-20 text-center text-gray-400">
              <Tag size={24} className="text-gray-300 mb-2" />
              <p className="text-sm text-gray-400">No grades yet</p>
            </div>
          ) : (
            <table className="w-full text-[13px]">
              <thead>
                <tr className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">
                  {['Code', 'Name', 'Min Salary', 'Max Salary', 'Status', 'Remarks'].map(h => (
                    <th key={h} className={MF_TH}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filtered.map((r) => (
                  <tr key={r.id || r.code} onClick={() => handleSelect(r)}
                    className={`${MF_ROW} ${MF_ROW_IDLE} ${editingId === (r.id || r.code) ? MF_ROW_SEL : ''}`}>
                    <td className="px-4 py-3 font-mono text-gray-900 font-semibold">{r.code}</td>
                    <td className="px-4 py-3 text-gray-900 font-medium max-w-xs truncate">{r.name}</td>
                    <td className="px-4 py-3 text-gray-600">{r.minSalary ? Number(r.minSalary).toLocaleString() : '—'}</td>
                    <td className="px-4 py-3 text-gray-600">{r.maxSalary ? Number(r.maxSalary).toLocaleString() : '—'}</td>
                    <td className="px-4 py-3"><StatusPill label={r.status} /></td>
                    <td className="px-4 py-3 text-gray-600 max-w-[160px] truncate">{r.remarks}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </MFGridSection>
      </div>

      <MFEntryPanel
        title={editingId ? 'Edit Grade' : 'Grade Entry'}
        onSave={handleSave}
        onClear={handleClear}
        saved={success}
      >
        <div>
          <MFLabel req>Grade Code</MFLabel>
          <input className={`${MF_INP} bg-gray-200 cursor-not-allowed`} value={form.code} disabled readOnly
            onChange={e => setForm(f => ({ ...f, code: e.target.value }))} />
          {editingId && <p className="text-[10px] text-surface-400 mt-0.5">Code can't be changed once created</p>}
        </div>
        <div>
          <MFLabel req>Grade Name</MFLabel>
          <input className={MF_INP} value={form.name}
            onChange={e => setForm(f => ({ ...f, name: e.target.value }))} />
        </div>
        <div>
          <MFLabel>Minimum Salary</MFLabel>
          <input type="number" className={MF_INP} value={form.minSalary}
            onChange={e => setForm(f => ({ ...f, minSalary: e.target.value }))} />
        </div>
        <div>
          <MFLabel>Maximum Salary</MFLabel>
          <input type="number" className={MF_INP} value={form.maxSalary}
            onChange={e => setForm(f => ({ ...f, maxSalary: e.target.value }))} />
        </div>
        <div>
          <MFLabel>Remarks</MFLabel>
          <input className={MF_INP} value={form.remarks}
            onChange={e => setForm(f => ({ ...f, remarks: e.target.value }))} />
        </div>
        {saving && <p className="text-[10px] text-primary-500">Saving...</p>}
        {error && <p className="text-[10px] text-red-500">{error}</p>}
      </MFEntryPanel>
    </div>
  );
}

// ─── MF Section: Education ────────────────────────────────────────────────────
function MFEducation() {
  const [rows, setRows] = useState(SEED_EDUCATION);
  const [form, setForm] = useState({ code: '', country: 'SRI LANKA', description: '', conductedBy: '', status: 'Active' });
  const [saved, setSaved] = useState(false);
  const handleSave = () => {
    if (!form.code || !form.description) return;
    setRows(prev => { const idx = prev.findIndex(r => r.code === form.code); if (idx >= 0) { const n = [...prev]; n[idx] = { ...form }; return n; } return [...prev, { ...form }]; });
    setSaved(true); setTimeout(() => setSaved(false), 1500);
  };
  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
      <div className="lg:col-span-2">
        <MFGridSection title="Educational Details" count={rows.length}>
          <table className="w-full text-[13px]">
            <thead><tr className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">{['Code', 'Country', 'Description', 'Conducted By', 'Status'].map(h => <th key={h} className={MF_TH}>{h}</th>)}</tr></thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={r.code} onClick={() => setForm({ code: r.code, country: r.country, description: r.description, conductedBy: r.conductedBy, status: r.status })}
                  className={`${MF_ROW} ${MF_ROW_IDLE} ${i === 0 ? 'bg-primary-50/50' : ''}`}>
                  <td className="px-4 py-3 font-mono text-gray-900 font-semibold">{r.code}</td>
                  <td className="px-4 py-3 text-gray-600">{r.country}</td>
                  <td className="px-4 py-3 text-gray-900 font-medium">{r.description}</td>
                  <td className="px-4 py-3 text-gray-600">{r.conductedBy}</td>
                  <td className="px-4 py-3"><StatusPill label={r.status} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </MFGridSection>
      </div>
      <MFEntryPanel title="Education Entry" onSave={handleSave} onClear={() => setForm({ code: '', country: 'SRI LANKA', description: '', conductedBy: '', status: 'Active' })} saved={saved}>
        <div><MFLabel req>Qualification Code</MFLabel><input className={MF_INP} value={form.code} onChange={e => setForm(f => ({ ...f, code: e.target.value }))} /></div>
        <div><MFLabel>Country</MFLabel><select className={MF_SEL} value={form.country} onChange={e => setForm(f => ({ ...f, country: e.target.value }))}><option>SRI LANKA</option><option>INDIA</option><option>UNITED KINGDOM</option><option>AUSTRALIA</option><option>USA</option></select></div>
        <div><MFLabel req>Description</MFLabel><input className={MF_INP} value={form.description} onChange={e => setForm(f => ({ ...f, description: e.target.value }))} /></div>
        <div><MFLabel>Conducted By</MFLabel><input className={MF_INP} value={form.conductedBy} onChange={e => setForm(f => ({ ...f, conductedBy: e.target.value }))} /></div>
        <div><MFLabel>Status</MFLabel><select className={MF_SEL} value={form.status} onChange={e => setForm(f => ({ ...f, status: e.target.value }))}><option>Active</option><option>Inactive</option></select></div>
      </MFEntryPanel>
    </div>
  );
}

// ─── MF Section: Professional ─────────────────────────────────────────────────
function MFProfessional() {
  const [rows, setRows] = useState(SEED_PROFESSIONAL);
  const [form, setForm] = useState({ code: '', country: 'SRI LANKA', description: '', instituteName: '', duration: '', status: 'Active' });
  const [saved, setSaved] = useState(false);
  const handleSave = () => {
    if (!form.code || !form.description) return;
    setRows(prev => { const idx = prev.findIndex(r => r.code === form.code); if (idx >= 0) { const n = [...prev]; n[idx] = { ...form }; return n; } return [...prev, { ...form }]; });
    setSaved(true); setTimeout(() => setSaved(false), 1500);
  };
  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
      <div className="lg:col-span-2">
        <MFGridSection title="Professional Details" count={rows.length}>
          <table className="w-full text-[13px]">
            <thead><tr className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">{['Code', 'Country', 'Description', 'Institute', 'Duration', 'Status'].map(h => <th key={h} className={MF_TH}>{h}</th>)}</tr></thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={r.code} onClick={() => setForm({ code: r.code, country: r.country, description: r.description, instituteName: r.instituteName, duration: r.duration, status: r.status })}
                  className={`${MF_ROW} ${MF_ROW_IDLE} ${i === 0 ? 'bg-primary-50/50' : ''}`}>
                  <td className="px-4 py-3 font-mono text-gray-900 font-semibold">{r.code}</td>
                  <td className="px-4 py-3 text-gray-600">{r.country}</td>
                  <td className="px-4 py-3 text-gray-900 font-medium max-w-xs truncate">{r.description}</td>
                  <td className="px-4 py-3 text-gray-600">{r.instituteName || '—'}</td>
                  <td className="px-4 py-3 text-gray-600">{r.duration || '—'}</td>
                  <td className="px-4 py-3"><StatusPill label={r.status} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </MFGridSection>
      </div>
      <MFEntryPanel title="Professional Entry" onSave={handleSave} onClear={() => setForm({ code: '', country: 'SRI LANKA', description: '', instituteName: '', duration: '', status: 'Active' })} saved={saved}>
        <div><MFLabel req>Qualification Code</MFLabel><input className={MF_INP} value={form.code} onChange={e => setForm(f => ({ ...f, code: e.target.value }))} /></div>
        <div><MFLabel>Country</MFLabel><select className={MF_SEL} value={form.country} onChange={e => setForm(f => ({ ...f, country: e.target.value }))}><option>SRI LANKA</option><option>INDIA</option><option>UNITED KINGDOM</option><option>AUSTRALIA</option><option>USA</option></select></div>
        <div><MFLabel req>Description</MFLabel><input className={MF_INP} value={form.description} onChange={e => setForm(f => ({ ...f, description: e.target.value }))} /></div>
        <div><MFLabel>Institute Name</MFLabel><input className={MF_INP} value={form.instituteName} onChange={e => setForm(f => ({ ...f, instituteName: e.target.value }))} /></div>
        <div><MFLabel>Duration</MFLabel><input className={MF_INP} value={form.duration} onChange={e => setForm(f => ({ ...f, duration: e.target.value }))} /></div>
        <div><MFLabel>Status</MFLabel><select className={MF_SEL} value={form.status} onChange={e => setForm(f => ({ ...f, status: e.target.value }))}><option>Active</option><option>Inactive</option></select></div>
      </MFEntryPanel>
    </div>
  );
}

// ─── MF Section: Div / Dep / Loc ─────────────────────────────────────────────
function MFDivDepLoc() {
  const today = new Date().toISOString().split('T')[0];
  const [divisions, setDivisions] = useState(SEED_DIVISIONS);
  const [departments, setDepartments] = useState(SEED_DEPARTMENTS);
  const [locations, setLocations] = useState(SEED_LOCATIONS);
  const [selDiv, setSelDiv] = useState('');
  const [divForm, setDivForm] = useState({ code: '', description: '', effectiveDate: today, status: 'Active' });
  const [deptForm, setDeptForm] = useState({ divCode: '', code: '', description: '', effectiveDate: today, status: 'Active' });
  const [locForm, setLocForm] = useState({ divCode: '', deptCode: '', code: '', description: '', effectiveDate: today, status: 'Active' });
  const filtDepts = selDiv ? departments.filter(d => d.divCode === selDiv) : departments;

  // ── Physical Location master (real API: GetLocationDetails / AddLocation) ──
  const dispatch = useDispatch();
  const { rows: phyRows, loading: phyLoading, error: phyError, adding: phyAdding, addError: phyAddError, addSuccess: phyAddSuccess } =
    useSelector(s => s.locationMaster);

  // Physical Locations grid: GetLocationDetails also returns non-physical
  // location rows mixed in — only keep rows whose HLD_DIV_CODE and
  // HLD_DEP_CODE are both "PHY" (Physical), and show those real field
  // values instead of a hard-coded label.
  const phyRowsFiltered = useMemo(() => {
    const isPhy = (v) => String(v ?? '').trim().toUpperCase().includes('PHY');
    return (phyRows || []).filter(r => isPhy(r.HLD_DIV_CODE) && isPhy(r.HLD_DEP_CODE));
  }, [phyRows]);

  const [phyForm, setPhyForm] = useState({ code: '', description: '', latitude: '', longitude: '' });
  const [mapRow, setMapRow] = useState(null);
  const [pickerOpen, setPickerOpen] = useState(false);

  useEffect(() => {
    dispatch(fetchLocationMaster());
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (phyAddSuccess) {
      dispatch(fetchLocationMaster());
      setPhyForm({ code: '', description: '', latitude: '', longitude: '' });
      const t = setTimeout(() => dispatch(clearLocationMasterAddState()), 2500);
      return () => clearTimeout(t);
    }
    // eslint-disable-next-line
  }, [phyAddSuccess]);

  const savePhyLocation = () => {
    if (!phyForm.code || !phyForm.description) return;
    dispatch(addLocationMaster({
      code: phyForm.code,
      description: phyForm.description,
      latitude: phyForm.latitude,
      longitude: phyForm.longitude,
    }));
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
      <div className="space-y-4">
        <div className="bg-white border border-surface-100 rounded-xl p-4 shadow-sm">
          <p className="text-xs font-bold text-primary-600 uppercase tracking-widest mb-2">Division Filter</p>
          <select className={MF_SEL} value={selDiv} onChange={e => setSelDiv(e.target.value)}>
            <option value="">All Divisions</option>
            {divisions.map(d => <option key={d.code} value={d.code}>{d.description}</option>)}
          </select>
        </div>
        <MFGridSection title="Department Details" count={filtDepts.length}>
          <table className="w-full text-[13px]">
            <thead><tr className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">{['Code', 'Description', 'Effective Date', 'Status'].map(h => <th key={h} className={MF_TH}>{h}</th>)}</tr></thead>
            <tbody>
              {filtDepts.map((r, i) => (
                <tr key={r.code + r.divCode} onClick={() => setDeptForm({ divCode: r.divCode, code: r.code, description: r.description, effectiveDate: r.effectiveDate, status: r.status })}
                  className={`${MF_ROW} ${MF_ROW_IDLE} ${i === 0 ? 'bg-primary-50/50' : ''}`}>
                  <td className="px-4 py-3 font-mono text-gray-900 font-semibold">{r.code}</td>
                  <td className="px-4 py-3 text-gray-900 font-medium">{r.description}</td>
                  <td className="px-4 py-3 text-gray-600">{r.effectiveDate}</td>
                  <td className="px-4 py-3"><StatusPill label={r.status} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </MFGridSection>
        <MFGridSection title="Location Details" count={locations.length}>
          <table className="w-full text-[13px]">
            <thead><tr className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">{['Code', 'Description', 'Effective Date', 'Status'].map(h => <th key={h} className={MF_TH}>{h}</th>)}</tr></thead>
            <tbody>
              {locations.map((r, i) => (
                <tr key={r.code} onClick={() => setLocForm({ divCode: r.divCode, deptCode: r.deptCode, code: r.code, description: r.description, effectiveDate: r.effectiveDate, status: r.status })}
                  className={`${MF_ROW} ${MF_ROW_IDLE} ${i === 0 ? 'bg-primary-50/50' : ''}`}>
                  <td className="px-4 py-3 font-mono text-gray-900 font-semibold">{r.code}</td>
                  <td className="px-4 py-3 text-gray-900 font-medium">{r.description}</td>
                  <td className="px-4 py-3 text-gray-600">{r.effectiveDate}</td>
                  <td className="px-4 py-3"><StatusPill label={r.status} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </MFGridSection>

        {/* Physical Locations grid — real API (GetLocationDetails) */}
        <MFGridSection title="Physical Locations" count={phyRowsFiltered.length}>
          {phyLoading ? (
            <div className="py-20 flex items-center justify-center gap-2 text-sm text-gray-400">
              <Loader2 size={14} className="animate-spin" /> Loading physical locations...
            </div>
          ) : phyError ? (
            <div className="py-20 flex items-center justify-center gap-2 text-sm text-red-600">
              <AlertCircle size={13} className="shrink-0" /> {phyError}
            </div>
          ) : phyRowsFiltered.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-20 text-center text-gray-400">
              <MapPinned size={24} className="text-gray-300 mb-2" />
              <p className="text-sm text-gray-400">No physical locations yet</p>
            </div>
          ) : (
            <table className="w-full text-[13px]">
              <thead>
                <tr className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">
                  {['Code', 'Name', 'Division', 'Department', 'Status', ''].map(h => (
                    <th key={h} className={MF_TH}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {phyRowsFiltered.map((r, i) => (
                  <tr key={r.HLD_LOC_CODE || i} className={`border-b border-gray-100 last:border-0 ${i === 0 ? MF_ROW_SEL : ''}`}>
                    <td className="px-4 py-3 font-mono text-gray-900 font-semibold">{r.HLD_LOC_CODE}</td>
                    <td className="px-4 py-3 text-gray-900 font-medium">{r.HLD_LOC_DESC}</td>
                    <td className="px-4 py-3 text-gray-600 font-medium">{r.HLD_DIV_CODE}</td>
                    <td className="px-4 py-3 text-gray-600 font-medium">{r.HLD_DEP_CODE}</td>
                    <td className="px-4 py-3"><StatusPill label={r.HLD_CURRENT_STATUS === 'A' ? 'Active' : 'Inactive'} /></td>
                    <td className="px-4 py-3">
                      <button
                        onClick={() => setMapRow(r)}
                        className="flex items-center gap-1 text-[11px] font-semibold text-primary-600 hover:text-primary-700 transition-colors"
                        title="View on map"
                      >
                        <MapPinned size={12} /> Map
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </MFGridSection>
      </div>
      <div className="space-y-4">
        <div className="bg-white border border-surface-100 rounded-xl p-4 shadow-sm">
          <p className="text-xs font-bold text-primary-600 uppercase tracking-widest mb-3 border-b border-primary-100 pb-2">Create New Division</p>
          <div className="grid grid-cols-2 gap-2 mb-3">
            <div><MFLabel req>Division Code</MFLabel><input className={MF_INP} value={divForm.code} onChange={e => setDivForm(f => ({ ...f, code: e.target.value }))} /></div>
            <div><MFLabel req>Description</MFLabel><input className={MF_INP} value={divForm.description} onChange={e => setDivForm(f => ({ ...f, description: e.target.value }))} /></div>
            <div><MFLabel>Effective Date</MFLabel><input className={MF_INP} type="date" value={divForm.effectiveDate} onChange={e => setDivForm(f => ({ ...f, effectiveDate: e.target.value }))} /></div>
            <div><MFLabel>Status</MFLabel><select className={MF_SEL} value={divForm.status} onChange={e => setDivForm(f => ({ ...f, status: e.target.value }))}><option>Active</option><option>Inactive</option></select></div>
          </div>
          <div className="flex gap-2">
            <button onClick={() => { if (!divForm.code) return; setDivisions(prev => { const idx = prev.findIndex(d => d.code === divForm.code); if (idx >= 0) { const n = [...prev]; n[idx] = { ...divForm }; return n; } return [...prev, { ...divForm }]; }); setDivForm({ code: '', description: '', effectiveDate: today, status: 'Active' }); }} className="flex items-center gap-1 bg-surface-800 text-primary-400 text-xs px-3 py-1.5 rounded hover:bg-surface-700"><Save size={11} /> Save</button>
            <button onClick={() => setDivForm({ code: '', description: '', effectiveDate: today, status: 'Active' })} className="flex items-center gap-1 border border-surface-200 text-surface-500 text-xs px-3 py-1.5 rounded hover:bg-surface-50"><RotateCcw size={11} /> Clear</button>
          </div>
        </div>
        <div className="bg-white border border-surface-100 rounded-xl p-4 shadow-sm">
          <p className="text-xs font-bold text-primary-600 uppercase tracking-widest mb-3 border-b border-primary-100 pb-2">Create New Department</p>
          <div className="grid grid-cols-2 gap-2 mb-3">
            <div><MFLabel>Division Code</MFLabel><input className={MF_INP} value={deptForm.divCode} onChange={e => setDeptForm(f => ({ ...f, divCode: e.target.value }))} /></div>
            <div><MFLabel req>Dept. Code</MFLabel><input className={MF_INP} value={deptForm.code} onChange={e => setDeptForm(f => ({ ...f, code: e.target.value }))} /></div>
            <div className="col-span-2"><MFLabel req>Description</MFLabel><input className={MF_INP} value={deptForm.description} onChange={e => setDeptForm(f => ({ ...f, description: e.target.value }))} /></div>
            <div><MFLabel>Effective Date</MFLabel><input className={MF_INP} type="date" value={deptForm.effectiveDate} onChange={e => setDeptForm(f => ({ ...f, effectiveDate: e.target.value }))} /></div>
            <div><MFLabel>Status</MFLabel><select className={MF_SEL} value={deptForm.status} onChange={e => setDeptForm(f => ({ ...f, status: e.target.value }))}><option>Active</option><option>Inactive</option></select></div>
          </div>
          <div className="flex gap-2">
            <button onClick={() => { if (!deptForm.code) return; setDepartments(prev => { const idx = prev.findIndex(d => d.code === deptForm.code && d.divCode === deptForm.divCode); if (idx >= 0) { const n = [...prev]; n[idx] = { ...deptForm }; return n; } return [...prev, { ...deptForm }]; }); setDeptForm({ divCode: '', code: '', description: '', effectiveDate: today, status: 'Active' }); }} className="flex items-center gap-1 bg-surface-800 text-primary-400 text-xs px-3 py-1.5 rounded hover:bg-surface-700"><Save size={11} /> Save</button>
            <button onClick={() => setDeptForm({ divCode: '', code: '', description: '', effectiveDate: today, status: 'Active' })} className="flex items-center gap-1 border border-surface-200 text-surface-500 text-xs px-3 py-1.5 rounded hover:bg-surface-50"><RotateCcw size={11} /> Clear</button>
          </div>
        </div>
        <div className="bg-white border border-surface-100 rounded-xl p-4 shadow-sm">
          <p className="text-xs font-bold text-primary-600 uppercase tracking-widest mb-3 border-b border-primary-100 pb-2">Create New Location</p>
          <div className="grid grid-cols-2 gap-2 mb-3">
            <div><MFLabel>Division Code</MFLabel><input className={MF_INP} value={locForm.divCode} onChange={e => setLocForm(f => ({ ...f, divCode: e.target.value }))} /></div>
            <div><MFLabel>Dept. Code</MFLabel><input className={MF_INP} value={locForm.deptCode} onChange={e => setLocForm(f => ({ ...f, deptCode: e.target.value }))} /></div>
            <div><MFLabel req>Location Code</MFLabel><input className={MF_INP} value={locForm.code} onChange={e => setLocForm(f => ({ ...f, code: e.target.value }))} /></div>
            <div><MFLabel req>Description</MFLabel><input className={MF_INP} value={locForm.description} onChange={e => setLocForm(f => ({ ...f, description: e.target.value }))} /></div>
            <div><MFLabel>Effective Date</MFLabel><input className={MF_INP} type="date" value={locForm.effectiveDate} onChange={e => setLocForm(f => ({ ...f, effectiveDate: e.target.value }))} /></div>
            <div><MFLabel>Status</MFLabel><select className={MF_SEL} value={locForm.status} onChange={e => setLocForm(f => ({ ...f, status: e.target.value }))}><option>Active</option><option>Inactive</option></select></div>
          </div>
          <div className="flex gap-2">
            <button onClick={() => { if (!locForm.code) return; setLocations(prev => { const idx = prev.findIndex(l => l.code === locForm.code); if (idx >= 0) { const n = [...prev]; n[idx] = { ...locForm }; return n; } return [...prev, { ...locForm }]; }); setLocForm({ divCode: '', deptCode: '', code: '', description: '', effectiveDate: today, status: 'Active' }); }} className="flex items-center gap-1 bg-surface-800 text-primary-400 text-xs px-3 py-1.5 rounded hover:bg-surface-700"><Save size={11} /> Save</button>
            <button onClick={() => setLocForm({ divCode: '', deptCode: '', code: '', description: '', effectiveDate: today, status: 'Active' })} className="flex items-center gap-1 border border-surface-200 text-surface-500 text-xs px-3 py-1.5 rounded hover:bg-surface-50"><RotateCcw size={11} /> Clear</button>
          </div>
        </div>

        {/* Create New Physical Location — real API (AddLocation) */}
        <div className="bg-white border border-surface-100 rounded-xl p-4 shadow-sm">
          <p className="text-xs font-bold text-primary-600 uppercase tracking-widest mb-3 border-b border-primary-100 pb-2 flex items-center gap-1.5">
            <MapPinned size={12} /> Create New Physical Location
          </p>

          {phyAddError && (
            <div className="flex items-center gap-1.5 text-red-600 text-[11px] mb-2">
              <AlertCircle size={12} className="shrink-0" /> {phyAddError}
            </div>
          )}
          {phyAddSuccess && (
            <div className="flex items-center gap-1.5 text-emerald-600 text-[11px] mb-2">
              <CheckCircle size={12} className="shrink-0" /> Physical location added.
            </div>
          )}

          <div className="grid grid-cols-2 gap-2 mb-2">
            <div className="col-span-2">
              <MFLabel req>Location Code</MFLabel>
              <input className={MF_INP} value={phyForm.code} onChange={e => setPhyForm(f => ({ ...f, code: e.target.value.toUpperCase() }))} placeholder="e.g. CDL" />
            </div>
            <div className="col-span-2">
              <MFLabel req>Description / Name</MFLabel>
              <input className={MF_INP} value={phyForm.description} onChange={e => setPhyForm(f => ({ ...f, description: e.target.value }))} placeholder="e.g. DOCKYARD SITE" />
            </div>
            <div>
              <MFLabel>Latitude</MFLabel>
              <input className={MF_INP} value={phyForm.latitude} onChange={e => setPhyForm(f => ({ ...f, latitude: e.target.value }))} placeholder="6.927079" />
            </div>
            <div>
              <MFLabel>Longitude</MFLabel>
              <input className={MF_INP} value={phyForm.longitude} onChange={e => setPhyForm(f => ({ ...f, longitude: e.target.value }))} placeholder="79.861244" />
            </div>
            <div className="col-span-2">
              <button
                type="button"
                onClick={() => setPickerOpen(true)}
                className="flex items-center gap-1 text-[11px] font-semibold text-primary-600 hover:text-primary-700 transition-colors"
              >
                <MapPinned size={12} /> Pick on Map
              </button>
            </div>
          </div>
          <div className="flex gap-2">
            <button
              onClick={savePhyLocation}
              disabled={phyAdding || !phyForm.code || !phyForm.description}
              className="flex items-center gap-1 bg-surface-800 hover:bg-surface-700 text-primary-400 text-xs px-3 py-1.5 rounded disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
            >
              {phyAdding ? <Loader2 size={11} className="animate-spin" /> : <Save size={11} />} {phyAdding ? 'Saving...' : 'Save'}
            </button>
            <button
              onClick={() => setPhyForm({ code: '', description: '', latitude: '', longitude: '' })}
              className="flex items-center gap-1 border border-surface-200 text-surface-500 text-xs px-3 py-1.5 rounded hover:bg-surface-50 transition-colors"
            >
              <RotateCcw size={11} /> Clear
            </button>
          </div>
        </div>
      </div>

      <LocationMapModal
        isOpen={!!mapRow}
        onClose={() => setMapRow(null)}
        name={mapRow?.HLD_LOC_DESC}
        code={mapRow?.HLD_LOC_CODE}
        latitude={mapRow?.HLD_LATITUDE}
        longitude={mapRow?.HLD_LONGITUDE}
      />

      <LocationPickerMapModal
        isOpen={pickerOpen}
        onClose={() => setPickerOpen(false)}
        title="Pick Physical Location Coordinates"
        initialLat={phyForm.latitude}
        initialLng={phyForm.longitude}
        onSelect={(lat, lng) => setPhyForm(f => ({ ...f, latitude: String(lat.toFixed(6)), longitude: String(lng.toFixed(6)) }))}
      />
    </div>
  );
}

// ─── MF Section: Shift ────────────────────────────────────────────────────────
// function MFShift() {
//   const [shifts, setShifts] = useState(SEED_SHIFTS);
//   const [form, setForm] = useState({ code: '', description: '', type: 'Normal', timeIn: '08:00', timeOut: '17:00', status: 'Active' });
//   const [saved, setSaved] = useState(false);
//   const handleSave = () => {
//     if (!form.code) return;
//     setShifts(prev => { const idx = prev.findIndex(s => s.code === form.code); if (idx >= 0) { const n = [...prev]; n[idx] = { ...form }; return n; } return [...prev, { ...form }]; });
//     setSaved(true); setTimeout(() => setSaved(false), 1500);
//   };
//   return (
//     <div className="space-y-4">
//       <div className="bg-white border border-surface-100 rounded-xl p-4 shadow-sm">
//         <p className="text-xs font-bold text-primary-600 uppercase tracking-widest mb-3 border-b border-primary-100 pb-2">Shift Type Entry</p>
//         {saved && <div className="flex items-center gap-1 text-emerald-600 text-xs mb-2"><CheckCircle size={12}/> Saved!</div>}
//         <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 items-end">
//           <div><MFLabel req>Shift Code</MFLabel><input className={MF_INP} value={form.code} onChange={e => setForm(f => ({ ...f, code: e.target.value }))} /></div>
//           <div className="col-span-2"><MFLabel>Description</MFLabel><input className={MF_INP} value={form.description} onChange={e => setForm(f => ({ ...f, description: e.target.value }))} /></div>
//           <div><MFLabel>Type</MFLabel><select className={MF_SEL} value={form.type} onChange={e => setForm(f => ({ ...f, type: e.target.value }))}><option>Normal</option><option>Rotating</option><option>Flexible</option></select></div>
//           <div><MFLabel>Time In</MFLabel><input className={MF_INP} type="time" value={form.timeIn} onChange={e => setForm(f => ({ ...f, timeIn: e.target.value }))} /></div>
//           <div><MFLabel>Time Out</MFLabel><input className={MF_INP} type="time" value={form.timeOut} onChange={e => setForm(f => ({ ...f, timeOut: e.target.value }))} /></div>
//         </div>
//         <div className="flex gap-2 mt-3">
//           <button onClick={handleSave} className="flex items-center gap-1 bg-surface-800 text-primary-400 text-xs px-3 py-1.5 rounded hover:bg-surface-700"><Save size={11} /> Save</button>
//           <button onClick={() => setForm({ code: '', description: '', type: 'Normal', timeIn: '08:00', timeOut: '17:00', status: 'Active' })} className="flex items-center gap-1 border border-surface-200 text-surface-500 text-xs px-3 py-1.5 rounded hover:bg-surface-50"><RotateCcw size={11} /> Clear</button>
//         </div>
//       </div>
//       <MFGridSection title="Defined Shifts">
//         <table className="w-full text-[13px]">
//           <thead><tr className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">{['Shift Code','Description','Type','Time In','Time Out','Status'].map(h => <th key={h} className={MF_TH}>{h}</th>)}</tr></thead>
//           <tbody>
//             {shifts.map((r, i) => (
//               <tr key={r.code} onClick={() => setForm({ code: r.code, description: r.description, type: r.type, timeIn: r.timeIn, timeOut: r.timeOut, status: r.status })}
//                 className={`${MF_ROW} ${MF_ROW_IDLE} ${i === 0 ? 'bg-primary-50/50' : ''}`}>
//                 <td className="px-4 py-3 font-mono text-gray-900 font-semibold">{r.code}</td>
//                 <td className="px-4 py-3 text-gray-900 font-medium">{r.description}</td>
//                 <td className="px-4 py-3 text-gray-600">{r.type}</td>
//                 <td className="px-4 py-3 text-gray-600">{r.timeIn}</td>
//                 <td className="px-4 py-3 text-gray-600">{r.timeOut}</td>
//                 <td className="px-4 py-3"><StatusPill label={r.status} /></td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </MFGridSection>
//     </div>
//   );
// }

const EMPTY_SHIFT_FORM = {
  shiftCode: '',
  shiftName: '',
  startTime: '',
  endTime: '',
  breakStartTime: '',
  breakEndTime: '',
  breakDuration: '',
  graceInMin: '',
  graceOutMin: '',
  halfDayHours: '',
  fullDayHours: '',
  otAfterMinutes: '',
  shiftColor: '',
  isActive: '',
  remarks: '',
};


function MFShift() {
  const dispatch = useDispatch();
  const { shifts, loading, saving, error, success } = useSelector(s => s.shiftSlice);

  const [search, setSearch] = useState('');
  const [form, setForm] = useState(EMPTY_BANK_FORM);
  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    dispatch(getShiftList());
  }, [dispatch]);

  useEffect(() => {
    if (success) {
      dispatch(getShiftList());
      setForm(EMPTY_SHIFT_FORM);
      setEditingId(null);
      const t = setTimeout(() => dispatch(clearShiftSuccess()), 1500);
      return () => clearTimeout(t);
    }
  }, [success, dispatch]);

  useEffect(() => {
    if (editingId) return;

    const existingCodes = (shifts || []).map(r =>
      pickField(r, [
        'ShiftCode',
        'shiftCode',
        'HSD_SHIFT_CODE'
      ])
    );

    setForm(f => ({
      ...f,
      shiftCode: generateCode(
        existingCodes,
        CODE_PREFIXES.SHIFT
      )
    }));
  }, [shifts, editingId]);

  const rows = (shifts || []).map(r => ({
    id: pickField(r, ['HSD_SHIFT_ID']),
    shiftCode: pickField(r, ['HSD_SHIFT_CODE']),
    shiftName: pickField(r, ['HSD_SHIFT_NAME']),
    startTime: pickField(r, ['HSD_START_TIME']),
    endTime: pickField(r, ['HSD_END_TIME']),
    breakStartTime: pickField(r, ['HSD_BREAK_START_TIME']),
    breakEndTime: pickField(r, ['HSD_BREAK_END_TIME']),
    breakDuration: pickField(r, ['HSD_BREAK_DURATION_MIN']),
    graceInMin: pickField(r, ['HSD_GRACE_IN_MIN']),
    graceOutMin: pickField(r, ['HSD_GRACE_OUT_MIN']),
    halfDayHours: pickField(r, ['HSD_HALF_DAY_HOURS']),
    fullDayHours: pickField(r, ['HSD_FULL_DAY_HOURS']),
    otAfterMinutes: pickField(r, ['HSD_OT_AFTER_MINUTES']),
    shiftColor: pickField(r, ['HSD_SHIFT_COLOR']),
    isActive: pickField(r, ['HSD_IS_ACTIVE']),
    remarks: pickField(r, ['HSD_REMARKS']),
  }));

  const filtered = rows.filter(r =>
    r.shiftCode.toLowerCase().includes(search.toLowerCase()) ||
    r.shiftName.toLowerCase().includes(search.toLowerCase())
  );

  const handleSelect = (r) => {
    setEditingId(r.id);
    setForm({
      shiftCode: r.shiftCode,
      shiftName: r.shiftName,
      startTime: r.startTime,
      endTime: r.endTime,
      breakStartTime: r.breakStartTime,
      breakEndTime: r.breakEndTime,
      breakDuration: r.breakDuration,
      graceInMin: r.graceInMin,
      graceOutMin: r.graceOutMin,
      halfDayHours: r.halfDayHours,
      fullDayHours: r.fullDayHours,
      otAfterMinutes: r.otAfterMinutes,
      shiftColor: r.shiftColor,
      isActive: r.isActive,
      remarks: r.remarks,
    });
  };

  const handleClear = () => {
    setEditingId(null);
    setForm(EMPTY_SHIFT_FORM);
    dispatch(clearBankError());
  };

  const handleSave = () => {
    if (!form.shiftCode || !form.shiftName) return;
    if (editingId) {
      dispatch(updateShift({
        p_shiftId: editingId,
        p_shiftCode: form.shiftCode,
        p_shiftName: form.shiftName,
        p_startTime: form.startTime,
        p_endTime: form.endTime,
        p_breakStartTime: form.breakStartTime || '',
        p_breakEndTime: form.breakEndTime || '',
        p_breakDurationMin: form.breakDuration || '',
        p_graceInMin: form.graceInMin || '',
        p_graceOutMin: form.graceOutMin || '',
        p_halfDayHours: form.halfDayHours || '',
        p_fullDayHours: form.fullDayHours || '',
        p_otAfterMinutes: form.otAfterMinutes || '',
        p_shiftColor: form.shiftColor || '',
        p_remarks: form.remarks || '',
        p_updatedBy: getLoggedInServiceNo() || 'admin',
      }));
    } else {
      dispatch(addShift({
        p_shiftCode: form.shiftCode,
        p_shiftName: form.shiftName,
        p_startTime: form.startTime,
        p_endTime: form.endTime,
        p_breakStartTime: form.breakStartTime || '',
        p_breakEndTime: form.breakEndTime || '',
        p_breakDurationMin: form.breakDuration || '',
        p_graceInMin: form.graceInMin || '',
        p_graceOutMin: form.graceOutMin || '',
        p_halfDayHours: form.halfDayHours || '',
        p_fullDayHours: form.fullDayHours || '',
        p_otAfterMinutes: form.otAfterMinutes || '',
        p_shiftColor: form.shiftColor || '',
        p_remarks: form.remarks || '',
        p_createdBy: getLoggedInServiceNo() || 'admin',
      }));
    }
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
      <div className="lg:col-span-2 space-y-3">
        <div className="relative">
          <Search size={12} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
          <input
            className="h-9 bg-white border border-gray-200 rounded-lg text-xs pl-8 pr-3 w-full outline-none text-gray-700 focus:border-primary-500"
            placeholder="Search shifts" value={search} onChange={e => setSearch(e.target.value)}
          />
        </div>
        <MFGridSection title="Shift Details" count={filtered.length}>
          {loading ? (
            <div className="py-20 flex items-center justify-center gap-2 text-sm text-gray-400">
              <Loader2 size={14} className="animate-spin" /> Loading shifts...
            </div>
          ) : error ? (
            <div className="py-20 flex items-center justify-center gap-2 text-sm text-red-600">
              <AlertCircle size={13} className="shrink-0" /> {error}
            </div>
          ) : filtered.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-20 text-center text-gray-400">
              <Tag size={24} className="text-gray-300 mb-2" />
              <p className="text-sm text-gray-400">No shifts yet</p>
            </div>
          ) : (
            <table className="w-full text-[13px]">
              <thead>
                <tr className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">
                  {['Code', 'Name', 'Start Time', 'End Time', 'Status'].map(h => (
                    <th key={h} className={MF_TH}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filtered.map((r) => (
                  <tr key={r.id || r.code} onClick={() => handleSelect(r)}
                    className={`${MF_ROW} ${MF_ROW_IDLE} ${editingId === r.id ? MF_ROW_SEL : ''}`}>
                    <td className="px-4 py-3 font-mono text-gray-900 font-semibold">{r.shiftCode}</td>
                    <td className="px-4 py-3 text-gray-900 font-medium max-w-xs truncate">{r.shiftName}</td>
                    <td className="px-4 py-3 text-gray-600 max-w-[120px] truncate">{r.startTime || '-'}</td>
                    <td className="px-4 py-3 text-gray-600 max-w-[160px] truncate">{r.endTime || '-'}</td>
                    <td className="px-4 py-3 text-gray-600 max-w-[160px] truncate">{r.isActive ? "Active" : "Inactive" || '-'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </MFGridSection>
      </div>

      <MFEntryPanel
        title={editingId ? 'Edit Shift' : 'Shift Entry'}
        onSave={handleSave}
        onClear={handleClear}
        saved={success}
      >
        <div>
          <MFLabel req>Shift Code</MFLabel>
          <input className={`${MF_INP} cursor-not-allowed bg-gray-200`} value={form.shiftCode} disabled readOnly
            onChange={e => setForm(f => ({ ...f, shiftCode: e.target.value }))} />
          {editingId && <p className="text-[10px] text-surface-400 mt-0.5">Code can't be changed once created</p>}
        </div>
        <div>
          <MFLabel req>Shift Name</MFLabel>
          <input className={MF_INP} value={form.shiftName}
            onChange={e => setForm(f => ({ ...f, shiftName: e.target.value }))} />
        </div>
        <div>
          <MFLabel>Start Time</MFLabel>
          <input className={MF_INP} value={form.startTime}
            onChange={e => setForm(f => ({ ...f, startTime: e.target.value }))} />
        </div>
        <div>
          <MFLabel>End Time</MFLabel>
          <input className={MF_INP} value={form.endTime}
            onChange={e => setForm(f => ({ ...f, endTime: e.target.value }))} />
        </div>
        <div>
          <MFLabel>Break Start Time</MFLabel>
          <input className={MF_INP} value={form.breakStartTime}
            onChange={e => setForm(f => ({ ...f, breakStartTime: e.target.value }))} />
        </div>
        <div>
          <MFLabel>Break End Time</MFLabel>
          <input className={MF_INP} value={form.breakEndTime}
            onChange={e => setForm(f => ({ ...f, breakEndTime: e.target.value }))} />
        </div>
        <div>
          <MFLabel>Grace In (minutes)</MFLabel>
          <input className={MF_INP} value={form.graceInMin}
            onChange={e => setForm(f => ({ ...f, graceInMin: e.target.value }))} />
        </div>
        <div>
          <MFLabel>Grace Out (minutes)</MFLabel>
          <input className={MF_INP} value={form.graceOutMin}
            onChange={e => setForm(f => ({ ...f, graceOutMin: e.target.value }))} />
        </div>
        <div>
          <MFLabel>Half Day Hours</MFLabel>
          <input className={MF_INP} value={form.halfDayHours}
            onChange={e => setForm(f => ({ ...f, halfDayHours: e.target.value }))} />
        </div>
        <div>
          <MFLabel>Full Day Hours</MFLabel>
          <input className={MF_INP} value={form.fullDayHours}
            onChange={e => setForm(f => ({ ...f, fullDayHours: e.target.value }))} />
        </div>
        <div>
          <MFLabel>OT After Minutes</MFLabel>
          <input className={MF_INP} value={form.otAfterMinutes}
            onChange={e => setForm(f => ({ ...f, otAfterMinutes: e.target.value }))} />
        </div>
        <div>
          <MFLabel>Shift Color</MFLabel>
          <input className={MF_INP} value={form.shiftColor}
            onChange={e => setForm(f => ({ ...f, shiftColor: e.target.value }))} />
        </div>
        <div>
          <MFLabel>Remarks</MFLabel>
          <input className={MF_INP} value={form.remarks}
            onChange={e => setForm(f => ({ ...f, remarks: e.target.value }))} />
        </div>
        {saving && <p className="text-[10px] text-primary-500">Saving...</p>}
        {error && <p className="text-[10px] text-red-500">{error}</p>}
      </MFEntryPanel>
    </div>
  );
}

// ─── MF Section: Province ─────────────────────────────────────────────────────
function MFProvince() {
  const [provinces, setProvinces] = useState(SEED_PROVINCES);
  const [districts, setDistricts] = useState(SEED_DISTRICTS);
  const [electorates, setElectorates] = useState(SEED_ELECTORATES);
  const [provForm, setProvForm] = useState({ code: '', name: '', status: 'Active' });
  const [distForm, setDistForm] = useState({ code: '', name: '', status: 'Active' });
  const [elecForm, setElecForm] = useState({ code: '', name: '', status: 'Active' });
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
      <div className="space-y-4">
        <MFGridSection title="Districts" count={districts.length}>
          <table className="w-full text-[13px]">
            <thead><tr className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">{['Prov. Code', 'Province', 'Dist. Code', 'District', 'Status'].map(h => <th key={h} className={MF_TH}>{h}</th>)}</tr></thead>
            <tbody>
              {districts.map((r, i) => (
                <tr key={r.code} onClick={() => setDistForm({ code: r.code, name: r.name, status: r.status })}
                  className={`${MF_ROW} ${MF_ROW_IDLE} ${i === 0 ? 'bg-primary-50/50' : ''}`}>
                  <td className="px-4 py-3 font-mono text-gray-900 font-semibold">{r.provCode}</td>
                  <td className="px-4 py-3 text-gray-600">{r.provName}</td>
                  <td className="px-4 py-3 font-mono text-gray-700 font-semibold">{r.code}</td>
                  <td className="px-4 py-3 text-gray-900 font-medium">{r.name}</td>
                  <td className="px-4 py-3"><StatusPill label={r.status} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </MFGridSection>
        <MFGridSection title="Electorates" count={electorates.length}>
          <table className="w-full text-[13px]">
            <thead><tr className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">{['Prov.', 'Dist.', 'Code', 'Name', 'Status'].map(h => <th key={h} className={MF_TH}>{h}</th>)}</tr></thead>
            <tbody>
              {electorates.map((r, i) => (
                <tr key={r.code} onClick={() => setElecForm({ code: r.code, name: r.name, status: r.status })}
                  className={`${MF_ROW} ${MF_ROW_IDLE} ${i === 0 ? 'bg-primary-50/50' : ''}`}>
                  <td className="px-4 py-3 font-mono text-primary-600">{r.provCode}</td>
                  <td className="px-4 py-3 font-mono text-gray-600">{r.distCode}</td>
                  <td className="px-4 py-3 font-mono text-gray-700 font-semibold">{r.code}</td>
                  <td className="px-4 py-3 text-gray-900 font-medium">{r.name}</td>
                  <td className="px-4 py-3"><StatusPill label={r.status} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </MFGridSection>
      </div>
      <div className="space-y-4">
        <div className="bg-white border border-surface-100 rounded-xl p-4 shadow-sm">
          <p className="text-xs font-bold text-primary-600 uppercase tracking-widest mb-3 border-b border-primary-100 pb-2">Province Entry</p>
          <div className="grid grid-cols-3 gap-2 mb-3 items-end">
            <div><MFLabel req>Code</MFLabel><input className={MF_INP} value={provForm.code} onChange={e => setProvForm(f => ({ ...f, code: e.target.value }))} placeholder="e.g. WP" /></div>
            <div className="col-span-2"><MFLabel>Name</MFLabel><input className={MF_INP} value={provForm.name} onChange={e => setProvForm(f => ({ ...f, name: e.target.value }))} /></div>
            <div><MFLabel>Status</MFLabel><select className={MF_SEL} value={provForm.status} onChange={e => setProvForm(f => ({ ...f, status: e.target.value }))}><option>Active</option><option>Inactive</option></select></div>
          </div>
          <div className="flex gap-2">
            <button onClick={() => { if (!provForm.code) return; setProvinces(prev => { const idx = prev.findIndex(p => p.code === provForm.code); if (idx >= 0) { const n = [...prev]; n[idx] = { ...provForm }; return n; } return [...prev, { ...provForm }]; }); setProvForm({ code: '', name: '', status: 'Active' }); }} className="flex items-center gap-1 bg-surface-800 text-primary-400 text-xs px-3 py-1.5 rounded hover:bg-surface-700"><Save size={11} /> Save</button>
            <button onClick={() => setProvForm({ code: '', name: '', status: 'Active' })} className="flex items-center gap-1 border border-surface-200 text-surface-500 text-xs px-3 py-1.5 rounded hover:bg-surface-50"><RotateCcw size={11} /> Clear</button>
          </div>
        </div>
        <div className="bg-white border border-surface-100 rounded-xl p-4 shadow-sm">
          <p className="text-xs font-bold text-primary-600 uppercase tracking-widest mb-3 border-b border-primary-100 pb-2">District Entry</p>
          <div className="grid grid-cols-2 gap-2 mb-3">
            <div><MFLabel req>District Code</MFLabel><input className={MF_INP} value={distForm.code} onChange={e => setDistForm(f => ({ ...f, code: e.target.value }))} /></div>
            <div><MFLabel req>District Name</MFLabel><input className={MF_INP} value={distForm.name} onChange={e => setDistForm(f => ({ ...f, name: e.target.value }))} /></div>
            <div><MFLabel>Status</MFLabel><select className={MF_SEL} value={distForm.status} onChange={e => setDistForm(f => ({ ...f, status: e.target.value }))}><option>Active</option><option>Inactive</option></select></div>
          </div>
          <div className="flex gap-2">
            <button onClick={() => { if (!distForm.code) return; setDistricts(prev => { const idx = prev.findIndex(d => d.code === distForm.code); if (idx >= 0) { const n = [...prev]; n[idx] = { ...distForm, provCode: 'WP', provName: 'Western Province' }; return n; } return [...prev, { ...distForm, provCode: 'WP', provName: 'Western Province' }]; }); setDistForm({ code: '', name: '', status: 'Active' }); }} className="flex items-center gap-1 bg-surface-800 text-primary-400 text-xs px-3 py-1.5 rounded hover:bg-surface-700"><Save size={11} /> Save</button>
            <button onClick={() => setDistForm({ code: '', name: '', status: 'Active' })} className="flex items-center gap-1 border border-surface-200 text-surface-500 text-xs px-3 py-1.5 rounded hover:bg-surface-50"><RotateCcw size={11} /> Clear</button>
          </div>
        </div>
        <div className="bg-white border border-surface-100 rounded-xl p-4 shadow-sm">
          <p className="text-xs font-bold text-primary-600 uppercase tracking-widest mb-3 border-b border-primary-100 pb-2">Electorate Entry</p>
          <div className="grid grid-cols-2 gap-2 mb-3">
            <div><MFLabel req>Electorate Code</MFLabel><input className={MF_INP} value={elecForm.code} onChange={e => setElecForm(f => ({ ...f, code: e.target.value }))} /></div>
            <div><MFLabel req>Electorate Name</MFLabel><input className={MF_INP} value={elecForm.name} onChange={e => setElecForm(f => ({ ...f, name: e.target.value }))} /></div>
            <div><MFLabel>Status</MFLabel><select className={MF_SEL} value={elecForm.status} onChange={e => setElecForm(f => ({ ...f, status: e.target.value }))}><option>Active</option><option>Inactive</option></select></div>
          </div>
          <div className="flex gap-2">
            <button onClick={() => { if (!elecForm.code) return; setElectorates(prev => { const idx = prev.findIndex(e => e.code === elecForm.code); if (idx >= 0) { const n = [...prev]; n[idx] = { ...elecForm, provCode: 'WP', distCode: 'CMB' }; return n; } return [...prev, { ...elecForm, provCode: 'WP', distCode: 'CMB' }]; }); setElecForm({ code: '', name: '', status: 'Active' }); }} className="flex items-center gap-1 bg-surface-800 text-primary-400 text-xs px-3 py-1.5 rounded hover:bg-surface-700"><Save size={11} /> Save</button>
            <button onClick={() => setElecForm({ code: '', name: '', status: 'Active' })} className="flex items-center gap-1 border border-surface-200 text-surface-500 text-xs px-3 py-1.5 rounded hover:bg-surface-50"><RotateCcw size={11} /> Clear</button>
          </div>
        </div>
        <MFGridSection title="All Provinces" count={provinces.length}>
          <table className="w-full text-[13px]">
            <thead><tr className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">{['Code', 'Province Name', 'Status'].map(h => <th key={h} className={MF_TH}>{h}</th>)}</tr></thead>
            <tbody>
              {provinces.map((r, i) => (
                <tr key={r.code} onClick={() => setProvForm({ code: r.code, name: r.name, status: r.status })}
                  className={`${MF_ROW} ${MF_ROW_IDLE} ${i === 0 ? 'bg-primary-50/50' : ''}`}>
                  <td className="px-4 py-3 font-mono text-gray-900 font-semibold">{r.code}</td>
                  <td className="px-4 py-3 text-gray-900 font-medium">{r.name}</td>
                  <td className="px-4 py-3"><StatusPill label={r.status} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </MFGridSection>
      </div>
    </div>
  );
}

// ─── MF Section: Police ───────────────────────────────────────────────────────
// function MFPolice() {
//   const [stations, setStations] = useState(SEED_POLICE_STATIONS);
//   const [form, setForm] = useState({ code: '', electorateCode: '', name: '', status: 'Active' });
//   const [search, setSearch] = useState('');
//   const [saved, setSaved] = useState(false);
//   const filtered = stations.filter(s => s.name.toLowerCase().includes(search.toLowerCase()) || s.code.includes(search));
//   const handleSave = () => {
//     if (!form.code || !form.name) return;
//     setStations(prev => { const idx = prev.findIndex(s => s.code === form.code); if (idx >= 0) { const n = [...prev]; n[idx] = { ...form }; return n; } return [...prev, { ...form }]; });
//     setSaved(true); setTimeout(() => setSaved(false), 1500);
//   };
//   return (
//     <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
//       <div className="lg:col-span-2 space-y-3">
//         <div className="relative"><Search size={12} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" /><input className="h-9 bg-white border border-gray-200 rounded-lg text-xs pl-8 pr-3 w-full outline-none text-gray-700 focus:border-primary-500" placeholder="Search stations…" value={search} onChange={e => setSearch(e.target.value)} /></div>
//         <MFGridSection title="Police Station Details">
//           <table className="w-full text-[13px]">
//             <thead><tr className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">{['Code','Electorate','Station Name','Status'].map(h => <th key={h} className={MF_TH}>{h}</th>)}</tr></thead>
//             <tbody>
//               {filtered.map((r, i) => (
//                 <tr key={r.code} onClick={() => setForm({ code: r.code, electorateCode: r.electorateCode, name: r.name, status: r.status })}
//                   className={`${MF_ROW} ${MF_ROW_IDLE} ${i === 0 ? 'bg-primary-50/50' : ''}`}>
//                   <td className="px-4 py-3 font-mono text-gray-900 font-semibold">{r.code}</td>
//                   <td className="px-4 py-3 text-gray-600">{r.electorateCode}</td>
//                   <td className="px-4 py-3 text-gray-900 font-medium">{r.name}</td>
//                   <td className="px-4 py-3"><StatusPill label={r.status} /></td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </MFGridSection>
//       </div>
//       <MFEntryPanel title="Police Station Entry" onSave={handleSave} onClear={() => setForm({ code: '', electorateCode: '', name: '', status: 'Active' })} saved={saved}>
//         <div><MFLabel req>Code</MFLabel><input className={MF_INP} value={form.code} onChange={e => setForm(f => ({ ...f, code: e.target.value }))} /></div>
//         <div><MFLabel>Electorate</MFLabel><select className={MF_SEL} value={form.electorateCode} onChange={e => setForm(f => ({ ...f, electorateCode: e.target.value }))}><option value="">Select...</option>{SEED_ELECTORATES.map(e => <option key={e.code} value={e.code}>{e.name}</option>)}</select></div>
//         <div><MFLabel req>Station Name</MFLabel><input className={MF_INP} value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} /></div>
//         <div><MFLabel>Status</MFLabel><select className={MF_SEL} value={form.status} onChange={e => setForm(f => ({ ...f, status: e.target.value }))}><option>Active</option><option>Inactive</option></select></div>
//       </MFEntryPanel>
//     </div>
//   );
// }

// ─── MF Section: Bank ───────────────────────────────────────────────────────
const EMPTY_BANK_FORM = {
  bankCode: '',
  bankName: '',
  shortName: '',
  swiftCode: '',
  headOffice: '',
  remarks: '',
  isActive: false,
  isApproved: false,   // approval is separate from active; new banks start pending
};

const toBoolean = (value) => {
  if (typeof value === 'boolean') return value;

  return String(value).toLowerCase() === 'true';
};

function MFBank() {
  const dispatch = useDispatch();
  const { banks, loading, saving, error, success } = useSelector(s => s.bankSlice);

  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [form, setForm] = useState(EMPTY_BANK_FORM);
  const [editingId, setEditingId] = useState(null);
  const [importing, setImporting] = useState(false);
  const [importSuccess, setImportSuccess] = useState('');
  const [importError, setImportError] = useState('');

  useEffect(() => {
    dispatch(getBankList());
  }, [dispatch]);

  useEffect(() => {
    if (success) {
      dispatch(getBankList());
      setForm(EMPTY_BANK_FORM);
      setEditingId(null);
      const t = setTimeout(() => dispatch(clearBankSuccess()), 1500);
      return () => clearTimeout(t);
    }
  }, [success, dispatch]);

  const rows = (banks || []).map(r => ({
    id: pickField(r, ['HBD_BANK_ID']),
    bankCode: pickField(r, ['HBD_BANK_CODE']),
    bankName: pickField(r, ['HBD_BANK_NAME']),
    shortName: pickField(r, ['HBD_SHORT_NAME']),
    swiftCode: pickField(r, ['HBD_SWIFT_CODE']),
    headOffice: pickField(r, ['HBD_HEAD_OFFICE']),
    isActive: toBoolean(pickField(r, ['HBD_IS_ACTIVE'])),
    isApproved: isMasterApproved(r),
  }));

  const filtered = rows.filter(r => {
    const matchesSearch =
      r.bankName.toLowerCase().includes(search.toLowerCase()) ||
      r.bankCode.toLowerCase().includes(search.toLowerCase());

    const matchesStatus =
      statusFilter === 'all' ||
      (statusFilter === 'pending' && !r.isApproved) ||
      (statusFilter === 'approved' && r.isApproved);

    return matchesSearch && matchesStatus;
  });

  const handleExport = () => {
    const exportData = rows.map(r => ({
      Bank_Code: r.bankCode || '',
      Bank_Name: r.bankName || '',
      Swift_Code: r.swiftCode || '',
      Head_Office: r.headOffice || '',
      Remarks: '',   // Not returned by the API but can be inserted via AddBank API
      'Created _By': 'System', // Created by is not returned by GetBanks so, hardcoded
    }));

    exportToExcel(exportData, 'banks.xlsx');
  }

  const handleImport = async (event) => {
    const file = event.target.files?.[0];

    if (!file) return;

    try {
      setImporting(true);

      const rows = await importFromExcel(file);

      if (!rows.length) {
        setImportError('The Excel file does not contain any data.');

        setTimeout(() => {
          setImportError('');
        }, 3000);

        return;
      }

      const requiredFields = [
        'Bank_Code',
        'Bank_Name',
        'Swift_Code',
        'Head_Office',
        'Remarks',
        'Created _By',
      ];

      const missingHeaders = requiredFields.filter(
        field => !(field in rows[0])
      );

      if (missingHeaders.length) {
        setImportError(`Invalid bank Excel file.\n\nMissing columns:\n${missingHeaders.join('\n')}`);

        setTimeout(() => {
          setImportError('');
        }, 3000);

        return;
      }

      for (const row of rows) {
        if (!row.Bank_Code || !row.Bank_Name) {
          continue;
        }

        await dispatch(addBank({
          p_bankCode: String(row.Bank_Code).trim(),
          p_bankName: String(row.Bank_Name).trim(),
          p_shortName: '',
          p_swiftCode: String(row.Swift_Code || '').trim(),
          p_headOffice: String(row.Head_Office || '').trim() === "Null" ? '' : String(row.Head_Office),
          p_bankRemarks: String(row.Remarks || '').trim(),
          p_bankCreatedBy: String(row['Created _By'] || 'System').trim(),
        }));
      }

      await dispatch(getBankList());

      setImportSuccess(`Successfully imported ${rows.length} bank row(s).`);

      setTimeout(() => {
        setImportSuccess('');
      }, 3000);
    } catch (error) {
      console.error('Bank import failed:', error);

      setImportError(error?.message || 'An error occurred while importing the bank Excel file.');

      setTimeout(() => {
        setImportError('');
      }, 3000);

    } finally {
      setImporting(false);
      event.target.value = '';
    }
  };

  const handleSelect = (r) => {
    setEditingId(r.id);
    setForm({ bankCode: r.bankCode, bankName: r.bankName, shortName: r.shortName, swiftCode: r.swiftCode, headOffice: r.headOffice, isActive: r.isActive, isApproved: r.isApproved });
  };

  const handleClear = () => {
    setEditingId(null);
    setForm(EMPTY_BANK_FORM);
    dispatch(clearBankError());
  };

  const handleSave = () => {
    if (!form.bankCode || !form.bankName) return;
    if (editingId) {
      dispatch(updateBank({
        p_bankId: editingId,
        p_bankCode: form.bankCode,
        p_bankName: form.bankName,
        p_shortName: form.shortName,
        p_swiftCode: form.swiftCode,
        p_headOffice: form.headOffice,
        p_remarks: form.remarks || '',
        p_bankIsActive: form.isActive ? "True" : "False",
        p_updatedBy: getLoggedInServiceNo() || 'admin',
        // Ticking "Approved" in edit mode stamps who approved it and when.
        ...masterApprovalParams(form.isApproved, getLoggedInServiceNo() || 'admin'),
      }));
    } else {
      dispatch(addBank({
        p_bankCode: form.bankCode,
        p_bankName: form.bankName,
        p_shortName: form.shortName || '',
        p_swiftCode: form.swiftCode,
        p_headOffice: form.headOffice || '',
        p_bankRemarks: form.remarks || '',
        p_bankCreatedBy: getLoggedInServiceNo() || 'admin',
        p_isApproved: NEW_MASTER_IS_APPROVED,   // new banks always start pending
      }));
    }
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
      <div className="lg:col-span-2 space-y-3">
        <div className="flex gap-2">
          <div className="relative flex-1">
            <Search
              size={12}
              className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
            />

            <input
              className="h-9 bg-white border border-gray-200 rounded-lg text-xs pl-8 pr-3 w-full outline-none text-gray-700 focus:border-primary-500"
              placeholder="Search banks"
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
          </div>

          <select
            value={statusFilter}
            onChange={e => setStatusFilter(e.target.value)}
            className="border border-surface-200 rounded-lg px-3 py-2 text-xs focus:outline-none focus:border-primary-400 bg-white"
          >
            <option value="all">All</option>
            <option value="pending">Pending</option>
            <option value="approved">Approved</option>
          </select>

          <label
            className={`flex items-center gap-1 border border-surface-200 ${importing
              ? 'text-surface-400 cursor-not-allowed'
              : 'text-surface-600 hover:bg-surface-50 cursor-pointer'
              } text-xs px-3 py-2 rounded-lg transition-colors whitespace-nowrap`}
          >
            <Upload size={13} />
            {importing ? 'Importing...' : 'Import'}

            <input
              type="file"
              accept=".xlsx,.xls"
              onChange={handleImport}
              disabled={importing}
              className="hidden"
            />
          </label>

          <button
            type="button"
            onClick={handleExport}
            className="flex items-center gap-1 border border-surface-200 hover:bg-surface-50 text-surface-600 text-xs px-3 py-2 rounded-lg transition-colors whitespace-nowrap"
          >
            <Download size={13} />
            Export
          </button>
        </div>

        {importSuccess && (
          <div className="mb-3 flex items-center gap-2 bg-emerald-50 border border-emerald-200 text-emerald-700 rounded-lg px-3 py-2 text-xs">
            <CheckCircle size={14} />
            <span>{importSuccess}</span>
          </div>
        )}

        {importError && (
          <div className="mb-3 flex items-center gap-2 bg-red-50 border border-red-200 text-red-700 rounded-lg px-3 py-2 text-xs">
            <CheckCircle size={14} />
            <span>{importError}</span>
          </div>
        )}

        <MFGridSection title="Bank Details" count={filtered.length}>
          {loading ? (
            <div className="py-20 flex items-center justify-center gap-2 text-sm text-gray-400">
              <Loader2 size={14} className="animate-spin" /> Loading banks...
            </div>
          ) : error ? (
            <div className="py-20 flex items-center justify-center gap-2 text-sm text-red-600">
              <AlertCircle size={13} className="shrink-0" /> {error}
            </div>
          ) : filtered.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-20 text-center text-gray-400">
              <Tag size={24} className="text-gray-300 mb-2" />
              <p className="text-sm text-gray-400">No banks yet</p>
            </div>
          ) : (
            <table className="w-full text-[13px]">
              <thead>
                <tr className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">
                  {['Code', 'Name', 'Short Name', 'Swift Code', 'Head Office', 'Status'].map(h => (
                    <th key={h} className={MF_TH}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filtered.map((r) => (
                  <tr key={r.id || r.code} onClick={() => handleSelect(r)}
                    className={`${MF_ROW} ${MF_ROW_IDLE} ${editingId === r.id ? MF_ROW_SEL : ''}`}>
                    <td className="px-4 py-3 font-mono text-gray-900 font-semibold">{r.bankCode}</td>
                    <td className="px-4 py-3 text-gray-900 font-medium max-w-xs truncate">{r.bankName}</td>
                    <td className="px-4 py-3 text-gray-600 max-w-[120px] truncate">{r.shortName || '-'}</td>
                    <td className="px-4 py-3 text-gray-600 max-w-[160px] truncate">{r.swiftCode || '-'}</td>
                    <td className="px-4 py-3 text-gray-600 max-w-[160px] truncate">{r.headOffice || '-'}</td>
                    <td className="px-4 py-3 text-gray-600 max-w-[160px] truncate">
                      <span
                        className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${r.isApproved
                          ? 'bg-emerald-50 text-emerald-700'
                          : 'bg-amber-50 text-amber-700'
                          }`}
                      >
                        {r.isApproved ? 'Approved' : 'Pending'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </MFGridSection>
      </div>

      <MFEntryPanel
        title={editingId ? 'Edit Bank' : 'Bank Entry'}
        onSave={handleSave}
        onClear={handleClear}
        saved={success}
      >
        <div>
          <MFLabel req>Code</MFLabel>
          <input className={MF_INP} value={form.bankCode} disabled={!!editingId}
            onChange={e => setForm(f => ({ ...f, bankCode: e.target.value }))} />
          {editingId && <p className="text-[10px] text-surface-400 mt-0.5">Code can't be changed once created</p>}
        </div>
        <div>
          <MFLabel req>Name</MFLabel>
          <input className={MF_INP} value={form.bankName}
            onChange={e => setForm(f => ({ ...f, bankName: e.target.value }))} />
        </div>
        <div>
          <MFLabel>Short Name</MFLabel>
          <input className={MF_INP} value={form.shortName}
            onChange={e => setForm(f => ({ ...f, shortName: e.target.value }))} />
        </div>
        <div>
          <MFLabel>Swift Code</MFLabel>
          <input className={MF_INP} value={form.swiftCode}
            onChange={e => setForm(f => ({ ...f, swiftCode: e.target.value }))} />
        </div>
        <div>
          <MFLabel>Head Office</MFLabel>
          <input className={MF_INP} value={form.headOffice}
            onChange={e => setForm(f => ({ ...f, headOffice: e.target.value }))} />
        </div>

        {/* Approval tick only while editing an existing bank — a new entry is
            always saved as pending, so showing it during entry is misleading. */}
        {editingId ? (
          <div className="flex items-center gap-2 pt-2">
            <input
              id="bankIsApproved"
              type="checkbox"
              checked={form.isApproved}
              onChange={e =>
                setForm(prev => ({ ...prev, isApproved: e.target.checked }))
              }
              className="w-4 h-4 rounded border-surface-300 text-primary-600 focus:ring-primary-500"
            />
            <label
              htmlFor="bankIsApproved"
              className="text-sm font-medium text-surface-700 cursor-pointer"
            >
              Approved
            </label>
          </div>
        ) : (
          <p className="pt-2 text-[10px] text-amber-600">
            New banks are saved as <span className="font-semibold">Pending</span> and can be approved after saving.
          </p>
        )}
        {saving && <p className="text-[10px] text-primary-500">Saving...</p>}
        {error && <p className="text-[10px] text-red-500">{error}</p>}
      </MFEntryPanel>
    </div>
  );
}

// ─── MF Section: Bank Branch ──────────────────────────────────────────────────
const EMPTY_BRANCH_FORM = {
  bankId: '',
  branchCode: '',
  branchName: '',
  address: '',
  swiftCode: '',
  isActive: false,
  isApproved: false,   // new branches start pending
};

function MFBankBranch() {
  const dispatch = useDispatch();
  const { banks } = useSelector(s => s.bankSlice);
  const { bankBranches, loading, saving, error, success } = useSelector(s => s.bankBranchSlice);

  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [form, setForm] = useState(EMPTY_BRANCH_FORM);
  const [editingId, setEditingId] = useState(null);
  const [importing, setImporting] = useState(false);
  const [importSuccess, setImportSuccess] = useState('');
  const [importError, setImportError] = useState('');
  const [duplicateError, setDuplicateError] = useState('');

  useEffect(() => {
    dispatch(getBankList());
    dispatch(getBankBranchList());
  }, [dispatch]);

  useEffect(() => {
    if (success) {
      dispatch(getBankBranchList());

      setForm(EMPTY_BRANCH_FORM);
      setEditingId(null);
      setDuplicateError('');

      const t = setTimeout(
        () => dispatch(clearBankBranchSuccess()),
        1500
      );

      return () => clearTimeout(t);
    }
  }, [success, dispatch]);

  // Bank lookup: id -> name, used to label groups and the select dropdown
  const bankRows = (banks || []).map(b => ({
    id: pickField(b, ['HBD_BANK_ID']),
    code: pickField(b, ['HBD_BANK_CODE']),
    name: pickField(b, ['HBD_BANK_NAME']),
  }));

  const bankNameById = Object.fromEntries(bankRows.map(b => [String(b.id), b.name]));
  const bankCodeById = Object.fromEntries(bankRows.map(b => [String(b.id), b.code]));

  const branchRows = (bankBranches || []).map(r => ({
    id: pickField(r, ['HBB_BRANCH_ID', 'BranchId', 'branchId']),
    bankId: pickField(r, ['HBB_BANK_ID', 'BankId', 'bankId']),
    code: pickField(r, ['HBB_BRANCH_CODE', 'BranchCode', 'branchCode']),
    name: pickField(r, ['HBB_BRANCH_NAME', 'BranchName', 'branchName']),
    address: pickField(r, ['HBB_ADDRESS', 'BranchAddress', 'branchAddress']),
    swiftCode: pickField(r, ['HBB_SWIFT_CODE', 'SwitftCode', 'swiftCode']),
    isActive: toBoolean(pickField(r, ['HBB_IS_ACTIVE', 'HBB_BRANCH_IS_ACTIVE', 'BranchIsActive', 'branchIsActive', 'IsActive', 'isActive'])),
    isApproved: isMasterApproved(r),
  }));

  const handleExport = () => {
    const exportData = branchRows.map(r => ({
      Bank_Code: bankCodeById[String(r.bankId)] || '',
      Branch_Code: r.code || '',
      Branch_Name: r.name || '',
      Branch_Address: r.address || '',
      Swift_Code: r.swiftCode || '',
    }));

    exportToExcel(exportData, 'bankBranches.xlsx');
  };

  const handleImport = async (event) => {
    const file = event.target.files?.[0];

    if (!file) return;

    try {
      setImporting(true);

      const rows = await importFromExcel(file);

      if (!rows.length) {
        setImportError('The Excel file does not contain any data.');

        setTimeout(() => {
          setImportError('');
        }, 3000);

        return;
      }

      const requiredFields = [
        'Bank_Code',
        'Branch_Code',
        'Branch_Name',
        'Branch_Address',
        'Swift_Code',
      ];

      const missingHeaders = requiredFields.filter(
        field => !(field in rows[0])
      );

      if (missingHeaders.length) {
        setImportError(`Invalid bank branch Excel file.\n\nMissing columns:\n${missingHeaders.join('\n')}`);

        setTimeout(() => {
          setImportError('');
        }, 3000);

        return;
      }

      for (const row of rows) {
        if (!row.Bank_Code || !row.Branch_Code || !row.Branch_Name) {
          continue;
        }

        const bankCode = String(row.Bank_Code).trim();

        const bank = bankRows.find(
          b => String(b.code).trim() === bankCode
        );

        if (!bank) {
          console.error(
            `Bank code ${bankCode} was not found. Skipping branch.`,
            row
          );
          continue;
        }

        await dispatch(addBankBranch({
          p_bankId: bank.id,
          p_branchCode: String(row.Branch_Code).trim(),
          p_branchName: String(row.Branch_Name).trim(),
          p_branchAddress: String(row.Branch_Address || '').trim(),
          p_swiftCode: String(row.Swift_Code || '').trim(),
          p_branchCreatedBy: getLoggedInServiceNo() || 'admin',
          p_branchIsActive: 'False',
        }));
      }

      await dispatch(getBankBranchList());

      setImportSuccess(`Successfully imported ${rows.length} branch row(s).`);

      setTimeout(() => {
        setImportSuccess('');
      }, 3000);
    } catch (error) {
      console.error('Bank branch import failed:', error);

      setImportError(error?.message || 'An error occurred while importing the bank branch Excel file.');

      setTimeout(() => {
        setImportError('');
      }, 3000);

    } finally {
      setImporting(false);
      event.target.value = '';
    }
  };

  const filtered = branchRows.filter(r => {
    const matchesSearch =
      r.name.toLowerCase().includes(search.toLowerCase()) ||
      r.code.toLowerCase().includes(search.toLowerCase()) ||
      (bankNameById[String(r.bankId)] || '').toLowerCase().includes(search.toLowerCase());

    const matchesStatus =
      statusFilter === 'all' ||
      (statusFilter === 'pending' && !r.isApproved) ||
      (statusFilter === 'approved' && r.isApproved);

    return matchesSearch && matchesStatus;
  });

  // Group branches by bank, sorted so branches with the same bank sit together
  const grouped = useMemo(() => {
    const map = new Map();
    filtered.forEach(r => {
      const key = String(r.bankId);
      if (!map.has(key)) map.set(key, []);
      map.get(key).push(r);
    });
    return Array.from(map.entries())
      .map(([bankId, branches]) => ({
        bankId,
        bankName: bankNameById[bankId] || `Bank #${bankId}`,
        branches,
      }))
      .sort((a, b) => a.bankName.localeCompare(b.bankName));
  }, [filtered, bankNameById]);

  const handleSave = () => {
    setDuplicateError('');
    if (!form.bankId || !form.branchCode || !form.branchName) return;

    const trimmedCode = form.branchCode.trim().toLowerCase();
    const trimmedName = form.branchName.trim().toLowerCase();

    const dupCode = branchRows.find(
      r => String(r.id) !== String(editingId) &&
        String(r.bankId) === String(form.bankId) &&
        (r.code || '').trim().toLowerCase() === trimmedCode
    );

    const dupName = branchRows.find(
      r => String(r.id) !== String(editingId) &&
        String(r.bankId) === String(form.bankId) &&
        (r.name || '').trim().toLowerCase() === trimmedName
    );

    if (dupCode && dupName) {
      setDuplicateError(`Duplicate branch entry! Code '${form.branchCode.trim()}' and Name '${form.branchName.trim()}' already exist for this bank.`);
      return;
    }

    if (dupCode) {
      setDuplicateError(`Duplicate branch code! A branch with code '${form.branchCode.trim()}' already exists for this bank.`);
      return;
    }

    if (dupName) {
      setDuplicateError(`Duplicate branch name! A branch with name '${form.branchName.trim()}' already exists for this bank.`);
      return;
    }

    const serviceNo = getLoggedInServiceNo() || 'admin';

    if (editingId) {
      dispatch(updateBankBranch({
        p_branchId: editingId,
        p_bankId: form.bankId,
        p_branchCode: form.branchCode,
        p_branchName: form.branchName,
        p_branchAddress: form.address || '',
        p_swiftCode: form.swiftCode || '',
        p_branchUpdatedBy: serviceNo,
        p_branchRemarks: form.remarks || '',
        p_branchIsActive: form.isActive ? "True" : "False",
        // Ticking "Approved" in edit mode stamps who approved it and when.
        ...masterApprovalParams(form.isApproved, getLoggedInServiceNo() || 'admin'),
      }));
    } else {
      dispatch(addBankBranch({
        p_bankId: form.bankId,
        p_branchCode: form.branchCode,
        p_branchName: form.branchName,
        p_branchAddress: form.address || '',
        p_swiftCode: form.swiftCode || '',
        p_branchCreatedBy: serviceNo,
        p_branchRemarks: form.remarks || '',
        p_branchIsActive: "False",
        p_isApproved: NEW_MASTER_IS_APPROVED,   // new branches always start pending
      }));
    }
  };

  const handleSelect = (r) => {
    setEditingId(r.id);
    setDuplicateError('');

    setForm({
      bankId: r.bankId != null ? String(r.bankId) : '',
      branchCode: r.code ?? '',
      branchName: r.name ?? '',
      address: r.address ?? '',
      swiftCode: r.swiftCode ?? '',
      isActive: r.isActive ?? false,
      isApproved: r.isApproved ?? false,
    });
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
      <div className="lg:col-span-2 space-y-3">
        <div className="flex gap-2">
          <div className="relative flex-1">
            <Search
              size={12}
              className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
            />
            <input
              className="h-9 bg-white border border-gray-200 rounded-lg text-xs pl-8 pr-3 w-full outline-none text-gray-700 focus:border-primary-500"
              placeholder="Search bank branches"
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
          </div>

          <select
            value={statusFilter}
            onChange={e => setStatusFilter(e.target.value)}
            className="border border-surface-200 rounded-lg px-3 py-2 text-xs focus:outline-none focus:border-primary-400 bg-white"
          >
            <option value="all">All</option>
            <option value="pending">Pending</option>
            <option value="approved">Approved</option>
          </select>

          <label
            className={`flex items-center gap-1 border border-surface-200 ${importing
              ? 'text-surface-400 cursor-not-allowed'
              : 'text-surface-600 hover:bg-surface-50 cursor-pointer'
              } text-xs px-3 py-2 rounded-lg transition-colors whitespace-nowrap`}
          >
            <Upload size={13} />
            {importing ? 'Importing...' : 'Import'}

            <input
              type="file"
              accept=".xlsx,.xls"
              onChange={handleImport}
              disabled={importing}
              className="hidden"
            />
          </label>

          <button
            type="button"
            onClick={handleExport}
            className="flex items-center gap-1 border border-surface-200 hover:bg-surface-50 text-surface-600 text-xs px-3 py-2 rounded-lg transition-colors whitespace-nowrap"
          >
            <Download size={13} />
            Export
          </button>
        </div>

        {importSuccess && (
          <div className="mb-3 flex items-center gap-2 bg-emerald-50 border border-emerald-200 text-emerald-700 rounded-lg px-3 py-2 text-xs">
            <CheckCircle size={14} />
            <span>{importSuccess}</span>
          </div>
        )}

        {importError && (
          <div className="mb-3 flex items-center gap-2 bg-red-50 border border-red-200 text-red-700 rounded-lg px-3 py-2 text-xs">
            <CheckCircle size={14} />
            <span>{importError}</span>
          </div>
        )}

        {loading ? (
          <MFGridSection title="Bank Branch Details">
            <div className="py-20 flex items-center justify-center gap-2 text-sm text-gray-400">
              <Loader2 size={14} className="animate-spin" /> Loading branches...
            </div>
          </MFGridSection>
        ) : error ? (
          <MFGridSection title="Bank Branch Details">
            <div className="py-20 flex items-center justify-center gap-2 text-sm text-red-600">
              <AlertCircle size={13} className="shrink-0" /> {error}
            </div>
          </MFGridSection>
        ) : grouped.length === 0 ? (
          <MFGridSection title="Bank Branch Details">
            <div className="flex flex-col items-center justify-center py-20 text-center text-gray-400">
              <Building2 size={24} className="text-gray-300 mb-2" />
              <p className="text-sm text-gray-400">No branches yet</p>
            </div>
          </MFGridSection>
        ) : (
          grouped.map(group => (
            <MFGridSection key={group.bankId} title={group.bankName} count={group.branches.length}>
              <table className="w-full text-[13px]">
                <thead>
                  <tr className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">
                    {['Code', 'Name', 'Address', 'Swift Code', 'Status'].map(h => (
                      <th key={h} className={MF_TH}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {group.branches.map(r => (
                    <tr
                      key={r.id || r.code}
                      onClick={() => handleSelect(r)}
                      className={`${MF_ROW} ${MF_ROW_IDLE} ${editingId === r.id ? MF_ROW_SEL : ''
                        }`}
                    >
                      <td className="px-4 py-3 font-mono text-gray-900 font-semibold">
                        {r.code}
                      </td>

                      <td className="px-4 py-3 text-gray-900 font-medium">
                        {r.name}
                      </td>

                      <td className="px-4 py-3 text-gray-600 max-w-[200px] truncate">
                        {r.address || '—'}
                      </td>

                      <td className="px-4 py-3 text-gray-600 max-w-[160px] truncate">
                        {r.swiftCode || '—'}
                      </td>

                      <td className="px-4 py-3 text-gray-600 max-w-[160px] truncate">
                        <span
                          className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${r.isApproved
                            ? 'bg-emerald-50 text-emerald-700'
                            : 'bg-amber-50 text-amber-700'
                            }`}
                        >
                          {r.isApproved ? 'Approved' : 'Pending'}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </MFGridSection>
          ))
        )}
      </div>

      <MFEntryPanel
        title={editingId ? 'Edit Bank Branch' : 'Branch Entry'}
        onSave={handleSave}
        onClear={() => {
          setEditingId(null);
          setDuplicateError('');
          setForm(EMPTY_BRANCH_FORM);
        }}
        saved={success}
      >
        <div>
          <MFLabel req>Bank</MFLabel>
          <MFSearchSelect
            value={form.bankId}
            onChange={v => {
              setDuplicateError('');
              setForm(f => ({
                ...f,
                bankId: v,
              }));
            }}
            options={bankRows.map(b => ({ value: String(b.id), label: b.name }))}
            placeholder="Select..."
          />
        </div>
        <div>
          <MFLabel req>Branch Code</MFLabel>
          <input
            className={MF_INP}
            value={form.branchCode}
            onChange={e => {
              setDuplicateError('');
              setForm(f => ({ ...f, branchCode: e.target.value }));
            }}
          />
        </div>
        <div>
          <MFLabel req>Branch Name</MFLabel>
          <input
            className={MF_INP}
            value={form.branchName}
            onChange={e => {
              setDuplicateError('');
              setForm(f => ({ ...f, branchName: e.target.value }));
            }}
          />
        </div>
        <div>
          <MFLabel>Address</MFLabel>
          <input className={MF_INP} value={form.address} onChange={e => setForm(f => ({ ...f, address: e.target.value }))} />
        </div>
        <div>
          <MFLabel>Swift Code</MFLabel>
          <input className={MF_INP} value={form.swiftCode} onChange={e => setForm(f => ({ ...f, swiftCode: e.target.value }))} />
        </div>

        {/* Approval tick only while editing an existing branch. */}
        {editingId ? (
          <div className="flex items-center gap-2 pt-2">
            <input
              id="branchIsApproved"
              type="checkbox"
              checked={form.isApproved}
              onChange={e =>
                setForm(prev => ({ ...prev, isApproved: e.target.checked }))
              }
              className="w-4 h-4 rounded border-surface-300 text-primary-600 focus:ring-primary-500"
            />
            <label
              htmlFor="branchIsApproved"
              className="text-sm font-medium text-surface-700 cursor-pointer"
            >
              Approved
            </label>
          </div>
        ) : (
          <p className="pt-2 text-[10px] text-amber-600">
            New branches are saved as <span className="font-semibold">Pending</span> and can be approved after saving.
          </p>
        )}

        {duplicateError && (
          <div className="flex items-center gap-1.5 text-xs text-red-600 bg-red-50 border border-red-200 rounded p-2 mt-2 font-medium">
            <AlertCircle size={14} className="shrink-0 text-red-500" />
            <span>{duplicateError}</span>
          </div>
        )}

        {saving && <p className="text-[10px] text-primary-500">Saving...</p>}
        {error && <p className="text-[10px] text-red-500">{error}</p>}
      </MFEntryPanel>
    </div>
  );
}

// ─── MF Section: Calendar ─────────────────────────────────────────────────────
// ─── MF Section: Region (Province / District / Electorate / Police Station) ───

const REGION_SUBTABS = [
  { key: 'province', label: 'Province', icon: MapPin },
  { key: 'district', label: 'District', icon: Building2 },
  { key: 'electorate', label: 'Electorate', icon: MapPinned },
  { key: 'police', label: 'Police Station', icon: Shield },
  { key: 'grama', label: 'Grama Divisions', icon: Landmark },
];

/* The Region tables' column names are not settled on the backend yet, so a
   value is read by trying the likely keys rather than one hard-coded name —
   the same approach the other MF sections use for their own lists. */
const rgPick = (obj, keys, fallbackPattern) => {
  if (!obj || typeof obj !== 'object') return '';
  for (const k of keys) {
    if (obj[k] !== undefined && obj[k] !== null && String(obj[k]).trim() !== '') {
      return String(obj[k]).trim();
    }
  }
  const objKeys = Object.keys(obj);
  for (const target of keys) {
    const found = objKeys.find((k) => k.toLowerCase() === target.toLowerCase());
    if (found && obj[found] !== undefined && obj[found] !== null && String(obj[found]).trim() !== '') {
      return String(obj[found]).trim();
    }
  }
  if (fallbackPattern) {
    const found = objKeys.find((k) => fallbackPattern.test(k));
    if (found && obj[found] !== undefined && obj[found] !== null && String(obj[found]).trim() !== '') {
      return String(obj[found]).trim();
    }
  }
  return '';
};

const RG_PROVINCE_CODE_KEYS = ['PROVINCE_CODE', 'ProvinceCode', 'provinceCode', 'p_provinceCode', 'HPD_PROVINCE_CODE', 'Code', 'code', 'Id', 'id'];
const RG_PROVINCE_NAME_KEYS = ['PROVINCE_NAME', 'ProvinceName', 'provinceName', 'p_provinceName', 'HPD_PROVINCE_NAME', 'Name', 'name', 'Description', 'description'];

/* Active unless the row says otherwise — accepts 1/0, 'A'/'I', true/false. */
const rgActive = (row) => {
  const raw = rgPick(row, ['STATUS', 'Status', 'status', 'p_status', 'IsActive', 'isActive', 'CURRENT_STATUS'], /status|active/i);
  if (raw === '') return true;
  const v = raw.toLowerCase();
  return !(v === '0' || v === 'i' || v === 'false' || v === 'inactive' || v === 'n');
};

const MF_SEARCH = 'h-9 bg-white border border-gray-200 rounded-lg text-xs pl-8 pr-3 w-full outline-none text-gray-700 focus:border-primary-500';

/* ── Province ─────────────────────────────────────────────────────────────── */
const EMPTY_PROVINCE_FORM = { code: '', name: '', status: 'Active' };

function MFRegionProvince() {
  const dispatch = useDispatch();
  const { provinces = [], loading = false, saving = false, error = null,
    success = false, successFor = null, selectedLoading = false } =
    useSelector(s => s.regionSlice) || {};

  const [search, setSearch] = useState('');
  const [form, setForm] = useState(EMPTY_PROVINCE_FORM);
  const [editingId, setEditingId] = useState(null);

  useEffect(() => { dispatch(getProvinceList()); }, [dispatch]);

  useEffect(() => {
    if (success && successFor === 'province') {
      dispatch(getProvinceList());
      setForm(EMPTY_PROVINCE_FORM);
      setEditingId(null);
      const t = setTimeout(() => dispatch(clearRegionSuccess()), 1500);
      return () => clearTimeout(t);
    }
  }, [success, successFor, dispatch]);

  const rows = useMemo(() => (Array.isArray(provinces) ? provinces : []).map((p, i) => ({
    id: rgPick(p, RG_PROVINCE_CODE_KEYS, /province.*code|^code$|^id$/i) || `row-${i}`,
    code: rgPick(p, RG_PROVINCE_CODE_KEYS, /province.*code|^code$|^id$/i),
    name: rgPick(p, RG_PROVINCE_NAME_KEYS, /province.*name|^name$|desc/i),
    status: rgActive(p) ? 'Active' : 'Inactive',
  })), [provinces]);

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return rows;
    return rows.filter(r => `${r.code} ${r.name}`.toLowerCase().includes(q));
  }, [rows, search]);

  const handleSelect = (r) => {
    setEditingId(r.code);
    // Fill from the row first so the panel responds immediately, then
    // overwrite with the record the API returns for that code.
    setForm({ code: r.code, name: r.name, status: r.status });
    if (!r.code) return;
    dispatch(getProvinceById(r.code)).unwrap().then((rec) => {
      if (!rec) return;
      setForm({
        code: rgPick(rec, RG_PROVINCE_CODE_KEYS, /province.*code|^code$|^id$/i) || r.code,
        name: rgPick(rec, RG_PROVINCE_NAME_KEYS, /province.*name|^name$|desc/i) || r.name,
        status: rgActive(rec) ? 'Active' : 'Inactive',
      });
    }).catch(() => { });   // the row values are already on screen
  };

  const handleClear = () => {
    dispatch(clearRegionError());
    setEditingId(null);
    setForm(EMPTY_PROVINCE_FORM);
  };

  const handleSave = () => {
    if (!form.name) return;
    if (editingId) {
      // Same endpoint as insert — the province code is what marks it an update.
      dispatch(updateProvince({
        p_provinceCode: form.code,
        p_provinceName: form.name,
        p_status: form.status === 'Active' ? 1 : 0,
      }));
    } else {
      // The backend allocates the code, so only the name is sent.
      dispatch(addProvince({ p_provinceName: form.name }));
    }
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
      <div className="lg:col-span-2 space-y-3">
        <div className="relative">
          <Search size={12} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
          <input className={MF_SEARCH} placeholder="Search provinces…"
            value={search} onChange={e => setSearch(e.target.value)} />
        </div>
        <MFGridSection title="Province Details" count={filtered.length}>
          {loading ? (
            <div className="py-20 flex items-center justify-center gap-2 text-sm text-gray-400">
              <Loader2 size={14} className="animate-spin" /> Loading provinces...
            </div>
          ) : error ? (
            <div className="py-20 flex items-center justify-center gap-2 text-sm text-red-600">
              <AlertCircle size={13} className="shrink-0" /> {error}
            </div>
          ) : filtered.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-20 text-center text-gray-400">
              <MapPin size={24} className="text-gray-300 mb-2" />
              <p className="text-sm text-gray-400">No provinces yet</p>
            </div>
          ) : (
            <table className="w-full text-[13px]">
              <thead>
                <tr className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">
                  {['Code', 'Province Name', 'Status'].map(h => <th key={h} className={MF_TH}>{h}</th>)}
                </tr>
              </thead>
              <tbody>
                {filtered.map(r => (
                  <tr key={r.id} onClick={() => handleSelect(r)}
                    className={`${MF_ROW} ${MF_ROW_IDLE} ${editingId === r.code ? MF_ROW_SEL : ''}`}>
                    <td className="px-4 py-3 font-mono text-gray-900 font-semibold">{r.code || '—'}</td>
                    <td className="px-4 py-3 text-gray-900 font-medium">{r.name || '—'}</td>
                    <td className="px-4 py-3"><StatusPill label={r.status} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </MFGridSection>
      </div>

      <MFEntryPanel
        title={editingId ? 'Edit Province' : 'Province Entry'}
        onSave={handleSave}
        onClear={handleClear}
        saved={success && successFor === 'province'}
      >
        <div>
          <MFLabel>Code</MFLabel>
          <input className={`${MF_INP} cursor-not-allowed bg-gray-200`} disabled readOnly
            value={form.code} placeholder="Allocated on save" />
          <p className="text-[10px] text-surface-400 mt-0.5">The backend allocates the province code</p>
        </div>
        <div>
          <MFLabel req>Province Name</MFLabel>
          <input className={MF_INP} value={form.name}
            onChange={e => setForm(f => ({ ...f, name: e.target.value }))} />
        </div>
        <div>
          <MFLabel>Status</MFLabel>
          <select className={`${MF_INP} ${!editingId ? 'cursor-not-allowed bg-gray-200' : ''}`}
            disabled={!editingId} value={form.status}
            onChange={e => setForm(f => ({ ...f, status: e.target.value }))}>
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
          </select>
          {!editingId && <p className="text-[10px] text-surface-400 mt-0.5">Set once the record exists</p>}
        </div>
        {selectedLoading && <p className="text-[10px] text-surface-400">Loading record…</p>}
        {saving && <p className="text-[10px] text-primary-500">Saving...</p>}
        {error && <p className="text-[10px] text-red-500">{error}</p>}
      </MFEntryPanel>
    </div>
  );
}

/* ── District ─────────────────────────────────────────────────────────────── */
const EMPTY_DISTRICT_FORM = { code: '', name: '', provinceCode: '', status: 'Active' };

function MFRegionDistrict() {
  const dispatch = useDispatch();
  const {
    districts = [], provinces = [],
    districtLoading = false, saving = false, error = null,
    success = false, successFor = null, selectedLoading = false,
  } = useSelector(s => s.regionSlice) || {};

  const [search, setSearch] = useState('');
  const [form, setForm] = useState(EMPTY_DISTRICT_FORM);
  const [editingId, setEditingId] = useState(null);

  // Provinces feed the dropdown as well as the Province column below.
  useEffect(() => {
    dispatch(getDistrictList());
    dispatch(getProvinceList());
  }, [dispatch]);

  useEffect(() => {
    if (success && successFor === 'district') {
      dispatch(getDistrictList());
      setForm(EMPTY_DISTRICT_FORM);
      setEditingId(null);
      const t = setTimeout(() => dispatch(clearRegionSuccess()), 1500);
      return () => clearTimeout(t);
    }
  }, [success, successFor, dispatch]);

  const provinceOptions = useMemo(() => (Array.isArray(provinces) ? provinces : []).map(p => ({
    code: rgPick(p, RG_PROVINCE_CODE_KEYS, /province.*code|^code$|^id$/i),
    name: rgPick(p, RG_PROVINCE_NAME_KEYS, /province.*name|^name$/i),
  })).filter(p => p.code), [provinces]);

  const rows = useMemo(() => (Array.isArray(districts) ? districts : []).map((d, i) => {
    const provinceCode = rgPick(d, ['DISTRICT_PROVINCE_CODE', 'districtProvinceCode', 'p_districtProvinceCode', 'PROVINCE_CODE', 'ProvinceCode', 'provinceCode'], /province.*code/i);
    const match = provinceOptions.find(p => String(p.code) === String(provinceCode));
    const code = rgPick(d, ['DISTRICT_CODE', 'DistrictCode', 'districtCode', 'p_districtCode', 'HDD_DISTRICT_CODE', 'Code', 'code', 'Id', 'id'], /district.*code|^code$|^id$/i);
    return {
      id: code || `row-${i}`,
      code,
      name: rgPick(d, ['DISTRICT_NAME', 'DistrictName', 'districtName', 'p_districtName', 'HDD_DISTRICT_NAME', 'Name', 'name', 'Description'], /district.*name|^name$|desc/i),
      provinceCode,
      provinceName: rgPick(d, ['PROVINCE_NAME', 'ProvinceName', 'provinceName'], /province.*name/i) || (match ? match.name : ''),
      status: rgActive(d) ? 'Active' : 'Inactive',
    };
  }), [districts, provinceOptions]);

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return rows;
    return rows.filter(r => `${r.code} ${r.name} ${r.provinceName}`.toLowerCase().includes(q));
  }, [rows, search]);

  const handleSelect = (r) => {
    setEditingId(r.code);
    setForm({ code: r.code, name: r.name, provinceCode: r.provinceCode, status: r.status });
    if (!r.code) return;
    dispatch(getDistrictById(r.code)).unwrap().then((rec) => {
      if (!rec) return;
      setForm({
        code: rgDistrictCodeOf(rec) || r.code,
        name: rgDistrictNameOf(rec) || r.name,
        provinceCode: rgDistrictProvinceOf(rec) || r.provinceCode,
        status: rgActive(rec) ? 'Active' : 'Inactive',
      });
    }).catch(() => { });
  };

  const handleClear = () => {
    dispatch(clearRegionError());
    setEditingId(null);
    setForm(EMPTY_DISTRICT_FORM);
  };

  const handleSave = () => {
    if (!form.name || !form.provinceCode) return;
    if (editingId) {
      dispatch(updateDistrict({
        p_districtCode: form.code,
        p_districtProvinceCode: form.provinceCode,
        p_districtName: form.name,
        p_status: form.status === 'Active' ? 1 : 0,
      }));
    } else {
      dispatch(addDistrict({
        p_districtProvinceCode: form.provinceCode,
        p_districtName: form.name,
      }));
    }
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
      <div className="lg:col-span-2 space-y-3">
        <div className="relative">
          <Search size={12} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
          <input className={MF_SEARCH} placeholder="Search districts…"
            value={search} onChange={e => setSearch(e.target.value)} />
        </div>
        <MFGridSection title="District Details" count={filtered.length}>
          {districtLoading ? (
            <div className="py-20 flex items-center justify-center gap-2 text-sm text-gray-400">
              <Loader2 size={14} className="animate-spin" /> Loading districts...
            </div>
          ) : error ? (
            <div className="py-20 flex items-center justify-center gap-2 text-sm text-red-600">
              <AlertCircle size={13} className="shrink-0" /> {error}
            </div>
          ) : filtered.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-20 text-center text-gray-400">
              <Building2 size={24} className="text-gray-300 mb-2" />
              <p className="text-sm text-gray-400">No districts yet</p>
            </div>
          ) : (
            <table className="w-full text-[13px]">
              <thead>
                <tr className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">
                  {['Code', 'District Name', 'Province', 'Status'].map(h => <th key={h} className={MF_TH}>{h}</th>)}
                </tr>
              </thead>
              <tbody>
                {filtered.map(r => (
                  <tr key={r.id} onClick={() => handleSelect(r)}
                    className={`${MF_ROW} ${MF_ROW_IDLE} ${editingId === r.code ? MF_ROW_SEL : ''}`}>
                    <td className="px-4 py-3 font-mono text-gray-900 font-semibold">{r.code || '—'}</td>
                    <td className="px-4 py-3 text-gray-900 font-medium">{r.name || '—'}</td>
                    <td className="px-4 py-3 text-gray-600">{r.provinceName || r.provinceCode || '—'}</td>
                    <td className="px-4 py-3"><StatusPill label={r.status} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </MFGridSection>
      </div>

      <MFEntryPanel
        title={editingId ? 'Edit District' : 'District Entry'}
        onSave={handleSave}
        onClear={handleClear}
        saved={success && successFor === 'district'}
      >
        <div>
          <MFLabel>Code</MFLabel>
          <input className={`${MF_INP} cursor-not-allowed bg-gray-200`} disabled readOnly
            value={form.code} placeholder="Allocated on save" />
        </div>
        <div>
          <MFLabel req>Province</MFLabel>
          <MFSearchSelect className={MF_INP} value={form.provinceCode}
            onChange={v => setForm(f => ({ ...f, provinceCode: v }))}
            options={provinceOptions.map(p => ({ value: p.code, label: p.name || p.code }))}
            placeholder="— Select province —" />
        </div>
        <div>
          <MFLabel req>District Name</MFLabel>
          <input className={MF_INP} value={form.name}
            onChange={e => setForm(f => ({ ...f, name: e.target.value }))} />
        </div>
        <div>
          <MFLabel>Status</MFLabel>
          <select className={`${MF_INP} ${!editingId ? 'cursor-not-allowed bg-gray-200' : ''}`}
            disabled={!editingId} value={form.status}
            onChange={e => setForm(f => ({ ...f, status: e.target.value }))}>
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
          </select>
        </div>
        {selectedLoading && <p className="text-[10px] text-surface-400">Loading record…</p>}
        {saving && <p className="text-[10px] text-primary-500">Saving...</p>}
        {error && <p className="text-[10px] text-red-500">{error}</p>}
      </MFEntryPanel>
    </div>
  );
}

/* ── Electorate ───────────────────────────────────────────────────────────────
   Model: ELECTORATE_CODE, ELECTORATE_AREA, ELECTORATE_PROVINCE, ELECTORATE_DISTRICT
   No status column — the model does not carry one.                            */
const EMPTY_ELECTORATE_FORM = { code: '', area: '', provinceCode: '', districtCode: '' };

const rgDistrictProvinceOf = (d) =>
  rgPick(d, ['DISTRICT_PROVINCE_CODE', 'districtProvinceCode', 'p_districtProvinceCode', 'PROVINCE_CODE', 'ProvinceCode', 'provinceCode'], /province.*code/i);
const rgDistrictCodeOf = (d) =>
  rgPick(d, ['DISTRICT_CODE', 'DistrictCode', 'districtCode', 'p_districtCode', 'HDD_DISTRICT_CODE', 'Code', 'code', 'Id', 'id'], /district.*code|^code$|^id$/i);
const rgDistrictNameOf = (d) =>
  rgPick(d, ['DISTRICT_NAME', 'DistrictName', 'districtName', 'p_districtName', 'HDD_DISTRICT_NAME', 'Name', 'name'], /district.*name|^name$/i);

function MFRegionElectorate() {
  const dispatch = useDispatch();
  const {
    electorates = [], provinces = [], districts = [],
    electorateLoading = false, saving = false, error = null,
    success = false, successFor = null, selectedLoading = false,
  } = useSelector(s => s.regionSlice) || {};

  const [search, setSearch] = useState('');
  const [form, setForm] = useState(EMPTY_ELECTORATE_FORM);
  const [editingId, setEditingId] = useState(null);

  // Provinces and districts feed the two dropdowns and the name columns.
  useEffect(() => {
    dispatch(getElectorateList());
    dispatch(getProvinceList());
    dispatch(getDistrictList());
  }, [dispatch]);

  useEffect(() => {
    if (success && successFor === 'electorate') {
      dispatch(getElectorateList());
      setForm(EMPTY_ELECTORATE_FORM);
      setEditingId(null);
      const t = setTimeout(() => dispatch(clearRegionSuccess()), 1500);
      return () => clearTimeout(t);
    }
  }, [success, successFor, dispatch]);

  const provinceOptions = useMemo(() => (Array.isArray(provinces) ? provinces : []).map(p => ({
    code: rgPick(p, RG_PROVINCE_CODE_KEYS, /province.*code|^code$|^id$/i),
    name: rgPick(p, RG_PROVINCE_NAME_KEYS, /province.*name|^name$/i),
  })).filter(p => p.code), [provinces]);

  const districtOptions = useMemo(() => (Array.isArray(districts) ? districts : []).map(d => ({
    code: rgDistrictCodeOf(d),
    name: rgDistrictNameOf(d),
    provinceCode: rgDistrictProvinceOf(d),
  })).filter(d => d.code), [districts]);

  // Only districts inside the chosen province, so the pair can't contradict.
  const districtsForProvince = useMemo(
    () => (form.provinceCode
      ? districtOptions.filter(d => String(d.provinceCode) === String(form.provinceCode))
      : districtOptions),
    [districtOptions, form.provinceCode]
  );

  const nameOfProvince = (code) => (provinceOptions.find(p => String(p.code) === String(code)) || {}).name || '';
  const nameOfDistrict = (code) => (districtOptions.find(d => String(d.code) === String(code)) || {}).name || '';

  const rows = useMemo(() => (Array.isArray(electorates) ? electorates : []).map((e, i) => {
    const code = rgPick(e, ['ELECTORATE_CODE', 'ElectorateCode', 'electorateCode', 'p_electorateCode'], /electorate.*code/i);
    const provinceCode = rgPick(e, ['ELECTORATE_PROVINCE', 'ElectorateProvince', 'electorateProvince', 'p_electorateProvince'], /electorate.*province/i);
    const districtCode = rgPick(e, ['ELECTORATE_DISTRICT', 'ElectorateDistrict', 'electorateDistrict', 'p_electorateDistrict'], /electorate.*district/i);
    return {
      id: code || `row-${i}`,
      code,
      area: rgPick(e, ['ELECTORATE_AREA', 'ElectorateArea', 'electorateArea', 'p_electorateArea'], /electorate.*area|^area$/i),
      provinceCode,
      districtCode,
      provinceName: nameOfProvince(provinceCode),
      districtName: nameOfDistrict(districtCode),
    };
  }), [electorates, provinceOptions, districtOptions]); // eslint-disable-line react-hooks/exhaustive-deps

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return rows;
    return rows.filter(r => `${r.code} ${r.area} ${r.provinceName} ${r.districtName}`.toLowerCase().includes(q));
  }, [rows, search]);

  const handleSelect = (r) => {
    setEditingId(r.code);
    setForm({ code: r.code, area: r.area, provinceCode: r.provinceCode, districtCode: r.districtCode });
    if (!r.code) return;
    dispatch(getElectorateById(r.code)).unwrap().then((rec) => {
      if (!rec) return;
      setForm({
        code: rgPick(rec, ['ELECTORATE_CODE', 'ElectorateCode', 'electorateCode'], /electorate.*code/i) || r.code,
        area: rgPick(rec, ['ELECTORATE_AREA', 'ElectorateArea', 'electorateArea'], /electorate.*area|^area$/i) || r.area,
        provinceCode: rgPick(rec, ['ELECTORATE_PROVINCE', 'ElectorateProvince', 'electorateProvince'], /electorate.*province/i) || r.provinceCode,
        districtCode: rgPick(rec, ['ELECTORATE_DISTRICT', 'ElectorateDistrict', 'electorateDistrict'], /electorate.*district/i) || r.districtCode,
      });
    }).catch(() => { });
  };

  const handleClear = () => {
    dispatch(clearRegionError());
    setEditingId(null);
    setForm(EMPTY_ELECTORATE_FORM);
  };

  const handleSave = () => {
    if (!form.area || !form.provinceCode || !form.districtCode) return;
    const body = {
      p_electorateArea: form.area,
      p_electorateProvince: form.provinceCode,
      p_electorateDistrict: form.districtCode,
    };
    if (editingId) {
      dispatch(updateElectorate({ ...body, p_electorateCode: form.code }));
    } else {
      dispatch(addElectorate(body));
    }
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
      <div className="lg:col-span-2 space-y-3">
        <div className="relative">
          <Search size={12} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
          <input className={MF_SEARCH} placeholder="Search electorates…"
            value={search} onChange={e => setSearch(e.target.value)} />
        </div>
        <MFGridSection title="Electorate Details" count={filtered.length}>
          {electorateLoading ? (
            <div className="py-20 flex items-center justify-center gap-2 text-sm text-gray-400">
              <Loader2 size={14} className="animate-spin" /> Loading electorates...
            </div>
          ) : error ? (
            <div className="py-20 flex items-center justify-center gap-2 text-sm text-red-600">
              <AlertCircle size={13} className="shrink-0" /> {error}
            </div>
          ) : filtered.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-20 text-center text-gray-400">
              <MapPinned size={24} className="text-gray-300 mb-2" />
              <p className="text-sm text-gray-400">No electorates yet</p>
            </div>
          ) : (
            <table className="w-full text-[13px]">
              <thead>
                <tr className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">
                  {['Code', 'Area', 'Province', 'District'].map(h => <th key={h} className={MF_TH}>{h}</th>)}
                </tr>
              </thead>
              <tbody>
                {filtered.map(r => (
                  <tr key={r.id} onClick={() => handleSelect(r)}
                    className={`${MF_ROW} ${MF_ROW_IDLE} ${editingId === r.code ? MF_ROW_SEL : ''}`}>
                    <td className="px-4 py-3 font-mono text-gray-900 font-semibold">{r.code || '—'}</td>
                    <td className="px-4 py-3 text-gray-900 font-medium">{r.area || '—'}</td>
                    <td className="px-4 py-3 text-gray-600">{r.provinceName || r.provinceCode || '—'}</td>
                    <td className="px-4 py-3 text-gray-600">{r.districtName || r.districtCode || '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </MFGridSection>
      </div>

      <MFEntryPanel
        title={editingId ? 'Edit Electorate' : 'Electorate Entry'}
        onSave={handleSave}
        onClear={handleClear}
        saved={success && successFor === 'electorate'}
      >
        <div>
          <MFLabel>Code</MFLabel>
          <input className={`${MF_INP} cursor-not-allowed bg-gray-200`} disabled readOnly
            value={form.code} placeholder="Allocated on save" />
        </div>
        <div>
          <MFLabel req>Province</MFLabel>
          <MFSearchSelect className={MF_INP} value={form.provinceCode}
            onChange={v => setForm(f => ({ ...f, provinceCode: v, districtCode: '' }))}
            options={provinceOptions.map(p => ({ value: p.code, label: p.name || p.code }))}
            placeholder="— Select province —" />
        </div>
        <div>
          <MFLabel req>District</MFLabel>
          <MFSearchSelect className={`${MF_INP} ${!form.provinceCode ? 'cursor-not-allowed bg-gray-200' : ''}`}
            disabled={!form.provinceCode} value={form.districtCode}
            onChange={v => setForm(f => ({ ...f, districtCode: v }))}
            options={districtsForProvince.map(d => ({ value: d.code, label: d.name || d.code }))}
            placeholder="— Select district —" />
          {!form.provinceCode && <p className="text-[10px] text-surface-400 mt-0.5">Choose a province first</p>}
        </div>
        <div>
          <MFLabel req>Electorate Area</MFLabel>
          <input className={MF_INP} value={form.area}
            onChange={e => setForm(f => ({ ...f, area: e.target.value }))} />
        </div>
        {selectedLoading && <p className="text-[10px] text-surface-400">Loading record…</p>}
        {saving && <p className="text-[10px] text-primary-500">Saving...</p>}
        {error && <p className="text-[10px] text-red-500">{error}</p>}
      </MFEntryPanel>
    </div>
  );
}

/* ── Police Station ───────────────────────────────────────────────────────────
   Model: HPD_STATION_CODE, HPD_ELECTORATE_CODE, HPD_POLICESTATION_NAME,
          HPD_STATUS, HPD_PROVINCE_CODE, HPD_DISTRICT_CODE, HPD_PDIVISION_CODE  */
/* A station stores its own province and district codes — they are required on
   insert alongside the electorate, not derived from it. */
const EMPTY_POLICE_FORM = {
  code: '', name: '', provinceCode: '', districtCode: '', electorateCode: '', status: 'Active',
};

function MFRegionPolice() {
  const dispatch = useDispatch();
  const {
    policeStations = [], electorates = [], provinces = [], districts = [],
    policeStationLoading = false, saving = false, error = null,
    success = false, successFor = null, selectedLoading = false,
  } = useSelector(s => s.regionSlice) || {};

  const [search, setSearch] = useState('');
  const [form, setForm] = useState(EMPTY_POLICE_FORM);
  const [editingId, setEditingId] = useState(null);

  // Electorates feed the dropdown; provinces/districts name the extra columns
  // the model carries.
  useEffect(() => {
    dispatch(getPoliceStationList());
    dispatch(getElectorateList());
    dispatch(getProvinceList());
    dispatch(getDistrictList());
  }, [dispatch]);

  useEffect(() => {
    if (success && successFor === 'police') {
      dispatch(getPoliceStationList());
      setForm(EMPTY_POLICE_FORM);
      setEditingId(null);
      const t = setTimeout(() => dispatch(clearRegionSuccess()), 1500);
      return () => clearTimeout(t);
    }
  }, [success, successFor, dispatch]);

  const electorateOptions = useMemo(() => (Array.isArray(electorates) ? electorates : []).map(e => ({
    code: rgPick(e, ['ELECTORATE_CODE', 'ElectorateCode', 'electorateCode'], /electorate.*code/i),
    area: rgPick(e, ['ELECTORATE_AREA', 'ElectorateArea', 'electorateArea'], /electorate.*area|^area$/i),
    provinceCode: rgPick(e, ['ELECTORATE_PROVINCE', 'ElectorateProvince', 'electorateProvince'], /electorate.*province/i),
    districtCode: rgPick(e, ['ELECTORATE_DISTRICT', 'ElectorateDistrict', 'electorateDistrict'], /electorate.*district/i),
  })).filter(e => e.code), [electorates]);

  const provinceOptions = useMemo(() => (Array.isArray(provinces) ? provinces : []).map(p => ({
    code: rgPick(p, RG_PROVINCE_CODE_KEYS, /province.*code|^code$|^id$/i),
    name: rgPick(p, RG_PROVINCE_NAME_KEYS, /province.*name|^name$/i),
  })).filter(p => p.code), [provinces]);

  const districtOptions = useMemo(() => (Array.isArray(districts) ? districts : []).map(d => ({
    code: rgDistrictCodeOf(d),
    name: rgDistrictNameOf(d),
    provinceCode: rgDistrictProvinceOf(d),
  })).filter(d => d.code), [districts]);

  // Each dropdown is narrowed by the one above it, so the four codes sent to
  // the server can never contradict each other.
  const districtsForProvince = useMemo(
    () => (form.provinceCode
      ? districtOptions.filter(d => String(d.provinceCode) === String(form.provinceCode))
      : districtOptions),
    [districtOptions, form.provinceCode]
  );

  const electoratesForDistrict = useMemo(
    () => electorateOptions.filter(e =>
      (!form.provinceCode || String(e.provinceCode) === String(form.provinceCode))
      && (!form.districtCode || String(e.districtCode) === String(form.districtCode))),
    [electorateOptions, form.provinceCode, form.districtCode]
  );

  const provinceNameOf = (code) => {
    const hit = (Array.isArray(provinces) ? provinces : []).find(
      p => String(rgPick(p, RG_PROVINCE_CODE_KEYS, /province.*code|^code$|^id$/i)) === String(code));
    return hit ? rgPick(hit, RG_PROVINCE_NAME_KEYS, /province.*name|^name$/i) : '';
  };
  const districtNameOf = (code) => {
    const hit = (Array.isArray(districts) ? districts : []).find(
      d => String(rgDistrictCodeOf(d)) === String(code));
    return hit ? rgDistrictNameOf(hit) : '';
  };
  const areaOfElectorate = (code) =>
    (electorateOptions.find(e => String(e.code) === String(code)) || {}).area || '';

  const rows = useMemo(() => (Array.isArray(policeStations) ? policeStations : []).map((p, i) => {
    const code = rgPick(p, ['HPD_STATION_CODE', 'StationCode', 'stationCode', 'p_stationCode'], /station.*code/i);
    const electorateCode = rgPick(p, ['HPD_ELECTORATE_CODE', 'ElectorateCode', 'electorateCode', 'p_stationElectorateCode'], /electorate.*code/i);
    const provinceCode = rgPick(p, ['HPD_PROVINCE_CODE', 'ProvinceCode', 'provinceCode'], /province.*code/i);
    const districtCode = rgPick(p, ['HPD_DISTRICT_CODE', 'DistrictCode', 'districtCode'], /district.*code/i);
    return {
      id: code || `row-${i}`,
      code,
      name: rgPick(p, ['HPD_POLICESTATION_NAME', 'PoliceStationName', 'policeStationName', 'p_stationName', 'Name', 'name'], /policestation.*name|station.*name|^name$/i),
      electorateCode,
      electorateArea: areaOfElectorate(electorateCode),
      provinceCode,
      districtCode,
      provinceName: provinceNameOf(provinceCode) || provinceCode,
      districtName: districtNameOf(districtCode) || districtCode,
      status: rgPick(p, ['HPD_STATUS'], /status/i) === ''
        ? 'Active'
        : (rgActive(p) ? 'Active' : 'Inactive'),
    };
  }), [policeStations, electorateOptions, provinces, districts]); // eslint-disable-line react-hooks/exhaustive-deps

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return rows;
    return rows.filter(r => `${r.code} ${r.name} ${r.electorateArea} ${r.districtName}`.toLowerCase().includes(q));
  }, [rows, search]);

  const handleSelect = (r) => {
    setEditingId(r.code);
    setForm({
      code: r.code, name: r.name,
      provinceCode: r.provinceCode, districtCode: r.districtCode,
      electorateCode: r.electorateCode, status: r.status,
    });
    if (!r.code) return;
    dispatch(getPoliceStationById(r.code)).unwrap().then((rec) => {
      if (!rec) return;
      setForm({
        code: rgPick(rec, ['HPD_STATION_CODE', 'StationCode', 'stationCode'], /station.*code/i) || r.code,
        name: rgPick(rec, ['HPD_POLICESTATION_NAME', 'PoliceStationName', 'policeStationName', 'Name', 'name'], /policestation.*name|station.*name|^name$/i) || r.name,
        provinceCode: rgPick(rec, ['HPD_PROVINCE_CODE', 'ProvinceCode', 'provinceCode'], /province.*code/i) || r.provinceCode,
        districtCode: rgPick(rec, ['HPD_DISTRICT_CODE', 'DistrictCode', 'districtCode'], /district.*code/i) || r.districtCode,
        electorateCode: rgPick(rec, ['HPD_ELECTORATE_CODE', 'ElectorateCode', 'electorateCode'], /electorate.*code/i) || r.electorateCode,
        status: rgPick(rec, ['HPD_STATUS'], /status/i) === '' ? r.status : (rgActive(rec) ? 'Active' : 'Inactive'),
      });
    }).catch(() => { });
  };

  const handleClear = () => {
    dispatch(clearRegionError());
    setEditingId(null);
    setForm(EMPTY_POLICE_FORM);
  };

  const handleSave = () => {
    // All four are required by the procedure — it rejects the call outright
    // with "Station Name, Province, District and Electorate are required".
    if (!form.name || !form.provinceCode || !form.districtCode || !form.electorateCode) return;
    if (editingId) {
      dispatch(updatePoliceStation({
        p_stationCode: form.code,
        p_stationName: form.name,
        p_stationProvinceCode: form.provinceCode,
        p_stationDistrictCode: form.districtCode,
        p_stationElectorateCode: form.electorateCode,
        p_status: form.status === 'Active' ? 1 : 0,
      }));
    } else {
      dispatch(addPoliceStation({
        p_stationName: form.name,
        p_stationProvinceCode: form.provinceCode,
        p_stationDistrictCode: form.districtCode,
        p_stationElectorateCode: form.electorateCode,
        p_status: 1,
      }));
    }
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
      <div className="lg:col-span-2 space-y-3">
        <div className="relative">
          <Search size={12} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
          <input className={MF_SEARCH} placeholder="Search police stations…"
            value={search} onChange={e => setSearch(e.target.value)} />
        </div>
        <MFGridSection title="Police Station Details" count={filtered.length}>
          {policeStationLoading ? (
            <div className="py-20 flex items-center justify-center gap-2 text-sm text-gray-400">
              <Loader2 size={14} className="animate-spin" /> Loading police stations...
            </div>
          ) : error ? (
            <div className="py-20 flex items-center justify-center gap-2 text-sm text-red-600">
              <AlertCircle size={13} className="shrink-0" /> {error}
            </div>
          ) : filtered.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-20 text-center text-gray-400">
              <Shield size={24} className="text-gray-300 mb-2" />
              <p className="text-sm text-gray-400">No police stations yet</p>
            </div>
          ) : (
            <table className="w-full text-[13px]">
              <thead>
                <tr className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">
                  {['Code', 'Station Name', 'Electorate', 'District', 'Status'].map(h => <th key={h} className={MF_TH}>{h}</th>)}
                </tr>
              </thead>
              <tbody>
                {filtered.map(r => (
                  <tr key={r.id} onClick={() => handleSelect(r)}
                    className={`${MF_ROW} ${MF_ROW_IDLE} ${editingId === r.code ? MF_ROW_SEL : ''}`}>
                    <td className="px-4 py-3 font-mono text-gray-900 font-semibold">{r.code || '—'}</td>
                    <td className="px-4 py-3 text-gray-900 font-medium">{r.name || '—'}</td>
                    <td className="px-4 py-3 text-gray-600">{r.electorateArea || r.electorateCode || '—'}</td>
                    <td className="px-4 py-3 text-gray-600">{r.districtName || '—'}</td>
                    <td className="px-4 py-3"><StatusPill label={r.status} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </MFGridSection>
      </div>

      <MFEntryPanel
        title={editingId ? 'Edit Police Station' : 'Police Station Entry'}
        onSave={handleSave}
        onClear={handleClear}
        saved={success && successFor === 'police'}
      >
        <div>
          <MFLabel>Code</MFLabel>
          <input className={`${MF_INP} cursor-not-allowed bg-gray-200`} disabled readOnly
            value={form.code} placeholder="Allocated on save" />
        </div>
        <div>
          <MFLabel req>Province</MFLabel>
          {/* Changing a level clears the ones below it, so a stale child code
              can never be sent with a new parent. */}
          <MFSearchSelect className={MF_INP} value={form.provinceCode}
            onChange={v => setForm(f => ({
              ...f, provinceCode: v, districtCode: '', electorateCode: '',
            }))}
            options={provinceOptions.map(p => ({ value: p.code, label: p.name || p.code }))}
            placeholder="— Select province —" />
        </div>
        <div>
          <MFLabel req>District</MFLabel>
          <MFSearchSelect className={`${MF_INP} ${!form.provinceCode ? 'cursor-not-allowed bg-gray-200' : ''}`}
            disabled={!form.provinceCode} value={form.districtCode}
            onChange={v => setForm(f => ({ ...f, districtCode: v, electorateCode: '' }))}
            options={districtsForProvince.map(d => ({ value: d.code, label: d.name || d.code }))}
            placeholder="— Select district —" />
          {!form.provinceCode && <p className="text-[10px] text-surface-400 mt-0.5">Choose a province first</p>}
        </div>
        <div>
          <MFLabel req>Electorate</MFLabel>
          <MFSearchSelect className={`${MF_INP} ${!form.districtCode ? 'cursor-not-allowed bg-gray-200' : ''}`}
            disabled={!form.districtCode} value={form.electorateCode}
            onChange={v => setForm(f => ({ ...f, electorateCode: v }))}
            options={electoratesForDistrict.map(e => ({ value: e.code, label: e.area || e.code }))}
            placeholder="— Select electorate —" />
          {form.districtCode && electoratesForDistrict.length === 0 && (
            <p className="text-[10px] text-amber-600 mt-0.5">No electorates in this district yet</p>
          )}
          {!form.districtCode && <p className="text-[10px] text-surface-400 mt-0.5">Choose a district first</p>}
        </div>
        <div>
          <MFLabel req>Station Name</MFLabel>
          <input className={MF_INP} value={form.name}
            onChange={e => setForm(f => ({ ...f, name: e.target.value }))} />
        </div>
        <div>
          <MFLabel>Status</MFLabel>
          <select className={`${MF_INP} ${!editingId ? 'cursor-not-allowed bg-gray-200' : ''}`}
            disabled={!editingId} value={form.status}
            onChange={e => setForm(f => ({ ...f, status: e.target.value }))}>
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
          </select>
          {!editingId && <p className="text-[10px] text-surface-400 mt-0.5">Set once the record exists</p>}
        </div>
        {selectedLoading && <p className="text-[10px] text-surface-400">Loading record…</p>}
        {saving && <p className="text-[10px] text-primary-500">Saving...</p>}
        {error && <p className="text-[10px] text-red-500">{error}</p>}
      </MFEntryPanel>
    </div>
  );
}

/* ── Grama Sewaka Division ──────────────────────────────────────────────────
 * Flat list — a division belongs to no parent in the API, so there is no
 * cascade here. The code is typed rather than allocated, and the backend
 * exposes list and add only, so the panel does not offer an update.
 */
const EMPTY_GRAMA_FORM = { code: '', name: '' };

const rgGramaCodeOf = (g) =>
  rgPick(g, ['GRAMASEWAKA_CODE', 'GramasewakaCode', 'gramasewakaCode', 'p_GramasewakaCode',
    'HGD_GRAMASEWAKA_CODE', 'Code', 'code', 'Id', 'id'], /grama.*code|^code$|^id$/i);

const rgGramaNameOf = (g) =>
  rgPick(g, ['GRAMASEWAKA_DIVISION_NAME', 'GramasewakaDivisionName', 'gramasewakaDivisionName',
    'p_GramasewakaDivisionName', 'HGD_GRAMASEWAKA_DIVISION_NAME', 'DIVISION_NAME',
    'Name', 'name', 'Description'], /division.*name|grama.*name|^name$|desc/i);

function MFRegionGrama() {
  const dispatch = useDispatch();
  const { gramaDivisions = [], gramaLoading = false, saving = false, error = null,
    success = false, successFor = null } =
    useSelector(s => s.regionSlice) || {};

  const [search, setSearch] = useState('');
  const [form, setForm] = useState(EMPTY_GRAMA_FORM);

  useEffect(() => { dispatch(getGramaList()); }, [dispatch]);

  useEffect(() => {
    if (success && successFor === 'grama') {
      dispatch(getGramaList());
      setForm(EMPTY_GRAMA_FORM);
      const t = setTimeout(() => dispatch(clearRegionSuccess()), 1500);
      return () => clearTimeout(t);
    }
  }, [success, successFor, dispatch]);

  const rows = useMemo(() => (Array.isArray(gramaDivisions) ? gramaDivisions : []).map((g, i) => {
    const code = rgGramaCodeOf(g);
    return { id: code || `row-${i}`, code, name: rgGramaNameOf(g) };
  }), [gramaDivisions]);

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return rows;
    return rows.filter(r => `${r.code} ${r.name}`.toLowerCase().includes(q));
  }, [rows, search]);

  // The code is the key here, so a collision is caught before the round trip.
  const duplicate = useMemo(
    () => form.code.trim() !== '' &&
      rows.some(r => String(r.code).trim().toLowerCase() === form.code.trim().toLowerCase()),
    [rows, form.code]
  );

  const handleClear = () => {
    dispatch(clearRegionError());
    setForm(EMPTY_GRAMA_FORM);
  };

  const handleSave = () => {
    if (!form.code.trim() || !form.name.trim() || duplicate) return;
    dispatch(addGrama({
      p_GramasewakaCode: form.code.trim(),
      p_GramasewakaDivisionName: form.name.trim(),
    }));
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
      <div className="lg:col-span-2 space-y-3">
        <div className="relative">
          <Search size={12} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
          <input className={MF_SEARCH} placeholder="Search grama divisions…"
            value={search} onChange={e => setSearch(e.target.value)} />
        </div>
        <MFGridSection title="Grama Sewaka Divisions" count={filtered.length}>
          {gramaLoading ? (
            <div className="py-20 flex items-center justify-center gap-2 text-sm text-gray-400">
              <Loader2 size={14} className="animate-spin" /> Loading grama divisions...
            </div>
          ) : error ? (
            <div className="py-20 flex items-center justify-center gap-2 text-sm text-red-600">
              <AlertCircle size={13} className="shrink-0" /> {error}
            </div>
          ) : filtered.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-20 text-center text-gray-400">
              <Landmark size={24} className="text-gray-300 mb-2" />
              <p className="text-sm text-gray-400">No grama divisions yet</p>
            </div>
          ) : (
            <table className="w-full text-[13px]">
              <thead>
                <tr className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">
                  {['Code', 'Division Name'].map(h => <th key={h} className={MF_TH}>{h}</th>)}
                </tr>
              </thead>
              <tbody>
                {filtered.map(r => (
                  <tr key={r.id} className={`${MF_ROW} ${MF_ROW_IDLE}`}>
                    <td className="px-4 py-3 font-mono text-gray-900 font-semibold">{r.code || '—'}</td>
                    <td className="px-4 py-3 text-gray-900 font-medium">{r.name || '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </MFGridSection>
      </div>

      <MFEntryPanel
        title="Grama Division Entry"
        onSave={handleSave}
        onClear={handleClear}
        saved={success && successFor === 'grama'}
      >
        <div>
          <MFLabel req>Code</MFLabel>
          <input className={MF_INP} value={form.code}
            placeholder="e.g. 01"
            onChange={e => setForm(f => ({ ...f, code: e.target.value }))} />
          {duplicate
            ? <p className="text-[10px] text-red-500 mt-0.5">This code already exists</p>
            : <p className="text-[10px] text-surface-400 mt-0.5">You choose the code — it is not allocated</p>}
        </div>
        <div>
          <MFLabel req>Division Name</MFLabel>
          <input className={MF_INP} value={form.name}
            onChange={e => setForm(f => ({ ...f, name: e.target.value }))} />
        </div>
        <p className="text-[10px] text-surface-400">
          The backend has no update endpoint for divisions yet, so entries are add-only.
        </p>
        {saving && <p className="text-[10px] text-primary-500">Saving...</p>}
        {error && <p className="text-[10px] text-red-500">{error}</p>}
      </MFEntryPanel>
    </div>
  );
}

function MFRegion() {
  const dispatch = useDispatch();
  const [sub, setSub] = useState('province');
  const [importOpen, setImportOpen] = useState(false);

  /* One import can touch all four levels, so every list is re-read afterwards
     rather than just the sub-tab that happens to be open. */
  const handleImported = () => {
    dispatch(getProvinceList());
    dispatch(getDistrictList());
    dispatch(getElectorateList());
    dispatch(getPoliceStationList());
  };

  const renderSub = () => {
    switch (sub) {
      case 'province': return <MFRegionProvince />;
      case 'district': return <MFRegionDistrict />;
      case 'electorate': return <MFRegionElectorate />;
      case 'police': return <MFRegionPolice />;
      case 'grama': return <MFRegionGrama />;
      default: return null;
    }
  };

  return (
    <div className="space-y-4">
      {/* Sub-tabs, styled like the Master Files tab strip one level up. The
          import sits beside them, not inside a sub-tab, because one workbook
          fills all four levels in a single run. */}
      <div className="flex items-center gap-2">
        <div className="flex gap-2 overflow-x-auto pb-0.5 flex-1 min-w-0">
          {REGION_SUBTABS.map(t => {
            const Icon = t.icon;
            return (
              <button key={t.key} onClick={() => setSub(t.key)}
                className={`flex items-center gap-1.5 px-3 py-1.5 rounded text-xs font-medium whitespace-nowrap transition-colors
                  ${sub === t.key
                    ? 'bg-surface-900 text-primary-400'
                    : 'bg-surface-100 text-surface-500 hover:bg-surface-200 hover:text-surface-800'}`}>
                <Icon size={13} /> {t.label}
              </button>
            );
          })}
        </div>
        <button onClick={() => setImportOpen(true)}
          className="flex items-center gap-1.5 px-3 py-1.5 rounded text-xs font-semibold whitespace-nowrap shrink-0
            bg-primary-600 text-white hover:bg-primary-700 transition-colors">
          <FileSpreadsheet size={13} /> Import Excel
        </button>
      </div>
      {renderSub()}

      <ImportRegionModal
        isOpen={importOpen}
        onClose={() => setImportOpen(false)}
        onImported={handleImported}
      />
    </div>
  );
}

function MFCalendar() {
  const today = new Date().toISOString().split('T')[0];
  const [holidays, setHolidays] = useState(SEED_CALENDAR);
  const [form, setForm] = useState({ date: today, type: '', hours: 0, description: '' });
  const [saved, setSaved] = useState(false);
  const handleSave = () => {
    if (!form.date || !form.type) return;
    setHolidays(prev => { const idx = prev.findIndex(h => h.date === form.date); if (idx >= 0) { const n = [...prev]; n[idx] = { ...form }; return n; } return [...prev, { ...form }].sort((a, b) => a.date.localeCompare(b.date)); });
    setSaved(true); setTimeout(() => setSaved(false), 1500);
  };
  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
      <div className="lg:col-span-2">
        <MFGridSection title="Calendar — Holiday Schedule" count={holidays.length}>
          <table className="w-full text-[13px]">
            <thead><tr className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">{['Date', 'Type', 'Hours', 'Description'].map(h => <th key={h} className={MF_TH}>{h}</th>)}</tr></thead>
            <tbody>
              {holidays.map((r, i) => (
                <tr key={r.date + r.type} onClick={() => setForm({ date: r.date, type: r.type, hours: r.hours, description: r.description })}
                  className={`${MF_ROW} ${MF_ROW_IDLE} ${i === 0 ? 'bg-primary-50/50' : ''}`}>
                  <td className="px-4 py-3 font-mono text-gray-900 font-semibold">{r.date}</td>
                  <td className="px-4 py-3">
                    <span className={`px-2 py-0.5 rounded text-[10px] font-medium ${r.type === 'Mercantile Holiday' ? 'bg-orange-100 text-orange-700' : r.type === 'Poya Day' ? 'bg-purple-100 text-purple-700' : r.type === 'Company Holiday' ? 'bg-blue-100 text-blue-700' : r.type === 'Half Day' ? 'bg-yellow-100 text-yellow-700' : 'bg-surface-100 text-surface-600'}`}>{r.type}</span>
                  </td>
                  <td className="px-4 py-3 text-gray-600">{r.hours}</td>
                  <td className="px-4 py-3 text-gray-900 font-medium">{r.description}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </MFGridSection>
      </div>
      <MFEntryPanel title="Holiday Entry" onSave={handleSave} onClear={() => setForm({ date: today, type: '', hours: 0, description: '' })} saved={saved}>
        <div><MFLabel req>Date</MFLabel><input className={MF_INP} type="date" value={form.date} onChange={e => setForm(f => ({ ...f, date: e.target.value }))} /></div>
        <div><MFLabel req>Type</MFLabel><select className={MF_SEL} value={form.type} onChange={e => setForm(f => ({ ...f, type: e.target.value }))}><option value="">Select...</option><option>Mercantile Holiday</option><option>Poya Day</option><option>Company Holiday</option><option>Half Day</option><option>Bank Holiday</option></select></div>
        <div><MFLabel>No. of Hours</MFLabel><input className={MF_INP} type="number" min="0" max="12" value={form.hours} onChange={e => setForm(f => ({ ...f, hours: parseInt(e.target.value) }))} /></div>
        <div><MFLabel>Description</MFLabel><input className={MF_INP} value={form.description} onChange={e => setForm(f => ({ ...f, description: e.target.value }))} /></div>
      </MFEntryPanel>
    </div>
  );
}

// ─── Master Files Main View (embedded in HRM) ─────────────────────────────────
function HRMasterFilesView() {
  const [mfTab, setMfTab] = useState('overview');
  const activeTab = MF_TABS.find(t => t.key === mfTab);

  const renderContent = () => {
    switch (mfTab) {
      case 'overview': return <MFOverview setMfTab={setMfTab} />;
      case 'division': return <MFDivision />;
      case 'department': return <MFDepartment />;
      case 'location': return <MFLocation />;
      case 'designation': return <MFDesignation />;
      case 'emptype': return <MFEmploymentTypes />;
      case 'grade': return <MFGrade />;
      case 'education': return <MFEducation />;
      case 'professional': return <MFProfessional />;
      case 'shift': return <MFShift />;
      case 'province': return <MFProvince />;
      case 'bank': return <MFBank />;
      case 'bankBranch': return <MFBankBranch />;
      case 'region': return <MFRegion />;
      default: return null;
    }
  };

  return (
    <div className="-mx-4 lg:-mx-6 -mt-2 min-h-screen">
      {/* Main content area (no vertical sidebar) */}
      <div className="overflow-auto bg-gray-50/50">
        <div className="p-4 lg:p-6">
          {/* Breadcrumb header */}
          <div className="flex items-center justify-between mb-5">
            <div>
              <div className="flex items-center gap-2 text-xs text-surface-400 mb-1">
                <span>eHRM</span>
                <ChevronRight size={10} />
                <span>Master Files</span>
                <ChevronRight size={10} />
                <span className="text-primary-600 font-semibold">{activeTab?.label}</span>
              </div>
              <h1 className="text-xl font-bold text-surface-900">{activeTab?.label}</h1>
            </div>
            {mfTab !== 'overview' && (
              <button
                onClick={() => setMfTab('overview')}
                className="flex items-center gap-1 text-xs text-surface-500 hover:text-primary-600 border border-surface-200 rounded-lg px-3 py-1.5 transition-colors hover:border-primary-400"
              >
                ← Back to Overview
              </button>
            )}
          </div>
          {/* Horizontal tabs for quicker navigation (scrollable) */}
          <div className="mb-5 overflow-x-auto">
            <div className="flex items-center gap-2">
              {MF_TABS.map(t => (
                <button
                  key={t.key}
                  onClick={() => setMfTab(t.key)}
                  className={`px-3 py-1.5 rounded text-xs font-medium whitespace-nowrap transition-colors ${mfTab === t.key ? 'bg-surface-900 text-primary-400' : 'bg-surface-100 text-surface-500 hover:bg-surface-200 hover:text-surface-800'}`}
                >
                  <t.icon size={12} className="inline mr-2" />
                  {t.label}
                </button>
              ))}
            </div>
          </div>
          {renderContent()}
        </div>
      </div>
    </div>
  );
}

// ─── MAIN HRM PAGE ────────────────────────────────────────────────────────────
export default function HRMPage() {
  const dispatch = useDispatch();
  const { employees: hrEmployees, attendance, leaveRequests, payroll, recruitment, training, disciplinary, hrAssets, exits, loading } = useSelector(s => s.hr);
  const { employees: empEmployees, loading: empLoading, adding: empAdding, error: empError } = useSelector(s => s.emp);
  const { employees: realEmployees } = useSelector(s => s.employees);
  // Merge: real API employees take priority; fall back to mock hr employees
  const employees = empEmployees && empEmployees.length > 0 ? empEmployees : hrEmployees;
  const { activeModule: reduxActiveModule } = useSelector(s => s.ui);
  const activeModule = reduxActiveModule || 'overview';
  const [activeReport, setActiveReport] = useState(null);

  const [search, setSearch] = useState('');
  const [showAddEmployee, setShowAddEmployee] = useState(false);
  const [viewEmployee, setViewEmployee] = useState(null);
  const [showLeaveModal, setShowLeaveModal] = useState(false);
  const [showRecruitModal, setShowRecruitModal] = useState(false);
  const [showTrainingModal, setShowTrainingModal] = useState(false);
  const [showDiscModal, setShowDiscModal] = useState(false);
  const [showAssetModal, setShowAssetModal] = useState(false);
  const [showExitModal, setShowExitModal] = useState(false);
  const [leaveForm, setLeaveForm] = useState({ employeeId: '', type: 'Annual', from: '', to: '', days: 1, reason: '' });
  const [recruitForm, setRecruitForm] = useState({ position: '', department: '', vacancies: 1, postedDate: '', closingDate: '' });
  const [trainingForm, setTrainingForm] = useState({ title: '', employeeId: '', category: 'Technical', startDate: '', endDate: '', provider: '', status: 'Scheduled' });
  const [discForm, setDiscForm] = useState({ employeeId: '', type: 'Warning Letter', reason: '', date: '', issuedBy: '' });
  const [assetForm, setAssetForm] = useState({ employeeId: '', assetType: '', assetId: '', issuedDate: '', condition: 'Good' });
  const [exitForm, setExitForm] = useState({ employeeId: '', resignDate: '', lastDay: '', reason: '', finalSettlement: 0 });

  useEffect(() => {
    dispatch(fetchEmployees());
    dispatch(fetchAllEMP());
    dispatch(fetchAllEmployees());
    dispatch(fetchAttendance());
    dispatch(fetchLeave());
    dispatch(fetchPayroll());
    dispatch(fetchRecruitment());
    dispatch(fetchTraining());
    dispatch(fetchDisciplinary());
    dispatch(fetchHRAssets());
    dispatch(fetchExits());
  }, [dispatch]);

  const filtered = employees.map(normEmp).filter(e => {
    const name = `${e.firstName || ''} ${e.lastName || ''}`.toLowerCase();
    const q = search.toLowerCase();
    return name.includes(q)
      || (e.department || '').toLowerCase().includes(q)
      || (e.id || '').toLowerCase().includes(q)
      || (e.p_ced_service_no || '').toLowerCase().includes(q)
      || (e.p_email || '').toLowerCase().includes(q);
  });

  const empName = (id) => { const e = employees.find(x => x.id === id); return e ? `${e.firstName || ''} ${e.lastName || e.name || ''}`.trim() : id; };
  const setLF = (k, v) => setLeaveForm(f => ({ ...f, [k]: v }));
  const setRF = (k, v) => setRecruitForm(f => ({ ...f, [k]: v }));
  const setTF = (k, v) => setTrainingForm(f => ({ ...f, [k]: v }));
  const setDF = (k, v) => setDiscForm(f => ({ ...f, [k]: v }));
  const setAF = (k, v) => setAssetForm(f => ({ ...f, [k]: v }));
  const setEF = (k, v) => setExitForm(f => ({ ...f, [k]: v }));

  const inputCls = "input-field text-sm";
  const selectCls = "input-field text-sm";
  const activeCount = employees.filter(e => e.status === 'Active').length;
  const pendingLeave = leaveRequests.filter(l => l.status === 'Pending').length;
  const pendingPayroll = payroll.filter(p => p.status === 'Pending').length;

  return (
    <div className="min-h-screen">
      <div className="overflow-auto min-w-0">

        {/* ═══ OVERVIEW ═══ */}
        {activeModule === 'overview' && (
          <HRMDashboard />
        )}

        {/* ═══ EMPLOYEE MANAGEMENT ═══ */}
        {activeModule === 'employees' && (
          <div>
            <PageHeader title="Employee Management" subtitle="Master data, records & documents (eHRM)"
              actions={<button onClick={() => setShowAddEmployee(true)} className="btn-primary flex items-center gap-2"><Plus size={14} /> Add Employee</button>}
            />
            {(empLoading || empAdding) && (
              <div className="flex items-center gap-2 text-xs text-primary-600 mb-3 bg-primary-50 border border-primary-200 rounded-lg px-3 py-2">
                <span className="animate-spin border-2 border-primary-400 border-t-transparent rounded-full w-3 h-3 inline-block" />
                {empAdding ? 'Saving employee to API...' : 'Loading employees from eHRM API...'}
              </div>
            )}
            {empError && (
              <div className="flex items-center gap-2 text-xs text-red-600 mb-3 bg-red-50 border border-red-200 rounded-lg px-3 py-2">
                <AlertTriangle size={12} /> API Error: {empError}
              </div>
            )}
            <div className="mb-4 flex gap-2">
              <div className="flex-1"><SearchBar value={search} onChange={setSearch} placeholder="Search by name, ID, department, email..." /></div>
              <button onClick={() => dispatch(fetchAllEMP())}
                className="flex items-center gap-1 border border-surface-200 hover:bg-surface-50 text-surface-600 text-xs px-3 py-2 rounded-lg transition-colors">
                ↻ Refresh
              </button>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
              {filtered.map(e => <EmployeeSummaryCard key={e.id || e.p_ced_service_no} emp={e} onClick={setViewEmployee} />)}
              {filtered.length === 0 && !empLoading && <div className="col-span-3"><EmptyState title="No employees found" icon={Users} /></div>}
            </div>
          </div>
        )}

        {/* ═══ RECRUITMENT ═══ */}
        {activeModule === 'recruitment' && (
          <div>
            <PageHeader title="Recruitment & Onboarding" subtitle="Vacancies, applicants, interviews, selection"
              actions={<button onClick={() => setShowRecruitModal(true)} className="btn-primary flex items-center gap-2"><Plus size={14} /> Post Vacancy</button>}
            />
            <div className="grid grid-cols-3 gap-4 mb-5">
              <StatCard label="Active Vacancies" value={recruitment.filter(r => r.status === 'Active').length} icon={Briefcase} color="blue" />
              <StatCard label="Total Applicants" value={recruitment.reduce((a, r) => a + r.applicants, 0)} icon={Users} color="green" />
              <StatCard label="Shortlisted" value={recruitment.reduce((a, r) => a + r.shortlisted, 0)} icon={Award} color="gold" />
            </div>
            <Card noPad>
              <Table headers={['Ref', 'Position', 'Department', 'Vacancies', 'Posted', 'Closing', 'Applicants', 'Shortlisted', 'Status']}>
                {recruitment.map(r => (
                  <tr key={r.id} className="table-row">
                    <td className="px-4 py-3 font-mono text-xs text-primary-600 font-semibold">{r.id}</td>
                    <td className="px-4 py-3 font-medium text-surface-800 text-sm">{r.position}</td>
                    <td className="px-4 py-3 text-surface-600 text-sm">{r.department}</td>
                    <td className="px-4 py-3 text-center text-surface-700 font-medium text-sm">{r.vacancies}</td>
                    <td className="px-4 py-3 text-surface-500 text-sm">{r.postedDate}</td>
                    <td className="px-4 py-3 text-surface-500 text-sm">{r.closingDate}</td>
                    <td className="px-4 py-3 text-center text-surface-700 text-sm">{r.applicants}</td>
                    <td className="px-4 py-3 text-center text-surface-700 text-sm">{r.shortlisted}</td>
                    <td className="px-4 py-3"><Badge status={r.status} /></td>
                  </tr>
                ))}
              </Table>
            </Card>
          </div>
        )}

        {/* ═══ MASTER FILES ═══ */}
        {activeModule === 'masterfiles' && <HRMasterFilesView />}

        {/* ═══ ATTENDANCE ═══ */}
        {activeModule === 'attendance' && (
          <div>
            <PageHeader title="Attendance & Shifts" subtitle="Live attendance card from the eHRM API, by employee and month" />
            <AttendanceExplorer employees={realEmployees || []} />
          </div>
        )}

        {/* ═══ LEAVE MANAGEMENT ═══ */}
        {activeModule === 'leave' && (() => {
          // Redirect to dedicated Leave Management page
          if (typeof window !== 'undefined') {
            window.location.href = '/hrm/leave';
          }
          return null;
        })()}

        {/* ═══ PAYROLL ═══ */}
        {activeModule === 'payroll' && (
          <div>
            <PageHeader title="Payroll Management" subtitle="Salary, EPF/ETF, payslips, deductions" />
            <div className="grid grid-cols-4 gap-4 mb-5">
              <StatCard label="Total Payroll" value={'Rs. ' + payroll.reduce((s, p) => s + p.netPay, 0).toLocaleString()} icon={DollarSign} color="blue" />
              <StatCard label="Paid This Month" value={payroll.filter(p => p.status === 'Paid').length} icon={Check} color="green" />
              <StatCard label="Pending" value={payroll.filter(p => p.status === 'Pending').length} icon={Clock} color="gold" />
              <StatCard label="Total EPF" value={'Rs. ' + payroll.reduce((s, p) => s + p.epf, 0).toLocaleString()} icon={DollarSign} color="purple" />
            </div>
            <Card noPad>
              <Table headers={['Ref', 'Employee', 'Month', 'Basic', 'Allowances', 'Overtime', 'Deductions', 'EPF (8%)', 'ETF (3%)', 'Net Pay', 'Status']}>
                {payroll.map(p => (
                  <tr key={p.id} className="table-row">
                    <td className="px-4 py-3 font-mono text-xs text-primary-600 font-semibold">{p.id}</td>
                    <td className="px-4 py-3 font-medium text-surface-800 text-sm">{p.employeeName}</td>
                    <td className="px-4 py-3 text-surface-600 text-sm">{p.month}</td>
                    <td className="px-4 py-3 text-surface-700 text-sm text-right">{p.basic.toLocaleString()}</td>
                    <td className="px-4 py-3 text-surface-700 text-sm text-right">{p.allowances.toLocaleString()}</td>
                    <td className="px-4 py-3 text-surface-700 text-sm text-right">{p.overtime.toLocaleString()}</td>
                    <td className="px-4 py-3 text-red-600 text-sm text-right">({p.deductions.toLocaleString()})</td>
                    <td className="px-4 py-3 text-surface-600 text-sm text-right">{p.epf.toLocaleString()}</td>
                    <td className="px-4 py-3 text-surface-600 text-sm text-right">{p.etf.toLocaleString()}</td>
                    <td className="px-4 py-3 font-bold text-surface-900 text-sm text-right">{p.netPay.toLocaleString()}</td>
                    <td className="px-4 py-3"><Badge status={p.status} /></td>
                  </tr>
                ))}
              </Table>
            </Card>
          </div>
        )}

        {/* ═══ PERFORMANCE ═══ */}
        {activeModule === 'performance' && (
          <div>
            <PageHeader title="Performance Management" subtitle="KPIs, appraisals, reviews" />
            <div className="grid grid-cols-3 gap-5">
              <Card className="col-span-3">
                <p className="text-surface-500 text-sm text-center py-8">Performance appraisal cycles, KPI settings and employee reviews will be managed here.</p>
                <div className="grid grid-cols-3 gap-4">
                  {employees.slice(0, 3).map(e => (
                    <div key={e.id} className="border border-surface-100 rounded-xl p-4">
                      <div className="flex items-center gap-3 mb-3">
                        <div className="w-10 h-10 primary-gradient rounded-full flex items-center justify-center shrink-0"><span className="text-surface-900 font-bold text-sm">{(e.firstName || e.name || '?')[0]}</span></div>
                        <div><p className="font-semibold text-surface-800 text-sm">{e.firstName} {e.lastName}</p><p className="text-xs text-surface-400">{e.designation}</p></div>
                      </div>
                      <div className="space-y-2">
                        {['KPI Achievement', 'Attendance', 'Targets Met'].map((kpi, i) => (
                          <div key={kpi}>
                            <div className="flex justify-between text-xs mb-1"><span className="text-surface-500">{kpi}</span><span className="font-medium text-surface-700">{[88, 95, 75][i]}%</span></div>
                            <div className="h-1.5 bg-surface-100 rounded-full"><div className="h-full primary-gradient rounded-full" style={{ width: `${[88, 95, 75][i]}%` }} /></div>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </Card>
            </div>
          </div>
        )}

        {/* ═══ TRAINING ═══ */}
        {activeModule === 'training' && (
          <div>
            <PageHeader title="Training & Development" subtitle="Programs, skills, certifications"
              actions={<button onClick={() => setShowTrainingModal(true)} className="btn-primary flex items-center gap-2"><Plus size={14} /> Add Training</button>}
            />
            <div className="grid grid-cols-3 gap-4 mb-5">
              <StatCard label="Total Programs" value={training.length} icon={BookOpen} color="blue" />
              <StatCard label="Completed" value={training.filter(t => t.status === 'Completed').length} icon={Check} color="green" />
              <StatCard label="Scheduled" value={training.filter(t => t.status === 'Scheduled').length} icon={Calendar} color="gold" />
            </div>
            <Card noPad>
              <Table headers={['Ref', 'Training Title', 'Employee', 'Category', 'Start', 'End', 'Provider', 'Score', 'Status']}>
                {training.map(t => (
                  <tr key={t.id} className="table-row">
                    <td className="px-4 py-3 font-mono text-xs text-primary-600 font-semibold">{t.id}</td>
                    <td className="px-4 py-3 font-medium text-surface-800 text-sm">{t.title}</td>
                    <td className="px-4 py-3 text-surface-600 text-sm">{t.employeeName || empName(t.employeeId)}</td>
                    <td className="px-4 py-3 text-surface-500 text-sm">{t.category}</td>
                    <td className="px-4 py-3 text-surface-500 text-sm">{t.startDate}</td>
                    <td className="px-4 py-3 text-surface-500 text-sm">{t.endDate}</td>
                    <td className="px-4 py-3 text-surface-500 text-sm">{t.provider}</td>
                    <td className="px-4 py-3 text-surface-700 font-medium text-sm">{t.score != null ? `${t.score}%` : '—'}</td>
                    <td className="px-4 py-3"><Badge status={t.status} /></td>
                  </tr>
                ))}
              </Table>
            </Card>
          </div>
        )}

        {/* ═══ SELF SERVICE ═══ */}
        {activeModule === 'selfservice' && (
          <div>
            <PageHeader title="Employee Self Service" subtitle="Payslips, leave, attendance, personal info" />
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
              {[
                { label: 'View Payslips', icon: DollarSign, desc: 'Download monthly payslips', color: 'blue' },
                { label: 'Apply Leave', icon: Calendar, desc: 'Submit leave requests', color: 'green', action: () => { window.location.href = '/hrm/leave'; } },
                { label: 'My Attendance', icon: Clock, desc: 'View attendance history', color: 'gold', action: () => dispatch(setActiveModule('attendance')) },
                { label: 'Update Profile', icon: User, desc: 'Update personal details', color: 'purple' },
              ].map(({ label, icon: Icon, desc, color, action }) => (
                <div key={label} onClick={action} className="bg-white border border-surface-100 rounded-xl p-5 cursor-pointer hover:border-primary-400 hover:shadow-md transition-all">
                  <div className={`w-10 h-10 rounded-lg flex items-center justify-center mb-3 ${color === 'blue' ? 'bg-blue-100 text-blue-600' : color === 'green' ? 'bg-emerald-100 text-emerald-600' : color === 'gold' ? 'bg-primary-100 text-primary-600' : 'bg-purple-100 text-purple-600'}`}><Icon size={20} /></div>
                  <p className="font-semibold text-surface-800 text-sm">{label}</p>
                  <p className="text-xs text-surface-400 mt-0.5">{desc}</p>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* ═══ DISCIPLINARY ═══ */}
        {activeModule === 'disciplinary' && (
          <div>
            <PageHeader title="Disciplinary & Grievance" subtitle="Warnings, actions, incident tracking"
              actions={<button onClick={() => setShowDiscModal(true)} className="btn-primary flex items-center gap-2"><Plus size={14} /> New Action</button>}
            />
            <Card noPad>
              <Table headers={['Ref', 'Employee', 'Type', 'Reason', 'Date', 'Issued By', 'Status']}>
                {disciplinary.map(d => (
                  <tr key={d.id} className="table-row">
                    <td className="px-4 py-3 font-mono text-xs text-primary-600 font-semibold">{d.id}</td>
                    <td className="px-4 py-3 font-medium text-surface-800 text-sm">{d.employeeName || empName(d.employeeId)}</td>
                    <td className="px-4 py-3 text-surface-600 text-sm">{d.type}</td>
                    <td className="px-4 py-3 text-surface-500 text-sm max-w-40 truncate">{d.reason}</td>
                    <td className="px-4 py-3 text-surface-500 text-sm">{d.date}</td>
                    <td className="px-4 py-3 text-surface-500 text-sm">{d.issuedBy}</td>
                    <td className="px-4 py-3"><Badge status={d.status} /></td>
                  </tr>
                ))}
              </Table>
              {disciplinary.length === 0 && <EmptyState title="No disciplinary records" icon={ShieldAlert} />}
            </Card>
          </div>
        )}

        {/* ═══ HR ASSETS ═══ */}
        {activeModule === 'hrassets' && (
          <div>
            <PageHeader title="Asset Management (HR)" subtitle="Company assets assigned to employees"
              actions={<button onClick={() => setShowAssetModal(true)} className="btn-primary flex items-center gap-2"><Plus size={14} /> Assign Asset</button>}
            />
            <Card noPad>
              <Table headers={['Ref', 'Employee', 'Asset Type', 'Asset ID', 'Issued Date', 'Return Date', 'Condition', 'Status']}>
                {hrAssets.map(a => (
                  <tr key={a.id} className="table-row">
                    <td className="px-4 py-3 font-mono text-xs text-primary-600 font-semibold">{a.id}</td>
                    <td className="px-4 py-3 font-medium text-surface-800 text-sm">{a.employeeName || empName(a.employeeId)}</td>
                    <td className="px-4 py-3 text-surface-600 text-sm">{a.assetType}</td>
                    <td className="px-4 py-3 font-mono text-xs text-surface-500">{a.assetId}</td>
                    <td className="px-4 py-3 text-surface-500 text-sm">{a.issuedDate}</td>
                    <td className="px-4 py-3 text-surface-500 text-sm">{a.returnDate || '—'}</td>
                    <td className="px-4 py-3 text-surface-600 text-sm">{a.condition}</td>
                    <td className="px-4 py-3"><Badge status={a.status} /></td>
                  </tr>
                ))}
              </Table>
              {hrAssets.length === 0 && <EmptyState title="No assets assigned" icon={Package} />}
            </Card>
          </div>
        )}

        {/* ═══ EXIT MANAGEMENT ═══ */}
        {activeModule === 'exit' && (
          <div>
            <PageHeader title="Exit Management" subtitle="Resignations, clearance, final settlement"
              actions={<button onClick={() => setShowExitModal(true)} className="btn-primary flex items-center gap-2"><Plus size={14} /> New Exit</button>}
            />
            <Card noPad>
              <Table headers={['Ref', 'Employee', 'Designation', 'Dept', 'Resign Date', 'Last Day', 'Reason', 'Final Settlement', 'Clearance', 'Status']}>
                {exits.map(e => (
                  <tr key={e.id} className="table-row">
                    <td className="px-4 py-3 font-mono text-xs text-primary-600 font-semibold">{e.id}</td>
                    <td className="px-4 py-3 font-medium text-surface-800 text-sm">{e.employeeName || empName(e.employeeId)}</td>
                    <td className="px-4 py-3 text-surface-500 text-sm">{e.designation}</td>
                    <td className="px-4 py-3 text-surface-500 text-sm">{e.department}</td>
                    <td className="px-4 py-3 text-surface-500 text-sm">{e.resignDate}</td>
                    <td className="px-4 py-3 text-surface-500 text-sm">{e.lastDay}</td>
                    <td className="px-4 py-3 text-surface-500 text-sm max-w-32 truncate">{e.reason}</td>
                    <td className="px-4 py-3 text-surface-700 font-medium text-sm">{e.finalSettlement ? `Rs. ${e.finalSettlement.toLocaleString()}` : '—'}</td>
                    <td className="px-4 py-3 text-surface-500 text-sm">{e.clearance}</td>
                    <td className="px-4 py-3"><Badge status={e.status} /></td>
                  </tr>
                ))}
              </Table>
              {exits.length === 0 && <EmptyState title="No exit records" icon={LogOut} />}
            </Card>
          </div>
        )}

        {/* ═══ REPORTS ═══ */}
        {activeModule === 'reports' && (
          activeReport === 'attendance' ? (
            <AttendanceReport onBack={() => setActiveReport(null)} />
          ) : (
            <div>
              <PageHeader title="Reports & Analytics" subtitle="Attendance, payroll, turnover, leave summaries" />
              <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
                {[
                  { key: 'attendance', title: 'Attendance Report', desc: 'Daily/monthly attendance summary per department', icon: Clock, color: 'blue' },
                  { title: 'Payroll Report', desc: 'Salary, EPF/ETF summaries for accounting', icon: DollarSign, color: 'green' },
                  { title: 'Leave Summary', desc: 'Leave taken vs. balance per employee', icon: Calendar, color: 'gold' },
                  { title: 'Employee Turnover', desc: 'Joins, exits, retention rate analysis', icon: Users, color: 'purple' },
                  { title: 'Department Analytics', desc: 'Headcount & grade distribution by department', icon: BarChart2, color: 'blue' },
                  { title: 'Training Report', desc: 'Completed trainings and skill development', icon: BookOpen, color: 'green' },
                ].map(({ key, title, desc, icon: Icon, color }) => (
                  <div key={title} className="bg-white border border-surface-100 rounded-xl p-5 hover:border-primary-400 hover:shadow-md transition-all cursor-pointer">
                    <div className={`w-10 h-10 rounded-lg flex items-center justify-center mb-3 ${color === 'blue' ? 'bg-blue-100 text-blue-600' : color === 'green' ? 'bg-emerald-100 text-emerald-600' : color === 'gold' ? 'bg-primary-100 text-primary-600' : 'bg-purple-100 text-purple-600'}`}><Icon size={20} /></div>
                    <p className="font-semibold text-surface-800 text-sm">{title}</p>
                    <p className="text-xs text-surface-400 mt-1">{desc}</p>
                    <button onClick={() => key && setActiveReport(key)} className="mt-3 text-xs text-primary-600 font-medium hover:text-primary-700 flex items-center gap-1">Generate <ChevronRight size={12} /></button>
                  </div>
                ))}
              </div>
            </div>
          )
        )}
      </div>

      {/* ══════════════════════ MODALS ══════════════════════ */}
      <Modal open={showAddEmployee} onClose={() => setShowAddEmployee(false)} title="Employee Information — Add New Employee" size="xl">
        <AddEmployeeForm onClose={() => setShowAddEmployee(false)} onSuccess={() => dispatch(fetchAllEMP())} />
      </Modal>
      <Modal open={!!viewEmployee} onClose={() => setViewEmployee(null)} title="Employee Information" size="xl">
        {viewEmployee && <EmployeeDetailView emp={viewEmployee} onClose={() => setViewEmployee(null)} />}
      </Modal>
      <Modal open={showLeaveModal} onClose={() => setShowLeaveModal(false)} title="New Leave Request">
        <div className="space-y-4">
          <FormField label="Employee" required><select className={selectCls} value={leaveForm.employeeId} onChange={e => setLF('employeeId', e.target.value)}><option value="">Select Employee...</option>{employees.map(e => <option key={e.id} value={e.id}>{e.firstName} {e.lastName} ({e.id})</option>)}</select></FormField>
          <div className="grid grid-cols-2 gap-4">
            <FormField label="Leave Type" required><select className={selectCls} value={leaveForm.type} onChange={e => setLF('type', e.target.value)}>{['Annual', 'Casual', 'Medical', 'Unpaid', 'Maternity', 'Paternity'].map(t => <option key={t}>{t}</option>)}</select></FormField>
            <FormField label="No. of Days" required><input className={inputCls} type="number" min="1" value={leaveForm.days} onChange={e => setLF('days', parseInt(e.target.value))} /></FormField>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <FormField label="From Date" required><input className={inputCls} type="date" value={leaveForm.from} onChange={e => setLF('from', e.target.value)} /></FormField>
            <FormField label="To Date" required><input className={inputCls} type="date" value={leaveForm.to} onChange={e => setLF('to', e.target.value)} /></FormField>
          </div>
          <FormField label="Reason"><textarea className={inputCls + ' h-20 resize-none'} value={leaveForm.reason} onChange={e => setLF('reason', e.target.value)} placeholder="Reason for leave..." /></FormField>
          <div className="flex justify-end gap-3 pt-2">
            <button onClick={() => setShowLeaveModal(false)} className="btn-ghost">Cancel</button>
            <button onClick={() => { dispatch(createLeaveRequest({ ...leaveForm, employeeName: empName(leaveForm.employeeId) })); setShowLeaveModal(false); }} className="btn-primary">Submit Request</button>
          </div>
        </div>
      </Modal>
      <Modal open={showRecruitModal} onClose={() => setShowRecruitModal(false)} title="Post New Vacancy">
        <div className="space-y-4">
          <FormField label="Position Title" required><input className={inputCls} value={recruitForm.position} onChange={e => setRF('position', e.target.value)} placeholder="e.g. Mechanical Engineer" /></FormField>
          <div className="grid grid-cols-2 gap-4">
            <FormField label="Department" required><select className={selectCls} value={recruitForm.department} onChange={e => setRF('department', e.target.value)}><option value="">Select...</option>{['Engineering', 'Finance', 'HR', 'Production', 'Procurement', 'Commercial', 'ICT', 'Administration'].map(d => <option key={d}>{d}</option>)}</select></FormField>
            <FormField label="No. of Vacancies" required><input className={inputCls} type="number" min="1" value={recruitForm.vacancies} onChange={e => setRF('vacancies', parseInt(e.target.value))} /></FormField>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <FormField label="Posted Date"><input className={inputCls} type="date" value={recruitForm.postedDate} onChange={e => setRF('postedDate', e.target.value)} /></FormField>
            <FormField label="Closing Date"><input className={inputCls} type="date" value={recruitForm.closingDate} onChange={e => setRF('closingDate', e.target.value)} /></FormField>
          </div>
          <div className="flex justify-end gap-3 pt-2">
            <button onClick={() => setShowRecruitModal(false)} className="btn-ghost">Cancel</button>
            <button onClick={() => { dispatch(createRecruitment(recruitForm)); setShowRecruitModal(false); }} className="btn-primary">Post Vacancy</button>
          </div>
        </div>
      </Modal>
      <Modal open={showTrainingModal} onClose={() => setShowTrainingModal(false)} title="Add Training Record">
        <div className="space-y-4">
          <FormField label="Training Title" required><input className={inputCls} value={trainingForm.title} onChange={e => setTF('title', e.target.value)} /></FormField>
          <div className="grid grid-cols-2 gap-4">
            <FormField label="Employee" required><select className={selectCls} value={trainingForm.employeeId} onChange={e => setTF('employeeId', e.target.value)}><option value="">Select...</option>{employees.map(e => <option key={e.id} value={e.id}>{e.firstName} {e.lastName}</option>)}</select></FormField>
            <FormField label="Category"><select className={selectCls} value={trainingForm.category} onChange={e => setTF('category', e.target.value)}>{['Technical', 'Compliance', 'Quality', 'Management', 'Soft Skills'].map(c => <option key={c}>{c}</option>)}</select></FormField>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <FormField label="Start Date"><input className={inputCls} type="date" value={trainingForm.startDate} onChange={e => setTF('startDate', e.target.value)} /></FormField>
            <FormField label="End Date"><input className={inputCls} type="date" value={trainingForm.endDate} onChange={e => setTF('endDate', e.target.value)} /></FormField>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <FormField label="Provider"><input className={inputCls} value={trainingForm.provider} onChange={e => setTF('provider', e.target.value)} /></FormField>
            <FormField label="Status"><select className={selectCls} value={trainingForm.status} onChange={e => setTF('status', e.target.value)}>{['Scheduled', 'In Progress', 'Completed', 'Cancelled'].map(s => <option key={s}>{s}</option>)}</select></FormField>
          </div>
          <div className="flex justify-end gap-3 pt-2">
            <button onClick={() => setShowTrainingModal(false)} className="btn-ghost">Cancel</button>
            <button onClick={() => { dispatch(createTraining({ ...trainingForm, employeeName: empName(trainingForm.employeeId) })); setShowTrainingModal(false); }} className="btn-primary">Save Training</button>
          </div>
        </div>
      </Modal>
      <Modal open={showDiscModal} onClose={() => setShowDiscModal(false)} title="New Disciplinary Action">
        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <FormField label="Employee" required><select className={selectCls} value={discForm.employeeId} onChange={e => setDF('employeeId', e.target.value)}><option value="">Select...</option>{employees.map(e => <option key={e.id} value={e.id}>{e.firstName} {e.lastName}</option>)}</select></FormField>
            <FormField label="Action Type" required><select className={selectCls} value={discForm.type} onChange={e => setDF('type', e.target.value)}>{['Verbal Warning', 'Warning Letter', 'Final Warning', 'Suspension', 'Termination'].map(t => <option key={t}>{t}</option>)}</select></FormField>
          </div>
          <FormField label="Reason" required><textarea className={inputCls + ' h-20 resize-none'} value={discForm.reason} onChange={e => setDF('reason', e.target.value)} /></FormField>
          <div className="grid grid-cols-2 gap-4">
            <FormField label="Date"><input className={inputCls} type="date" value={discForm.date} onChange={e => setDF('date', e.target.value)} /></FormField>
            <FormField label="Issued By"><input className={inputCls} value={discForm.issuedBy} onChange={e => setDF('issuedBy', e.target.value)} /></FormField>
          </div>
          <div className="flex justify-end gap-3 pt-2">
            <button onClick={() => setShowDiscModal(false)} className="btn-ghost">Cancel</button>
            <button onClick={() => { dispatch(createDisciplinary({ ...discForm, employeeName: empName(discForm.employeeId) })); setShowDiscModal(false); }} className="btn-primary">Save</button>
          </div>
        </div>
      </Modal>
      <Modal open={showAssetModal} onClose={() => setShowAssetModal(false)} title="Assign HR Asset">
        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <FormField label="Employee" required><select className={selectCls} value={assetForm.employeeId} onChange={e => setAF('employeeId', e.target.value)}><option value="">Select...</option>{employees.map(e => <option key={e.id} value={e.id}>{e.firstName} {e.lastName}</option>)}</select></FormField>
            <FormField label="Asset Type" required><select className={selectCls} value={assetForm.assetType} onChange={e => setAF('assetType', e.target.value)}><option value="">Select...</option>{['Laptop', 'Desktop', 'Mobile Phone', 'ID Card', 'Uniform', 'Access Card', 'Vehicle', 'Tools', 'Other'].map(t => <option key={t}>{t}</option>)}</select></FormField>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <FormField label="Asset ID"><input className={inputCls} value={assetForm.assetId} onChange={e => setAF('assetId', e.target.value)} /></FormField>
            <FormField label="Condition"><select className={selectCls} value={assetForm.condition} onChange={e => setAF('condition', e.target.value)}>{['New', 'Good', 'Fair', 'Poor'].map(c => <option key={c}>{c}</option>)}</select></FormField>
          </div>
          <FormField label="Issued Date"><input className={inputCls} type="date" value={assetForm.issuedDate} onChange={e => setAF('issuedDate', e.target.value)} /></FormField>
          <div className="flex justify-end gap-3 pt-2">
            <button onClick={() => setShowAssetModal(false)} className="btn-ghost">Cancel</button>
            <button onClick={() => { dispatch(createHRAsset({ ...assetForm, employeeName: empName(assetForm.employeeId) })); setShowAssetModal(false); }} className="btn-primary">Assign Asset</button>
          </div>
        </div>
      </Modal>
      <Modal open={showExitModal} onClose={() => setShowExitModal(false)} title="New Exit Record">
        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <FormField label="Employee" required><select className={selectCls} value={exitForm.employeeId} onChange={e => setEF('employeeId', e.target.value)}><option value="">Select...</option>{employees.map(e => <option key={e.id} value={e.id}>{e.firstName} {e.lastName}</option>)}</select></FormField>
            <FormField label="Reason"><select className={selectCls} value={exitForm.reason} onChange={e => setEF('reason', e.target.value)}><option value="">Select...</option>{['Resignation', 'Retirement', 'Termination', 'Transfer', 'Contract End', 'Death'].map(r => <option key={r}>{r}</option>)}</select></FormField>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <FormField label="Resign Date"><input className={inputCls} type="date" value={exitForm.resignDate} onChange={e => setEF('resignDate', e.target.value)} /></FormField>
            <FormField label="Last Working Day"><input className={inputCls} type="date" value={exitForm.lastDay} onChange={e => setEF('lastDay', e.target.value)} /></FormField>
          </div>
          <FormField label="Final Settlement (Rs.)"><input className={inputCls} type="number" value={exitForm.finalSettlement} onChange={e => setEF('finalSettlement', parseFloat(e.target.value))} /></FormField>
          <div className="flex justify-end gap-3 pt-2">
            <button onClick={() => setShowExitModal(false)} className="btn-ghost">Cancel</button>
            <button onClick={() => {
              const emp = employees.find(x => x.id === exitForm.employeeId);
              dispatch(createExit({ ...exitForm, employeeName: empName(exitForm.employeeId), designation: emp?.designation, department: emp?.department, clearance: 'In Progress' }));
              setShowExitModal(false);
            }} className="btn-primary">Save Exit Record</button>
          </div>
        </div>
      </Modal>
    </div>
  );
}